//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IYardManagementClient {
    completeAppointmentShunt(command: CompleteAppointmentShuntCommand): Observable<string>;
    completeEmptyCheckInShunt(command: CompleteEmptyCheckInShuntCommand): Observable<string>;
    completeEmptyCheckOutShunt(command: CompleteEmptyCheckOutShuntCommand): Observable<string>;
    getShuntMoves(): Observable<ShuntMoveViewDto[]>;
    getYardCapacity(): Observable<YardCapacityGridViewDto[]>;
    exportYrdCapacity(command: YardCapacityScoreExportQuery): Observable<ExportedFileDto>;
    getYardCapacityScore(command: YardCapacityScoreQuery): Observable<{ [key in keyof typeof YardCapacityScoreType]?: ScoreDto; }>;
    getYardCapacityTrending(command: YardCapacityTrendingQuery): Observable<TrendingDto>;
    exportEmptyTrailer(command: EmptyTrailerScoreExportQuery): Observable<ExportedFileDto>;
    getEmptyTrailerScore(command: EmptyTrailerScoreQuery): Observable<{ [key in keyof typeof EmptyTrailerScoreType]?: ScoreDto; }>;
    exportShuntProductivity(command: ShuntProductivityScoreExportQuery): Observable<ExportedFileDto>;
    getShuntProductivityScore(command: ShuntProductivityScoreQuery): Observable<ScoreDto>;
    getShuntProductivityTrending(command: ShuntProductivityTrendingQuery): Observable<TrendingDto>;
    getShuntProductivityUserOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class YardManagementClient implements IYardManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    completeAppointmentShunt(command: CompleteAppointmentShuntCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/YardManagement/CompleteAppointmentShunt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteAppointmentShunt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteAppointmentShunt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCompleteAppointmentShunt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeEmptyCheckInShunt(command: CompleteEmptyCheckInShuntCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/YardManagement/CompleteEmptyCheckInShunt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteEmptyCheckInShunt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteEmptyCheckInShunt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCompleteEmptyCheckInShunt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeEmptyCheckOutShunt(command: CompleteEmptyCheckOutShuntCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/YardManagement/CompleteEmptyCheckOutShunt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteEmptyCheckOutShunt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteEmptyCheckOutShunt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCompleteEmptyCheckOutShunt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShuntMoves(): Observable<ShuntMoveViewDto[]> {
        let url_ = this.baseUrl + "/api/YardManagement/GetShuntMoves";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShuntMoves(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShuntMoves(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShuntMoveViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShuntMoveViewDto[]>;
        }));
    }

    protected processGetShuntMoves(response: HttpResponseBase): Observable<ShuntMoveViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShuntMoveViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYardCapacity(): Observable<YardCapacityGridViewDto[]> {
        let url_ = this.baseUrl + "/api/YardManagement/GetYardCapacity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYardCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYardCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YardCapacityGridViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YardCapacityGridViewDto[]>;
        }));
    }

    protected processGetYardCapacity(response: HttpResponseBase): Observable<YardCapacityGridViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(YardCapacityGridViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportYrdCapacity(command: YardCapacityScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/YardManagement/ExportYrdCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportYrdCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportYrdCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportYrdCapacity(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYardCapacityScore(command: YardCapacityScoreQuery): Observable<{ [key in keyof typeof YardCapacityScoreType]?: ScoreDto; }> {
        let url_ = this.baseUrl + "/api/YardManagement/GetYardCapacityScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYardCapacityScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYardCapacityScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key in keyof typeof YardCapacityScoreType]?: ScoreDto; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key in keyof typeof YardCapacityScoreType]?: ScoreDto; }>;
        }));
    }

    protected processGetYardCapacityScore(response: HttpResponseBase): Observable<{ [key in keyof typeof YardCapacityScoreType]?: ScoreDto; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? ScoreDto.fromJS(resultData200[key]) : new ScoreDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYardCapacityTrending(command: YardCapacityTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/YardManagement/GetYardCapacityTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYardCapacityTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYardCapacityTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetYardCapacityTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEmptyTrailer(command: EmptyTrailerScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/YardManagement/ExportEmptyTrailer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmptyTrailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmptyTrailer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportEmptyTrailer(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyTrailerScore(command: EmptyTrailerScoreQuery): Observable<{ [key in keyof typeof EmptyTrailerScoreType]?: ScoreDto; }> {
        let url_ = this.baseUrl + "/api/YardManagement/GetEmptyTrailerScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyTrailerScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyTrailerScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key in keyof typeof EmptyTrailerScoreType]?: ScoreDto; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key in keyof typeof EmptyTrailerScoreType]?: ScoreDto; }>;
        }));
    }

    protected processGetEmptyTrailerScore(response: HttpResponseBase): Observable<{ [key in keyof typeof EmptyTrailerScoreType]?: ScoreDto; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? ScoreDto.fromJS(resultData200[key]) : new ScoreDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportShuntProductivity(command: ShuntProductivityScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/YardManagement/ExportShuntProductivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportShuntProductivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportShuntProductivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportShuntProductivity(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShuntProductivityScore(command: ShuntProductivityScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/YardManagement/GetShuntProductivityScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShuntProductivityScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShuntProductivityScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetShuntProductivityScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShuntProductivityTrending(command: ShuntProductivityTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/YardManagement/GetShuntProductivityTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShuntProductivityTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShuntProductivityTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetShuntProductivityTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShuntProductivityUserOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/YardManagement/GetShuntProductivityUserOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShuntProductivityUserOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShuntProductivityUserOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetShuntProductivityUserOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IShuntLocationsClient {
    getShuntLocationOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ShuntLocationsClient implements IShuntLocationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getShuntLocationOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/ShuntLocations/GetShuntLocationOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShuntLocationOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShuntLocationOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetShuntLocationOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersClient {
    getUserList(): Observable<LoadResult>;
    getUserRoles(id: string): Observable<string[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUserList(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Users/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserRoles(id: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Users/GetUserRoles?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IShiftsClient {
    createShift(createCommand: CreateShiftCommand): Observable<void>;
    deleteShift(key: string): Observable<void>;
    getShift(query: GetShiftQuery): Observable<ShiftDto>;
    getShiftOptions(): Observable<LoadResult>;
    getShiftList(): Observable<LoadResult>;
    updateShift(command: UpdateShiftCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ShiftsClient implements IShiftsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createShift(createCommand: CreateShiftCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Shifts/CreateShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateShift(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteShift(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Shifts/DeleteShift?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShift(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShift(query: GetShiftQuery): Observable<ShiftDto> {
        let url_ = this.baseUrl + "/api/Shifts/GetShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDto>;
        }));
    }

    protected processGetShift(response: HttpResponseBase): Observable<ShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShiftOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Shifts/GetShiftOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetShiftOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShiftList(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Shifts/GetShiftList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetShiftList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateShift(command: UpdateShiftCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Shifts/UpdateShift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShift(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRolesClient {
    createRole(createCommand: CreateRoleCommand): Observable<string>;
    deleteRole(key: string): Observable<void>;
    getPermissionHierarchy(): Observable<PermissionHierarchyDto>;
    getRole(query: GetRoleQuery): Observable<RoleDto>;
    getRoleOptions(): Observable<LoadResult>;
    getRoleList(): Observable<LoadResult>;
    updateRole(command: UpdateRoleCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RolesClient implements IRolesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createRole(createCommand: CreateRoleCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Roles/CreateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRole(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/DeleteRole?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPermissionHierarchy(): Observable<PermissionHierarchyDto> {
        let url_ = this.baseUrl + "/api/Roles/GetPermissionHierarchy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissionHierarchy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionHierarchy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionHierarchyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionHierarchyDto>;
        }));
    }

    protected processGetPermissionHierarchy(response: HttpResponseBase): Observable<PermissionHierarchyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionHierarchyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRole(query: GetRoleQuery): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/Roles/GetRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGetRole(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Roles/GetRoleOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetRoleOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoleList(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Roles/GetRoleList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetRoleList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRole(command: UpdateRoleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Roles/UpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMustDepartTimesClient {
    getMustDepartTimes(): Observable<LoadResult>;
    createMustDepartTime(command: CreateMustDepartTimeCommand): Observable<string>;
    updateMustDepartTime(command: UpdateMustDepartTimeCommand): Observable<string>;
    deleteMustDepartTime(id: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MustDepartTimesClient implements IMustDepartTimesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMustDepartTimes(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/MustDepartTimes/GetMustDepartTimes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMustDepartTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMustDepartTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetMustDepartTimes(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMustDepartTime(command: CreateMustDepartTimeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/MustDepartTimes/CreateMustDepartTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMustDepartTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMustDepartTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateMustDepartTime(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMustDepartTime(command: UpdateMustDepartTimeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/MustDepartTimes/UpdateMustDepartTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMustDepartTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMustDepartTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateMustDepartTime(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMustDepartTime(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/MustDepartTimes/DeleteMustDepartTime?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMustDepartTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMustDepartTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMustDepartTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailsClient {
    getEmailLog(id: string): Observable<EmailLogDto>;
    getEmailLogs(): Observable<LoadResult>;
    getEmailTemplate(type: NotificationType): Observable<EmailTemplateDto>;
    getEmailTemplates(): Observable<LoadResult>;
    getRecipientOptions(): Observable<LoadResult>;
    updateEmailTemplate(command: UpdateEmailTemplateCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailsClient implements IEmailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEmailLog(id: string): Observable<EmailLogDto> {
        let url_ = this.baseUrl + "/api/Emails/GetEmailLog?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailLogDto>;
        }));
    }

    protected processGetEmailLog(response: HttpResponseBase): Observable<EmailLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailLogs(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Emails/GetEmailLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmailLogs(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailTemplate(type: NotificationType): Observable<EmailTemplateDto> {
        let url_ = this.baseUrl + "/api/Emails/GetEmailTemplate?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailTemplateDto>;
        }));
    }

    protected processGetEmailTemplate(response: HttpResponseBase): Observable<EmailTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailTemplates(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Emails/GetEmailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmailTemplates(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRecipientOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Emails/GetRecipientOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipientOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipientOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetRecipientOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmailTemplate(command: UpdateEmailTemplateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/UpdateEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmailTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmailTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAssetsClient {
    createAsset(command: CreateAssetCommand): Observable<string>;
    getAsset(id: string): Observable<AssetDto>;
    getAssetOptions(): Observable<LoadResult>;
    getAssetList(): Observable<LoadResult>;
    updateAsset(command: UpdateAssetCommand): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class AssetsClient implements IAssetsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createAsset(command: CreateAssetCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Assets/CreateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAsset(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAsset(id: string): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/Assets/GetAsset?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processGetAsset(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssetOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Assets/GetAssetOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAssetOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssetList(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Assets/GetAssetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAssetList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAsset(command: UpdateAssetCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Assets/UpdateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateAsset(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChecklistClient {
    createChecklist(command: CreateChecklistCommand): Observable<string>;
    getChecklist(id: string): Observable<ChecklistDto>;
    getChecklistQuestions(assetId: string, includeRadioShuttleQuestions: boolean, includeTwoWayRadioQuestions: boolean): Observable<ChecklistQuestionGroupDto[]>;
    getChecklists(): Observable<LoadResult>;
    repairChecklist(command: RepairChecklistCommand): Observable<void>;
    exportChecklistCondition(command: ChecklistConditionExportQuery): Observable<ExportedFileDto>;
    getChecklistConditionScore(command: ChecklistConditionQuery): Observable<ScoreDto>;
    getChecklistConditionTrending(command: ChecklistConditionTrendingQuery): Observable<TrendingDto>;
    exportChecklistComplianceScore(command: ChecklistComplianceScoreExportQuery): Observable<ExportedFileDto>;
    getChecklistComplianceScore(command: ChecklistComplianceScoreQuery): Observable<ScoreDto>;
    getChecklistComplianceTrending(command: ChecklistComplianceTrendingQuery): Observable<TrendingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ChecklistClient implements IChecklistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createChecklist(command: CreateChecklistCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Checklist/CreateChecklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateChecklist(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklist(id: string): Observable<ChecklistDto> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklist?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChecklistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChecklistDto>;
        }));
    }

    protected processGetChecklist(response: HttpResponseBase): Observable<ChecklistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChecklistDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklistQuestions(assetId: string, includeRadioShuttleQuestions: boolean, includeTwoWayRadioQuestions: boolean): Observable<ChecklistQuestionGroupDto[]> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklistQuestions?";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined and cannot be null.");
        else
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (includeRadioShuttleQuestions === undefined || includeRadioShuttleQuestions === null)
            throw new Error("The parameter 'includeRadioShuttleQuestions' must be defined and cannot be null.");
        else
            url_ += "includeRadioShuttleQuestions=" + encodeURIComponent("" + includeRadioShuttleQuestions) + "&";
        if (includeTwoWayRadioQuestions === undefined || includeTwoWayRadioQuestions === null)
            throw new Error("The parameter 'includeTwoWayRadioQuestions' must be defined and cannot be null.");
        else
            url_ += "includeTwoWayRadioQuestions=" + encodeURIComponent("" + includeTwoWayRadioQuestions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChecklistQuestionGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChecklistQuestionGroupDto[]>;
        }));
    }

    protected processGetChecklistQuestions(response: HttpResponseBase): Observable<ChecklistQuestionGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistQuestionGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklists(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetChecklists(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    repairChecklist(command: RepairChecklistCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Checklist/RepairChecklist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRepairChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepairChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRepairChecklist(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportChecklistCondition(command: ChecklistConditionExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Checklist/ExportChecklistCondition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChecklistCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChecklistCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportChecklistCondition(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklistConditionScore(command: ChecklistConditionQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklistConditionScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistConditionScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistConditionScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetChecklistConditionScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklistConditionTrending(command: ChecklistConditionTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklistConditionTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistConditionTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistConditionTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetChecklistConditionTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportChecklistComplianceScore(command: ChecklistComplianceScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Checklist/ExportChecklistComplianceScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChecklistComplianceScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChecklistComplianceScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportChecklistComplianceScore(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklistComplianceScore(command: ChecklistComplianceScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklistComplianceScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistComplianceScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistComplianceScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetChecklistComplianceScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklistComplianceTrending(command: ChecklistComplianceTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Checklist/GetChecklistComplianceTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistComplianceTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistComplianceTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetChecklistComplianceTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIncidentReportsClient {
    approveIncidentReport(command: ApproveIncidentReportCommand): Observable<string>;
    updateIncidentReport(command: UpdateIncidentReportCommand): Observable<string>;
    createIncidentReport(command: CreateIncidentReportCommand): Observable<string>;
    getIncidentReport(id: string): Observable<IncidentReportDto>;
    getIncidentReports(): Observable<LoadResult>;
    exportIncidentReport(command: IncidentReportExportQuery): Observable<ExportedFileDto>;
    getIncidentReportScore(command: IncidentReportQuery): Observable<ScoreDto>;
    getIncidentReportTrending(command: IncidentReportTrendingQuery): Observable<TrendingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class IncidentReportsClient implements IIncidentReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    approveIncidentReport(command: ApproveIncidentReportCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/IncidentReports/ApproveIncidentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveIncidentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveIncidentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApproveIncidentReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateIncidentReport(command: UpdateIncidentReportCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/IncidentReports/UpdateIncidentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIncidentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIncidentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateIncidentReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createIncidentReport(command: CreateIncidentReportCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/IncidentReports/CreateIncidentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIncidentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIncidentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateIncidentReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncidentReport(id: string): Observable<IncidentReportDto> {
        let url_ = this.baseUrl + "/api/IncidentReports/GetIncidentReport?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncidentReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncidentReportDto>;
        }));
    }

    protected processGetIncidentReport(response: HttpResponseBase): Observable<IncidentReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncidentReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncidentReports(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/IncidentReports/GetIncidentReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetIncidentReports(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportIncidentReport(command: IncidentReportExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/IncidentReports/ExportIncidentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportIncidentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportIncidentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportIncidentReport(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncidentReportScore(command: IncidentReportQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/IncidentReports/GetIncidentReportScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentReportScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentReportScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetIncidentReportScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncidentReportTrending(command: IncidentReportTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/IncidentReports/GetIncidentReportTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentReportTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentReportTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetIncidentReportTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductivityClient {
    getPerformance(): Observable<LoadResult>;
    getNextView(): Observable<LoadResult>;
    deleteNextView(key: string): Observable<void>;
    getYearToDate(): Observable<LoadResult>;
    getProductivitySettings(): Observable<LoadResult>;
    createProductivitySetting(command: CreateProductivitySettingCommand): Observable<string>;
    updateProductivitySetting(command: UpdateProductivitySettingCommand): Observable<string>;
    deleteProductivitySetting(id: string): Observable<void>;
    exportNextViewScore(command: NextViewScoreExportQuery): Observable<ExportedFileDto>;
    getNextViewScore(command: NextViewScoreQuery): Observable<ScoreDto>;
    exportYearToDateScore(command: YearToDateScoreExportQuery): Observable<ExportedFileDto>;
    getYearToDateScore(command: YearToDateScoreQuery): Observable<ScoreDto>;
    getYearToDateSummary(command: GetYearToDateSummaryQuery): Observable<YearToDateSummaryDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductivityClient implements IProductivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPerformance(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Productivity/GetPerformance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerformance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetPerformance(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextView(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Productivity/GetNextView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetNextView(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteNextView(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Productivity/DeleteNextView?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNextView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNextView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNextView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYearToDate(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Productivity/GetYearToDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearToDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearToDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetYearToDate(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductivitySettings(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Productivity/GetProductivitySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductivitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductivitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetProductivitySettings(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProductivitySetting(command: CreateProductivitySettingCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Productivity/CreateProductivitySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductivitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductivitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateProductivitySetting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProductivitySetting(command: UpdateProductivitySettingCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Productivity/UpdateProductivitySetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductivitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductivitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateProductivitySetting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteProductivitySetting(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Productivity/DeleteProductivitySetting?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProductivitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductivitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProductivitySetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportNextViewScore(command: NextViewScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Productivity/ExportNextViewScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportNextViewScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportNextViewScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportNextViewScore(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextViewScore(command: NextViewScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Productivity/GetNextViewScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextViewScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextViewScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetNextViewScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportYearToDateScore(command: YearToDateScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Productivity/ExportYearToDateScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportYearToDateScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportYearToDateScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportYearToDateScore(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYearToDateScore(command: YearToDateScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Productivity/GetYearToDateScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearToDateScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearToDateScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetYearToDateScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getYearToDateSummary(command: GetYearToDateSummaryQuery): Observable<YearToDateSummaryDto> {
        let url_ = this.baseUrl + "/api/Productivity/GetYearToDateSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetYearToDateSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYearToDateSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YearToDateSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YearToDateSummaryDto>;
        }));
    }

    protected processGetYearToDateSummary(response: HttpResponseBase): Observable<YearToDateSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YearToDateSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomersClient {
    createCustomer(command: CreateCustomerCommand): Observable<string>;
    updateCustomer(command: UpdateCustomerCommand): Observable<string>;
    deleteCustomer(id: string): Observable<void>;
    getCustomers(): Observable<LoadResult>;
    getCustomerOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomersClient implements ICustomersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createCustomer(command: CreateCustomerCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Customers/CreateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCustomer(command: UpdateCustomerCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Customers/UpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCustomer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCustomer(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Customers/DeleteCustomer?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomers(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Customers/GetCustomers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Customers/GetCustomerOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCustomerOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmptyCheckOutsClient {
    updateEmptyCheckOut(command: UpdateEmptyCheckOutCommand): Observable<string>;
    shuntEmptyCheckOut(command: ShuntEmptyCheckOutCommand): Observable<string>;
    getEmptyCheckOut(arg1: string | null | undefined): Observable<EmptyCheckOutDto>;
    getEmptyCheckOuts(): Observable<LoadResult>;
    getEmptyCheckOutHistory(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class EmptyCheckOutsClient implements IEmptyCheckOutsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    updateEmptyCheckOut(command: UpdateEmptyCheckOutCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/EmptyCheckOuts/UpdateEmptyCheckOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmptyCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmptyCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEmptyCheckOut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    shuntEmptyCheckOut(command: ShuntEmptyCheckOutCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/EmptyCheckOuts/ShuntEmptyCheckOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShuntEmptyCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShuntEmptyCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShuntEmptyCheckOut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckOut(arg1: string | null | undefined): Observable<EmptyCheckOutDto> {
        let url_ = this.baseUrl + "/api/EmptyCheckOuts/GetEmptyCheckOut?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmptyCheckOutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmptyCheckOutDto>;
        }));
    }

    protected processGetEmptyCheckOut(response: HttpResponseBase): Observable<EmptyCheckOutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmptyCheckOutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckOuts(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/EmptyCheckOuts/GetEmptyCheckOuts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckOuts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckOuts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmptyCheckOuts(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckOutHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/EmptyCheckOuts/GetEmptyCheckOutHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckOutHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckOutHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmptyCheckOutHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrdersClient {
    getOrder(arg1: string | null | undefined): Observable<OrderDto>;
    getOrders(): Observable<LoadResult>;
    getOrderLines(): Observable<LoadResult>;
    getLoads(): Observable<LoadResult>;
    getLoadLines(): Observable<LoadResult>;
    getOrderHistory(): Observable<LoadResult>;
    updateOrderAppointmentOverride(command: UpdateOrderAppointmentOverrideCommand): Observable<void>;
    getShipmentOptions(): Observable<LoadResult>;
    getOrderPlanningMixScore(query: GetOrderPlanningMixScoreQuery): Observable<OrderPlanningMixScoreDto>;
    getOrderPlanningMixTrending(query: GetOrderPlanningMixTrendingQuery): Observable<OrderPlanningMixTrendingDto>;
    getPreProductionOrdersScore(query: GetPreProductionOrdersScoreQuery): Observable<PreProductionOrdersScoreDto>;
    getPreProductionOrdersTrending(query: GetPreProductionOrdersTrendingQuery): Observable<PreProductionOrdersTrendingDto>;
    getPostProductionMdtScore(query: GetPostProductionMdtScoreQuery): Observable<PostProductionMdtScoreDto>;
    getPostProductionMdtTrending(query: GetPostProductionMdtTrendingQuery): Observable<PostProductionMdtTrendingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OrdersClient implements IOrdersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOrder(arg1: string | null | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/Orders/GetOrder?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDto>;
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrders(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Orders/GetOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetOrders(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderLines(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderLines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetOrderLines(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLoads(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Orders/GetLoads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetLoads(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLoadLines(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Orders/GetLoadLines";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetLoadLines(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetOrderHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOrderAppointmentOverride(command: UpdateOrderAppointmentOverrideCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateOrderAppointmentOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderAppointmentOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderAppointmentOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderAppointmentOverride(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShipmentOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Orders/GetShipmentOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetShipmentOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderPlanningMixScore(query: GetOrderPlanningMixScoreQuery): Observable<OrderPlanningMixScoreDto> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderPlanningMixScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderPlanningMixScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderPlanningMixScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPlanningMixScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPlanningMixScoreDto>;
        }));
    }

    protected processGetOrderPlanningMixScore(response: HttpResponseBase): Observable<OrderPlanningMixScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPlanningMixScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderPlanningMixTrending(query: GetOrderPlanningMixTrendingQuery): Observable<OrderPlanningMixTrendingDto> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderPlanningMixTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderPlanningMixTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderPlanningMixTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPlanningMixTrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPlanningMixTrendingDto>;
        }));
    }

    protected processGetOrderPlanningMixTrending(response: HttpResponseBase): Observable<OrderPlanningMixTrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPlanningMixTrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreProductionOrdersScore(query: GetPreProductionOrdersScoreQuery): Observable<PreProductionOrdersScoreDto> {
        let url_ = this.baseUrl + "/api/Orders/GetPreProductionOrdersScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreProductionOrdersScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreProductionOrdersScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreProductionOrdersScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreProductionOrdersScoreDto>;
        }));
    }

    protected processGetPreProductionOrdersScore(response: HttpResponseBase): Observable<PreProductionOrdersScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreProductionOrdersScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreProductionOrdersTrending(query: GetPreProductionOrdersTrendingQuery): Observable<PreProductionOrdersTrendingDto> {
        let url_ = this.baseUrl + "/api/Orders/GetPreProductionOrdersTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreProductionOrdersTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreProductionOrdersTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreProductionOrdersTrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreProductionOrdersTrendingDto>;
        }));
    }

    protected processGetPreProductionOrdersTrending(response: HttpResponseBase): Observable<PreProductionOrdersTrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreProductionOrdersTrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPostProductionMdtScore(query: GetPostProductionMdtScoreQuery): Observable<PostProductionMdtScoreDto> {
        let url_ = this.baseUrl + "/api/Orders/GetPostProductionMdtScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostProductionMdtScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostProductionMdtScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostProductionMdtScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostProductionMdtScoreDto>;
        }));
    }

    protected processGetPostProductionMdtScore(response: HttpResponseBase): Observable<PostProductionMdtScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostProductionMdtScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPostProductionMdtTrending(query: GetPostProductionMdtTrendingQuery): Observable<PostProductionMdtTrendingDto> {
        let url_ = this.baseUrl + "/api/Orders/GetPostProductionMdtTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostProductionMdtTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostProductionMdtTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostProductionMdtTrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostProductionMdtTrendingDto>;
        }));
    }

    protected processGetPostProductionMdtTrending(response: HttpResponseBase): Observable<PostProductionMdtTrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostProductionMdtTrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInvoicingClient {
    getVendor(id: string): Observable<VendorDto>;
    getVendorInfo(id: string): Observable<VendorInfoDto>;
    createVendor(command: CreateVendorCommand): Observable<string>;
    updateVendor(command: UpdateVendorCommand): Observable<string>;
    deleteVendor(key: string): Observable<void>;
    getVendors(): Observable<LoadResult>;
    getVendorOptions(id: string | null | undefined): Observable<LoadResult>;
    getMyScoreVendorsScore(query: GetMyScoreVendorsScoreQuery): Observable<MyScoreVendorsScoreDto>;
    getMyScoreVendorsTrending(query: GetMyScoreVendorsTrendingQuery): Observable<TrendingDto>;
    exportMyScoreVendors(command: ExportMyScoreVendorsQuery): Observable<ExportedFileDto>;
    getMyScoreOperationsL1Score(query: GetMyScoreOperationsL1ScoreQuery): Observable<MyScoreOperationsScoreDto>;
    getMyScoreOperationsL2Score(query: GetMyScoreOperationsL2ScoreQuery): Observable<MyScoreOperationsScoreDto>;
    getMyScoreOperationsL3Score(query: GetMyScoreOperationsL3ScoreQuery): Observable<MyScoreOperationsScoreDto>;
    exportMyScoreOperations(command: ExportMyScoreOperationsQuery): Observable<ExportedFileDto>;
    getMyScoreFinanceInvoicesScore(query: GetMyScoreFinanceInvoicesScoreQuery): Observable<MyScoreFinanceScoreDto>;
    getMyScoreCreditRequestsScore(query: GetMyScoreCreditRequestsScoreQuery): Observable<MyScoreFinanceScoreDto>;
    exportMyScoreFinance(command: ExportMyScoreFinanceQuery): Observable<ExportedFileDto>;
    getGlCodes(): Observable<LoadResult>;
    createGlCode(command: CreateGlCodeCommand): Observable<string>;
    updateGlCode(command: UpdateGlCodeCommand): Observable<string>;
    deleteGlCode(id: string): Observable<void>;
    getGlCodeOptions(id: PermissionType | null | undefined): Observable<LoadResult>;
    getGlCodeClients(): Observable<LoadResult>;
    createGlCodeClient(command: CreateGlCodeClientCommand): Observable<string>;
    updateGlCodeClient(command: UpdateGlCodeClientCommand): Observable<string>;
    deleteGlCodeClient(id: string): Observable<void>;
    getGlCodeClientOptions(): Observable<LoadResult>;
    getSiteOptions(id: PermissionType | null | undefined): Observable<LoadResult>;
    getBillToOptions(id: PermissionType | null | undefined): Observable<LoadResult>;
    getBillToInfo(id: string): Observable<BillToInfoDto>;
    getServiceTypes(): Observable<LoadResult>;
    createServiceType(command: CreateServiceTypeCommand): Observable<string>;
    updateServiceType(command: UpdateServiceTypeCommand): Observable<string>;
    deleteServiceType(id: string): Observable<void>;
    getServiceTypeOptions(): Observable<LoadResult>;
    createInvoicePurchaseOrder(command: CreateInvoicePurchaseOrderCommand): Observable<string>;
    updateInvoicePurchaseOrder(command: UpdateInvoicePurchaseOrderCommand): Observable<string>;
    getInvoicePurchaseOrder(arg1: string | null | undefined): Observable<InvoicePurchaseOrderDto>;
    exportInvoicePurchaseOrderPdf(arg1: string | null | undefined): Observable<ExportedFileDto>;
    getInvoicePurchaseOrders(): Observable<LoadResult>;
    getInvoicePurchaseOrderHistory(): Observable<LoadResult>;
    getInvoicePurchaseOrderOptions(id: string | null | undefined): Observable<LoadResult>;
    getInvoicePurchaseOrderInfo(id: string): Observable<InvoicePurchaseOrderInfoDto>;
    getConversionRate(arg1: Date): Observable<number>;
    getConversionRates(): Observable<LoadResult>;
    createConversionRate(command: CreateConversionRateCommand): Observable<string>;
    updateConversionRate(command: UpdateConversionRateCommand): Observable<string>;
    deleteConversionRate(id: string): Observable<void>;
    createInvoice(command: CreateInvoiceCommand): Observable<string>;
    updateInvoice(command: UpdateInvoiceCommand): Observable<string>;
    getInvoice(arg1: string | null | undefined): Observable<InvoiceDto>;
    exportInvoicePdf(arg1: string | null | undefined): Observable<ExportedFileDto>;
    getInvoices(): Observable<LoadResult>;
    getInvoiceHistory(): Observable<LoadResult>;
    getInvoiceOptions(arg1: string, arg2: string | null | undefined): Observable<LoadResult>;
    createCreditRequest(command: CreateCreditRequestCommand): Observable<string>;
    updateCreditRequest(command: UpdateCreditRequestCommand): Observable<string>;
    getCreditRequest(arg1: string | null | undefined): Observable<CreditRequestDto>;
    exportCreditRequestPdf(arg1: string | null | undefined): Observable<ExportedFileDto>;
    getCreditRequests(): Observable<LoadResult>;
    getCreditRequestHistory(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoicingClient implements IInvoicingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVendor(id: string): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetVendor?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processGetVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorInfo(id: string): Observable<VendorInfoDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetVendorInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInfoDto>;
        }));
    }

    protected processGetVendorInfo(response: HttpResponseBase): Observable<VendorInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VendorInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVendor(command: CreateVendorCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateVendor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVendor(command: UpdateVendorCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateVendor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVendor(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoicing/DeleteVendor?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteVendor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendors(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetVendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetVendors(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorOptions(id: string | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetVendorOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetVendorOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreVendorsScore(query: GetMyScoreVendorsScoreQuery): Observable<MyScoreVendorsScoreDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreVendorsScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreVendorsScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreVendorsScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyScoreVendorsScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyScoreVendorsScoreDto>;
        }));
    }

    protected processGetMyScoreVendorsScore(response: HttpResponseBase): Observable<MyScoreVendorsScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyScoreVendorsScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreVendorsTrending(query: GetMyScoreVendorsTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreVendorsTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreVendorsTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreVendorsTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetMyScoreVendorsTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportMyScoreVendors(command: ExportMyScoreVendorsQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Invoicing/ExportMyScoreVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMyScoreVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMyScoreVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportMyScoreVendors(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreOperationsL1Score(query: GetMyScoreOperationsL1ScoreQuery): Observable<MyScoreOperationsScoreDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreOperationsL1Score";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreOperationsL1Score(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreOperationsL1Score(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyScoreOperationsScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyScoreOperationsScoreDto>;
        }));
    }

    protected processGetMyScoreOperationsL1Score(response: HttpResponseBase): Observable<MyScoreOperationsScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyScoreOperationsScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreOperationsL2Score(query: GetMyScoreOperationsL2ScoreQuery): Observable<MyScoreOperationsScoreDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreOperationsL2Score";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreOperationsL2Score(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreOperationsL2Score(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyScoreOperationsScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyScoreOperationsScoreDto>;
        }));
    }

    protected processGetMyScoreOperationsL2Score(response: HttpResponseBase): Observable<MyScoreOperationsScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyScoreOperationsScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreOperationsL3Score(query: GetMyScoreOperationsL3ScoreQuery): Observable<MyScoreOperationsScoreDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreOperationsL3Score";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreOperationsL3Score(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreOperationsL3Score(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyScoreOperationsScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyScoreOperationsScoreDto>;
        }));
    }

    protected processGetMyScoreOperationsL3Score(response: HttpResponseBase): Observable<MyScoreOperationsScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyScoreOperationsScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportMyScoreOperations(command: ExportMyScoreOperationsQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Invoicing/ExportMyScoreOperations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMyScoreOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMyScoreOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportMyScoreOperations(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreFinanceInvoicesScore(query: GetMyScoreFinanceInvoicesScoreQuery): Observable<MyScoreFinanceScoreDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreFinanceInvoicesScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreFinanceInvoicesScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreFinanceInvoicesScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyScoreFinanceScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyScoreFinanceScoreDto>;
        }));
    }

    protected processGetMyScoreFinanceInvoicesScore(response: HttpResponseBase): Observable<MyScoreFinanceScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyScoreFinanceScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyScoreCreditRequestsScore(query: GetMyScoreCreditRequestsScoreQuery): Observable<MyScoreFinanceScoreDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetMyScoreCreditRequestsScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyScoreCreditRequestsScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyScoreCreditRequestsScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyScoreFinanceScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyScoreFinanceScoreDto>;
        }));
    }

    protected processGetMyScoreCreditRequestsScore(response: HttpResponseBase): Observable<MyScoreFinanceScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyScoreFinanceScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportMyScoreFinance(command: ExportMyScoreFinanceQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Invoicing/ExportMyScoreFinance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMyScoreFinance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMyScoreFinance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportMyScoreFinance(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlCodes(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetGlCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetGlCodes(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createGlCode(command: CreateGlCodeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateGlCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGlCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGlCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateGlCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateGlCode(command: UpdateGlCodeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateGlCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGlCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGlCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateGlCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteGlCode(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoicing/DeleteGlCode?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGlCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGlCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteGlCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlCodeOptions(id: PermissionType | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetGlCodeOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlCodeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlCodeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetGlCodeOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlCodeClients(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetGlCodeClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlCodeClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlCodeClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetGlCodeClients(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createGlCodeClient(command: CreateGlCodeClientCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateGlCodeClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGlCodeClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGlCodeClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateGlCodeClient(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateGlCodeClient(command: UpdateGlCodeClientCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateGlCodeClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGlCodeClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGlCodeClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateGlCodeClient(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteGlCodeClient(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoicing/DeleteGlCodeClient?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGlCodeClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGlCodeClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteGlCodeClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlCodeClientOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetGlCodeClientOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlCodeClientOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlCodeClientOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetGlCodeClientOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSiteOptions(id: PermissionType | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetSiteOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiteOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiteOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetSiteOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBillToOptions(id: PermissionType | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetBillToOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillToOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillToOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetBillToOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBillToInfo(id: string): Observable<BillToInfoDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetBillToInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillToInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillToInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillToInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillToInfoDto>;
        }));
    }

    protected processGetBillToInfo(response: HttpResponseBase): Observable<BillToInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillToInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceTypes(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetServiceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetServiceTypes(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createServiceType(command: CreateServiceTypeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateServiceType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateServiceType(command: UpdateServiceTypeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateServiceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateServiceType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteServiceType(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoicing/DeleteServiceType?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteServiceType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceTypeOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetServiceTypeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetServiceTypeOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInvoicePurchaseOrder(command: CreateInvoicePurchaseOrderCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateInvoicePurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoicePurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoicePurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateInvoicePurchaseOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInvoicePurchaseOrder(command: UpdateInvoicePurchaseOrderCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateInvoicePurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoicePurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoicePurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateInvoicePurchaseOrder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoicePurchaseOrder(arg1: string | null | undefined): Observable<InvoicePurchaseOrderDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoicePurchaseOrder?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicePurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicePurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoicePurchaseOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoicePurchaseOrderDto>;
        }));
    }

    protected processGetInvoicePurchaseOrder(response: HttpResponseBase): Observable<InvoicePurchaseOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePurchaseOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportInvoicePurchaseOrderPdf(arg1: string | null | undefined): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Invoicing/ExportInvoicePurchaseOrderPdf?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoicePurchaseOrderPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoicePurchaseOrderPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportInvoicePurchaseOrderPdf(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoicePurchaseOrders(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoicePurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicePurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicePurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInvoicePurchaseOrders(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoicePurchaseOrderHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoicePurchaseOrderHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicePurchaseOrderHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicePurchaseOrderHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInvoicePurchaseOrderHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoicePurchaseOrderOptions(id: string | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoicePurchaseOrderOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicePurchaseOrderOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicePurchaseOrderOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInvoicePurchaseOrderOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoicePurchaseOrderInfo(id: string): Observable<InvoicePurchaseOrderInfoDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoicePurchaseOrderInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicePurchaseOrderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicePurchaseOrderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoicePurchaseOrderInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoicePurchaseOrderInfoDto>;
        }));
    }

    protected processGetInvoicePurchaseOrderInfo(response: HttpResponseBase): Observable<InvoicePurchaseOrderInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePurchaseOrderInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConversionRate(arg1: Date): Observable<number> {
        let url_ = this.baseUrl + "/api/Invoicing/GetConversionRate?";
        if (arg1 === undefined || arg1 === null)
            throw new Error("The parameter 'arg1' must be defined and cannot be null.");
        else
            url_ += "arg1=" + encodeURIComponent(arg1 ? "" + arg1.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConversionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetConversionRate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConversionRates(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetConversionRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConversionRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversionRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetConversionRates(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createConversionRate(command: CreateConversionRateCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateConversionRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConversionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConversionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateConversionRate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateConversionRate(command: UpdateConversionRateCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateConversionRate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConversionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConversionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateConversionRate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteConversionRate(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoicing/DeleteConversionRate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConversionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConversionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConversionRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInvoice(command: CreateInvoiceCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInvoice(command: UpdateInvoiceCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateInvoice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoice(arg1: string | null | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoice?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportInvoicePdf(arg1: string | null | undefined): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Invoicing/ExportInvoicePdf?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoicePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoicePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportInvoicePdf(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoices(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInvoices(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoiceHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoiceHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInvoiceHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoiceOptions(arg1: string, arg2: string | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetInvoiceOptions?";
        if (arg1 === undefined || arg1 === null)
            throw new Error("The parameter 'arg1' must be defined and cannot be null.");
        else
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        if (arg2 !== undefined && arg2 !== null)
            url_ += "arg2=" + encodeURIComponent("" + arg2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInvoiceOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCreditRequest(command: CreateCreditRequestCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/CreateCreditRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCreditRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCreditRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCreditRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCreditRequest(command: UpdateCreditRequestCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Invoicing/UpdateCreditRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCreditRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCreditRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCreditRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreditRequest(arg1: string | null | undefined): Observable<CreditRequestDto> {
        let url_ = this.baseUrl + "/api/Invoicing/GetCreditRequest?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreditRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditRequestDto>;
        }));
    }

    protected processGetCreditRequest(response: HttpResponseBase): Observable<CreditRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCreditRequestPdf(arg1: string | null | undefined): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Invoicing/ExportCreditRequestPdf?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCreditRequestPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCreditRequestPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportCreditRequestPdf(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreditRequests(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetCreditRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreditRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCreditRequests(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreditRequestHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Invoicing/GetCreditRequestHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreditRequestHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditRequestHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCreditRequestHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IInventoryClient {
    getMaterial(arg1: string | null | undefined): Observable<MaterialDto>;
    getMaterials(): Observable<LoadResult>;
    updateMaterial(command: UpdateMaterialCommand): Observable<void>;
    getHalb(arg1: string | null | undefined): Observable<HalbDto>;
    getHalbs(): Observable<LoadResult>;
    updateHalb(command: UpdateHalbCommand): Observable<void>;
    getBin(arg1: string | null | undefined): Observable<BinDto>;
    getBins(): Observable<LoadResult>;
    updateBin(command: UpdateBinCommand): Observable<void>;
    getFacilityUtilization(): Observable<LoadResult>;
    getCountsPerStorageType(countType: CountType): Observable<LoadResult>;
    getCountsPerPalletType(palletTypeCount: PalletCountType): Observable<LoadResult>;
    getFacilityCapacity(): Observable<FacilityCapacityDto>;
    updateFacilityCapacity(command: UpdateFacilityCapacityCommand): Observable<void>;
    getDurationSettings(): Observable<LoadResult>;
    createDurationSetting(command: CreateDurationSettingCommand): Observable<void>;
    updateDurationSetting(command: UpdateDurationSettingCommand): Observable<void>;
    deleteDurationSetting(id: string): Observable<void>;
    getStorageUnit(arg1: string | null | undefined): Observable<StorageUnitDto>;
    getStorageUnits(): Observable<LoadResult>;
    getStorageUnitsByBin(): Observable<LoadResult>;
    exportSLAScore(command: SLAScoreExportQuery): Observable<ExportedFileDto>;
    getSLAScore(command: SLAScoreQuery): Observable<ScoreDto>;
    getSLATrending(command: SLATrendingQuery): Observable<TrendingDto>;
    exportFacilityUtilizationScore(command: FacilityUtilizationScoreExportQuery): Observable<ExportedFileDto>;
    getFacilityUtilizationScore(command: FacilityUtilizationScoreQuery): Observable<ScoreDto>;
    getFacilityUtilizationTrending(command: FacilityUtilizationTrendingQuery): Observable<TrendingDto>;
    getBlockedStock(): Observable<LoadResult>;
    getBlockedStockScore(): Observable<LoadResult>;
    getBlockedStockScoreAggregate(command: BlockedStockScoreAggregateQuery): Observable<BlockedStockScoreAggregateDto[]>;
    getMB51Quantities(id: MB51Reason): Observable<LoadResult>;
    getMB51(): Observable<LoadResult>;
    getMB51Aggregate(command: MB51AggregateQuery): Observable<MB51AggregateDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class InventoryClient implements IInventoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMaterial(arg1: string | null | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetMaterial?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processGetMaterial(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaterialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMaterials(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetMaterials(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMaterial(command: UpdateMaterialCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/UpdateMaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMaterial(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHalb(arg1: string | null | undefined): Observable<HalbDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetHalb?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHalb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHalb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HalbDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HalbDto>;
        }));
    }

    protected processGetHalb(response: HttpResponseBase): Observable<HalbDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HalbDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHalbs(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetHalbs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHalbs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHalbs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetHalbs(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateHalb(command: UpdateHalbCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/UpdateHalb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHalb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHalb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateHalb(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBin(arg1: string | null | undefined): Observable<BinDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetBin?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BinDto>;
        }));
    }

    protected processGetBin(response: HttpResponseBase): Observable<BinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBins(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetBins";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetBins(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBin(command: UpdateBinCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/UpdateBin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFacilityUtilization(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetFacilityUtilization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityUtilization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityUtilization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetFacilityUtilization(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountsPerStorageType(countType: CountType): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetCountsPerStorageType?";
        if (countType === undefined || countType === null)
            throw new Error("The parameter 'countType' must be defined and cannot be null.");
        else
            url_ += "countType=" + encodeURIComponent("" + countType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountsPerStorageType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountsPerStorageType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCountsPerStorageType(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountsPerPalletType(palletTypeCount: PalletCountType): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetCountsPerPalletType?";
        if (palletTypeCount === undefined || palletTypeCount === null)
            throw new Error("The parameter 'palletTypeCount' must be defined and cannot be null.");
        else
            url_ += "palletTypeCount=" + encodeURIComponent("" + palletTypeCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountsPerPalletType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountsPerPalletType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCountsPerPalletType(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFacilityCapacity(): Observable<FacilityCapacityDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetFacilityCapacity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityCapacityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityCapacityDto>;
        }));
    }

    protected processGetFacilityCapacity(response: HttpResponseBase): Observable<FacilityCapacityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FacilityCapacityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFacilityCapacity(command: UpdateFacilityCapacityCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/UpdateFacilityCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFacilityCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFacilityCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFacilityCapacity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDurationSettings(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetDurationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDurationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDurationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetDurationSettings(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDurationSetting(command: CreateDurationSettingCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/CreateDurationSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDurationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDurationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDurationSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDurationSetting(command: UpdateDurationSettingCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/UpdateDurationSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDurationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDurationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDurationSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDurationSetting(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Inventory/DeleteDurationSetting?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDurationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDurationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDurationSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStorageUnit(arg1: string | null | undefined): Observable<StorageUnitDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetStorageUnit?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorageUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorageUnitDto>;
        }));
    }

    protected processGetStorageUnit(response: HttpResponseBase): Observable<StorageUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorageUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStorageUnits(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetStorageUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetStorageUnits(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStorageUnitsByBin(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetStorageUnitsByBin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStorageUnitsByBin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStorageUnitsByBin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetStorageUnitsByBin(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportSLAScore(command: SLAScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Inventory/ExportSLAScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSLAScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSLAScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportSLAScore(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSLAScore(command: SLAScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetSLAScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSLAScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSLAScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetSLAScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSLATrending(command: SLATrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetSLATrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSLATrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSLATrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetSLATrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportFacilityUtilizationScore(command: FacilityUtilizationScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Inventory/ExportFacilityUtilizationScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFacilityUtilizationScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFacilityUtilizationScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportFacilityUtilizationScore(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFacilityUtilizationScore(command: FacilityUtilizationScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetFacilityUtilizationScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityUtilizationScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityUtilizationScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetFacilityUtilizationScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFacilityUtilizationTrending(command: FacilityUtilizationTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Inventory/GetFacilityUtilizationTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityUtilizationTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityUtilizationTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetFacilityUtilizationTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlockedStock(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetBlockedStock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlockedStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlockedStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetBlockedStock(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlockedStockScore(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetBlockedStockScore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlockedStockScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlockedStockScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetBlockedStockScore(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlockedStockScoreAggregate(command: BlockedStockScoreAggregateQuery): Observable<BlockedStockScoreAggregateDto[]> {
        let url_ = this.baseUrl + "/api/Inventory/GetBlockedStockScoreAggregate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlockedStockScoreAggregate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlockedStockScoreAggregate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlockedStockScoreAggregateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlockedStockScoreAggregateDto[]>;
        }));
    }

    protected processGetBlockedStockScoreAggregate(response: HttpResponseBase): Observable<BlockedStockScoreAggregateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlockedStockScoreAggregateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMB51Quantities(id: MB51Reason): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetMB51Quantities?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMB51Quantities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMB51Quantities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetMB51Quantities(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMB51(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Inventory/GetMB51";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMB51(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMB51(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetMB51(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMB51Aggregate(command: MB51AggregateQuery): Observable<MB51AggregateDto[]> {
        let url_ = this.baseUrl + "/api/Inventory/GetMB51Aggregate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMB51Aggregate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMB51Aggregate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MB51AggregateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MB51AggregateDto[]>;
        }));
    }

    protected processGetMB51Aggregate(response: HttpResponseBase): Observable<MB51AggregateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MB51AggregateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAppointmentsClient {
    createAppointment(command: CreateAppointmentCommand): Observable<string>;
    updateAppointment(command: UpdateAppointmentCommand): Observable<string>;
    shuntAppointment(command: ShuntAppointmentCommand): Observable<string>;
    assignToUnloadAppointment(command: AssignToUnloadAppointmentCommand): Observable<string>;
    completeAppointment(command: CompleteAppointmentCommand): Observable<string>;
    checkOutAppointment(command: CheckOutAppointmentCommand): Observable<string>;
    updateAppointmentCompliance(command: UpdateAppointmentComplianceCommand): Observable<string>;
    getAppointment(arg1: string | null | undefined): Observable<AppointmentDto>;
    getAppointmentCompliance(arg1: string | null | undefined): Observable<AppointmentComplianceDto>;
    getAppointments(): Observable<LoadResult>;
    getAppointmentHistory(): Observable<LoadResult>;
    getAppointmentCompliances(): Observable<LoadResult>;
    getCalendarAppointments(command: GetCalendarAppointmentsQuery): Observable<CalendarAppointmentDto[]>;
    getAppointmentsCountAt(arg1: Date, arg2: string | null | undefined): Observable<number>;
    exportAppointmentAging(command: AppointmentAgingScoreExportQuery): Observable<ExportedFileDto>;
    getAppointmentAgingScore(command: AppointmentAgingScoreQuery): Observable<ScoreDto>;
    getAppointmentAgingTrending(command: AppointmentAgingTrendingQuery): Observable<TrendingDto>;
    exportInboundProductivity(command: InboundProductivityScoreExportQuery): Observable<ExportedFileDto>;
    getInboundProductivityScore(command: InboundProductivityScoreQuery): Observable<ScoreDto>;
    getInboundProductivityTrending(command: InboundProductivityTrendingQuery): Observable<TrendingDto>;
    getInboundProductivityEmployeeOptions(): Observable<LoadResult>;
    getAppointmentComplianceScore(query: GetAppointmentComplianceScoreQuery): Observable<ScoreDto>;
    getAppointmentComplianceTrending(query: GetAppointmentComplianceTrendingQuery): Observable<TrendingDto>;
    getAppointmentSupplierComplianceTrending(query: GetAppointmentSupplierComplianceTrendingQuery): Observable<SupplierComplianceBreakdownDto>;
    exportAppointmentCompliance(command: ExportAppointmentComplianceQuery): Observable<ExportedFileDto>;
    getAppointmentComplianceSupplierOptions(): Observable<LoadResult>;
    exportTagsRequired(command: TagsRequiredScoreExportQuery): Observable<ExportedFileDto>;
    getTagsRequiredScore(command: TagsRequiredScoreQuery): Observable<ScoreDto>;
    getTagsRequiredTrending(command: TagsRequiredTrendingQuery): Observable<TrendingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AppointmentsClient implements IAppointmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createAppointment(command: CreateAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/CreateAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAppointment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAppointment(command: UpdateAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/UpdateAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateAppointment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    shuntAppointment(command: ShuntAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/ShuntAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShuntAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShuntAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShuntAppointment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignToUnloadAppointment(command: AssignToUnloadAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/AssignToUnloadAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignToUnloadAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignToUnloadAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAssignToUnloadAppointment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeAppointment(command: CompleteAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/CompleteAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCompleteAppointment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkOutAppointment(command: CheckOutAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/CheckOutAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOutAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOutAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckOutAppointment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAppointmentCompliance(command: UpdateAppointmentComplianceCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appointments/UpdateAppointmentCompliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAppointmentCompliance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAppointmentCompliance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateAppointmentCompliance(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointment(arg1: string | null | undefined): Observable<AppointmentDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointment?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDto>;
        }));
    }

    protected processGetAppointment(response: HttpResponseBase): Observable<AppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentCompliance(arg1: string | null | undefined): Observable<AppointmentComplianceDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentCompliance?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentCompliance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentCompliance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentComplianceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentComplianceDto>;
        }));
    }

    protected processGetAppointmentCompliance(response: HttpResponseBase): Observable<AppointmentComplianceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentComplianceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointments(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAppointments(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAppointmentHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentCompliances(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentCompliances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentCompliances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentCompliances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAppointmentCompliances(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCalendarAppointments(command: GetCalendarAppointmentsQuery): Observable<CalendarAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/Appointments/GetCalendarAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarAppointments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarAppointments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarAppointmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarAppointmentDto[]>;
        }));
    }

    protected processGetCalendarAppointments(response: HttpResponseBase): Observable<CalendarAppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarAppointmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentsCountAt(arg1: Date, arg2: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentsCountAt?";
        if (arg1 === undefined || arg1 === null)
            throw new Error("The parameter 'arg1' must be defined and cannot be null.");
        else
            url_ += "arg1=" + encodeURIComponent(arg1 ? "" + arg1.toISOString() : "") + "&";
        if (arg2 !== undefined && arg2 !== null)
            url_ += "arg2=" + encodeURIComponent("" + arg2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentsCountAt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentsCountAt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAppointmentsCountAt(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAppointmentAging(command: AppointmentAgingScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Appointments/ExportAppointmentAging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAppointmentAging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAppointmentAging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportAppointmentAging(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentAgingScore(command: AppointmentAgingScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentAgingScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentAgingScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentAgingScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetAppointmentAgingScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentAgingTrending(command: AppointmentAgingTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentAgingTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentAgingTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentAgingTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetAppointmentAgingTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportInboundProductivity(command: InboundProductivityScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Appointments/ExportInboundProductivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInboundProductivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInboundProductivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportInboundProductivity(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInboundProductivityScore(command: InboundProductivityScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetInboundProductivityScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInboundProductivityScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInboundProductivityScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetInboundProductivityScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInboundProductivityTrending(command: InboundProductivityTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetInboundProductivityTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInboundProductivityTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInboundProductivityTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetInboundProductivityTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInboundProductivityEmployeeOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Appointments/GetInboundProductivityEmployeeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInboundProductivityEmployeeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInboundProductivityEmployeeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetInboundProductivityEmployeeOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentComplianceScore(query: GetAppointmentComplianceScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentComplianceScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentComplianceScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentComplianceScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetAppointmentComplianceScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentComplianceTrending(query: GetAppointmentComplianceTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentComplianceTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentComplianceTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentComplianceTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetAppointmentComplianceTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentSupplierComplianceTrending(query: GetAppointmentSupplierComplianceTrendingQuery): Observable<SupplierComplianceBreakdownDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentSupplierComplianceTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentSupplierComplianceTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentSupplierComplianceTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierComplianceBreakdownDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierComplianceBreakdownDto>;
        }));
    }

    protected processGetAppointmentSupplierComplianceTrending(response: HttpResponseBase): Observable<SupplierComplianceBreakdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierComplianceBreakdownDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAppointmentCompliance(command: ExportAppointmentComplianceQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Appointments/ExportAppointmentCompliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAppointmentCompliance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAppointmentCompliance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportAppointmentCompliance(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentComplianceSupplierOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Appointments/GetAppointmentComplianceSupplierOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentComplianceSupplierOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentComplianceSupplierOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAppointmentComplianceSupplierOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportTagsRequired(command: TagsRequiredScoreExportQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/Appointments/ExportTagsRequired";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTagsRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTagsRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportTagsRequired(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTagsRequiredScore(command: TagsRequiredScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetTagsRequiredScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagsRequiredScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagsRequiredScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetTagsRequiredScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTagsRequiredTrending(command: TagsRequiredTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/Appointments/GetTagsRequiredTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagsRequiredTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagsRequiredTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetTagsRequiredTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICarriersClient {
    getCarrier(id: string): Observable<CarrierDto>;
    createCarrier(command: CreateCarrierCommand): Observable<string>;
    updateCarrier(command: UpdateCarrierCommand): Observable<string>;
    deleteCarrier(key: string): Observable<void>;
    getCarriers(): Observable<LoadResult>;
    getCarrierOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CarriersClient implements ICarriersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCarrier(id: string): Observable<CarrierDto> {
        let url_ = this.baseUrl + "/api/Carriers/GetCarrier?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarrierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarrierDto>;
        }));
    }

    protected processGetCarrier(response: HttpResponseBase): Observable<CarrierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCarrier(command: CreateCarrierCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Carriers/CreateCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCarrier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCarrier(command: UpdateCarrierCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Carriers/UpdateCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCarrier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCarrier(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Carriers/DeleteCarrier?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCarrier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCarriers(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Carriers/GetCarriers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarriers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarriers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCarriers(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCarrierOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Carriers/GetCarrierOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarrierOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarrierOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetCarrierOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmptyCheckInsClient {
    createEmptyCheckIn(command: CreateEmptyCheckInCommand): Observable<string>;
    updateEmptyCheckIn(command: UpdateEmptyCheckInCommand): Observable<string>;
    shuntEmptyCheckIn(command: ShuntEmptyCheckInCommand): Observable<string>;
    checkOutEmptyCheckIn(command: CheckOutEmptyCheckInCommand): Observable<string>;
    getEmptyCheckIn(arg1: string | null | undefined): Observable<EmptyCheckInDto>;
    getEmptyCheckIns(): Observable<LoadResult>;
    getEmptyCheckInHistory(): Observable<LoadResult>;
    getUnloadEmployeeOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class EmptyCheckInsClient implements IEmptyCheckInsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createEmptyCheckIn(command: CreateEmptyCheckInCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/CreateEmptyCheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmptyCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmptyCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEmptyCheckIn(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmptyCheckIn(command: UpdateEmptyCheckInCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/UpdateEmptyCheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmptyCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmptyCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateEmptyCheckIn(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    shuntEmptyCheckIn(command: ShuntEmptyCheckInCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/ShuntEmptyCheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShuntEmptyCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShuntEmptyCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processShuntEmptyCheckIn(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkOutEmptyCheckIn(command: CheckOutEmptyCheckInCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/CheckOutEmptyCheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOutEmptyCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOutEmptyCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckOutEmptyCheckIn(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckIn(arg1: string | null | undefined): Observable<EmptyCheckInDto> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/GetEmptyCheckIn?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmptyCheckInDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmptyCheckInDto>;
        }));
    }

    protected processGetEmptyCheckIn(response: HttpResponseBase): Observable<EmptyCheckInDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmptyCheckInDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckIns(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/GetEmptyCheckIns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckIns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckIns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmptyCheckIns(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckInHistory(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/GetEmptyCheckInHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckInHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckInHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmptyCheckInHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnloadEmployeeOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/EmptyCheckIns/GetUnloadEmployeeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnloadEmployeeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnloadEmployeeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetUnloadEmployeeOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPurchaseOrdersClient {
    getPurchaseOrder(arg1: string | null | undefined): Observable<PurchaseOrderDto>;
    getPurchaseOrders(): Observable<LoadResult>;
    getPurchaseOrderOptions(arg1: string, arg2: string | null | undefined): Observable<LoadResult>;
    getPurchaseOrderItems(id: string | null | undefined): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class PurchaseOrdersClient implements IPurchaseOrdersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPurchaseOrder(arg1: string | null | undefined): Observable<PurchaseOrderDto> {
        let url_ = this.baseUrl + "/api/PurchaseOrders/GetPurchaseOrder?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDto>;
        }));
    }

    protected processGetPurchaseOrder(response: HttpResponseBase): Observable<PurchaseOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPurchaseOrders(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/PurchaseOrders/GetPurchaseOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetPurchaseOrders(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPurchaseOrderOptions(arg1: string, arg2: string | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/PurchaseOrders/GetPurchaseOrderOptions?";
        if (arg1 === undefined || arg1 === null)
            throw new Error("The parameter 'arg1' must be defined and cannot be null.");
        else
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        if (arg2 !== undefined && arg2 !== null)
            url_ += "arg2=" + encodeURIComponent("" + arg2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrderOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetPurchaseOrderOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPurchaseOrderItems(id: string | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/PurchaseOrders/GetPurchaseOrderItems?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetPurchaseOrderItems(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISuppliersClient {
    getSupplier(id: string): Observable<SupplierDto>;
    createSupplier(command: CreateSupplierCommand): Observable<string>;
    updateSupplier(command: UpdateSupplierCommand): Observable<string>;
    deleteSupplier(key: string): Observable<void>;
    getSuppliers(): Observable<LoadResult>;
    getSupplierOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class SuppliersClient implements ISuppliersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSupplier(id: string): Observable<SupplierDto> {
        let url_ = this.baseUrl + "/api/Suppliers/GetSupplier?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierDto>;
        }));
    }

    protected processGetSupplier(response: HttpResponseBase): Observable<SupplierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSupplier(command: CreateSupplierCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Suppliers/CreateSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateSupplier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSupplier(command: UpdateSupplierCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Suppliers/UpdateSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateSupplier(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSupplier(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Suppliers/DeleteSupplier?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSupplier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSuppliers(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Suppliers/GetSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupplierOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Suppliers/GetSupplierOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetSupplierOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFileImportsClient {
    getFileImports(): Observable<LoadResult>;
    getFileImportsByHour(query: GetFileImportsByHourQuery): Observable<FileImportByHourDto>;
    getFileImportStatus(query: GetFileImportStatusQuery): Observable<FileImportStatusDto[]>;
    importFile(fileType: ImportFileType, files: any[] | null | undefined): Observable<string[]>;
}

@Injectable({
    providedIn: 'root'
})
export class FileImportsClient implements IFileImportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFileImports(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/FileImports/GetFileImports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileImports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileImports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetFileImports(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFileImportsByHour(query: GetFileImportsByHourQuery): Observable<FileImportByHourDto> {
        let url_ = this.baseUrl + "/api/FileImports/GetFileImportsByHour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileImportsByHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileImportsByHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileImportByHourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileImportByHourDto>;
        }));
    }

    protected processGetFileImportsByHour(response: HttpResponseBase): Observable<FileImportByHourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileImportByHourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFileImportStatus(query: GetFileImportStatusQuery): Observable<FileImportStatusDto[]> {
        let url_ = this.baseUrl + "/api/FileImports/GetFileImportStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileImportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileImportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileImportStatusDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileImportStatusDto[]>;
        }));
    }

    protected processGetFileImportStatus(response: HttpResponseBase): Observable<FileImportStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileImportStatusDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importFile(fileType: ImportFileType, files: any[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/FileImports/ImportFile?";
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined and cannot be null.");
        else
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processImportFile(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAuthClient {
    changePassword(command: ChangePasswordCommand): Observable<void>;
    getSignedUrl(command: CreateUrlSignatureCommand): Observable<string>;
    impersonate(userId: string): Observable<AuthResponseDto>;
    login(command: LoginCommand): Observable<AuthResponseDto>;
    logout(): Observable<void>;
    me(): Observable<MeDto>;
    refresh(): Observable<AuthResponseDto>;
    resetPassword(command: ResetPasswordCommand): Observable<void>;
    sendInvitation(userId: string): Observable<void>;
    sendPasswordResetLink(email: string): Observable<void>;
    undoImpersonate(): Observable<AuthResponseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    changePassword(command: ChangePasswordCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSignedUrl(command: CreateUrlSignatureCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/GetSignedUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignedUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignedUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSignedUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    impersonate(userId: string): Observable<AuthResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/Impersonate?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponseDto>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<AuthResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    login(command: LoginCommand): Observable<AuthResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponseDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AuthResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    me(): Observable<MeDto> {
        let url_ = this.baseUrl + "/api/Auth/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeDto>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<MeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refresh(): Observable<AuthResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponseDto>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<AuthResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(command: ResetPasswordCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendInvitation(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/SendInvitation?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendPasswordResetLink(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Auth/SendPasswordResetLink?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    undoImpersonate(): Observable<AuthResponseDto> {
        let url_ = this.baseUrl + "/api/Auth/UndoImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponseDto>;
        }));
    }

    protected processUndoImpersonate(response: HttpResponseBase): Observable<AuthResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITimeOffClient {
    getEmployeeBalance(id: string): Observable<EmployeeBalanceDto>;
    getWorkingDays(query: GetWorkingDaysQuery): Observable<number>;
    getVacations(): Observable<LoadResult>;
    getVacationConflicts(query: GetVacationConflictsQuery): Observable<VacationConflictDto[]>;
    createVacation(command: CreateVacationCommand): Observable<string>;
    changeVacationStatus(command: ChangeVacationStatusCommand): Observable<void>;
    getLieuDays(): Observable<LoadResult>;
    createLieuDay(command: CreateLieuDayCommand): Observable<string>;
    changeLieuDayStatus(command: ChangeLieuDayStatusCommand): Observable<void>;
    getPersonalTimes(): Observable<LoadResult>;
    createPersonalTime(command: CreatePersonalTimeCommand): Observable<string>;
    changePersonalTimeStatus(command: ChangePersonalTimeStatusCommand): Observable<void>;
    getFloaterDays(): Observable<LoadResult>;
    createFloaterDay(command: CreateFloaterDayCommand): Observable<string>;
    changeFloaterDayStatus(command: ChangeFloaterDayStatusCommand): Observable<void>;
    getLeaveOfAbsences(): Observable<LoadResult>;
    createLeaveOfAbsence(command: CreateLeaveOfAbsenceCommand): Observable<string>;
    changeLeaveOfAbsenceStatus(command: ChangeLeaveOfAbsenceStatusCommand): Observable<void>;
    getAgencyTimeOffs(): Observable<LoadResult>;
    createAgencyTimeOff(command: CreateAgencyTimeOffCommand): Observable<string>;
    changeAgencyTimeOffStatus(command: ChangeAgencyTimeOffStatusCommand): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class TimeOffClient implements ITimeOffClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEmployeeBalance(id: string): Observable<EmployeeBalanceDto> {
        let url_ = this.baseUrl + "/api/TimeOff/GetEmployeeBalance?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeBalanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeBalanceDto>;
        }));
    }

    protected processGetEmployeeBalance(response: HttpResponseBase): Observable<EmployeeBalanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeBalanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkingDays(query: GetWorkingDaysQuery): Observable<number> {
        let url_ = this.baseUrl + "/api/TimeOff/GetWorkingDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkingDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkingDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetWorkingDays(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacations(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/TimeOff/GetVacations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetVacations(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacationConflicts(query: GetVacationConflictsQuery): Observable<VacationConflictDto[]> {
        let url_ = this.baseUrl + "/api/TimeOff/GetVacationConflicts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacationConflicts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacationConflicts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacationConflictDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacationConflictDto[]>;
        }));
    }

    protected processGetVacationConflicts(response: HttpResponseBase): Observable<VacationConflictDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VacationConflictDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVacation(command: CreateVacationCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeOff/CreateVacation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVacation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVacation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateVacation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeVacationStatus(command: ChangeVacationStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/TimeOff/ChangeVacationStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeVacationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeVacationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeVacationStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLieuDays(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/TimeOff/GetLieuDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLieuDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLieuDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetLieuDays(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLieuDay(command: CreateLieuDayCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeOff/CreateLieuDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLieuDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLieuDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateLieuDay(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeLieuDayStatus(command: ChangeLieuDayStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/TimeOff/ChangeLieuDayStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLieuDayStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLieuDayStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLieuDayStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonalTimes(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/TimeOff/GetPersonalTimes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonalTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalTimes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetPersonalTimes(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPersonalTime(command: CreatePersonalTimeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeOff/CreatePersonalTime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonalTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonalTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePersonalTime(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePersonalTimeStatus(command: ChangePersonalTimeStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/TimeOff/ChangePersonalTimeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePersonalTimeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePersonalTimeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePersonalTimeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFloaterDays(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/TimeOff/GetFloaterDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFloaterDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFloaterDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetFloaterDays(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFloaterDay(command: CreateFloaterDayCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeOff/CreateFloaterDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFloaterDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFloaterDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateFloaterDay(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeFloaterDayStatus(command: ChangeFloaterDayStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/TimeOff/ChangeFloaterDayStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeFloaterDayStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeFloaterDayStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeFloaterDayStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaveOfAbsences(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/TimeOff/GetLeaveOfAbsences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaveOfAbsences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveOfAbsences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetLeaveOfAbsences(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLeaveOfAbsence(command: CreateLeaveOfAbsenceCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeOff/CreateLeaveOfAbsence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLeaveOfAbsence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveOfAbsence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateLeaveOfAbsence(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeLeaveOfAbsenceStatus(command: ChangeLeaveOfAbsenceStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/TimeOff/ChangeLeaveOfAbsenceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLeaveOfAbsenceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLeaveOfAbsenceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLeaveOfAbsenceStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgencyTimeOffs(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/TimeOff/GetAgencyTimeOffs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyTimeOffs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyTimeOffs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAgencyTimeOffs(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAgencyTimeOff(command: CreateAgencyTimeOffCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/TimeOff/CreateAgencyTimeOff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgencyTimeOff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgencyTimeOff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAgencyTimeOff(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeAgencyTimeOffStatus(command: ChangeAgencyTimeOffStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/TimeOff/ChangeAgencyTimeOffStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAgencyTimeOffStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAgencyTimeOffStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeAgencyTimeOffStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmployeesClient {
    clearExceptions(command: ClearExceptionsCommand): Observable<void>;
    getTimeLogs(): Observable<LoadResult>;
    getSchedulerEvents(query: GetSchedulerEventsQuery): Observable<SchedulerEventDto[]>;
    getContactInfo(id: string): Observable<ContactInfoDto>;
    getAlternativeName(id: string): Observable<AlternativeNameDto>;
    getEmergencyDetails(id: string): Observable<EmergencyDetailsDto>;
    getEmployeePosition(id: string): Observable<EmployeePositionDto>;
    getEmploymentDetails(id: string): Observable<EmploymentDetailsDto>;
    getFinancialDetails(id: string): Observable<FinancialDetailsDto>;
    getNestleDetails(id: string): Observable<NestleDetailsDto>;
    getNestleStatus(id: string): Observable<NestleStatusDto>;
    getNestleDeactivationHistory(id: string): Observable<LoadResult>;
    getSecurityPermissions(id: string): Observable<SecurityPermissionsDto>;
    getShiftDetails(id: string): Observable<ShiftDetailsDto>;
    getProfileSupplier(id: string): Observable<ProfileSupplierDto>;
    getProfileCarrier(id: string): Observable<ProfileCarrierDto>;
    getProfileVendor(id: string): Observable<ProfileVendorDto>;
    getProfileCustomer(id: string): Observable<ProfileCustomerDto>;
    getProfileSite(id: string): Observable<ProfileSiteDto>;
    getProfileAgency(id: string): Observable<ProfileAgencyDto>;
    getUserStatus(id: string): Observable<UserStatusDto>;
    getUserHistory(id: string): Observable<LoadResult>;
    updateAlternativeName(command: UpdateAlternativeNameCommand): Observable<void>;
    updateProfileCarrier(command: UpdateProfileCarrierCommand): Observable<void>;
    updateProfileSupplier(command: UpdateProfileSupplierCommand): Observable<void>;
    updateProfileVendor(command: UpdateProfileVendorCommand): Observable<void>;
    updateProfileCustomer(command: UpdateProfileCustomerCommand): Observable<void>;
    updateProfileSite(command: UpdateProfileSiteCommand): Observable<void>;
    updateProfileAgency(command: UpdateProfileAgencyCommand): Observable<void>;
    updateEmploymentDetails(command: UpdateEmploymentDetailsCommand): Observable<void>;
    updateNestleDetails(command: UpdateNestleDetailsCommand): Observable<void>;
    confirmSapNestle(command: ConfirmSapNestleCommand): Observable<void>;
    confirmDwaNestle(command: ConfirmDwaNestleCommand): Observable<void>;
    confirmDwaHopewell(command: ConfirmDwaHopewellCommand): Observable<void>;
    confirmNextViewHopewell(command: ConfirmNextViewHopewellCommand): Observable<void>;
    confirmPasswordReset(command: ConfirmPasswordResetCommand): Observable<void>;
    terminateUser(command: TerminateUserCommand): Observable<void>;
    activateUser(command: ActivateUserCommand): Observable<void>;
    issuePassword(command: IssuePasswordCommand): Observable<void>;
    confirmTermination(command: ConfirmTerminationCommand): Observable<void>;
    confirmDeactivation(command: ConfirmDeactivationCommand): Observable<void>;
    delimitPosition(command: DelimitPositionCommand): Observable<void>;
    suspend(userId: string): Observable<void>;
    updateContactInfo(command: UpdateContactInfoCommand): Observable<void>;
    updateEmergencyDetails(command: UpdateEmergencyDetailsCommand): Observable<void>;
    updateSecurityPermissions(command: UpdateSecurityPermissionsCommand): Observable<void>;
    updateShiftDetails(command: UpdateShiftDetailsCommand): Observable<void>;
    uploadAvatar(employeeId: string): Observable<string>;
    getHuddleList(): Observable<LoadResult>;
    markAsLate(createCommand: MarkAsLateCommand): Observable<void>;
    undoLate(command: UndoLateCommand): Observable<void>;
    createEmployee(createCommand: CreateEmployeeCommand): Observable<string>;
    getEmployeeOptions(id: PermissionType | null | undefined): Observable<LoadResult>;
    getVendorEmployeeOptions(id: string | null | undefined): Observable<LoadResult>;
    getEmployeeList(): Observable<LoadResult>;
    getSupervisorOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeesClient implements IEmployeesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    clearExceptions(command: ClearExceptionsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ClearExceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearExceptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTimeLogs(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetTimeLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetTimeLogs(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSchedulerEvents(query: GetSchedulerEventsQuery): Observable<SchedulerEventDto[]> {
        let url_ = this.baseUrl + "/api/Employees/GetSchedulerEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulerEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulerEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchedulerEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchedulerEventDto[]>;
        }));
    }

    protected processGetSchedulerEvents(response: HttpResponseBase): Observable<SchedulerEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SchedulerEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContactInfo(id: string): Observable<ContactInfoDto> {
        let url_ = this.baseUrl + "/api/Employees/GetContactInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInfoDto>;
        }));
    }

    protected processGetContactInfo(response: HttpResponseBase): Observable<ContactInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAlternativeName(id: string): Observable<AlternativeNameDto> {
        let url_ = this.baseUrl + "/api/Employees/GetAlternativeName?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlternativeName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlternativeName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlternativeNameDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlternativeNameDto>;
        }));
    }

    protected processGetAlternativeName(response: HttpResponseBase): Observable<AlternativeNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlternativeNameDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmergencyDetails(id: string): Observable<EmergencyDetailsDto> {
        let url_ = this.baseUrl + "/api/Employees/GetEmergencyDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmergencyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmergencyDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmergencyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmergencyDetailsDto>;
        }));
    }

    protected processGetEmergencyDetails(response: HttpResponseBase): Observable<EmergencyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmergencyDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeePosition(id: string): Observable<EmployeePositionDto> {
        let url_ = this.baseUrl + "/api/Employees/GetEmployeePosition?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePositionDto>;
        }));
    }

    protected processGetEmployeePosition(response: HttpResponseBase): Observable<EmployeePositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeePositionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmploymentDetails(id: string): Observable<EmploymentDetailsDto> {
        let url_ = this.baseUrl + "/api/Employees/GetEmploymentDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentDetailsDto>;
        }));
    }

    protected processGetEmploymentDetails(response: HttpResponseBase): Observable<EmploymentDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmploymentDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFinancialDetails(id: string): Observable<FinancialDetailsDto> {
        let url_ = this.baseUrl + "/api/Employees/GetFinancialDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialDetailsDto>;
        }));
    }

    protected processGetFinancialDetails(response: HttpResponseBase): Observable<FinancialDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNestleDetails(id: string): Observable<NestleDetailsDto> {
        let url_ = this.baseUrl + "/api/Employees/GetNestleDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNestleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNestleDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NestleDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NestleDetailsDto>;
        }));
    }

    protected processGetNestleDetails(response: HttpResponseBase): Observable<NestleDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NestleDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNestleStatus(id: string): Observable<NestleStatusDto> {
        let url_ = this.baseUrl + "/api/Employees/GetNestleStatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNestleStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNestleStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NestleStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NestleStatusDto>;
        }));
    }

    protected processGetNestleStatus(response: HttpResponseBase): Observable<NestleStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NestleStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNestleDeactivationHistory(id: string): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetNestleDeactivationHistory?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNestleDeactivationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNestleDeactivationHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetNestleDeactivationHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSecurityPermissions(id: string): Observable<SecurityPermissionsDto> {
        let url_ = this.baseUrl + "/api/Employees/GetSecurityPermissions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SecurityPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SecurityPermissionsDto>;
        }));
    }

    protected processGetSecurityPermissions(response: HttpResponseBase): Observable<SecurityPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShiftDetails(id: string): Observable<ShiftDetailsDto> {
        let url_ = this.baseUrl + "/api/Employees/GetShiftDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDetailsDto>;
        }));
    }

    protected processGetShiftDetails(response: HttpResponseBase): Observable<ShiftDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileSupplier(id: string): Observable<ProfileSupplierDto> {
        let url_ = this.baseUrl + "/api/Employees/GetProfileSupplier?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSupplierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSupplierDto>;
        }));
    }

    protected processGetProfileSupplier(response: HttpResponseBase): Observable<ProfileSupplierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSupplierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileCarrier(id: string): Observable<ProfileCarrierDto> {
        let url_ = this.baseUrl + "/api/Employees/GetProfileCarrier?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileCarrierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileCarrierDto>;
        }));
    }

    protected processGetProfileCarrier(response: HttpResponseBase): Observable<ProfileCarrierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileCarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileVendor(id: string): Observable<ProfileVendorDto> {
        let url_ = this.baseUrl + "/api/Employees/GetProfileVendor?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileVendorDto>;
        }));
    }

    protected processGetProfileVendor(response: HttpResponseBase): Observable<ProfileVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileCustomer(id: string): Observable<ProfileCustomerDto> {
        let url_ = this.baseUrl + "/api/Employees/GetProfileCustomer?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileCustomerDto>;
        }));
    }

    protected processGetProfileCustomer(response: HttpResponseBase): Observable<ProfileCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileSite(id: string): Observable<ProfileSiteDto> {
        let url_ = this.baseUrl + "/api/Employees/GetProfileSite?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSiteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSiteDto>;
        }));
    }

    protected processGetProfileSite(response: HttpResponseBase): Observable<ProfileSiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileAgency(id: string): Observable<ProfileAgencyDto> {
        let url_ = this.baseUrl + "/api/Employees/GetProfileAgency?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileAgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileAgencyDto>;
        }));
    }

    protected processGetProfileAgency(response: HttpResponseBase): Observable<ProfileAgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileAgencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserStatus(id: string): Observable<UserStatusDto> {
        let url_ = this.baseUrl + "/api/Employees/GetUserStatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserStatusDto>;
        }));
    }

    protected processGetUserStatus(response: HttpResponseBase): Observable<UserStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserHistory(id: string): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetUserHistory?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetUserHistory(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAlternativeName(command: UpdateAlternativeNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateAlternativeName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlternativeName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlternativeName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAlternativeName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileCarrier(command: UpdateProfileCarrierCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateProfileCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileCarrier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileCarrier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileSupplier(command: UpdateProfileSupplierCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateProfileSupplier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileSupplier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileVendor(command: UpdateProfileVendorCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateProfileVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileVendor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileCustomer(command: UpdateProfileCustomerCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateProfileCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileSite(command: UpdateProfileSiteCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateProfileSite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProfileAgency(command: UpdateProfileAgencyCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateProfileAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfileAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmploymentDetails(command: UpdateEmploymentDetailsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateEmploymentDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmploymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmploymentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmploymentDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNestleDetails(command: UpdateNestleDetailsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateNestleDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNestleDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNestleDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNestleDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmSapNestle(command: ConfirmSapNestleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmSapNestle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmSapNestle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmSapNestle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmSapNestle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmDwaNestle(command: ConfirmDwaNestleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmDwaNestle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmDwaNestle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmDwaNestle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmDwaNestle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmDwaHopewell(command: ConfirmDwaHopewellCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmDwaHopewell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmDwaHopewell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmDwaHopewell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmDwaHopewell(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmNextViewHopewell(command: ConfirmNextViewHopewellCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmNextViewHopewell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmNextViewHopewell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmNextViewHopewell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmNextViewHopewell(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmPasswordReset(command: ConfirmPasswordResetCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmPasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateUser(command: TerminateUserCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/TerminateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateUser(command: ActivateUserCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ActivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    issuePassword(command: IssuePasswordCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/IssuePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIssuePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIssuePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIssuePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmTermination(command: ConfirmTerminationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmTermination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmTermination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmTermination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmTermination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmDeactivation(command: ConfirmDeactivationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/ConfirmDeactivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmDeactivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmDeactivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmDeactivation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delimitPosition(command: DelimitPositionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/DelimitPosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelimitPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelimitPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelimitPosition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    suspend(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/Suspend?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSuspend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateContactInfo(command: UpdateContactInfoCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateContactInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateContactInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEmergencyDetails(command: UpdateEmergencyDetailsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateEmergencyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEmergencyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmergencyDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEmergencyDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSecurityPermissions(command: UpdateSecurityPermissionsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateSecurityPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSecurityPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSecurityPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSecurityPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateShiftDetails(command: UpdateShiftDetailsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UpdateShiftDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShiftDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadAvatar(employeeId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Employees/UploadAvatar?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadAvatar(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHuddleList(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetHuddleList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHuddleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHuddleList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetHuddleList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markAsLate(createCommand: MarkAsLateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/MarkAsLate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsLate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsLate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsLate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    undoLate(command: UndoLateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Employees/UndoLate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoLate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoLate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUndoLate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEmployee(createCommand: CreateEmployeeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Employees/CreateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEmployee(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeOptions(id: PermissionType | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetEmployeeOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmployeeOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVendorEmployeeOptions(id: string | null | undefined): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetVendorEmployeeOptions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorEmployeeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorEmployeeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetVendorEmployeeOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeList(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetEmployeeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetEmployeeList(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSupervisorOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Employees/GetSupervisorOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetSupervisorOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotesClient {
    createEmployeeNote(command: CreateEmployeeNoteCommand): Observable<string>;
    createAssetNote(command: CreateAssetNoteCommand): Observable<string>;
    createChecklistNote(command: CreateChecklistNoteCommand): Observable<string>;
    createIncidentReportNote(command: CreateIncidentReportNoteCommand): Observable<string>;
    createAppointmentNote(command: CreateAppointmentNoteCommand): Observable<string>;
    createEmptyCheckInNote(command: CreateEmptyCheckInNoteCommand): Observable<string>;
    createEmptyCheckOutNote(command: CreateEmptyCheckOutNoteCommand): Observable<string>;
    createInvoicePurchaseOrderNote(command: CreateInvoicePurchaseOrderNoteCommand): Observable<string>;
    createInvoiceNote(command: CreateInvoiceNoteCommand): Observable<string>;
    createCreditRequestNote(command: CreateCreditRequestNoteCommand): Observable<string>;
    getEmployeeNotes(id: string): Observable<ResultOfListOfNoteDto>;
    getAssetNotes(id: string): Observable<ResultOfListOfNoteDto>;
    getChecklistNotes(id: string): Observable<ResultOfListOfNoteDto>;
    getIncidentReportNotes(id: string): Observable<ResultOfListOfNoteDto>;
    getAppointmentNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto>;
    getEmptyCheckInNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto>;
    getEmptyCheckOutNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto>;
    getInvoicePurchaseOrderNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto>;
    getInvoiceNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto>;
    getCreditRequestNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto>;
    exportEmployeeNotes(id: string): Observable<ResultOfExportedFileDto>;
    exportAssetNotes(id: string): Observable<ResultOfExportedFileDto>;
    exportChecklistNotes(id: string): Observable<ResultOfExportedFileDto>;
    exportIncidentReportNotes(id: string): Observable<ResultOfExportedFileDto>;
    exportAppointmentNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto>;
    exportEmptyCheckInNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto>;
    exportEmptyCheckOutNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto>;
    exportInvoicePurchaseOrderNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto>;
    exportInvoiceNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto>;
    exportCreditRequestNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto>;
}

@Injectable({
    providedIn: 'root'
})
export class NotesClient implements INotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createEmployeeNote(command: CreateEmployeeNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateEmployeeNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployeeNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployeeNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEmployeeNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAssetNote(command: CreateAssetNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateAssetNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssetNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssetNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAssetNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChecklistNote(command: CreateChecklistNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateChecklistNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChecklistNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChecklistNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateChecklistNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createIncidentReportNote(command: CreateIncidentReportNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateIncidentReportNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIncidentReportNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIncidentReportNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateIncidentReportNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAppointmentNote(command: CreateAppointmentNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateAppointmentNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAppointmentNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEmptyCheckInNote(command: CreateEmptyCheckInNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateEmptyCheckInNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmptyCheckInNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmptyCheckInNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEmptyCheckInNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEmptyCheckOutNote(command: CreateEmptyCheckOutNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateEmptyCheckOutNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmptyCheckOutNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmptyCheckOutNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEmptyCheckOutNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInvoicePurchaseOrderNote(command: CreateInvoicePurchaseOrderNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateInvoicePurchaseOrderNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoicePurchaseOrderNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoicePurchaseOrderNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateInvoicePurchaseOrderNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInvoiceNote(command: CreateInvoiceNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateInvoiceNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateInvoiceNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCreditRequestNote(command: CreateCreditRequestNoteCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notes/CreateCreditRequestNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCreditRequestNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCreditRequestNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCreditRequestNote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployeeNotes(id: string): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetEmployeeNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetEmployeeNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssetNotes(id: string): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetAssetNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetAssetNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChecklistNotes(id: string): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetChecklistNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklistNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklistNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetChecklistNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIncidentReportNotes(id: string): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetIncidentReportNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncidentReportNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncidentReportNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetIncidentReportNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppointmentNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetAppointmentNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetAppointmentNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckInNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetEmptyCheckInNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckInNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckInNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetEmptyCheckInNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmptyCheckOutNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetEmptyCheckOutNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmptyCheckOutNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmptyCheckOutNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetEmptyCheckOutNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoicePurchaseOrderNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetInvoicePurchaseOrderNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicePurchaseOrderNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicePurchaseOrderNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetInvoicePurchaseOrderNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInvoiceNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetInvoiceNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetInvoiceNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreditRequestNotes(arg1: string | null | undefined): Observable<ResultOfListOfNoteDto> {
        let url_ = this.baseUrl + "/api/Notes/GetCreditRequestNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreditRequestNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditRequestNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfNoteDto>;
        }));
    }

    protected processGetCreditRequestNotes(response: HttpResponseBase): Observable<ResultOfListOfNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEmployeeNotes(id: string): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportEmployeeNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmployeeNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmployeeNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportEmployeeNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAssetNotes(id: string): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportAssetNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAssetNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAssetNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportAssetNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportChecklistNotes(id: string): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportChecklistNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChecklistNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChecklistNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportChecklistNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportIncidentReportNotes(id: string): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportIncidentReportNotes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportIncidentReportNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportIncidentReportNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportIncidentReportNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportAppointmentNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportAppointmentNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAppointmentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAppointmentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportAppointmentNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEmptyCheckInNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportEmptyCheckInNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmptyCheckInNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmptyCheckInNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportEmptyCheckInNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEmptyCheckOutNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportEmptyCheckOutNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmptyCheckOutNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmptyCheckOutNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportEmptyCheckOutNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportInvoicePurchaseOrderNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportInvoicePurchaseOrderNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoicePurchaseOrderNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoicePurchaseOrderNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportInvoicePurchaseOrderNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportInvoiceNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportInvoiceNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoiceNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoiceNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportInvoiceNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCreditRequestNotes(arg1: string | null | undefined): Observable<ResultOfExportedFileDto> {
        let url_ = this.baseUrl + "/api/Notes/ExportCreditRequestNotes?";
        if (arg1 !== undefined && arg1 !== null)
            url_ += "arg1=" + encodeURIComponent("" + arg1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCreditRequestNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCreditRequestNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfExportedFileDto>;
        }));
    }

    protected processExportCreditRequestNotes(response: HttpResponseBase): Observable<ResultOfExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMyScoreClient {
    exportScore(query: ExportScoreQuery): Observable<ExportedFileDto>;
    getAttendanceScore(query: GetAttendanceScoreQuery): Observable<ScoreDto>;
    getAttendanceSummary(query: GetAttendanceSummaryQuery): Observable<AttendanceSummaryDto>;
    getTrending(query: GetAttendanceTrendingQuery): Observable<TrendingDto>;
}

@Injectable({
    providedIn: 'root'
})
export class MyScoreClient implements IMyScoreClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportScore(query: ExportScoreQuery): Observable<ExportedFileDto> {
        let url_ = this.baseUrl + "/api/MyScore/ExportScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportedFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportedFileDto>;
        }));
    }

    protected processExportScore(response: HttpResponseBase): Observable<ExportedFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportedFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendanceScore(query: GetAttendanceScoreQuery): Observable<ScoreDto> {
        let url_ = this.baseUrl + "/api/MyScore/GetAttendanceScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScoreDto>;
        }));
    }

    protected processGetAttendanceScore(response: HttpResponseBase): Observable<ScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttendanceSummary(query: GetAttendanceSummaryQuery): Observable<AttendanceSummaryDto> {
        let url_ = this.baseUrl + "/api/MyScore/GetAttendanceSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendanceSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceSummaryDto>;
        }));
    }

    protected processGetAttendanceSummary(response: HttpResponseBase): Observable<AttendanceSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrending(query: GetAttendanceTrendingQuery): Observable<TrendingDto> {
        let url_ = this.baseUrl + "/api/MyScore/GetTrending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrending(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrending(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendingDto>;
        }));
    }

    protected processGetTrending(response: HttpResponseBase): Observable<TrendingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChangeRequestsClient {
    changeRequestStatus(id: string, status: ChangeRequestStatus): Observable<void>;
    createChangeRequest(createCommand: CreateChangeRequestCommand): Observable<string>;
    getChangeRequests(): Observable<LoadResult>;
    getCurrentValues(employeeId: string): Observable<CurrentValuesDto>;
    viewChangeRequest(id: string): Observable<ChangeRequestViewDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ChangeRequestsClient implements IChangeRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    changeRequestStatus(id: string, status: ChangeRequestStatus): Observable<void> {
        let url_ = this.baseUrl + "/api/ChangeRequests/ChangeRequestStatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeRequestStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChangeRequest(createCommand: CreateChangeRequestCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/ChangeRequests/CreateChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChangeRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateChangeRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(IError.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChangeRequests(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/ChangeRequests/GetChangeRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangeRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangeRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetChangeRequests(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentValues(employeeId: string): Observable<CurrentValuesDto> {
        let url_ = this.baseUrl + "/api/ChangeRequests/GetCurrentValues?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentValuesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentValuesDto>;
        }));
    }

    protected processGetCurrentValues(response: HttpResponseBase): Observable<CurrentValuesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentValuesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    viewChangeRequest(id: string): Observable<ChangeRequestViewDto> {
        let url_ = this.baseUrl + "/api/ChangeRequests/ViewChangeRequest?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewChangeRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeRequestViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeRequestViewDto>;
        }));
    }

    protected processViewChangeRequest(response: HttpResponseBase): Observable<ChangeRequestViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAgenciesClient {
    getAgencyOptions(): Observable<LoadResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AgenciesClient implements IAgenciesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAgencyOptions(): Observable<LoadResult> {
        let url_ = this.baseUrl + "/api/Agencies/GetAgencyOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoadResult>;
        }));
    }

    protected processGetAgencyOptions(response: HttpResponseBase): Observable<LoadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoadResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export abstract class IError implements IIError {
    reasons?: IError[] | undefined;

    constructor(data?: IIError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(IError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IError {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IError' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIError {
    reasons?: IError[] | undefined;
}

export class CompleteAppointmentShuntCommand implements ICompleteAppointmentShuntCommand {
    number?: string;

    constructor(data?: ICompleteAppointmentShuntCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): CompleteAppointmentShuntCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteAppointmentShuntCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data;
    }
}

export interface ICompleteAppointmentShuntCommand {
    number?: string;
}

export class CompleteEmptyCheckInShuntCommand implements ICompleteEmptyCheckInShuntCommand {
    number?: string;

    constructor(data?: ICompleteEmptyCheckInShuntCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): CompleteEmptyCheckInShuntCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteEmptyCheckInShuntCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data;
    }
}

export interface ICompleteEmptyCheckInShuntCommand {
    number?: string;
}

export class CompleteEmptyCheckOutShuntCommand implements ICompleteEmptyCheckOutShuntCommand {
    number?: string;

    constructor(data?: ICompleteEmptyCheckOutShuntCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): CompleteEmptyCheckOutShuntCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteEmptyCheckOutShuntCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data;
    }
}

export interface ICompleteEmptyCheckOutShuntCommand {
    number?: string;
}

export class ShuntMoveViewDto implements IShuntMoveViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerNumber?: string | undefined;
    currentShuntLocation?: string | undefined;
    newShuntLocation?: string | undefined;
    newLocation?: ShuntLocationType | undefined;
    newShuntLocationId?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    notes?: string | undefined;
    employee?: EmployeeDto;
    created?: Date;
    yardEntityType?: YardEntityType;

    constructor(data?: IShuntMoveViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.carrier = _data["carrier"];
            this.trailerNumber = _data["trailerNumber"];
            this.currentShuntLocation = _data["currentShuntLocation"];
            this.newShuntLocation = _data["newShuntLocation"];
            this.newLocation = _data["newLocation"];
            this.newShuntLocationId = _data["newShuntLocationId"];
            this.shuntPriority = _data["shuntPriority"];
            this.notes = _data["notes"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.yardEntityType = _data["yardEntityType"];
        }
    }

    static fromJS(data: any): ShuntMoveViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntMoveViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["carrier"] = this.carrier;
        data["trailerNumber"] = this.trailerNumber;
        data["currentShuntLocation"] = this.currentShuntLocation;
        data["newShuntLocation"] = this.newShuntLocation;
        data["newLocation"] = this.newLocation;
        data["newShuntLocationId"] = this.newShuntLocationId;
        data["shuntPriority"] = this.shuntPriority;
        data["notes"] = this.notes;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["yardEntityType"] = this.yardEntityType;
        return data;
    }
}

export interface IShuntMoveViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerNumber?: string | undefined;
    currentShuntLocation?: string | undefined;
    newShuntLocation?: string | undefined;
    newLocation?: ShuntLocationType | undefined;
    newShuntLocationId?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    notes?: string | undefined;
    employee?: EmployeeDto;
    created?: Date;
    yardEntityType?: YardEntityType;
}

export enum ShuntLocationType {
    Door = "Door",
    Yard = "Yard",
    Office = "Office",
}

export enum ShuntPriority {
    High = "High",
    Medium = "Medium",
    Low = "Low",
}

export class EmployeeDto implements IEmployeeDto {
    id?: string;
    name?: string;
    avatarUrl?: string | undefined;
    email?: string | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.avatarUrl = _data["avatarUrl"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["avatarUrl"] = this.avatarUrl;
        data["email"] = this.email;
        return data;
    }
}

export interface IEmployeeDto {
    id?: string;
    name?: string;
    avatarUrl?: string | undefined;
    email?: string | undefined;
}

export enum YardEntityType {
    Appointment = "Appointment",
    EmptyCheckIn = "EmptyCheckIn",
    EmptyCheckOut = "EmptyCheckOut",
}

export class YardCapacityGridViewDto implements IYardCapacityGridViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerNumber?: string | undefined;
    currentShuntLocation?: string | undefined;
    pendingShuntLocation?: string | undefined;
    created?: Date;
    yardEntityType?: YardEntityType;
    status?: string;

    constructor(data?: IYardCapacityGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.carrier = _data["carrier"];
            this.trailerNumber = _data["trailerNumber"];
            this.currentShuntLocation = _data["currentShuntLocation"];
            this.pendingShuntLocation = _data["pendingShuntLocation"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.yardEntityType = _data["yardEntityType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): YardCapacityGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new YardCapacityGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["carrier"] = this.carrier;
        data["trailerNumber"] = this.trailerNumber;
        data["currentShuntLocation"] = this.currentShuntLocation;
        data["pendingShuntLocation"] = this.pendingShuntLocation;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["yardEntityType"] = this.yardEntityType;
        data["status"] = this.status;
        return data;
    }
}

export interface IYardCapacityGridViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerNumber?: string | undefined;
    currentShuntLocation?: string | undefined;
    pendingShuntLocation?: string | undefined;
    created?: Date;
    yardEntityType?: YardEntityType;
    status?: string;
}

export class ExportedFileDto implements IExportedFileDto {
    fileName?: string;
    content?: string;
    contentType?: string;

    constructor(data?: IExportedFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): ExportedFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportedFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IExportedFileDto {
    fileName?: string;
    content?: string;
    contentType?: string;
}

export class YardCapacityScoreExportQuery implements IYardCapacityScoreExportQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IYardCapacityScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): YardCapacityScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new YardCapacityScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IYardCapacityScoreExportQuery {
    from?: Date;
    to?: Date | undefined;
}

export enum YardCapacityScoreType {
    MainScore = "MainScore",
    Controllable = "Controllable",
    Uncontrollable = "Uncontrollable",
}

export class ScoreDto implements IScoreDto {
    avgScorePercent?: number | undefined;
    totals?: { [key: string]: number; };
    pallet?: { [key: string]: ColorClass; } | undefined;

    constructor(data?: IScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avgScorePercent = _data["avgScorePercent"];
            if (_data["totals"]) {
                this.totals = {} as any;
                for (let key in _data["totals"]) {
                    if (_data["totals"].hasOwnProperty(key))
                        (<any>this.totals)![key] = _data["totals"][key];
                }
            }
            if (_data["pallet"]) {
                this.pallet = {} as any;
                for (let key in _data["pallet"]) {
                    if (_data["pallet"].hasOwnProperty(key))
                        (<any>this.pallet)![key] = _data["pallet"][key];
                }
            }
        }
    }

    static fromJS(data: any): ScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avgScorePercent"] = this.avgScorePercent;
        if (this.totals) {
            data["totals"] = {};
            for (let key in this.totals) {
                if (this.totals.hasOwnProperty(key))
                    (<any>data["totals"])[key] = (<any>this.totals)[key];
            }
        }
        if (this.pallet) {
            data["pallet"] = {};
            for (let key in this.pallet) {
                if (this.pallet.hasOwnProperty(key))
                    (<any>data["pallet"])[key] = (<any>this.pallet)[key];
            }
        }
        return data;
    }
}

export interface IScoreDto {
    avgScorePercent?: number | undefined;
    totals?: { [key: string]: number; };
    pallet?: { [key: string]: ColorClass; } | undefined;
}

export enum ColorClass {
    Primary = "Primary",
    Secondary = "Secondary",
    Success = "Success",
    Info = "Info",
    Warning = "Warning",
    Danger = "Danger",
    Light = "Light",
    Dark = "Dark",
}

export class YardCapacityScoreQuery implements IYardCapacityScoreQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IYardCapacityScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): YardCapacityScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new YardCapacityScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IYardCapacityScoreQuery {
    from?: Date;
    to?: Date | undefined;
}

export class TrendingDto implements ITrendingDto {
    timeSeries?: { [key: string]: number; };

    constructor(data?: ITrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["timeSeries"]) {
                this.timeSeries = {} as any;
                for (let key in _data["timeSeries"]) {
                    if (_data["timeSeries"].hasOwnProperty(key))
                        (<any>this.timeSeries)![key] = _data["timeSeries"][key];
                }
            }
        }
    }

    static fromJS(data: any): TrendingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.timeSeries) {
            data["timeSeries"] = {};
            for (let key in this.timeSeries) {
                if (this.timeSeries.hasOwnProperty(key))
                    (<any>data["timeSeries"])[key] = (<any>this.timeSeries)[key];
            }
        }
        return data;
    }
}

export interface ITrendingDto {
    timeSeries?: { [key: string]: number; };
}

export class TrendingQuery implements ITrendingQuery {
    userId?: string | undefined;
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;

    constructor(data?: ITrendingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.aggregateType = _data["aggregateType"];
        }
    }

    static fromJS(data: any): TrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TrendingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["aggregateType"] = this.aggregateType;
        return data;
    }
}

export interface ITrendingQuery {
    userId?: string | undefined;
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;
}

export class YardCapacityTrendingQuery extends TrendingQuery implements IYardCapacityTrendingQuery {

    constructor(data?: IYardCapacityTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): YardCapacityTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new YardCapacityTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IYardCapacityTrendingQuery extends ITrendingQuery {
}

export enum AggregateType {
    Day = "Day",
    Week = "Week",
    Month = "Month",
}

export class EmptyTrailerScoreExportQuery implements IEmptyTrailerScoreExportQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IEmptyTrailerScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyTrailerScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyTrailerScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IEmptyTrailerScoreExportQuery {
    from?: Date;
    to?: Date | undefined;
}

export enum EmptyTrailerScoreType {
    MainScore = "MainScore",
    Required = "Required",
    NotRequired = "NotRequired",
}

export class EmptyTrailerScoreQuery implements IEmptyTrailerScoreQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IEmptyTrailerScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyTrailerScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyTrailerScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IEmptyTrailerScoreQuery {
    from?: Date;
    to?: Date | undefined;
}

export abstract class MyScoreQueryOfExportedFileDto implements IMyScoreQueryOfExportedFileDto {
    from?: Date;
    to?: Date | undefined;
    userId?: string | undefined;

    constructor(data?: IMyScoreQueryOfExportedFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MyScoreQueryOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreQueryOfExportedFileDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMyScoreQueryOfExportedFileDto {
    from?: Date;
    to?: Date | undefined;
    userId?: string | undefined;
}

export class ShuntProductivityScoreExportQuery extends MyScoreQueryOfExportedFileDto implements IShuntProductivityScoreExportQuery {

    constructor(data?: IShuntProductivityScoreExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ShuntProductivityScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntProductivityScoreExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IShuntProductivityScoreExportQuery extends IMyScoreQueryOfExportedFileDto {
}

export abstract class MyScoreQueryOfScoreDto implements IMyScoreQueryOfScoreDto {
    from?: Date;
    to?: Date | undefined;
    userId?: string | undefined;

    constructor(data?: IMyScoreQueryOfScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MyScoreQueryOfScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreQueryOfScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMyScoreQueryOfScoreDto {
    from?: Date;
    to?: Date | undefined;
    userId?: string | undefined;
}

export class ShuntProductivityScoreQuery extends MyScoreQueryOfScoreDto implements IShuntProductivityScoreQuery {

    constructor(data?: IShuntProductivityScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ShuntProductivityScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntProductivityScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IShuntProductivityScoreQuery extends IMyScoreQueryOfScoreDto {
}

export class ShuntProductivityTrendingQuery extends TrendingQuery implements IShuntProductivityTrendingQuery {

    constructor(data?: IShuntProductivityTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ShuntProductivityTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntProductivityTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IShuntProductivityTrendingQuery extends ITrendingQuery {
}

export class LoadResult implements ILoadResult {
    data?: IEnumerable | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.totalCount = -1;
            this.groupCount = -1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? IEnumerable.fromJS(_data["data"]) : <any>undefined;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : -1;
            this.groupCount = _data["groupCount"] !== undefined ? _data["groupCount"] : -1;
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResult {
    data?: IEnumerable | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export abstract class IEnumerable implements IIEnumerable {

    constructor(data?: IIEnumerable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEnumerable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEnumerable' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIEnumerable {
}

export class CreateShiftCommand implements ICreateShiftCommand {
    shiftType?: ShiftType;
    shiftStart?: string;
    shiftEnd?: string;
    code?: string;
    days?: DayOfWeek[];
    supervisorId?: string;
    premiumRate?: number;
    locked?: boolean;
    hasMealTicked?: boolean;
    showInHuddle?: boolean;
    mealTickedRoles?: string[];

    constructor(data?: ICreateShiftCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftType = _data["shiftType"];
            this.shiftStart = _data["shiftStart"];
            this.shiftEnd = _data["shiftEnd"];
            this.code = _data["code"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            this.supervisorId = _data["supervisorId"];
            this.premiumRate = _data["premiumRate"];
            this.locked = _data["locked"];
            this.hasMealTicked = _data["hasMealTicked"];
            this.showInHuddle = _data["showInHuddle"];
            if (Array.isArray(_data["mealTickedRoles"])) {
                this.mealTickedRoles = [] as any;
                for (let item of _data["mealTickedRoles"])
                    this.mealTickedRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateShiftCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftType"] = this.shiftType;
        data["shiftStart"] = this.shiftStart;
        data["shiftEnd"] = this.shiftEnd;
        data["code"] = this.code;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["supervisorId"] = this.supervisorId;
        data["premiumRate"] = this.premiumRate;
        data["locked"] = this.locked;
        data["hasMealTicked"] = this.hasMealTicked;
        data["showInHuddle"] = this.showInHuddle;
        if (Array.isArray(this.mealTickedRoles)) {
            data["mealTickedRoles"] = [];
            for (let item of this.mealTickedRoles)
                data["mealTickedRoles"].push(item);
        }
        return data;
    }
}

export interface ICreateShiftCommand {
    shiftType?: ShiftType;
    shiftStart?: string;
    shiftEnd?: string;
    code?: string;
    days?: DayOfWeek[];
    supervisorId?: string;
    premiumRate?: number;
    locked?: boolean;
    hasMealTicked?: boolean;
    showInHuddle?: boolean;
    mealTickedRoles?: string[];
}

export enum ShiftType {
    Day = "Day",
    Afternoons = "Afternoons",
    WeekendDays = "WeekendDays",
    WeekendNights = "WeekendNights",
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class ShiftDto implements IShiftDto {
    id?: string;
    shiftType?: ShiftType;
    shiftStart?: string;
    shiftEnd?: string;
    code?: string;
    days?: DayOfWeek[];
    supervisorId?: string;
    locked?: boolean;
    hasMealTicked?: boolean;
    showInHuddle?: boolean;
    premiumRate?: number;
    mealTickedRoles?: string[];

    constructor(data?: IShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shiftType = _data["shiftType"];
            this.shiftStart = _data["shiftStart"];
            this.shiftEnd = _data["shiftEnd"];
            this.code = _data["code"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            this.supervisorId = _data["supervisorId"];
            this.locked = _data["locked"];
            this.hasMealTicked = _data["hasMealTicked"];
            this.showInHuddle = _data["showInHuddle"];
            this.premiumRate = _data["premiumRate"];
            if (Array.isArray(_data["mealTickedRoles"])) {
                this.mealTickedRoles = [] as any;
                for (let item of _data["mealTickedRoles"])
                    this.mealTickedRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): ShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shiftType"] = this.shiftType;
        data["shiftStart"] = this.shiftStart;
        data["shiftEnd"] = this.shiftEnd;
        data["code"] = this.code;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["supervisorId"] = this.supervisorId;
        data["locked"] = this.locked;
        data["hasMealTicked"] = this.hasMealTicked;
        data["showInHuddle"] = this.showInHuddle;
        data["premiumRate"] = this.premiumRate;
        if (Array.isArray(this.mealTickedRoles)) {
            data["mealTickedRoles"] = [];
            for (let item of this.mealTickedRoles)
                data["mealTickedRoles"].push(item);
        }
        return data;
    }
}

export interface IShiftDto {
    id?: string;
    shiftType?: ShiftType;
    shiftStart?: string;
    shiftEnd?: string;
    code?: string;
    days?: DayOfWeek[];
    supervisorId?: string;
    locked?: boolean;
    hasMealTicked?: boolean;
    showInHuddle?: boolean;
    premiumRate?: number;
    mealTickedRoles?: string[];
}

export class GetShiftQuery implements IGetShiftQuery {
    shiftId?: string;

    constructor(data?: IGetShiftQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): GetShiftQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetShiftQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        return data;
    }
}

export interface IGetShiftQuery {
    shiftId?: string;
}

export class UpdateShiftCommand extends CreateShiftCommand implements IUpdateShiftCommand {
    shiftId?: string;

    constructor(data?: IUpdateShiftCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiftId = _data["shiftId"];
        }
    }

    static override fromJS(data: any): UpdateShiftCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShiftCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateShiftCommand extends ICreateShiftCommand {
    shiftId?: string;
}

export class CreateRoleCommand implements ICreateRoleCommand {
    name?: string;
    description?: string | undefined;
    access?: PermissionDto[];

    constructor(data?: ICreateRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["access"])) {
                this.access = [] as any;
                for (let item of _data["access"])
                    this.access!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.access)) {
            data["access"] = [];
            for (let item of this.access)
                data["access"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateRoleCommand {
    name?: string;
    description?: string | undefined;
    access?: PermissionDto[];
}

export class PermissionDto implements IPermissionDto {
    permissionType?: PermissionType;
    accessType?: AccessType;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionType = _data["permissionType"];
            this.accessType = _data["accessType"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionType"] = this.permissionType;
        data["accessType"] = this.accessType;
        return data;
    }
}

export interface IPermissionDto {
    permissionType?: PermissionType;
    accessType?: AccessType;
}

export enum PermissionType {
    DashboardMyScore = "DashboardMyScore",
    MyScore = "MyScore",
    MyScoreAttendance = "MyScoreAttendance",
    MyScoreFinancialDetails = "MyScoreFinancialDetails",
    MyScoreTrending = "MyScoreTrending",
    EmployeesList = "EmployeesList",
    CreateNewEmployee = "CreateNewEmployee",
    UserContactInformationOwn = "UserContactInformationOwn",
    UserContactInformationOthers = "UserContactInformationOthers",
    UserAlternateNamesOwn = "UserAlternateNamesOwn",
    UserAlternateNamesOthers = "UserAlternateNamesOthers",
    UserPasswordResetOwn = "UserPasswordResetOwn",
    UserPasswordResetOthers = "UserPasswordResetOthers",
    UserNotesOwn = "UserNotesOwn",
    UserNotesOthers = "UserNotesOthers",
    UserSecurityAndPermissionsOwn = "UserSecurityAndPermissionsOwn",
    UserSecurityAndPermissionsOthers = "UserSecurityAndPermissionsOthers",
    UserProfileHistoryOwn = "UserProfileHistoryOwn",
    UserProfileHistoryOthers = "UserProfileHistoryOthers",
    Impersonate = "Impersonate",
    SendInvitationEmail = "SendInvitationEmail",
    DeactivateUser = "DeactivateUser",
    TerminateUser = "TerminateUser",
    ConfirmTermination = "ConfirmTermination",
    ConfirmDeactivation = "ConfirmDeactivation",
    DelimitPosition = "DelimitPosition",
    ActivateUser = "ActivateUser",
    IssuePassword = "IssuePassword",
    UserEmergencyDetailsOwn = "UserEmergencyDetailsOwn",
    UserEmergencyDetailsOthers = "UserEmergencyDetailsOthers",
    EmployeeShiftDetailsOwn = "EmployeeShiftDetailsOwn",
    EmployeeShiftDetailsOthers = "EmployeeShiftDetailsOthers",
    EmployeeFinancialDetailsOwn = "EmployeeFinancialDetailsOwn",
    EmployeeFinancialDetailsOthers = "EmployeeFinancialDetailsOthers",
    EmployeeEmploymentDetailsOwn = "EmployeeEmploymentDetailsOwn",
    EmployeeEmploymentDetailsOthers = "EmployeeEmploymentDetailsOthers",
    EmployeeNestleDetailsOwn = "EmployeeNestleDetailsOwn",
    EmployeeNestleDetailsOthers = "EmployeeNestleDetailsOthers",
    ConfirmSapNestle = "ConfirmSapNestle",
    ConfirmDwaNestle = "ConfirmDwaNestle",
    ConfirmDwaHopewell = "ConfirmDwaHopewell",
    ConfirmNextViewHopewell = "ConfirmNextViewHopewell",
    ConfirmPasswordReset = "ConfirmPasswordReset",
    UserSupplierDetailsOwn = "UserSupplierDetailsOwn",
    UserSupplierDetailsOthers = "UserSupplierDetailsOthers",
    UserCarrierDetailsOwn = "UserCarrierDetailsOwn",
    UserCarrierDetailsOthers = "UserCarrierDetailsOthers",
    UserVendorDetailsOwn = "UserVendorDetailsOwn",
    UserVendorDetailsOthers = "UserVendorDetailsOthers",
    UserCustomerDetailsOwn = "UserCustomerDetailsOwn",
    UserCustomerDetailsOthers = "UserCustomerDetailsOthers",
    UserSiteDetailsOwn = "UserSiteDetailsOwn",
    UserSiteDetailsOthers = "UserSiteDetailsOthers",
    UserAgencyDetailsOwn = "UserAgencyDetailsOwn",
    UserAgencyDetailsOthers = "UserAgencyDetailsOthers",
    TimeLogs = "TimeLogs",
    EditTimeLogs = "EditTimeLogs",
    TimeLogShiftRate = "TimeLogShiftRate",
    Schedule = "Schedule",
    Huddle = "Huddle",
    VacationRequests = "VacationRequests",
    LieuDayRequests = "LieuDayRequests",
    PersonalTimeRequests = "PersonalTimeRequests",
    FloaterDayRequests = "FloaterDayRequests",
    LeaveOfAbsenceRequests = "LeaveOfAbsenceRequests",
    AgencyTimeOffRequests = "AgencyTimeOffRequests",
    InformationChangeRequestsList = "InformationChangeRequestsList",
    InformationChangeRequestsStatusChange = "InformationChangeRequestsStatusChange",
    HrApprovalInformationChange = "HrApprovalInformationChange",
    UserList = "UserList",
    UserRoles = "UserRoles",
    EmployeeShifts = "EmployeeShifts",
    FileImports = "FileImports",
    Emails = "Emails",
    Assets = "Assets",
    Checklist = "Checklist",
    ChecklistRepair = "ChecklistRepair",
    ChecklistCompliance = "ChecklistCompliance",
    ChecklistCondition = "ChecklistCondition",
    InventoryMaterials = "InventoryMaterials",
    InventoryBins = "InventoryBins",
    InventoryHALB = "InventoryHALB",
    InventoryStorageUnits = "InventoryStorageUnits",
    InventoryStorageUnits210 = "InventoryStorageUnits210",
    InventoryStorageUnits216 = "InventoryStorageUnits216",
    InventoryStorageUnits260 = "InventoryStorageUnits260",
    InventoryStorageUnits999 = "InventoryStorageUnits999",
    InventoryStorageUnitsLT22 = "InventoryStorageUnitsLT22",
    InventoryFacilityUtilization = "InventoryFacilityUtilization",
    FacilityCapacity = "FacilityCapacity",
    IncidentReport = "IncidentReport",
    IncidentReportApproval = "IncidentReportApproval",
    IncidentReports = "IncidentReports",
    SLA = "SLA",
    BlockedStock = "BlockedStock",
    MB51 = "MB51",
    ImportEmployees = "ImportEmployees",
    ImportVacations = "ImportVacations",
    ImportMaterials = "ImportMaterials",
    ImportBins = "ImportBins",
    ImportHALB = "ImportHALB",
    ImportStorageUnits = "ImportStorageUnits",
    ImportStorageUnits210 = "ImportStorageUnits210",
    ImportStorageUnits216 = "ImportStorageUnits216",
    ImportStorageUnits260 = "ImportStorageUnits260",
    ImportStorageUnits999 = "ImportStorageUnits999",
    ImportStorageUnitsLT22 = "ImportStorageUnitsLT22",
    ImportPurchaseOrders = "ImportPurchaseOrders",
    ImportBlockedStock = "ImportBlockedStock",
    ImportMB51 = "ImportMB51",
    ImportNextView = "ImportNextView",
    ImportYearToDate = "ImportYearToDate",
    ImportOrders = "ImportOrders",
    ImportTmReport = "ImportTmReport",
    ImportGlCodes = "ImportGlCodes",
    Suppliers = "Suppliers",
    Carriers = "Carriers",
    Appointments = "Appointments",
    AppointmentDetails = "AppointmentDetails",
    AppointmentGuardHouse = "AppointmentGuardHouse",
    AppointmentCompliance = "AppointmentCompliance",
    AppointmentHistory = "AppointmentHistory",
    AppointmentSubmit = "AppointmentSubmit",
    AppointmentApprove = "AppointmentApprove",
    AppointmentDecline = "AppointmentDecline",
    AppointmentSendBack = "AppointmentSendBack",
    AppointmentNoShow = "AppointmentNoShow",
    AppointmentCheckIn = "AppointmentCheckIn",
    AppointmentShuntMove = "AppointmentShuntMove",
    AppointmentCompleteMove = "AppointmentCompleteMove",
    AppointmentTagsAsnPgiRequired = "AppointmentTagsAsnPgiRequired",
    AppointmentTagsAsnPgiConfirmed = "AppointmentTagsAsnPgiConfirmed",
    AppointmentInvestigate = "AppointmentInvestigate",
    AppointmentInvestigationCompleted = "AppointmentInvestigationCompleted",
    AppointmentRefuseLoad = "AppointmentRefuseLoad",
    AppointmentAcceptLoad = "AppointmentAcceptLoad",
    AppointmentAssignToUnload = "AppointmentAssignToUnload",
    AppointmentComplete = "AppointmentComplete",
    AppointmentCheckOut = "AppointmentCheckOut",
    PurchaseOrders = "PurchaseOrders",
    Orders = "Orders",
    MyScoreOrderPlanningMix = "MyScoreOrderPlanningMix",
    MyScorePreProductionOrders = "MyScorePreProductionOrders",
    MyScorePostProductionMdt = "MyScorePostProductionMdt",
    Customers = "Customers",
    EmptyCheckIns = "EmptyCheckIns",
    EmptyCheckInDetails = "EmptyCheckInDetails",
    EmptyCheckInHistory = "EmptyCheckInHistory",
    EmptyCheckInCheckIn = "EmptyCheckInCheckIn",
    EmptyCheckInNotRequired = "EmptyCheckInNotRequired",
    EmptyCheckInRequired = "EmptyCheckInRequired",
    EmptyCheckInShuntMove = "EmptyCheckInShuntMove",
    EmptyCheckInCompleteMove = "EmptyCheckInCompleteMove",
    EmptyCheckInInvestigate = "EmptyCheckInInvestigate",
    EmptyCheckInInvestigationCompleted = "EmptyCheckInInvestigationCompleted",
    EmptyCheckInCheckOut = "EmptyCheckInCheckOut",
    EmptyCheckInStartLoading = "EmptyCheckInStartLoading",
    EmptyCheckInMarkAsLoaded = "EmptyCheckInMarkAsLoaded",
    EmptyCheckOuts = "EmptyCheckOuts",
    EmptyCheckOutDetails = "EmptyCheckOutDetails",
    EmptyCheckOutHistory = "EmptyCheckOutHistory",
    EmptyCheckOutShuntMove = "EmptyCheckOutShuntMove",
    EmptyCheckOutCompleteMove = "EmptyCheckOutCompleteMove",
    EmptyCheckOutInvestigate = "EmptyCheckOutInvestigate",
    EmptyCheckOutInvestigationCompleted = "EmptyCheckOutInvestigationCompleted",
    EmptyCheckOutCheckOut = "EmptyCheckOutCheckOut",
    AppointmentCalendar = "AppointmentCalendar",
    AppointmentAgingScore = "AppointmentAgingScore",
    InboundProductivityScore = "InboundProductivityScore",
    AppointmentComplianceScore = "AppointmentComplianceScore",
    AppointmentSupplierComplianceScore = "AppointmentSupplierComplianceScore",
    TagsRequiredScore = "TagsRequiredScore",
    ShuntManagement = "ShuntManagement",
    YardCapacity = "YardCapacity",
    Performance = "Performance",
    NextView = "NextView",
    YearToDate = "YearToDate",
    ProductivitySettings = "ProductivitySettings",
    DeleteProductivityReport = "DeleteProductivityReport",
    YardCapacityScore = "YardCapacityScore",
    ShuntProductivityScore = "ShuntProductivityScore",
    EmptyTrailerAgingScore = "EmptyTrailerAgingScore",
    Vendors = "Vendors",
    MyScoreVendors = "MyScoreVendors",
    MyScoreOperationsL1 = "MyScoreOperationsL1",
    MyScoreOperationsL2 = "MyScoreOperationsL2",
    MyScoreOperationsL3 = "MyScoreOperationsL3",
    MyScoreFinanceInvoices = "MyScoreFinanceInvoices",
    MyScoreCreditRequests = "MyScoreCreditRequests",
    GlCodes = "GlCodes",
    GlCodesClients = "GlCodesClients",
    ServiceTypes = "ServiceTypes",
    InvoicePurchaseOrders = "InvoicePurchaseOrders",
    InvoicePurchaseOrderDetails = "InvoicePurchaseOrderDetails",
    InvoicePurchaseOrderHistory = "InvoicePurchaseOrderHistory",
    InvoicePurchaseSubmit = "InvoicePurchaseSubmit",
    InvoicePurchaseCancel = "InvoicePurchaseCancel",
    InvoicePurchaseOrderGlCodes = "InvoicePurchaseOrderGlCodes",
    InvoicePurchaseOrderNotes = "InvoicePurchaseOrderNotes",
    InvoicePurchaseOrderInternalNotes = "InvoicePurchaseOrderInternalNotes",
    ConversionRates = "ConversionRates",
    MustDepartTimes = "MustDepartTimes",
    Invoices = "Invoices",
    InvoiceDetails = "InvoiceDetails",
    InvoiceHistory = "InvoiceHistory",
    InvoiceSubmit = "InvoiceSubmit",
    InvoiceApproveL1 = "InvoiceApproveL1",
    InvoiceApproveL2 = "InvoiceApproveL2",
    InvoiceApproveL3 = "InvoiceApproveL3",
    InvoiceBackToVendor = "InvoiceBackToVendor",
    InvoiceDecline = "InvoiceDecline",
    InvoiceInvestigate = "InvoiceInvestigate",
    InvoiceInvestigationCompleted = "InvoiceInvestigationCompleted",
    InvoiceOnHold = "InvoiceOnHold",
    InvoiceResumeInvoice = "InvoiceResumeInvoice",
    InvoicePosted = "InvoicePosted",
    InvoiceUndoToPendingAP = "InvoiceUndoToPendingAP",
    InvoiceGlCodes = "InvoiceGlCodes",
    InvoiceBackToL1 = "InvoiceBackToL1",
    InvoiceNotes = "InvoiceNotes",
    InvoiceInternalNotes = "InvoiceInternalNotes",
    CreditRequests = "CreditRequests",
    CreditRequestDetails = "CreditRequestDetails",
    CreditRequestHistory = "CreditRequestHistory",
    CreditRequestSubmit = "CreditRequestSubmit",
    CreditRequestCancel = "CreditRequestCancel",
    CreditRequestComplete = "CreditRequestComplete",
    CreditRequestBackToAP = "CreditRequestBackToAP",
    CreditRequestGlCodes = "CreditRequestGlCodes",
    CreditRequestNotes = "CreditRequestNotes",
    CreditRequestInternalNotes = "CreditRequestInternalNotes",
}

export enum AccessType {
    Hidden = "Hidden",
    ViewOnly = "ViewOnly",
    Edit = "Edit",
    Manage = "Manage",
}

export class PermissionHierarchyDto implements IPermissionHierarchyDto {
    data?: PermissionGroup[];

    constructor(data?: IPermissionHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PermissionGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionHierarchyDto {
    data?: PermissionGroup[];
}

export class PermissionGroup implements IPermissionGroup {
    name?: string;
    permissionLines?: PermissionLine[];

    constructor(data?: IPermissionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["permissionLines"])) {
                this.permissionLines = [] as any;
                for (let item of _data["permissionLines"])
                    this.permissionLines!.push(PermissionLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.permissionLines)) {
            data["permissionLines"] = [];
            for (let item of this.permissionLines)
                data["permissionLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionGroup {
    name?: string;
    permissionLines?: PermissionLine[];
}

export class PermissionLine implements IPermissionLine {
    permissionType?: PermissionType;
    excludeAccessTypes?: AccessType[];

    constructor(data?: IPermissionLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionType = _data["permissionType"];
            if (Array.isArray(_data["excludeAccessTypes"])) {
                this.excludeAccessTypes = [] as any;
                for (let item of _data["excludeAccessTypes"])
                    this.excludeAccessTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): PermissionLine {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionType"] = this.permissionType;
        if (Array.isArray(this.excludeAccessTypes)) {
            data["excludeAccessTypes"] = [];
            for (let item of this.excludeAccessTypes)
                data["excludeAccessTypes"].push(item);
        }
        return data;
    }
}

export interface IPermissionLine {
    permissionType?: PermissionType;
    excludeAccessTypes?: AccessType[];
}

export class RoleDto implements IRoleDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissions?: PermissionDto[];

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    permissions?: PermissionDto[];
}

export class GetRoleQuery implements IGetRoleQuery {
    roleId?: string;

    constructor(data?: IGetRoleQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): GetRoleQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IGetRoleQuery {
    roleId?: string;
}

export class UpdateRoleCommand implements IUpdateRoleCommand {
    roleId?: string;
    name?: string;
    description?: string | undefined;
    access?: PermissionDto[];

    constructor(data?: IUpdateRoleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["access"])) {
                this.access = [] as any;
                for (let item of _data["access"])
                    this.access!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.access)) {
            data["access"] = [];
            for (let item of this.access)
                data["access"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateRoleCommand {
    roleId?: string;
    name?: string;
    description?: string | undefined;
    access?: PermissionDto[];
}

export class CreateMustDepartTimeCommand implements ICreateMustDepartTimeCommand {
    city?: string;
    province?: Province;
    country?: Country;
    shipToTimeZone?: ShipToTimeZone;
    dropToHdcHours?: number;
    mdtHopewell?: string | undefined;
    travelTimeHours?: number;

    constructor(data?: ICreateMustDepartTimeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.shipToTimeZone = _data["shipToTimeZone"];
            this.dropToHdcHours = _data["dropToHdcHours"];
            this.mdtHopewell = _data["mdtHopewell"];
            this.travelTimeHours = _data["travelTimeHours"];
        }
    }

    static fromJS(data: any): CreateMustDepartTimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMustDepartTimeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["shipToTimeZone"] = this.shipToTimeZone;
        data["dropToHdcHours"] = this.dropToHdcHours;
        data["mdtHopewell"] = this.mdtHopewell;
        data["travelTimeHours"] = this.travelTimeHours;
        return data;
    }
}

export interface ICreateMustDepartTimeCommand {
    city?: string;
    province?: Province;
    country?: Country;
    shipToTimeZone?: ShipToTimeZone;
    dropToHdcHours?: number;
    mdtHopewell?: string | undefined;
    travelTimeHours?: number;
}

export enum Province {
    Alberta = "Alberta",
    BritishColumbia = "BritishColumbia",
    Manitoba = "Manitoba",
    NewBrunswick = "NewBrunswick",
    NewfoundlandAndLabrador = "NewfoundlandAndLabrador",
    NorthwestTerritories = "NorthwestTerritories",
    NovaScotia = "NovaScotia",
    Nunavut = "Nunavut",
    Ontario = "Ontario",
    PrinceEdwardIsland = "PrinceEdwardIsland",
    Quebec = "Quebec",
    Saskatchewan = "Saskatchewan",
    Yukon = "Yukon",
}

export enum Country {
    Canada = "Canada",
}

export enum ShipToTimeZone {
    NewfoundlandTime = "NewfoundlandTime",
    AtlanticTime = "AtlanticTime",
    EasternTime = "EasternTime",
    CentralTime = "CentralTime",
    MountainTime = "MountainTime",
    PacificTime = "PacificTime",
    SaskatchewanTime = "SaskatchewanTime",
    YukonTime = "YukonTime",
}

export class UpdateMustDepartTimeCommand extends CreateMustDepartTimeCommand implements IUpdateMustDepartTimeCommand {
    id?: string;

    constructor(data?: IUpdateMustDepartTimeCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateMustDepartTimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMustDepartTimeCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMustDepartTimeCommand extends ICreateMustDepartTimeCommand {
    id?: string;
}

export class EmailLogGridViewDto implements IEmailLogGridViewDto {
    id?: string;
    type?: NotificationType;
    subject?: string | undefined;
    to?: string;
    cc?: string | undefined;
    created?: Date;

    constructor(data?: IEmailLogGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailLogGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLogGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmailLogGridViewDto {
    id?: string;
    type?: NotificationType;
    subject?: string | undefined;
    to?: string;
    cc?: string | undefined;
    created?: Date;
}

export class EmailLogDto extends EmailLogGridViewDto implements IEmailLogDto {
    body?: string | undefined;

    constructor(data?: IEmailLogDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"];
        }
    }

    static override fromJS(data: any): EmailLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLogDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailLogDto extends IEmailLogGridViewDto {
    body?: string | undefined;
}

export enum NotificationType {
    UserPlatformInvitation = "UserPlatformInvitation",
    UserPasswordReset = "UserPasswordReset",
    EmployeeArrivedLate = "EmployeeArrivedLate",
    EmployeeLeftEarly = "EmployeeLeftEarly",
    EmployeeAbsent = "EmployeeAbsent",
    EmployeeLateToHuddle = "EmployeeLateToHuddle",
    EmployeeTimeOffRequestApproved = "EmployeeTimeOffRequestApproved",
    EmployeeTimeOffRequestDeclined = "EmployeeTimeOffRequestDeclined",
    EmployeeInformationChangeRequestApproved = "EmployeeInformationChangeRequestApproved",
    EmployeeInformationChangeRequestDeclined = "EmployeeInformationChangeRequestDeclined",
    SupervisorMissingContactInformation = "SupervisorMissingContactInformation",
    SupervisorMissingAdpInformation = "SupervisorMissingAdpInformation",
    SupervisorPendingTimeOffRequest = "SupervisorPendingTimeOffRequest",
    SupervisorWithdrawnTimeOffRequest = "SupervisorWithdrawnTimeOffRequest",
    SupervisorPendingInformationChangeRequest = "SupervisorPendingInformationChangeRequest",
    SupervisorSentToHrInformationChangeRequest = "SupervisorSentToHrInformationChangeRequest",
    SupervisorWithdrawnInformationChangeRequest = "SupervisorWithdrawnInformationChangeRequest",
    SupervisorMheChecklistDefectReport = "SupervisorMheChecklistDefectReport",
    SupervisorMheChecklistRepairCompleted = "SupervisorMheChecklistRepairCompleted",
    SupervisorMheChecklistsNotSubmitted = "SupervisorMheChecklistsNotSubmitted",
    IncidentReportReadyForApproval = "IncidentReportReadyForApproval",
    AppointmentSubmitted = "AppointmentSubmitted",
    AppointmentSentBack = "AppointmentSentBack",
    AppointmentDeclined = "AppointmentDeclined",
    AppointmentApproved = "AppointmentApproved",
    AppointmentNoShow = "AppointmentNoShow",
    AppointmentRefused = "AppointmentRefused",
    AppointmentAccepted = "AppointmentAccepted",
    AppointmentTagsRequired = "AppointmentTagsRequired",
    AppointmentTagsCompleted = "AppointmentTagsCompleted",
    AppointmentCompleted = "AppointmentCompleted",
    EmptyCheckInRequired = "EmptyCheckInRequired",
    EmptyCheckInNotRequired = "EmptyCheckInNotRequired",
    EmptyCheckInNotRequiredAfterTwelveHours = "EmptyCheckInNotRequiredAfterTwelveHours",
    CheckOutCompleted = "CheckOutCompleted",
    InvestigationStarted = "InvestigationStarted",
    InvestigationCompleted = "InvestigationCompleted",
    InvoicePurchaseOrderCreated = "InvoicePurchaseOrderCreated",
    InvoicePurchaseOrderCancelled = "InvoicePurchaseOrderCancelled",
    InvoicePurchaseOrderInvoiceMissed = "InvoicePurchaseOrderInvoiceMissed",
    InvoiceL1Approval = "InvoiceL1Approval",
    InvoiceL2Approval = "InvoiceL2Approval",
    InvoiceL3Approval = "InvoiceL3Approval",
    InvoicePendingAP = "InvoicePendingAP",
    InvoiceInvestigation = "InvoiceInvestigation",
    InvoiceInvestigationCompleted = "InvoiceInvestigationCompleted",
    InvoiceSentBackToVendor = "InvoiceSentBackToVendor",
    InvoiceInvoiceDeclined = "InvoiceInvoiceDeclined",
    InvoiceInvoicePosted = "InvoiceInvoicePosted",
    CreditRequestPendingAP = "CreditRequestPendingAP",
    CreditRequestCompleted = "CreditRequestCompleted",
    StatusChangeSapPendingNestle = "StatusChangeSapPendingNestle",
    StatusChangeDwaPendingHopewell = "StatusChangeDwaPendingHopewell",
    StatusChangeTerminationOrDeactivationPending = "StatusChangeTerminationOrDeactivationPending",
    StatusChangePasswordResetRequired = "StatusChangePasswordResetRequired",
    DailyReminderNestlePendingActions = "DailyReminderNestlePendingActions",
    DailyReminderHopewellPendingActions = "DailyReminderHopewellPendingActions",
    DailyReminderPendingOffboarding = "DailyReminderPendingOffboarding",
    DailyReminderPasswordResetRequired = "DailyReminderPasswordResetRequired",
    PositionDelimited = "PositionDelimited",
    IssuePassword = "IssuePassword",
}

export class EmailTemplateDto implements IEmailTemplateDto {
    type?: NotificationType;
    subject?: string | undefined;
    body?: string | undefined;
    description?: string | undefined;
    to?: string[];
    cc?: string[];

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.description = _data["description"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["description"] = this.description;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        return data;
    }
}

export interface IEmailTemplateDto {
    type?: NotificationType;
    subject?: string | undefined;
    body?: string | undefined;
    description?: string | undefined;
    to?: string[];
    cc?: string[];
}

export class UpdateEmailTemplateCommand implements IUpdateEmailTemplateCommand {
    type?: NotificationType;
    subject?: string | undefined;
    body?: string | undefined;
    description?: string | undefined;
    to?: string[];
    cc?: string[];

    constructor(data?: IUpdateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.description = _data["description"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["description"] = this.description;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        return data;
    }
}

export interface IUpdateEmailTemplateCommand {
    type?: NotificationType;
    subject?: string | undefined;
    body?: string | undefined;
    description?: string | undefined;
    to?: string[];
    cc?: string[];
}

export class CreateAssetCommand implements ICreateAssetCommand {
    type?: AssetType;
    brand?: string;
    ownership?: AssetOwnership;
    ownershipInfo?: OwnershipInfoDto | undefined;
    condition?: AssetCondition;
    classification?: AssetClassification;
    tagId?: string | undefined;
    model?: string | undefined;
    serial?: string | undefined;
    businessUnitLocation?: string | undefined;
    attachments?: AttachmentsDto | undefined;

    constructor(data?: ICreateAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.brand = _data["brand"];
            this.ownership = _data["ownership"];
            this.ownershipInfo = _data["ownershipInfo"] ? OwnershipInfoDto.fromJS(_data["ownershipInfo"]) : <any>undefined;
            this.condition = _data["condition"];
            this.classification = _data["classification"];
            this.tagId = _data["tagId"];
            this.model = _data["model"];
            this.serial = _data["serial"];
            this.businessUnitLocation = _data["businessUnitLocation"];
            this.attachments = _data["attachments"] ? AttachmentsDto.fromJS(_data["attachments"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["brand"] = this.brand;
        data["ownership"] = this.ownership;
        data["ownershipInfo"] = this.ownershipInfo ? this.ownershipInfo.toJSON() : <any>undefined;
        data["condition"] = this.condition;
        data["classification"] = this.classification;
        data["tagId"] = this.tagId;
        data["model"] = this.model;
        data["serial"] = this.serial;
        data["businessUnitLocation"] = this.businessUnitLocation;
        data["attachments"] = this.attachments ? this.attachments.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateAssetCommand {
    type?: AssetType;
    brand?: string;
    ownership?: AssetOwnership;
    ownershipInfo?: OwnershipInfoDto | undefined;
    condition?: AssetCondition;
    classification?: AssetClassification;
    tagId?: string | undefined;
    model?: string | undefined;
    serial?: string | undefined;
    businessUnitLocation?: string | undefined;
    attachments?: AttachmentsDto | undefined;
}

export enum AssetType {
    TwoWayRadio = "TwoWayRadio",
    ChargerConventional = "ChargerConventional",
    ChargerEastPenn = "ChargerEastPenn",
    ChargerPosi = "ChargerPosi",
    ChargerRadioShuttle = "ChargerRadioShuttle",
    ChargerShuntTruck = "ChargerShuntTruck",
    ClampLayerAttach = "ClampLayerAttach",
    DesktopComputer = "DesktopComputer",
    HandheldScanner = "HandheldScanner",
    LaptopChargingBlock = "LaptopChargingBlock",
    LaptopComputer = "LaptopComputer",
    MhBtS = "MhBtS",
    MhCounterBalance = "MhCounterBalance",
    MhCounterBalanceLayPick = "MhCounterBalanceLayPick",
    MhReach = "MhReach",
    MhWalkies = "MhWalkies",
    MheBatteries = "MheBatteries",
    MobileLabelPrinter = "MobileLabelPrinter",
    OfficeDocPrinters = "OfficeDocPrinters",
    OfficeLabelPrinters = "OfficeLabelPrinters",
    Palletizer = "Palletizer",
    PhotoCopyMachine = "PhotoCopyMachine",
    RfScanGuns = "RfScanGuns",
    RadioShuttleBatteries = "RadioShuttleBatteries",
    RadioShuttleCart = "RadioShuttleCart",
    RadioShuttleRemote = "RadioShuttleRemote",
    ScissorLift = "ScissorLift",
    Scrubbers = "Scrubbers",
    ShuntTruck = "ShuntTruck",
    SlipSheetAttach = "SlipSheetAttach",
    TvSets = "TvSets",
    TabletComputers = "TabletComputers",
    WrapMachine = "WrapMachine",
}

export enum AssetOwnership {
    Nestle = "Nestle",
    Hopewell = "Hopewell",
    Lease = "Lease",
    Rental = "Rental",
    Purolator = "Purolator",
    Scrap = "Scrap",
    Returned = "Returned",
}

export class OwnershipInfoDto implements IOwnershipInfoDto {
    agreement?: string | undefined;
    vendor?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;

    constructor(data?: IOwnershipInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreement = _data["agreement"];
            this.vendor = _data["vendor"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OwnershipInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreement"] = this.agreement;
        data["vendor"] = this.vendor;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOwnershipInfoDto {
    agreement?: string | undefined;
    vendor?: string | undefined;
    effectiveDate?: Date;
    endDate?: Date | undefined;
}

export enum AssetCondition {
    Active = "Active",
    Inactive = "Inactive",
}

export enum AssetClassification {
    Land = "Land",
    Building = "Building",
    MachineriesEquipment = "MachineriesEquipment",
    OfficeEquipment = "OfficeEquipment",
    FurnitureAndFixtures = "FurnitureAndFixtures",
    Software = "Software",
}

export class AttachmentsDto implements IAttachmentsDto {
    mobileLabelPrinterId?: string | undefined;
    tabletComputerId?: string | undefined;
    rfScanGunId?: string | undefined;
    mheBatteryId?: string | undefined;
    clampLayerAttachId?: string | undefined;
    slipSheetAttachId?: string | undefined;

    constructor(data?: IAttachmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileLabelPrinterId = _data["mobileLabelPrinterId"];
            this.tabletComputerId = _data["tabletComputerId"];
            this.rfScanGunId = _data["rfScanGunId"];
            this.mheBatteryId = _data["mheBatteryId"];
            this.clampLayerAttachId = _data["clampLayerAttachId"];
            this.slipSheetAttachId = _data["slipSheetAttachId"];
        }
    }

    static fromJS(data: any): AttachmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileLabelPrinterId"] = this.mobileLabelPrinterId;
        data["tabletComputerId"] = this.tabletComputerId;
        data["rfScanGunId"] = this.rfScanGunId;
        data["mheBatteryId"] = this.mheBatteryId;
        data["clampLayerAttachId"] = this.clampLayerAttachId;
        data["slipSheetAttachId"] = this.slipSheetAttachId;
        return data;
    }
}

export interface IAttachmentsDto {
    mobileLabelPrinterId?: string | undefined;
    tabletComputerId?: string | undefined;
    rfScanGunId?: string | undefined;
    mheBatteryId?: string | undefined;
    clampLayerAttachId?: string | undefined;
    slipSheetAttachId?: string | undefined;
}

export class AssetGridViewDto implements IAssetGridViewDto {
    id?: string;
    code?: string;
    type?: AssetType;
    ownership?: AssetOwnership;
    brand?: string;
    condition?: AssetCondition;
    classification?: AssetClassification;
    tagId?: string | undefined;
    model?: string | undefined;
    serial?: string | undefined;
    businessUnitLocation?: string | undefined;
    created?: Date;
    agreement?: string | undefined;
    vendor?: string | undefined;
    effectiveDate?: Date | undefined;
    endDate?: Date | undefined;
    mobileLabelPrinterCode?: string | undefined;
    rfScanGunCode?: string | undefined;
    mheBatteryCode?: string | undefined;
    tabletComputerCode?: string | undefined;
    slipSheetAttachCode?: string | undefined;
    clampLayerAttachCode?: string | undefined;

    constructor(data?: IAssetGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.ownership = _data["ownership"];
            this.brand = _data["brand"];
            this.condition = _data["condition"];
            this.classification = _data["classification"];
            this.tagId = _data["tagId"];
            this.model = _data["model"];
            this.serial = _data["serial"];
            this.businessUnitLocation = _data["businessUnitLocation"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.agreement = _data["agreement"];
            this.vendor = _data["vendor"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.mobileLabelPrinterCode = _data["mobileLabelPrinterCode"];
            this.rfScanGunCode = _data["rfScanGunCode"];
            this.mheBatteryCode = _data["mheBatteryCode"];
            this.tabletComputerCode = _data["tabletComputerCode"];
            this.slipSheetAttachCode = _data["slipSheetAttachCode"];
            this.clampLayerAttachCode = _data["clampLayerAttachCode"];
        }
    }

    static fromJS(data: any): AssetGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["ownership"] = this.ownership;
        data["brand"] = this.brand;
        data["condition"] = this.condition;
        data["classification"] = this.classification;
        data["tagId"] = this.tagId;
        data["model"] = this.model;
        data["serial"] = this.serial;
        data["businessUnitLocation"] = this.businessUnitLocation;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["agreement"] = this.agreement;
        data["vendor"] = this.vendor;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["mobileLabelPrinterCode"] = this.mobileLabelPrinterCode;
        data["rfScanGunCode"] = this.rfScanGunCode;
        data["mheBatteryCode"] = this.mheBatteryCode;
        data["tabletComputerCode"] = this.tabletComputerCode;
        data["slipSheetAttachCode"] = this.slipSheetAttachCode;
        data["clampLayerAttachCode"] = this.clampLayerAttachCode;
        return data;
    }
}

export interface IAssetGridViewDto {
    id?: string;
    code?: string;
    type?: AssetType;
    ownership?: AssetOwnership;
    brand?: string;
    condition?: AssetCondition;
    classification?: AssetClassification;
    tagId?: string | undefined;
    model?: string | undefined;
    serial?: string | undefined;
    businessUnitLocation?: string | undefined;
    created?: Date;
    agreement?: string | undefined;
    vendor?: string | undefined;
    effectiveDate?: Date | undefined;
    endDate?: Date | undefined;
    mobileLabelPrinterCode?: string | undefined;
    rfScanGunCode?: string | undefined;
    mheBatteryCode?: string | undefined;
    tabletComputerCode?: string | undefined;
    slipSheetAttachCode?: string | undefined;
    clampLayerAttachCode?: string | undefined;
}

export class AssetDto extends AssetGridViewDto implements IAssetDto {
    ownershipInfo?: OwnershipInfoDto | undefined;
    attachments?: AttachmentsDto | undefined;

    constructor(data?: IAssetDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ownershipInfo = _data["ownershipInfo"] ? OwnershipInfoDto.fromJS(_data["ownershipInfo"]) : <any>undefined;
            this.attachments = _data["attachments"] ? AttachmentsDto.fromJS(_data["attachments"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownershipInfo"] = this.ownershipInfo ? this.ownershipInfo.toJSON() : <any>undefined;
        data["attachments"] = this.attachments ? this.attachments.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDto extends IAssetGridViewDto {
    ownershipInfo?: OwnershipInfoDto | undefined;
    attachments?: AttachmentsDto | undefined;
}

export class UpdateAssetCommand extends CreateAssetCommand implements IUpdateAssetCommand {
    id?: string;

    constructor(data?: IUpdateAssetCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAssetCommand extends ICreateAssetCommand {
    id?: string;
}

export class CreateChecklistCommand implements ICreateChecklistCommand {
    assetType?: AssetType;
    machineId?: string | undefined;
    twoWayRadioId?: string | undefined;
    radioShuttleCardId?: string | undefined;
    radioShuttleRemoteId?: string | undefined;
    radioShuttleBatteryId?: string | undefined;
    equipmentId?: string | undefined;
    mobileLabelPrinterCheck?: MachineAttachmentCheckDto | undefined;
    tabletComputerCheck?: MachineAttachmentCheckDto | undefined;
    rfScanGunCheck?: MachineAttachmentCheckDto | undefined;
    clampLayerAttachCheck?: MachineAttachmentCheckDto | undefined;
    mhBatteryCheck?: MachineAttachmentCheckDto | undefined;
    slipSheetAttachCheck?: MachineAttachmentCheckDto | undefined;
    answers?: ChecklistQuestionAnswerDto[];

    constructor(data?: ICreateChecklistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.machineId = _data["machineId"];
            this.twoWayRadioId = _data["twoWayRadioId"];
            this.radioShuttleCardId = _data["radioShuttleCardId"];
            this.radioShuttleRemoteId = _data["radioShuttleRemoteId"];
            this.radioShuttleBatteryId = _data["radioShuttleBatteryId"];
            this.equipmentId = _data["equipmentId"];
            this.mobileLabelPrinterCheck = _data["mobileLabelPrinterCheck"] ? MachineAttachmentCheckDto.fromJS(_data["mobileLabelPrinterCheck"]) : <any>undefined;
            this.tabletComputerCheck = _data["tabletComputerCheck"] ? MachineAttachmentCheckDto.fromJS(_data["tabletComputerCheck"]) : <any>undefined;
            this.rfScanGunCheck = _data["rfScanGunCheck"] ? MachineAttachmentCheckDto.fromJS(_data["rfScanGunCheck"]) : <any>undefined;
            this.clampLayerAttachCheck = _data["clampLayerAttachCheck"] ? MachineAttachmentCheckDto.fromJS(_data["clampLayerAttachCheck"]) : <any>undefined;
            this.mhBatteryCheck = _data["mhBatteryCheck"] ? MachineAttachmentCheckDto.fromJS(_data["mhBatteryCheck"]) : <any>undefined;
            this.slipSheetAttachCheck = _data["slipSheetAttachCheck"] ? MachineAttachmentCheckDto.fromJS(_data["slipSheetAttachCheck"]) : <any>undefined;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ChecklistQuestionAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateChecklistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChecklistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["machineId"] = this.machineId;
        data["twoWayRadioId"] = this.twoWayRadioId;
        data["radioShuttleCardId"] = this.radioShuttleCardId;
        data["radioShuttleRemoteId"] = this.radioShuttleRemoteId;
        data["radioShuttleBatteryId"] = this.radioShuttleBatteryId;
        data["equipmentId"] = this.equipmentId;
        data["mobileLabelPrinterCheck"] = this.mobileLabelPrinterCheck ? this.mobileLabelPrinterCheck.toJSON() : <any>undefined;
        data["tabletComputerCheck"] = this.tabletComputerCheck ? this.tabletComputerCheck.toJSON() : <any>undefined;
        data["rfScanGunCheck"] = this.rfScanGunCheck ? this.rfScanGunCheck.toJSON() : <any>undefined;
        data["clampLayerAttachCheck"] = this.clampLayerAttachCheck ? this.clampLayerAttachCheck.toJSON() : <any>undefined;
        data["mhBatteryCheck"] = this.mhBatteryCheck ? this.mhBatteryCheck.toJSON() : <any>undefined;
        data["slipSheetAttachCheck"] = this.slipSheetAttachCheck ? this.slipSheetAttachCheck.toJSON() : <any>undefined;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateChecklistCommand {
    assetType?: AssetType;
    machineId?: string | undefined;
    twoWayRadioId?: string | undefined;
    radioShuttleCardId?: string | undefined;
    radioShuttleRemoteId?: string | undefined;
    radioShuttleBatteryId?: string | undefined;
    equipmentId?: string | undefined;
    mobileLabelPrinterCheck?: MachineAttachmentCheckDto | undefined;
    tabletComputerCheck?: MachineAttachmentCheckDto | undefined;
    rfScanGunCheck?: MachineAttachmentCheckDto | undefined;
    clampLayerAttachCheck?: MachineAttachmentCheckDto | undefined;
    mhBatteryCheck?: MachineAttachmentCheckDto | undefined;
    slipSheetAttachCheck?: MachineAttachmentCheckDto | undefined;
    answers?: ChecklistQuestionAnswerDto[];
}

export class MachineAttachmentCheckDto implements IMachineAttachmentCheckDto {
    attachedAssetId?: string;
    isThisIdCorrect?: boolean;
    correctAssetId?: string | undefined;

    constructor(data?: IMachineAttachmentCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachedAssetId = _data["attachedAssetId"];
            this.isThisIdCorrect = _data["isThisIdCorrect"];
            this.correctAssetId = _data["correctAssetId"];
        }
    }

    static fromJS(data: any): MachineAttachmentCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineAttachmentCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachedAssetId"] = this.attachedAssetId;
        data["isThisIdCorrect"] = this.isThisIdCorrect;
        data["correctAssetId"] = this.correctAssetId;
        return data;
    }
}

export interface IMachineAttachmentCheckDto {
    attachedAssetId?: string;
    isThisIdCorrect?: boolean;
    correctAssetId?: string | undefined;
}

export class ChecklistQuestionAnswerDto implements IChecklistQuestionAnswerDto {
    questionId?: string;
    answer?: ChecklistQuestionAnswerType;

    constructor(data?: IChecklistQuestionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): ChecklistQuestionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistQuestionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IChecklistQuestionAnswerDto {
    questionId?: string;
    answer?: ChecklistQuestionAnswerType;
}

export enum ChecklistQuestionAnswerType {
    Ok = "Ok",
    NeedsService = "NeedsService",
}

export class ChecklistDto implements IChecklistDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    employeeId?: string;
    assetType?: AssetType;
    condition?: ChecklistCondition;
    machineId?: string | undefined;
    twoWayRadioId?: string | undefined;
    equipmentId?: string | undefined;
    radioShuttleCardId?: string | undefined;
    radioShuttleRemoteId?: string | undefined;
    radioShuttleBatteryId?: string | undefined;
    mobileLabelPrinterCheck?: MachineAttachmentCheckDto | undefined;
    tabletComputerCheck?: MachineAttachmentCheckDto | undefined;
    rfScanGunCheck?: MachineAttachmentCheckDto | undefined;
    clampLayerAttachCheck?: MachineAttachmentCheckDto | undefined;
    mhBatteryCheck?: MachineAttachmentCheckDto | undefined;
    slipSheetAttachCheck?: MachineAttachmentCheckDto | undefined;
    answers?: ChecklistQuestionAnswerDto[];
    employee?: EmployeeDto;
    repairDate?: Date | undefined;
    repairedBy?: EmployeeDto | undefined;
    created?: Date;
    shiftCode?: string | undefined;
    shiftType?: ShiftType | undefined;

    constructor(data?: IChecklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.numberWithPrefix = _data["numberWithPrefix"];
            this.employeeId = _data["employeeId"];
            this.assetType = _data["assetType"];
            this.condition = _data["condition"];
            this.machineId = _data["machineId"];
            this.twoWayRadioId = _data["twoWayRadioId"];
            this.equipmentId = _data["equipmentId"];
            this.radioShuttleCardId = _data["radioShuttleCardId"];
            this.radioShuttleRemoteId = _data["radioShuttleRemoteId"];
            this.radioShuttleBatteryId = _data["radioShuttleBatteryId"];
            this.mobileLabelPrinterCheck = _data["mobileLabelPrinterCheck"] ? MachineAttachmentCheckDto.fromJS(_data["mobileLabelPrinterCheck"]) : <any>undefined;
            this.tabletComputerCheck = _data["tabletComputerCheck"] ? MachineAttachmentCheckDto.fromJS(_data["tabletComputerCheck"]) : <any>undefined;
            this.rfScanGunCheck = _data["rfScanGunCheck"] ? MachineAttachmentCheckDto.fromJS(_data["rfScanGunCheck"]) : <any>undefined;
            this.clampLayerAttachCheck = _data["clampLayerAttachCheck"] ? MachineAttachmentCheckDto.fromJS(_data["clampLayerAttachCheck"]) : <any>undefined;
            this.mhBatteryCheck = _data["mhBatteryCheck"] ? MachineAttachmentCheckDto.fromJS(_data["mhBatteryCheck"]) : <any>undefined;
            this.slipSheetAttachCheck = _data["slipSheetAttachCheck"] ? MachineAttachmentCheckDto.fromJS(_data["slipSheetAttachCheck"]) : <any>undefined;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ChecklistQuestionAnswerDto.fromJS(item));
            }
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.repairDate = _data["repairDate"] ? new Date(_data["repairDate"].toString()) : <any>undefined;
            this.repairedBy = _data["repairedBy"] ? EmployeeDto.fromJS(_data["repairedBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.shiftCode = _data["shiftCode"];
            this.shiftType = _data["shiftType"];
        }
    }

    static fromJS(data: any): ChecklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["numberWithPrefix"] = this.numberWithPrefix;
        data["employeeId"] = this.employeeId;
        data["assetType"] = this.assetType;
        data["condition"] = this.condition;
        data["machineId"] = this.machineId;
        data["twoWayRadioId"] = this.twoWayRadioId;
        data["equipmentId"] = this.equipmentId;
        data["radioShuttleCardId"] = this.radioShuttleCardId;
        data["radioShuttleRemoteId"] = this.radioShuttleRemoteId;
        data["radioShuttleBatteryId"] = this.radioShuttleBatteryId;
        data["mobileLabelPrinterCheck"] = this.mobileLabelPrinterCheck ? this.mobileLabelPrinterCheck.toJSON() : <any>undefined;
        data["tabletComputerCheck"] = this.tabletComputerCheck ? this.tabletComputerCheck.toJSON() : <any>undefined;
        data["rfScanGunCheck"] = this.rfScanGunCheck ? this.rfScanGunCheck.toJSON() : <any>undefined;
        data["clampLayerAttachCheck"] = this.clampLayerAttachCheck ? this.clampLayerAttachCheck.toJSON() : <any>undefined;
        data["mhBatteryCheck"] = this.mhBatteryCheck ? this.mhBatteryCheck.toJSON() : <any>undefined;
        data["slipSheetAttachCheck"] = this.slipSheetAttachCheck ? this.slipSheetAttachCheck.toJSON() : <any>undefined;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["repairDate"] = this.repairDate ? this.repairDate.toISOString() : <any>undefined;
        data["repairedBy"] = this.repairedBy ? this.repairedBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["shiftCode"] = this.shiftCode;
        data["shiftType"] = this.shiftType;
        return data;
    }
}

export interface IChecklistDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    employeeId?: string;
    assetType?: AssetType;
    condition?: ChecklistCondition;
    machineId?: string | undefined;
    twoWayRadioId?: string | undefined;
    equipmentId?: string | undefined;
    radioShuttleCardId?: string | undefined;
    radioShuttleRemoteId?: string | undefined;
    radioShuttleBatteryId?: string | undefined;
    mobileLabelPrinterCheck?: MachineAttachmentCheckDto | undefined;
    tabletComputerCheck?: MachineAttachmentCheckDto | undefined;
    rfScanGunCheck?: MachineAttachmentCheckDto | undefined;
    clampLayerAttachCheck?: MachineAttachmentCheckDto | undefined;
    mhBatteryCheck?: MachineAttachmentCheckDto | undefined;
    slipSheetAttachCheck?: MachineAttachmentCheckDto | undefined;
    answers?: ChecklistQuestionAnswerDto[];
    employee?: EmployeeDto;
    repairDate?: Date | undefined;
    repairedBy?: EmployeeDto | undefined;
    created?: Date;
    shiftCode?: string | undefined;
    shiftType?: ShiftType | undefined;
}

export enum ChecklistCondition {
    Ok = "Ok",
    Defect = "Defect",
    Repaired = "Repaired",
}

export class ChecklistQuestionGroupDto implements IChecklistQuestionGroupDto {
    groupType?: ChecklistQuestionGroupType;
    questions?: ChecklistQuestionDto[];

    constructor(data?: IChecklistQuestionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupType = _data["groupType"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ChecklistQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistQuestionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistQuestionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupType"] = this.groupType;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistQuestionGroupDto {
    groupType?: ChecklistQuestionGroupType;
    questions?: ChecklistQuestionDto[];
}

export enum ChecklistQuestionGroupType {
    AfterStartingMachine = "AfterStartingMachine",
    BeforeStartingMachine = "BeforeStartingMachine",
    AfterStartingMachineCounterBalance = "AfterStartingMachineCounterBalance",
    BeforeStartingMachineCounterBalance = "BeforeStartingMachineCounterBalance",
    MobileLabelPrinter = "MobileLabelPrinter",
    RadioShuttleCart = "RadioShuttleCart",
    RadioShuttleRemote = "RadioShuttleRemote",
    RfScanningGun = "RfScanningGun",
    TabletComputers = "TabletComputers",
    TwoWayRadio = "TwoWayRadio",
    SlipSheetAttach = "SlipSheetAttach",
    ClampLayerAttach = "ClampLayerAttach",
    HandheldScanner = "HandheldScanner",
    Scrubbers = "Scrubbers",
    ShuntTruck = "ShuntTruck",
    ScissorLiftVisualInspection = "ScissorLiftVisualInspection",
    ScissorLiftOperationalInspection = "ScissorLiftOperationalInspection",
    ScissorLiftBatteryPowered = "ScissorLiftBatteryPowered",
    WrapMachine = "WrapMachine",
}

export class ChecklistQuestionDto implements IChecklistQuestionDto {
    questionId?: string;
    title?: string;

    constructor(data?: IChecklistQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ChecklistQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["title"] = this.title;
        return data;
    }
}

export interface IChecklistQuestionDto {
    questionId?: string;
    title?: string;
}

export class RepairChecklistCommand implements IRepairChecklistCommand {
    id?: string;

    constructor(data?: IRepairChecklistCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RepairChecklistCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RepairChecklistCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRepairChecklistCommand {
    id?: string;
}

export class ChecklistConditionExportQuery extends MyScoreQueryOfExportedFileDto implements IChecklistConditionExportQuery {

    constructor(data?: IChecklistConditionExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChecklistConditionExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistConditionExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChecklistConditionExportQuery extends IMyScoreQueryOfExportedFileDto {
}

export class MyScoreShiftQuery extends MyScoreQueryOfScoreDto implements IMyScoreShiftQuery {
    shiftType?: ShiftType | undefined;

    constructor(data?: IMyScoreShiftQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shiftType = _data["shiftType"];
        }
    }

    static override fromJS(data: any): MyScoreShiftQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MyScoreShiftQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftType"] = this.shiftType;
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreShiftQuery extends IMyScoreQueryOfScoreDto {
    shiftType?: ShiftType | undefined;
}

export class ChecklistConditionQuery extends MyScoreShiftQuery implements IChecklistConditionQuery {

    constructor(data?: IChecklistConditionQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChecklistConditionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistConditionQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChecklistConditionQuery extends IMyScoreShiftQuery {
}

export class ChecklistConditionTrendingQuery extends TrendingQuery implements IChecklistConditionTrendingQuery {

    constructor(data?: IChecklistConditionTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChecklistConditionTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistConditionTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChecklistConditionTrendingQuery extends ITrendingQuery {
}

export class ChecklistComplianceScoreExportQuery extends MyScoreQueryOfExportedFileDto implements IChecklistComplianceScoreExportQuery {

    constructor(data?: IChecklistComplianceScoreExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChecklistComplianceScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistComplianceScoreExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChecklistComplianceScoreExportQuery extends IMyScoreQueryOfExportedFileDto {
}

export class ChecklistComplianceScoreQuery extends MyScoreShiftQuery implements IChecklistComplianceScoreQuery {

    constructor(data?: IChecklistComplianceScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChecklistComplianceScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistComplianceScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChecklistComplianceScoreQuery extends IMyScoreShiftQuery {
}

export class ChecklistComplianceTrendingQuery extends TrendingQuery implements IChecklistComplianceTrendingQuery {

    constructor(data?: IChecklistComplianceTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChecklistComplianceTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistComplianceTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IChecklistComplianceTrendingQuery extends ITrendingQuery {
}

export class CreateIncidentReportCommand implements ICreateIncidentReportCommand {
    humanResourcesContacted?: boolean;
    category?: IncidentCategory;
    type?: IncidentType;
    location?: IncidentLocation;
    injuryType?: InjuryType;
    outsideMedical?: boolean;
    employeeId?: string | undefined;
    externalName?: string | undefined;
    incidentDate?: Date;
    incidentTime?: string;
    placeOfIncident?: string;
    shiftId?: string;
    bodyPartInjured?: string;
    emsCalled?: boolean;
    firstAidAdministered?: boolean;
    byWhomFirstAidAdministered?: string | undefined;
    lostTime?: boolean;
    isDrivingEquipment?: boolean;
    isLifting?: boolean;
    isClimbing?: boolean;
    isStanding?: boolean;
    isRunning?: boolean;
    isCarrying?: boolean;
    isSitting?: boolean;
    isLayingDown?: boolean;
    isWalking?: boolean;
    isPushingOrPulling?: boolean;
    isKneeling?: boolean;
    isStretchingOrReclining?: boolean;
    isOther?: boolean;
    equipment?: string | undefined;
    lifting?: string | undefined;
    carrying?: string | undefined;
    pushingOrPulling?: string | undefined;
    other?: string | undefined;
    equipmentIssues?: string | undefined;
    environmentalFactors?: string | undefined;
    basicCauses?: string | undefined;
    rootCause?: string | undefined;
    suggestedSolution?: string | undefined;
    workOrderSent?: boolean;
    workOrderNumber?: string | undefined;
    workOrderTargetCompletionDate?: Date | undefined;
    workOrderActualCompletionDate?: Date | undefined;
    reTrainingNeeded?: boolean;
    reTrainingTopic?: string | undefined;
    reTrainingTrainer?: string | undefined;
    reTrainingTargetCompletionDate?: Date | undefined;
    reTrainingActualCompletionDate?: Date | undefined;
    steps?: IncidentStepDto[];
    correctiveActions?: IncidentCorrectiveActionDto[];
    witnesses?: IncidentWitnessDto[];

    constructor(data?: ICreateIncidentReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.humanResourcesContacted = _data["humanResourcesContacted"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.injuryType = _data["injuryType"];
            this.outsideMedical = _data["outsideMedical"];
            this.employeeId = _data["employeeId"];
            this.externalName = _data["externalName"];
            this.incidentDate = _data["incidentDate"] ? new Date(_data["incidentDate"].toString()) : <any>undefined;
            this.incidentTime = _data["incidentTime"];
            this.placeOfIncident = _data["placeOfIncident"];
            this.shiftId = _data["shiftId"];
            this.bodyPartInjured = _data["bodyPartInjured"];
            this.emsCalled = _data["emsCalled"];
            this.firstAidAdministered = _data["firstAidAdministered"];
            this.byWhomFirstAidAdministered = _data["byWhomFirstAidAdministered"];
            this.lostTime = _data["lostTime"];
            this.isDrivingEquipment = _data["isDrivingEquipment"];
            this.isLifting = _data["isLifting"];
            this.isClimbing = _data["isClimbing"];
            this.isStanding = _data["isStanding"];
            this.isRunning = _data["isRunning"];
            this.isCarrying = _data["isCarrying"];
            this.isSitting = _data["isSitting"];
            this.isLayingDown = _data["isLayingDown"];
            this.isWalking = _data["isWalking"];
            this.isPushingOrPulling = _data["isPushingOrPulling"];
            this.isKneeling = _data["isKneeling"];
            this.isStretchingOrReclining = _data["isStretchingOrReclining"];
            this.isOther = _data["isOther"];
            this.equipment = _data["equipment"];
            this.lifting = _data["lifting"];
            this.carrying = _data["carrying"];
            this.pushingOrPulling = _data["pushingOrPulling"];
            this.other = _data["other"];
            this.equipmentIssues = _data["equipmentIssues"];
            this.environmentalFactors = _data["environmentalFactors"];
            this.basicCauses = _data["basicCauses"];
            this.rootCause = _data["rootCause"];
            this.suggestedSolution = _data["suggestedSolution"];
            this.workOrderSent = _data["workOrderSent"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.workOrderTargetCompletionDate = _data["workOrderTargetCompletionDate"] ? new Date(_data["workOrderTargetCompletionDate"].toString()) : <any>undefined;
            this.workOrderActualCompletionDate = _data["workOrderActualCompletionDate"] ? new Date(_data["workOrderActualCompletionDate"].toString()) : <any>undefined;
            this.reTrainingNeeded = _data["reTrainingNeeded"];
            this.reTrainingTopic = _data["reTrainingTopic"];
            this.reTrainingTrainer = _data["reTrainingTrainer"];
            this.reTrainingTargetCompletionDate = _data["reTrainingTargetCompletionDate"] ? new Date(_data["reTrainingTargetCompletionDate"].toString()) : <any>undefined;
            this.reTrainingActualCompletionDate = _data["reTrainingActualCompletionDate"] ? new Date(_data["reTrainingActualCompletionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(IncidentStepDto.fromJS(item));
            }
            if (Array.isArray(_data["correctiveActions"])) {
                this.correctiveActions = [] as any;
                for (let item of _data["correctiveActions"])
                    this.correctiveActions!.push(IncidentCorrectiveActionDto.fromJS(item));
            }
            if (Array.isArray(_data["witnesses"])) {
                this.witnesses = [] as any;
                for (let item of _data["witnesses"])
                    this.witnesses!.push(IncidentWitnessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateIncidentReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["humanResourcesContacted"] = this.humanResourcesContacted;
        data["category"] = this.category;
        data["type"] = this.type;
        data["location"] = this.location;
        data["injuryType"] = this.injuryType;
        data["outsideMedical"] = this.outsideMedical;
        data["employeeId"] = this.employeeId;
        data["externalName"] = this.externalName;
        data["incidentDate"] = this.incidentDate ? this.incidentDate.toISOString() : <any>undefined;
        data["incidentTime"] = this.incidentTime;
        data["placeOfIncident"] = this.placeOfIncident;
        data["shiftId"] = this.shiftId;
        data["bodyPartInjured"] = this.bodyPartInjured;
        data["emsCalled"] = this.emsCalled;
        data["firstAidAdministered"] = this.firstAidAdministered;
        data["byWhomFirstAidAdministered"] = this.byWhomFirstAidAdministered;
        data["lostTime"] = this.lostTime;
        data["isDrivingEquipment"] = this.isDrivingEquipment;
        data["isLifting"] = this.isLifting;
        data["isClimbing"] = this.isClimbing;
        data["isStanding"] = this.isStanding;
        data["isRunning"] = this.isRunning;
        data["isCarrying"] = this.isCarrying;
        data["isSitting"] = this.isSitting;
        data["isLayingDown"] = this.isLayingDown;
        data["isWalking"] = this.isWalking;
        data["isPushingOrPulling"] = this.isPushingOrPulling;
        data["isKneeling"] = this.isKneeling;
        data["isStretchingOrReclining"] = this.isStretchingOrReclining;
        data["isOther"] = this.isOther;
        data["equipment"] = this.equipment;
        data["lifting"] = this.lifting;
        data["carrying"] = this.carrying;
        data["pushingOrPulling"] = this.pushingOrPulling;
        data["other"] = this.other;
        data["equipmentIssues"] = this.equipmentIssues;
        data["environmentalFactors"] = this.environmentalFactors;
        data["basicCauses"] = this.basicCauses;
        data["rootCause"] = this.rootCause;
        data["suggestedSolution"] = this.suggestedSolution;
        data["workOrderSent"] = this.workOrderSent;
        data["workOrderNumber"] = this.workOrderNumber;
        data["workOrderTargetCompletionDate"] = this.workOrderTargetCompletionDate ? this.workOrderTargetCompletionDate.toISOString() : <any>undefined;
        data["workOrderActualCompletionDate"] = this.workOrderActualCompletionDate ? this.workOrderActualCompletionDate.toISOString() : <any>undefined;
        data["reTrainingNeeded"] = this.reTrainingNeeded;
        data["reTrainingTopic"] = this.reTrainingTopic;
        data["reTrainingTrainer"] = this.reTrainingTrainer;
        data["reTrainingTargetCompletionDate"] = this.reTrainingTargetCompletionDate ? this.reTrainingTargetCompletionDate.toISOString() : <any>undefined;
        data["reTrainingActualCompletionDate"] = this.reTrainingActualCompletionDate ? this.reTrainingActualCompletionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.correctiveActions)) {
            data["correctiveActions"] = [];
            for (let item of this.correctiveActions)
                data["correctiveActions"].push(item.toJSON());
        }
        if (Array.isArray(this.witnesses)) {
            data["witnesses"] = [];
            for (let item of this.witnesses)
                data["witnesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateIncidentReportCommand {
    humanResourcesContacted?: boolean;
    category?: IncidentCategory;
    type?: IncidentType;
    location?: IncidentLocation;
    injuryType?: InjuryType;
    outsideMedical?: boolean;
    employeeId?: string | undefined;
    externalName?: string | undefined;
    incidentDate?: Date;
    incidentTime?: string;
    placeOfIncident?: string;
    shiftId?: string;
    bodyPartInjured?: string;
    emsCalled?: boolean;
    firstAidAdministered?: boolean;
    byWhomFirstAidAdministered?: string | undefined;
    lostTime?: boolean;
    isDrivingEquipment?: boolean;
    isLifting?: boolean;
    isClimbing?: boolean;
    isStanding?: boolean;
    isRunning?: boolean;
    isCarrying?: boolean;
    isSitting?: boolean;
    isLayingDown?: boolean;
    isWalking?: boolean;
    isPushingOrPulling?: boolean;
    isKneeling?: boolean;
    isStretchingOrReclining?: boolean;
    isOther?: boolean;
    equipment?: string | undefined;
    lifting?: string | undefined;
    carrying?: string | undefined;
    pushingOrPulling?: string | undefined;
    other?: string | undefined;
    equipmentIssues?: string | undefined;
    environmentalFactors?: string | undefined;
    basicCauses?: string | undefined;
    rootCause?: string | undefined;
    suggestedSolution?: string | undefined;
    workOrderSent?: boolean;
    workOrderNumber?: string | undefined;
    workOrderTargetCompletionDate?: Date | undefined;
    workOrderActualCompletionDate?: Date | undefined;
    reTrainingNeeded?: boolean;
    reTrainingTopic?: string | undefined;
    reTrainingTrainer?: string | undefined;
    reTrainingTargetCompletionDate?: Date | undefined;
    reTrainingActualCompletionDate?: Date | undefined;
    steps?: IncidentStepDto[];
    correctiveActions?: IncidentCorrectiveActionDto[];
    witnesses?: IncidentWitnessDto[];
}

export class UpdateIncidentReportCommand extends CreateIncidentReportCommand implements IUpdateIncidentReportCommand {
    id?: string;
    isCparRequired?: boolean | undefined;
    cparTrackingNumber?: string | undefined;
    riskAssessmentReviewedBy?: string | undefined;
    riskAssessmentReviewedDate?: Date | undefined;
    isCparChangesRequired?: boolean | undefined;
    couldOccurElsewhere?: boolean | undefined;
    wasFoodSafetyImpacted?: boolean | undefined;
    foodSafetyImpactDetails?: string | undefined;
    isSafetyHazard?: boolean;
    isHealthHazard?: boolean;
    isEnvironmentalHazard?: boolean;
    aspectsAndImpactsReviewedBy?: string | undefined;
    areAspectChangesRequired?: boolean | undefined;
    probabilityCriteria?: string | undefined;
    severityCriteria?: string | undefined;
    legalRequirementsReviewedBy?: string | undefined;
    areLegalRequirementChangesRequired?: boolean | undefined;
    riskRanking?: string | undefined;

    constructor(data?: IUpdateIncidentReportCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.isCparRequired = _data["isCparRequired"];
            this.cparTrackingNumber = _data["cparTrackingNumber"];
            this.riskAssessmentReviewedBy = _data["riskAssessmentReviewedBy"];
            this.riskAssessmentReviewedDate = _data["riskAssessmentReviewedDate"] ? new Date(_data["riskAssessmentReviewedDate"].toString()) : <any>undefined;
            this.isCparChangesRequired = _data["isCparChangesRequired"];
            this.couldOccurElsewhere = _data["couldOccurElsewhere"];
            this.wasFoodSafetyImpacted = _data["wasFoodSafetyImpacted"];
            this.foodSafetyImpactDetails = _data["foodSafetyImpactDetails"];
            this.isSafetyHazard = _data["isSafetyHazard"];
            this.isHealthHazard = _data["isHealthHazard"];
            this.isEnvironmentalHazard = _data["isEnvironmentalHazard"];
            this.aspectsAndImpactsReviewedBy = _data["aspectsAndImpactsReviewedBy"];
            this.areAspectChangesRequired = _data["areAspectChangesRequired"];
            this.probabilityCriteria = _data["probabilityCriteria"];
            this.severityCriteria = _data["severityCriteria"];
            this.legalRequirementsReviewedBy = _data["legalRequirementsReviewedBy"];
            this.areLegalRequirementChangesRequired = _data["areLegalRequirementChangesRequired"];
            this.riskRanking = _data["riskRanking"];
        }
    }

    static override fromJS(data: any): UpdateIncidentReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncidentReportCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCparRequired"] = this.isCparRequired;
        data["cparTrackingNumber"] = this.cparTrackingNumber;
        data["riskAssessmentReviewedBy"] = this.riskAssessmentReviewedBy;
        data["riskAssessmentReviewedDate"] = this.riskAssessmentReviewedDate ? this.riskAssessmentReviewedDate.toISOString() : <any>undefined;
        data["isCparChangesRequired"] = this.isCparChangesRequired;
        data["couldOccurElsewhere"] = this.couldOccurElsewhere;
        data["wasFoodSafetyImpacted"] = this.wasFoodSafetyImpacted;
        data["foodSafetyImpactDetails"] = this.foodSafetyImpactDetails;
        data["isSafetyHazard"] = this.isSafetyHazard;
        data["isHealthHazard"] = this.isHealthHazard;
        data["isEnvironmentalHazard"] = this.isEnvironmentalHazard;
        data["aspectsAndImpactsReviewedBy"] = this.aspectsAndImpactsReviewedBy;
        data["areAspectChangesRequired"] = this.areAspectChangesRequired;
        data["probabilityCriteria"] = this.probabilityCriteria;
        data["severityCriteria"] = this.severityCriteria;
        data["legalRequirementsReviewedBy"] = this.legalRequirementsReviewedBy;
        data["areLegalRequirementChangesRequired"] = this.areLegalRequirementChangesRequired;
        data["riskRanking"] = this.riskRanking;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateIncidentReportCommand extends ICreateIncidentReportCommand {
    id?: string;
    isCparRequired?: boolean | undefined;
    cparTrackingNumber?: string | undefined;
    riskAssessmentReviewedBy?: string | undefined;
    riskAssessmentReviewedDate?: Date | undefined;
    isCparChangesRequired?: boolean | undefined;
    couldOccurElsewhere?: boolean | undefined;
    wasFoodSafetyImpacted?: boolean | undefined;
    foodSafetyImpactDetails?: string | undefined;
    isSafetyHazard?: boolean;
    isHealthHazard?: boolean;
    isEnvironmentalHazard?: boolean;
    aspectsAndImpactsReviewedBy?: string | undefined;
    areAspectChangesRequired?: boolean | undefined;
    probabilityCriteria?: string | undefined;
    severityCriteria?: string | undefined;
    legalRequirementsReviewedBy?: string | undefined;
    areLegalRequirementChangesRequired?: boolean | undefined;
    riskRanking?: string | undefined;
}

export class ApproveIncidentReportCommand extends UpdateIncidentReportCommand implements IApproveIncidentReportCommand {

    constructor(data?: IApproveIncidentReportCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ApproveIncidentReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveIncidentReportCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApproveIncidentReportCommand extends IUpdateIncidentReportCommand {
}

export enum IncidentCategory {
    Observations = "Observations",
    IncidentInjury = "IncidentInjury",
    FoodSafety = "FoodSafety",
    Illness = "Illness",
    NearMiss = "NearMiss",
    ProductLoss = "ProductLoss",
    Environmental = "Environmental",
    Theft = "Theft",
    PropertyDamage = "PropertyDamage",
    Other = "Other",
}

export enum IncidentType {
    CaughtInUnderBetween = "CaughtInUnderBetween",
    FallOnSameLevel = "FallOnSameLevel",
    MaterialsDropped = "MaterialsDropped",
    ChemicalExposure = "ChemicalExposure",
    Lifting = "Lifting",
    EquipmentFailure = "EquipmentFailure",
    ContactWithTemperatureExtremes = "ContactWithTemperatureExtremes",
    StruckBy = "StruckBy",
    PropertyMissing = "PropertyMissing",
    OverExertion = "OverExertion",
    RubbedAbraded = "RubbedAbraded",
    ContractorDamage = "ContractorDamage",
    FallFromElevation = "FallFromElevation",
    StruckAgainst = "StruckAgainst",
    MaterialsPunctured = "MaterialsPunctured",
    Twisting = "Twisting",
    Other = "Other",
}

export enum IncidentLocation {
    TruckYard = "TruckYard",
    ParkingLot = "ParkingLot",
    CoolerWarehouse = "CoolerWarehouse",
    AmbientWarehouse = "AmbientWarehouse",
    CoolerDockStaging = "CoolerDockStaging",
    AmbientDockStaging = "AmbientDockStaging",
    LayerPickLine = "LayerPickLine",
    LooseCasePickLine = "LooseCasePickLine",
    RadioShuttleRack = "RadioShuttleRack",
    MHEChargingArea = "MHEChargingArea",
    MHEMaintenanceArea = "MHEMaintenanceArea",
    DockRollUpDoors = "DockRollUpDoors",
    Office = "Office",
    Cafeteria = "Cafeteria",
}

export enum InjuryType {
    Amputation = "Amputation",
    BackInjury = "BackInjury",
    Burn = "Burn",
    ChemicalExposureBurn = "ChemicalExposureBurn",
    ConcussionHeadInjury = "ConcussionHeadInjury",
    ContusionBruise = "ContusionBruise",
    Crushing = "Crushing",
    CumulativeTrauma = "CumulativeTrauma",
    CutLaceration = "CutLaceration",
    ElectricShock = "ElectricShock",
    Puncture = "Puncture",
    StrainSprain = "StrainSprain",
    Other = "Other",
}

export class IncidentStepDto implements IIncidentStepDto {
    id?: number;
    stepNumber?: number;
    description?: string;

    constructor(data?: IIncidentStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepNumber = _data["stepNumber"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IncidentStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepNumber"] = this.stepNumber;
        data["description"] = this.description;
        return data;
    }
}

export interface IIncidentStepDto {
    id?: number;
    stepNumber?: number;
    description?: string;
}

export class IncidentCorrectiveActionDto implements IIncidentCorrectiveActionDto {
    id?: number;
    actionItem?: string;
    responsiblePerson?: string;
    targetDate?: Date;
    completedDate?: Date;

    constructor(data?: IIncidentCorrectiveActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionItem = _data["actionItem"];
            this.responsiblePerson = _data["responsiblePerson"];
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentCorrectiveActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentCorrectiveActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionItem"] = this.actionItem;
        data["responsiblePerson"] = this.responsiblePerson;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIncidentCorrectiveActionDto {
    id?: number;
    actionItem?: string;
    responsiblePerson?: string;
    targetDate?: Date;
    completedDate?: Date;
}

export class IncidentWitnessDto implements IIncidentWitnessDto {
    id?: number;
    employeeId?: string | undefined;
    employee?: EmployeeDto | undefined;
    isNotEmployee?: boolean;
    externalName?: string | undefined;

    constructor(data?: IIncidentWitnessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.isNotEmployee = _data["isNotEmployee"];
            this.externalName = _data["externalName"];
        }
    }

    static fromJS(data: any): IncidentWitnessDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentWitnessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["isNotEmployee"] = this.isNotEmployee;
        data["externalName"] = this.externalName;
        return data;
    }
}

export interface IIncidentWitnessDto {
    id?: number;
    employeeId?: string | undefined;
    employee?: EmployeeDto | undefined;
    isNotEmployee?: boolean;
    externalName?: string | undefined;
}

export class IncidentReportDto implements IIncidentReportDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    createdBy?: EmployeeDto;
    status?: IncidentStatus;
    lastModified?: Date;
    lastModifiedBy?: string;
    canBeApproved?: boolean;
    humanResourcesContacted?: boolean;
    category?: IncidentCategory;
    type?: IncidentType;
    location?: IncidentLocation;
    injuryType?: InjuryType;
    outsideMedical?: boolean;
    employeeId?: string | undefined;
    externalName?: string | undefined;
    incidentDate?: Date;
    incidentTime?: string;
    placeOfIncident?: string;
    shiftId?: string;
    bodyPartInjured?: string;
    emsCalled?: boolean;
    firstAidAdministered?: boolean;
    byWhomFirstAidAdministered?: string | undefined;
    lostTime?: boolean;
    witnesses?: IncidentWitnessDto[];
    isDrivingEquipment?: boolean;
    isLifting?: boolean;
    isClimbing?: boolean;
    isStanding?: boolean;
    isRunning?: boolean;
    isCarrying?: boolean;
    isSitting?: boolean;
    isLayingDown?: boolean;
    isWalking?: boolean;
    isPushingOrPulling?: boolean;
    isKneeling?: boolean;
    isStretchingOrReclining?: boolean;
    isOther?: boolean;
    equipment?: string | undefined;
    lifting?: string | undefined;
    carrying?: string | undefined;
    pushingOrPulling?: string | undefined;
    other?: string | undefined;
    equipmentIssues?: string | undefined;
    environmentalFactors?: string | undefined;
    basicCauses?: string | undefined;
    rootCause?: string | undefined;
    suggestedSolution?: string | undefined;
    workOrderSent?: boolean;
    workOrderNumber?: string | undefined;
    workOrderTargetCompletionDate?: Date | undefined;
    workOrderActualCompletionDate?: Date | undefined;
    reTrainingNeeded?: boolean;
    reTrainingTopic?: string | undefined;
    reTrainingTargetCompletionDate?: Date | undefined;
    reTrainingTrainer?: string | undefined;
    reTrainingActualCompletionDate?: Date | undefined;
    isCparRequired?: boolean | undefined;
    cparTrackingNumber?: string | undefined;
    riskAssessmentReviewedBy?: string | undefined;
    riskAssessmentReviewedDate?: Date | undefined;
    isCparChangesRequired?: boolean | undefined;
    couldOccurElsewhere?: boolean | undefined;
    wasFoodSafetyImpacted?: boolean | undefined;
    foodSafetyImpactDetails?: string | undefined;
    isSafetyHazard?: boolean;
    isHealthHazard?: boolean;
    isEnvironmentalHazard?: boolean;
    aspectsAndImpactsReviewedBy?: string | undefined;
    areAspectChangesRequired?: boolean | undefined;
    probabilityCriteria?: string | undefined;
    severityCriteria?: string | undefined;
    legalRequirementsReviewedBy?: string | undefined;
    areLegalRequirementChangesRequired?: boolean | undefined;
    riskRanking?: string | undefined;
    created?: Date;
    correctiveActions?: IncidentCorrectiveActionDto[];
    approvals?: IncidentApprovalDto[];
    steps?: IncidentStepDto[];

    constructor(data?: IIncidentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.numberWithPrefix = _data["numberWithPrefix"];
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.status = _data["status"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.canBeApproved = _data["canBeApproved"];
            this.humanResourcesContacted = _data["humanResourcesContacted"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.injuryType = _data["injuryType"];
            this.outsideMedical = _data["outsideMedical"];
            this.employeeId = _data["employeeId"];
            this.externalName = _data["externalName"];
            this.incidentDate = _data["incidentDate"] ? new Date(_data["incidentDate"].toString()) : <any>undefined;
            this.incidentTime = _data["incidentTime"];
            this.placeOfIncident = _data["placeOfIncident"];
            this.shiftId = _data["shiftId"];
            this.bodyPartInjured = _data["bodyPartInjured"];
            this.emsCalled = _data["emsCalled"];
            this.firstAidAdministered = _data["firstAidAdministered"];
            this.byWhomFirstAidAdministered = _data["byWhomFirstAidAdministered"];
            this.lostTime = _data["lostTime"];
            if (Array.isArray(_data["witnesses"])) {
                this.witnesses = [] as any;
                for (let item of _data["witnesses"])
                    this.witnesses!.push(IncidentWitnessDto.fromJS(item));
            }
            this.isDrivingEquipment = _data["isDrivingEquipment"];
            this.isLifting = _data["isLifting"];
            this.isClimbing = _data["isClimbing"];
            this.isStanding = _data["isStanding"];
            this.isRunning = _data["isRunning"];
            this.isCarrying = _data["isCarrying"];
            this.isSitting = _data["isSitting"];
            this.isLayingDown = _data["isLayingDown"];
            this.isWalking = _data["isWalking"];
            this.isPushingOrPulling = _data["isPushingOrPulling"];
            this.isKneeling = _data["isKneeling"];
            this.isStretchingOrReclining = _data["isStretchingOrReclining"];
            this.isOther = _data["isOther"];
            this.equipment = _data["equipment"];
            this.lifting = _data["lifting"];
            this.carrying = _data["carrying"];
            this.pushingOrPulling = _data["pushingOrPulling"];
            this.other = _data["other"];
            this.equipmentIssues = _data["equipmentIssues"];
            this.environmentalFactors = _data["environmentalFactors"];
            this.basicCauses = _data["basicCauses"];
            this.rootCause = _data["rootCause"];
            this.suggestedSolution = _data["suggestedSolution"];
            this.workOrderSent = _data["workOrderSent"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.workOrderTargetCompletionDate = _data["workOrderTargetCompletionDate"] ? new Date(_data["workOrderTargetCompletionDate"].toString()) : <any>undefined;
            this.workOrderActualCompletionDate = _data["workOrderActualCompletionDate"] ? new Date(_data["workOrderActualCompletionDate"].toString()) : <any>undefined;
            this.reTrainingNeeded = _data["reTrainingNeeded"];
            this.reTrainingTopic = _data["reTrainingTopic"];
            this.reTrainingTargetCompletionDate = _data["reTrainingTargetCompletionDate"] ? new Date(_data["reTrainingTargetCompletionDate"].toString()) : <any>undefined;
            this.reTrainingTrainer = _data["reTrainingTrainer"];
            this.reTrainingActualCompletionDate = _data["reTrainingActualCompletionDate"] ? new Date(_data["reTrainingActualCompletionDate"].toString()) : <any>undefined;
            this.isCparRequired = _data["isCparRequired"];
            this.cparTrackingNumber = _data["cparTrackingNumber"];
            this.riskAssessmentReviewedBy = _data["riskAssessmentReviewedBy"];
            this.riskAssessmentReviewedDate = _data["riskAssessmentReviewedDate"] ? new Date(_data["riskAssessmentReviewedDate"].toString()) : <any>undefined;
            this.isCparChangesRequired = _data["isCparChangesRequired"];
            this.couldOccurElsewhere = _data["couldOccurElsewhere"];
            this.wasFoodSafetyImpacted = _data["wasFoodSafetyImpacted"];
            this.foodSafetyImpactDetails = _data["foodSafetyImpactDetails"];
            this.isSafetyHazard = _data["isSafetyHazard"];
            this.isHealthHazard = _data["isHealthHazard"];
            this.isEnvironmentalHazard = _data["isEnvironmentalHazard"];
            this.aspectsAndImpactsReviewedBy = _data["aspectsAndImpactsReviewedBy"];
            this.areAspectChangesRequired = _data["areAspectChangesRequired"];
            this.probabilityCriteria = _data["probabilityCriteria"];
            this.severityCriteria = _data["severityCriteria"];
            this.legalRequirementsReviewedBy = _data["legalRequirementsReviewedBy"];
            this.areLegalRequirementChangesRequired = _data["areLegalRequirementChangesRequired"];
            this.riskRanking = _data["riskRanking"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            if (Array.isArray(_data["correctiveActions"])) {
                this.correctiveActions = [] as any;
                for (let item of _data["correctiveActions"])
                    this.correctiveActions!.push(IncidentCorrectiveActionDto.fromJS(item));
            }
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(IncidentApprovalDto.fromJS(item));
            }
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(IncidentStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["numberWithPrefix"] = this.numberWithPrefix;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["canBeApproved"] = this.canBeApproved;
        data["humanResourcesContacted"] = this.humanResourcesContacted;
        data["category"] = this.category;
        data["type"] = this.type;
        data["location"] = this.location;
        data["injuryType"] = this.injuryType;
        data["outsideMedical"] = this.outsideMedical;
        data["employeeId"] = this.employeeId;
        data["externalName"] = this.externalName;
        data["incidentDate"] = this.incidentDate ? this.incidentDate.toISOString() : <any>undefined;
        data["incidentTime"] = this.incidentTime;
        data["placeOfIncident"] = this.placeOfIncident;
        data["shiftId"] = this.shiftId;
        data["bodyPartInjured"] = this.bodyPartInjured;
        data["emsCalled"] = this.emsCalled;
        data["firstAidAdministered"] = this.firstAidAdministered;
        data["byWhomFirstAidAdministered"] = this.byWhomFirstAidAdministered;
        data["lostTime"] = this.lostTime;
        if (Array.isArray(this.witnesses)) {
            data["witnesses"] = [];
            for (let item of this.witnesses)
                data["witnesses"].push(item.toJSON());
        }
        data["isDrivingEquipment"] = this.isDrivingEquipment;
        data["isLifting"] = this.isLifting;
        data["isClimbing"] = this.isClimbing;
        data["isStanding"] = this.isStanding;
        data["isRunning"] = this.isRunning;
        data["isCarrying"] = this.isCarrying;
        data["isSitting"] = this.isSitting;
        data["isLayingDown"] = this.isLayingDown;
        data["isWalking"] = this.isWalking;
        data["isPushingOrPulling"] = this.isPushingOrPulling;
        data["isKneeling"] = this.isKneeling;
        data["isStretchingOrReclining"] = this.isStretchingOrReclining;
        data["isOther"] = this.isOther;
        data["equipment"] = this.equipment;
        data["lifting"] = this.lifting;
        data["carrying"] = this.carrying;
        data["pushingOrPulling"] = this.pushingOrPulling;
        data["other"] = this.other;
        data["equipmentIssues"] = this.equipmentIssues;
        data["environmentalFactors"] = this.environmentalFactors;
        data["basicCauses"] = this.basicCauses;
        data["rootCause"] = this.rootCause;
        data["suggestedSolution"] = this.suggestedSolution;
        data["workOrderSent"] = this.workOrderSent;
        data["workOrderNumber"] = this.workOrderNumber;
        data["workOrderTargetCompletionDate"] = this.workOrderTargetCompletionDate ? this.workOrderTargetCompletionDate.toISOString() : <any>undefined;
        data["workOrderActualCompletionDate"] = this.workOrderActualCompletionDate ? this.workOrderActualCompletionDate.toISOString() : <any>undefined;
        data["reTrainingNeeded"] = this.reTrainingNeeded;
        data["reTrainingTopic"] = this.reTrainingTopic;
        data["reTrainingTargetCompletionDate"] = this.reTrainingTargetCompletionDate ? this.reTrainingTargetCompletionDate.toISOString() : <any>undefined;
        data["reTrainingTrainer"] = this.reTrainingTrainer;
        data["reTrainingActualCompletionDate"] = this.reTrainingActualCompletionDate ? this.reTrainingActualCompletionDate.toISOString() : <any>undefined;
        data["isCparRequired"] = this.isCparRequired;
        data["cparTrackingNumber"] = this.cparTrackingNumber;
        data["riskAssessmentReviewedBy"] = this.riskAssessmentReviewedBy;
        data["riskAssessmentReviewedDate"] = this.riskAssessmentReviewedDate ? this.riskAssessmentReviewedDate.toISOString() : <any>undefined;
        data["isCparChangesRequired"] = this.isCparChangesRequired;
        data["couldOccurElsewhere"] = this.couldOccurElsewhere;
        data["wasFoodSafetyImpacted"] = this.wasFoodSafetyImpacted;
        data["foodSafetyImpactDetails"] = this.foodSafetyImpactDetails;
        data["isSafetyHazard"] = this.isSafetyHazard;
        data["isHealthHazard"] = this.isHealthHazard;
        data["isEnvironmentalHazard"] = this.isEnvironmentalHazard;
        data["aspectsAndImpactsReviewedBy"] = this.aspectsAndImpactsReviewedBy;
        data["areAspectChangesRequired"] = this.areAspectChangesRequired;
        data["probabilityCriteria"] = this.probabilityCriteria;
        data["severityCriteria"] = this.severityCriteria;
        data["legalRequirementsReviewedBy"] = this.legalRequirementsReviewedBy;
        data["areLegalRequirementChangesRequired"] = this.areLegalRequirementChangesRequired;
        data["riskRanking"] = this.riskRanking;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        if (Array.isArray(this.correctiveActions)) {
            data["correctiveActions"] = [];
            for (let item of this.correctiveActions)
                data["correctiveActions"].push(item.toJSON());
        }
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncidentReportDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    createdBy?: EmployeeDto;
    status?: IncidentStatus;
    lastModified?: Date;
    lastModifiedBy?: string;
    canBeApproved?: boolean;
    humanResourcesContacted?: boolean;
    category?: IncidentCategory;
    type?: IncidentType;
    location?: IncidentLocation;
    injuryType?: InjuryType;
    outsideMedical?: boolean;
    employeeId?: string | undefined;
    externalName?: string | undefined;
    incidentDate?: Date;
    incidentTime?: string;
    placeOfIncident?: string;
    shiftId?: string;
    bodyPartInjured?: string;
    emsCalled?: boolean;
    firstAidAdministered?: boolean;
    byWhomFirstAidAdministered?: string | undefined;
    lostTime?: boolean;
    witnesses?: IncidentWitnessDto[];
    isDrivingEquipment?: boolean;
    isLifting?: boolean;
    isClimbing?: boolean;
    isStanding?: boolean;
    isRunning?: boolean;
    isCarrying?: boolean;
    isSitting?: boolean;
    isLayingDown?: boolean;
    isWalking?: boolean;
    isPushingOrPulling?: boolean;
    isKneeling?: boolean;
    isStretchingOrReclining?: boolean;
    isOther?: boolean;
    equipment?: string | undefined;
    lifting?: string | undefined;
    carrying?: string | undefined;
    pushingOrPulling?: string | undefined;
    other?: string | undefined;
    equipmentIssues?: string | undefined;
    environmentalFactors?: string | undefined;
    basicCauses?: string | undefined;
    rootCause?: string | undefined;
    suggestedSolution?: string | undefined;
    workOrderSent?: boolean;
    workOrderNumber?: string | undefined;
    workOrderTargetCompletionDate?: Date | undefined;
    workOrderActualCompletionDate?: Date | undefined;
    reTrainingNeeded?: boolean;
    reTrainingTopic?: string | undefined;
    reTrainingTargetCompletionDate?: Date | undefined;
    reTrainingTrainer?: string | undefined;
    reTrainingActualCompletionDate?: Date | undefined;
    isCparRequired?: boolean | undefined;
    cparTrackingNumber?: string | undefined;
    riskAssessmentReviewedBy?: string | undefined;
    riskAssessmentReviewedDate?: Date | undefined;
    isCparChangesRequired?: boolean | undefined;
    couldOccurElsewhere?: boolean | undefined;
    wasFoodSafetyImpacted?: boolean | undefined;
    foodSafetyImpactDetails?: string | undefined;
    isSafetyHazard?: boolean;
    isHealthHazard?: boolean;
    isEnvironmentalHazard?: boolean;
    aspectsAndImpactsReviewedBy?: string | undefined;
    areAspectChangesRequired?: boolean | undefined;
    probabilityCriteria?: string | undefined;
    severityCriteria?: string | undefined;
    legalRequirementsReviewedBy?: string | undefined;
    areLegalRequirementChangesRequired?: boolean | undefined;
    riskRanking?: string | undefined;
    created?: Date;
    correctiveActions?: IncidentCorrectiveActionDto[];
    approvals?: IncidentApprovalDto[];
    steps?: IncidentStepDto[];
}

export enum IncidentStatus {
    PendingApproval = "PendingApproval",
    Approved = "Approved",
}

export class IncidentApprovalDto implements IIncidentApprovalDto {
    employeeId?: string;
    employee?: EmployeeDto;
    approvedDate?: Date;

    constructor(data?: IIncidentApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIncidentApprovalDto {
    employeeId?: string;
    employee?: EmployeeDto;
    approvedDate?: Date;
}

export class IncidentReportExportQuery extends MyScoreQueryOfExportedFileDto implements IIncidentReportExportQuery {
    isObservations?: boolean;

    constructor(data?: IIncidentReportExportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isObservations = _data["isObservations"];
        }
    }

    static override fromJS(data: any): IncidentReportExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportExportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isObservations"] = this.isObservations;
        super.toJSON(data);
        return data;
    }
}

export interface IIncidentReportExportQuery extends IMyScoreQueryOfExportedFileDto {
    isObservations?: boolean;
}

export class IncidentReportQuery extends MyScoreShiftQuery implements IIncidentReportQuery {
    isObservations?: boolean;

    constructor(data?: IIncidentReportQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isObservations = _data["isObservations"];
        }
    }

    static override fromJS(data: any): IncidentReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isObservations"] = this.isObservations;
        super.toJSON(data);
        return data;
    }
}

export interface IIncidentReportQuery extends IMyScoreShiftQuery {
    isObservations?: boolean;
}

export class IncidentReportTrendingQuery extends TrendingQuery implements IIncidentReportTrendingQuery {
    isObservations?: boolean;

    constructor(data?: IIncidentReportTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isObservations = _data["isObservations"];
        }
    }

    static override fromJS(data: any): IncidentReportTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isObservations"] = this.isObservations;
        super.toJSON(data);
        return data;
    }
}

export interface IIncidentReportTrendingQuery extends ITrendingQuery {
    isObservations?: boolean;
}

export class CreateProductivitySettingCommand implements ICreateProductivitySettingCommand {
    value?: number;
    month?: Month;
    year?: number;

    constructor(data?: ICreateProductivitySettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CreateProductivitySettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductivitySettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ICreateProductivitySettingCommand {
    value?: number;
    month?: Month;
    year?: number;
}

export enum Month {
    January = "January",
    February = "February",
    March = "March",
    April = "April",
    May = "May",
    June = "June",
    July = "July",
    August = "August",
    September = "September",
    October = "October",
    November = "November",
    December = "December",
}

export class UpdateProductivitySettingCommand extends CreateProductivitySettingCommand implements IUpdateProductivitySettingCommand {
    id?: string;

    constructor(data?: IUpdateProductivitySettingCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateProductivitySettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductivitySettingCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateProductivitySettingCommand extends ICreateProductivitySettingCommand {
    id?: string;
}

export class NextViewScoreExportQuery implements INextViewScoreExportQuery {
    shiftType?: ShiftType | undefined;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: INextViewScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftType = _data["shiftType"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NextViewScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new NextViewScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftType"] = this.shiftType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface INextViewScoreExportQuery {
    shiftType?: ShiftType | undefined;
    from?: Date;
    to?: Date | undefined;
}

export class NextViewScoreQuery implements INextViewScoreQuery {
    shiftType?: ShiftType | undefined;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: INextViewScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftType = _data["shiftType"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NextViewScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new NextViewScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftType"] = this.shiftType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface INextViewScoreQuery {
    shiftType?: ShiftType | undefined;
    from?: Date;
    to?: Date | undefined;
}

export class YearToDateScoreExportQuery implements IYearToDateScoreExportQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IYearToDateScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): YearToDateScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new YearToDateScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IYearToDateScoreExportQuery {
    from?: Date;
    to?: Date | undefined;
}

export class YearToDateScoreQuery implements IYearToDateScoreQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IYearToDateScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): YearToDateScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new YearToDateScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IYearToDateScoreQuery {
    from?: Date;
    to?: Date | undefined;
}

export class YearToDateSummaryDto implements IYearToDateSummaryDto {
    inboundVolumeCases?: number;
    inboundVolumePallets?: number;
    outboundVolumeCases?: number;
    outboundVolumePallets?: number;
    casePickVolume?: number;
    layerPickVolume?: number;
    mpsPallets?: number;

    constructor(data?: IYearToDateSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inboundVolumeCases = _data["inboundVolumeCases"];
            this.inboundVolumePallets = _data["inboundVolumePallets"];
            this.outboundVolumeCases = _data["outboundVolumeCases"];
            this.outboundVolumePallets = _data["outboundVolumePallets"];
            this.casePickVolume = _data["casePickVolume"];
            this.layerPickVolume = _data["layerPickVolume"];
            this.mpsPallets = _data["mpsPallets"];
        }
    }

    static fromJS(data: any): YearToDateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearToDateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inboundVolumeCases"] = this.inboundVolumeCases;
        data["inboundVolumePallets"] = this.inboundVolumePallets;
        data["outboundVolumeCases"] = this.outboundVolumeCases;
        data["outboundVolumePallets"] = this.outboundVolumePallets;
        data["casePickVolume"] = this.casePickVolume;
        data["layerPickVolume"] = this.layerPickVolume;
        data["mpsPallets"] = this.mpsPallets;
        return data;
    }
}

export interface IYearToDateSummaryDto {
    inboundVolumeCases?: number;
    inboundVolumePallets?: number;
    outboundVolumeCases?: number;
    outboundVolumePallets?: number;
    casePickVolume?: number;
    layerPickVolume?: number;
    mpsPallets?: number;
}

export class GetYearToDateSummaryQuery implements IGetYearToDateSummaryQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IGetYearToDateSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetYearToDateSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetYearToDateSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetYearToDateSummaryQuery {
    from?: Date;
    to?: Date | undefined;
}

export class CreateCustomerCommand implements ICreateCustomerCommand {
    number?: string;
    status?: CustomerStatus;
    name?: string;
    address?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICreateCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateCustomerCommand {
    number?: string;
    status?: CustomerStatus;
    name?: string;
    address?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export enum CustomerStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class UpdateCustomerCommand extends CreateCustomerCommand implements IUpdateCustomerCommand {
    id?: string;

    constructor(data?: IUpdateCustomerCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCustomerCommand extends ICreateCustomerCommand {
    id?: string;
}

export class UpdateEmptyCheckOutCommand implements IUpdateEmptyCheckOutCommand {
    number?: string;
    action?: EmptyCheckOutAction;
    carrierId?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    driverName?: string | undefined;
    tractor?: string | undefined;
    isTrailerEmpty?: boolean | undefined;
    sealNumber?: string | undefined;
    shipments?: string[];

    constructor(data?: IUpdateEmptyCheckOutCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.action = _data["action"];
            this.carrierId = _data["carrierId"];
            this.trailerType = _data["trailerType"];
            this.trailerNumber = _data["trailerNumber"];
            this.driverName = _data["driverName"];
            this.tractor = _data["tractor"];
            this.isTrailerEmpty = _data["isTrailerEmpty"];
            this.sealNumber = _data["sealNumber"];
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateEmptyCheckOutCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmptyCheckOutCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["action"] = this.action;
        data["carrierId"] = this.carrierId;
        data["trailerType"] = this.trailerType;
        data["trailerNumber"] = this.trailerNumber;
        data["driverName"] = this.driverName;
        data["tractor"] = this.tractor;
        data["isTrailerEmpty"] = this.isTrailerEmpty;
        data["sealNumber"] = this.sealNumber;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item);
        }
        return data;
    }
}

export interface IUpdateEmptyCheckOutCommand {
    number?: string;
    action?: EmptyCheckOutAction;
    carrierId?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    driverName?: string | undefined;
    tractor?: string | undefined;
    isTrailerEmpty?: boolean | undefined;
    sealNumber?: string | undefined;
    shipments?: string[];
}

export enum EmptyCheckOutAction {
    Save = "Save",
    CheckOut = "CheckOut",
    InvestigationCompleted = "InvestigationCompleted",
    CompleteMove = "CompleteMove",
    CancelMove = "CancelMove",
    ShuntMove = "ShuntMove",
    Investigate = "Investigate",
}

export enum TrailerType {
    ReeferTandem = "ReeferTandem",
    ReeferTriAxle = "ReeferTriAxle",
    HeaterTandem = "HeaterTandem",
    HeaterTriAxle = "HeaterTriAxle",
    DryTandem = "DryTandem",
    DryTriAxle = "DryTriAxle",
}

export class ShuntEmptyCheckOutCommand extends UpdateEmptyCheckOutCommand implements IShuntEmptyCheckOutCommand {
    shuntMoveLocation?: ShuntLocationType;
    shuntMoveLocationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;

    constructor(data?: IShuntEmptyCheckOutCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shuntMoveLocation = _data["shuntMoveLocation"];
            this.shuntMoveLocationId = _data["shuntMoveLocationId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static override fromJS(data: any): ShuntEmptyCheckOutCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntEmptyCheckOutCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shuntMoveLocation"] = this.shuntMoveLocation;
        data["shuntMoveLocationId"] = this.shuntMoveLocationId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        super.toJSON(data);
        return data;
    }
}

export interface IShuntEmptyCheckOutCommand extends IUpdateEmptyCheckOutCommand {
    shuntMoveLocation?: ShuntLocationType;
    shuntMoveLocationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;
}

export class EmptyCheckOutDto implements IEmptyCheckOutDto {
    id?: string;
    numberWithPrefix?: string;
    emptyCheckInNumber?: string | undefined;
    appointmentNumber?: string | undefined;
    status?: EmptyCheckOutStatus;
    carrierId?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    driverName?: string | undefined;
    tractor?: string | undefined;
    isTrailerEmpty?: boolean | undefined;
    sealNumber?: string | undefined;
    shipments?: string[];
    actions?: EmptyCheckOutAction[];

    constructor(data?: IEmptyCheckOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberWithPrefix = _data["numberWithPrefix"];
            this.emptyCheckInNumber = _data["emptyCheckInNumber"];
            this.appointmentNumber = _data["appointmentNumber"];
            this.status = _data["status"];
            this.carrierId = _data["carrierId"];
            this.trailerType = _data["trailerType"];
            this.trailerNumber = _data["trailerNumber"];
            this.driverName = _data["driverName"];
            this.tractor = _data["tractor"];
            this.isTrailerEmpty = _data["isTrailerEmpty"];
            this.sealNumber = _data["sealNumber"];
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(item);
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
        }
    }

    static fromJS(data: any): EmptyCheckOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCheckOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberWithPrefix"] = this.numberWithPrefix;
        data["emptyCheckInNumber"] = this.emptyCheckInNumber;
        data["appointmentNumber"] = this.appointmentNumber;
        data["status"] = this.status;
        data["carrierId"] = this.carrierId;
        data["trailerType"] = this.trailerType;
        data["trailerNumber"] = this.trailerNumber;
        data["driverName"] = this.driverName;
        data["tractor"] = this.tractor;
        data["isTrailerEmpty"] = this.isTrailerEmpty;
        data["sealNumber"] = this.sealNumber;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        return data;
    }
}

export interface IEmptyCheckOutDto {
    id?: string;
    numberWithPrefix?: string;
    emptyCheckInNumber?: string | undefined;
    appointmentNumber?: string | undefined;
    status?: EmptyCheckOutStatus;
    carrierId?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    driverName?: string | undefined;
    tractor?: string | undefined;
    isTrailerEmpty?: boolean | undefined;
    sealNumber?: string | undefined;
    shipments?: string[];
    actions?: EmptyCheckOutAction[];
}

export enum EmptyCheckOutStatus {
    ReadyForCheckout = "ReadyForCheckout",
    CheckedOut = "CheckedOut",
    Investigation = "Investigation",
    ShuntMovePending = "ShuntMovePending",
    ReadyForCheckoutEmpty = "ReadyForCheckoutEmpty",
    CheckedOutEmpty = "CheckedOutEmpty",
    ReadyForCheckoutLoaded = "ReadyForCheckoutLoaded",
    CheckedOutLoaded = "CheckedOutLoaded",
}

export class OrderGridViewDto implements IOrderGridViewDto {
    salesDocument?: string;
    documentDate?: Date | undefined;
    logisticalGroup?: string | undefined;
    deliveryNumber?: string | undefined;
    stagingArea?: string | undefined;
    salesOrganization?: string | undefined;
    overallWmStatus?: OrderWmStatus;
    preProductionStatus?: PreProductionStatus;
    productionStatus?: ProductionStatus | undefined;
    emptyTrailerNumber?: string | undefined;
    outboundNumber?: string | undefined;
    exception?: OrderHeaderException | undefined;
    appointmentStatus?: OrderAppointmentStatus | undefined;
    appointment?: Date | undefined;
    appointmentOverride?: OrderAppointmentOverride;
    manualAppointment?: Date | undefined;
    mdt?: Date | undefined;
    missedOpportunities?: MissedOpportunity[];
    casePick?: number;
    layerPick?: number;
    palletPick?: number;
    requestedDeliveryDate?: Date | undefined;
    deliveryAppointment?: Date | undefined;
    loading?: Date | undefined;
    deliveryDateTime?: Date | undefined;
    deliveryCreated?: Date | undefined;
    sourceLocationAppointmentDate?: Date | undefined;
    destinationLocationAppointmentDate?: Date | undefined;
    destinationLocationAppointmentTimeZone?: string | undefined;
    shipToId?: string | undefined;
    shipToName?: string | undefined;
    shipToStreet?: string | undefined;
    shipToStreetNumber?: string | undefined;
    shipToCity?: string | undefined;
    shipToRegion?: string | undefined;
    shipToPostalCode?: string | undefined;

    constructor(data?: IOrderGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesDocument = _data["salesDocument"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.logisticalGroup = _data["logisticalGroup"];
            this.deliveryNumber = _data["deliveryNumber"];
            this.stagingArea = _data["stagingArea"];
            this.salesOrganization = _data["salesOrganization"];
            this.overallWmStatus = _data["overallWmStatus"];
            this.preProductionStatus = _data["preProductionStatus"];
            this.productionStatus = _data["productionStatus"];
            this.emptyTrailerNumber = _data["emptyTrailerNumber"];
            this.outboundNumber = _data["outboundNumber"];
            this.exception = _data["exception"];
            this.appointmentStatus = _data["appointmentStatus"];
            this.appointment = _data["appointment"] ? new Date(_data["appointment"].toString()) : <any>undefined;
            this.appointmentOverride = _data["appointmentOverride"];
            this.manualAppointment = _data["manualAppointment"] ? new Date(_data["manualAppointment"].toString()) : <any>undefined;
            this.mdt = _data["mdt"] ? new Date(_data["mdt"].toString()) : <any>undefined;
            if (Array.isArray(_data["missedOpportunities"])) {
                this.missedOpportunities = [] as any;
                for (let item of _data["missedOpportunities"])
                    this.missedOpportunities!.push(item);
            }
            this.casePick = _data["casePick"];
            this.layerPick = _data["layerPick"];
            this.palletPick = _data["palletPick"];
            this.requestedDeliveryDate = _data["requestedDeliveryDate"] ? new Date(_data["requestedDeliveryDate"].toString()) : <any>undefined;
            this.deliveryAppointment = _data["deliveryAppointment"] ? new Date(_data["deliveryAppointment"].toString()) : <any>undefined;
            this.loading = _data["loading"] ? new Date(_data["loading"].toString()) : <any>undefined;
            this.deliveryDateTime = _data["deliveryDateTime"] ? new Date(_data["deliveryDateTime"].toString()) : <any>undefined;
            this.deliveryCreated = _data["deliveryCreated"] ? new Date(_data["deliveryCreated"].toString()) : <any>undefined;
            this.sourceLocationAppointmentDate = _data["sourceLocationAppointmentDate"] ? new Date(_data["sourceLocationAppointmentDate"].toString()) : <any>undefined;
            this.destinationLocationAppointmentDate = _data["destinationLocationAppointmentDate"] ? new Date(_data["destinationLocationAppointmentDate"].toString()) : <any>undefined;
            this.destinationLocationAppointmentTimeZone = _data["destinationLocationAppointmentTimeZone"];
            this.shipToId = _data["shipToId"];
            this.shipToName = _data["shipToName"];
            this.shipToStreet = _data["shipToStreet"];
            this.shipToStreetNumber = _data["shipToStreetNumber"];
            this.shipToCity = _data["shipToCity"];
            this.shipToRegion = _data["shipToRegion"];
            this.shipToPostalCode = _data["shipToPostalCode"];
        }
    }

    static fromJS(data: any): OrderGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesDocument"] = this.salesDocument;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["logisticalGroup"] = this.logisticalGroup;
        data["deliveryNumber"] = this.deliveryNumber;
        data["stagingArea"] = this.stagingArea;
        data["salesOrganization"] = this.salesOrganization;
        data["overallWmStatus"] = this.overallWmStatus;
        data["preProductionStatus"] = this.preProductionStatus;
        data["productionStatus"] = this.productionStatus;
        data["emptyTrailerNumber"] = this.emptyTrailerNumber;
        data["outboundNumber"] = this.outboundNumber;
        data["exception"] = this.exception;
        data["appointmentStatus"] = this.appointmentStatus;
        data["appointment"] = this.appointment ? this.appointment.toISOString() : <any>undefined;
        data["appointmentOverride"] = this.appointmentOverride;
        data["manualAppointment"] = this.manualAppointment ? this.manualAppointment.toISOString() : <any>undefined;
        data["mdt"] = this.mdt ? this.mdt.toISOString() : <any>undefined;
        if (Array.isArray(this.missedOpportunities)) {
            data["missedOpportunities"] = [];
            for (let item of this.missedOpportunities)
                data["missedOpportunities"].push(item);
        }
        data["casePick"] = this.casePick;
        data["layerPick"] = this.layerPick;
        data["palletPick"] = this.palletPick;
        data["requestedDeliveryDate"] = this.requestedDeliveryDate ? this.requestedDeliveryDate.toISOString() : <any>undefined;
        data["deliveryAppointment"] = this.deliveryAppointment ? this.deliveryAppointment.toISOString() : <any>undefined;
        data["loading"] = this.loading ? this.loading.toISOString() : <any>undefined;
        data["deliveryDateTime"] = this.deliveryDateTime ? this.deliveryDateTime.toISOString() : <any>undefined;
        data["deliveryCreated"] = this.deliveryCreated ? this.deliveryCreated.toISOString() : <any>undefined;
        data["sourceLocationAppointmentDate"] = this.sourceLocationAppointmentDate ? this.sourceLocationAppointmentDate.toISOString() : <any>undefined;
        data["destinationLocationAppointmentDate"] = this.destinationLocationAppointmentDate ? this.destinationLocationAppointmentDate.toISOString() : <any>undefined;
        data["destinationLocationAppointmentTimeZone"] = this.destinationLocationAppointmentTimeZone;
        data["shipToId"] = this.shipToId;
        data["shipToName"] = this.shipToName;
        data["shipToStreet"] = this.shipToStreet;
        data["shipToStreetNumber"] = this.shipToStreetNumber;
        data["shipToCity"] = this.shipToCity;
        data["shipToRegion"] = this.shipToRegion;
        data["shipToPostalCode"] = this.shipToPostalCode;
        return data;
    }
}

export interface IOrderGridViewDto {
    salesDocument?: string;
    documentDate?: Date | undefined;
    logisticalGroup?: string | undefined;
    deliveryNumber?: string | undefined;
    stagingArea?: string | undefined;
    salesOrganization?: string | undefined;
    overallWmStatus?: OrderWmStatus;
    preProductionStatus?: PreProductionStatus;
    productionStatus?: ProductionStatus | undefined;
    emptyTrailerNumber?: string | undefined;
    outboundNumber?: string | undefined;
    exception?: OrderHeaderException | undefined;
    appointmentStatus?: OrderAppointmentStatus | undefined;
    appointment?: Date | undefined;
    appointmentOverride?: OrderAppointmentOverride;
    manualAppointment?: Date | undefined;
    mdt?: Date | undefined;
    missedOpportunities?: MissedOpportunity[];
    casePick?: number;
    layerPick?: number;
    palletPick?: number;
    requestedDeliveryDate?: Date | undefined;
    deliveryAppointment?: Date | undefined;
    loading?: Date | undefined;
    deliveryDateTime?: Date | undefined;
    deliveryCreated?: Date | undefined;
    sourceLocationAppointmentDate?: Date | undefined;
    destinationLocationAppointmentDate?: Date | undefined;
    destinationLocationAppointmentTimeZone?: string | undefined;
    shipToId?: string | undefined;
    shipToName?: string | undefined;
    shipToStreet?: string | undefined;
    shipToStreetNumber?: string | undefined;
    shipToCity?: string | undefined;
    shipToRegion?: string | undefined;
    shipToPostalCode?: string | undefined;
}

export class OrderDto extends OrderGridViewDto implements IOrderDto {
    lines?: OrderLineDto[];

    constructor(data?: IOrderDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderLineDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDto extends IOrderGridViewDto {
    lines?: OrderLineDto[];
}

export class OrderLineDto implements IOrderLineDto {
    salesDocument?: string;
    salesDocumentItem?: string;
    material?: string;
    productionItem?: string | undefined;
    orderQuantity?: number | undefined;
    orderConfirmedQuantity?: number | undefined;
    actualQuantityDelivered?: number | undefined;
    deliveryQuantity?: number;
    referenceItem?: string | undefined;
    poNumber?: string | undefined;
    materialDescription?: string | undefined;
    reasonForRejection?: string | undefined;
    logisticalGroup?: string | undefined;
    salesOrganization?: string | undefined;
    deliveryNumber?: string | undefined;
    batch?: string | undefined;
    wmActivityStatus?: OrderWmStatus | undefined;
    overallPickStatus?: OrderWmStatus | undefined;
    preProductionStatus?: PreProductionStatus | undefined;
    deliveryCreated?: Date | undefined;
    releasedToHdcAt?: Date | undefined;
    exceptions?: OrderException[];
    casesPerLayer?: number | undefined;
    casesPerPallet?: number | undefined;
    casePick?: number;
    layerPick?: number;
    palletPick?: number;
    missedOpportunities?: MissedOpportunity[];
    corporateBrand?: string | undefined;
    corporateBrandDescription?: string | undefined;
    rangeBrand?: string | undefined;
    rangeBrandDescription?: string | undefined;
    brandDenomination?: string | undefined;
    brandDenominationD?: string | undefined;

    constructor(data?: IOrderLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesDocument = _data["salesDocument"];
            this.salesDocumentItem = _data["salesDocumentItem"];
            this.material = _data["material"];
            this.productionItem = _data["productionItem"];
            this.orderQuantity = _data["orderQuantity"];
            this.orderConfirmedQuantity = _data["orderConfirmedQuantity"];
            this.actualQuantityDelivered = _data["actualQuantityDelivered"];
            this.deliveryQuantity = _data["deliveryQuantity"];
            this.referenceItem = _data["referenceItem"];
            this.poNumber = _data["poNumber"];
            this.materialDescription = _data["materialDescription"];
            this.reasonForRejection = _data["reasonForRejection"];
            this.logisticalGroup = _data["logisticalGroup"];
            this.salesOrganization = _data["salesOrganization"];
            this.deliveryNumber = _data["deliveryNumber"];
            this.batch = _data["batch"];
            this.wmActivityStatus = _data["wmActivityStatus"];
            this.overallPickStatus = _data["overallPickStatus"];
            this.preProductionStatus = _data["preProductionStatus"];
            this.deliveryCreated = _data["deliveryCreated"] ? new Date(_data["deliveryCreated"].toString()) : <any>undefined;
            this.releasedToHdcAt = _data["releasedToHdcAt"] ? new Date(_data["releasedToHdcAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["exceptions"])) {
                this.exceptions = [] as any;
                for (let item of _data["exceptions"])
                    this.exceptions!.push(item);
            }
            this.casesPerLayer = _data["casesPerLayer"];
            this.casesPerPallet = _data["casesPerPallet"];
            this.casePick = _data["casePick"];
            this.layerPick = _data["layerPick"];
            this.palletPick = _data["palletPick"];
            if (Array.isArray(_data["missedOpportunities"])) {
                this.missedOpportunities = [] as any;
                for (let item of _data["missedOpportunities"])
                    this.missedOpportunities!.push(item);
            }
            this.corporateBrand = _data["corporateBrand"];
            this.corporateBrandDescription = _data["corporateBrandDescription"];
            this.rangeBrand = _data["rangeBrand"];
            this.rangeBrandDescription = _data["rangeBrandDescription"];
            this.brandDenomination = _data["brandDenomination"];
            this.brandDenominationD = _data["brandDenominationD"];
        }
    }

    static fromJS(data: any): OrderLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesDocument"] = this.salesDocument;
        data["salesDocumentItem"] = this.salesDocumentItem;
        data["material"] = this.material;
        data["productionItem"] = this.productionItem;
        data["orderQuantity"] = this.orderQuantity;
        data["orderConfirmedQuantity"] = this.orderConfirmedQuantity;
        data["actualQuantityDelivered"] = this.actualQuantityDelivered;
        data["deliveryQuantity"] = this.deliveryQuantity;
        data["referenceItem"] = this.referenceItem;
        data["poNumber"] = this.poNumber;
        data["materialDescription"] = this.materialDescription;
        data["reasonForRejection"] = this.reasonForRejection;
        data["logisticalGroup"] = this.logisticalGroup;
        data["salesOrganization"] = this.salesOrganization;
        data["deliveryNumber"] = this.deliveryNumber;
        data["batch"] = this.batch;
        data["wmActivityStatus"] = this.wmActivityStatus;
        data["overallPickStatus"] = this.overallPickStatus;
        data["preProductionStatus"] = this.preProductionStatus;
        data["deliveryCreated"] = this.deliveryCreated ? this.deliveryCreated.toISOString() : <any>undefined;
        data["releasedToHdcAt"] = this.releasedToHdcAt ? this.releasedToHdcAt.toISOString() : <any>undefined;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item);
        }
        data["casesPerLayer"] = this.casesPerLayer;
        data["casesPerPallet"] = this.casesPerPallet;
        data["casePick"] = this.casePick;
        data["layerPick"] = this.layerPick;
        data["palletPick"] = this.palletPick;
        if (Array.isArray(this.missedOpportunities)) {
            data["missedOpportunities"] = [];
            for (let item of this.missedOpportunities)
                data["missedOpportunities"].push(item);
        }
        data["corporateBrand"] = this.corporateBrand;
        data["corporateBrandDescription"] = this.corporateBrandDescription;
        data["rangeBrand"] = this.rangeBrand;
        data["rangeBrandDescription"] = this.rangeBrandDescription;
        data["brandDenomination"] = this.brandDenomination;
        data["brandDenominationD"] = this.brandDenominationD;
        return data;
    }
}

export interface IOrderLineDto {
    salesDocument?: string;
    salesDocumentItem?: string;
    material?: string;
    productionItem?: string | undefined;
    orderQuantity?: number | undefined;
    orderConfirmedQuantity?: number | undefined;
    actualQuantityDelivered?: number | undefined;
    deliveryQuantity?: number;
    referenceItem?: string | undefined;
    poNumber?: string | undefined;
    materialDescription?: string | undefined;
    reasonForRejection?: string | undefined;
    logisticalGroup?: string | undefined;
    salesOrganization?: string | undefined;
    deliveryNumber?: string | undefined;
    batch?: string | undefined;
    wmActivityStatus?: OrderWmStatus | undefined;
    overallPickStatus?: OrderWmStatus | undefined;
    preProductionStatus?: PreProductionStatus | undefined;
    deliveryCreated?: Date | undefined;
    releasedToHdcAt?: Date | undefined;
    exceptions?: OrderException[];
    casesPerLayer?: number | undefined;
    casesPerPallet?: number | undefined;
    casePick?: number;
    layerPick?: number;
    palletPick?: number;
    missedOpportunities?: MissedOpportunity[];
    corporateBrand?: string | undefined;
    corporateBrandDescription?: string | undefined;
    rangeBrand?: string | undefined;
    rangeBrandDescription?: string | undefined;
    brandDenomination?: string | undefined;
    brandDenominationD?: string | undefined;
}

export enum OrderWmStatus {
    A = "A",
    B = "B",
    C = "C",
}

export enum PreProductionStatus {
    PoReceived = "PoReceived",
    Planning = "Planning",
    Rejection = "Rejection",
    NoStock = "NoStock",
    ReleasedToHdc = "ReleasedToHdc",
    LateReleasedToHdc = "LateReleasedToHdc",
    ReleasedToHdcSto = "ReleasedToHdcSto",
}

export enum OrderException {
    CNumberMismatch = "CNumberMismatch",
    DeliveryNumberMismatch = "DeliveryNumberMismatch",
    PickStatusMismatch = "PickStatusMismatch",
    DeliveryDateMismatch = "DeliveryDateMismatch",
}

export enum MissedOpportunity {
    LayerOpportunity = "LayerOpportunity",
    PalletOpportunity = "PalletOpportunity",
}

export enum ProductionStatus {
    InProductionNoStaging = "InProductionNoStaging",
    InProduction = "InProduction",
    PickingNoStaging = "PickingNoStaging",
    Picking = "Picking",
    ReadyToLoadNoStaging = "ReadyToLoadNoStaging",
    ReadyToLoad = "ReadyToLoad",
    ReadyForCheckout = "ReadyForCheckout",
    CheckedOut = "CheckedOut",
    Loading = "Loading",
    LoadedOnTime = "LoadedOnTime",
    LoadedLate = "LoadedLate",
}

export enum OrderHeaderException {
    Mismatch = "Mismatch",
}

export enum OrderAppointmentStatus {
    NoAppointmentAssigned = "NoAppointmentAssigned",
    AppointmentAssigned = "AppointmentAssigned",
    AppointmentConfirmed = "AppointmentConfirmed",
    LtlLoad = "LtlLoad",
    ManualAppointmentSet = "ManualAppointmentSet",
}

export enum OrderAppointmentOverride {
    None = "None",
    Ltl = "Ltl",
    Manual = "Manual",
}

export class UpdateOrderAppointmentOverrideCommand implements IUpdateOrderAppointmentOverrideCommand {
    number?: string;
    override?: OrderAppointmentOverride;
    manualAppointment?: Date | undefined;

    constructor(data?: IUpdateOrderAppointmentOverrideCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.override = _data["override"];
            this.manualAppointment = _data["manualAppointment"] ? new Date(_data["manualAppointment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOrderAppointmentOverrideCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderAppointmentOverrideCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["override"] = this.override;
        data["manualAppointment"] = this.manualAppointment ? this.manualAppointment.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateOrderAppointmentOverrideCommand {
    number?: string;
    override?: OrderAppointmentOverride;
    manualAppointment?: Date | undefined;
}

export class OrderPlanningMixScoreDto implements IOrderPlanningMixScoreDto {
    myScorePercent?: number;
    totals?: { [key: string]: number; };

    constructor(data?: IOrderPlanningMixScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myScorePercent = _data["myScorePercent"];
            if (_data["totals"]) {
                this.totals = {} as any;
                for (let key in _data["totals"]) {
                    if (_data["totals"].hasOwnProperty(key))
                        (<any>this.totals)![key] = _data["totals"][key];
                }
            }
        }
    }

    static fromJS(data: any): OrderPlanningMixScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPlanningMixScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myScorePercent"] = this.myScorePercent;
        if (this.totals) {
            data["totals"] = {};
            for (let key in this.totals) {
                if (this.totals.hasOwnProperty(key))
                    (<any>data["totals"])[key] = (<any>this.totals)[key];
            }
        }
        return data;
    }
}

export interface IOrderPlanningMixScoreDto {
    myScorePercent?: number;
    totals?: { [key: string]: number; };
}

export abstract class OutboundMyScoreQueryOfOrderPlanningMixScoreDto implements IOutboundMyScoreQueryOfOrderPlanningMixScoreDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;

    constructor(data?: IOutboundMyScoreQueryOfOrderPlanningMixScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.fromHour = _data["fromHour"];
            this.toHour = _data["toHour"];
        }
    }

    static fromJS(data: any): OutboundMyScoreQueryOfOrderPlanningMixScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OutboundMyScoreQueryOfOrderPlanningMixScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        return data;
    }
}

export interface IOutboundMyScoreQueryOfOrderPlanningMixScoreDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;
}

export abstract class OrderPlanningMixQueryOfOrderPlanningMixScoreDto extends OutboundMyScoreQueryOfOrderPlanningMixScoreDto implements IOrderPlanningMixQueryOfOrderPlanningMixScoreDto {

    constructor(data?: IOrderPlanningMixQueryOfOrderPlanningMixScoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OrderPlanningMixQueryOfOrderPlanningMixScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OrderPlanningMixQueryOfOrderPlanningMixScoreDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOrderPlanningMixQueryOfOrderPlanningMixScoreDto extends IOutboundMyScoreQueryOfOrderPlanningMixScoreDto {
}

export class GetOrderPlanningMixScoreQuery extends OrderPlanningMixQueryOfOrderPlanningMixScoreDto implements IGetOrderPlanningMixScoreQuery {

    constructor(data?: IGetOrderPlanningMixScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetOrderPlanningMixScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderPlanningMixScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrderPlanningMixScoreQuery extends IOrderPlanningMixQueryOfOrderPlanningMixScoreDto {
}

export class OrderPlanningMixTrendingDto implements IOrderPlanningMixTrendingDto {
    points?: OrderPlanningMixTrendingPoint[];

    constructor(data?: IOrderPlanningMixTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(OrderPlanningMixTrendingPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderPlanningMixTrendingDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPlanningMixTrendingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderPlanningMixTrendingDto {
    points?: OrderPlanningMixTrendingPoint[];
}

export class OrderPlanningMixTrendingPoint implements IOrderPlanningMixTrendingPoint {
    period?: Date;
    loosePercent?: number;
    layerPercent?: number;
    fullPalletPercent?: number;

    constructor(data?: IOrderPlanningMixTrendingPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? new Date(_data["period"].toString()) : <any>undefined;
            this.loosePercent = _data["loosePercent"];
            this.layerPercent = _data["layerPercent"];
            this.fullPalletPercent = _data["fullPalletPercent"];
        }
    }

    static fromJS(data: any): OrderPlanningMixTrendingPoint {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPlanningMixTrendingPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toISOString() : <any>undefined;
        data["loosePercent"] = this.loosePercent;
        data["layerPercent"] = this.layerPercent;
        data["fullPalletPercent"] = this.fullPalletPercent;
        return data;
    }
}

export interface IOrderPlanningMixTrendingPoint {
    period?: Date;
    loosePercent?: number;
    layerPercent?: number;
    fullPalletPercent?: number;
}

export abstract class OutboundMyScoreQueryOfOrderPlanningMixTrendingDto implements IOutboundMyScoreQueryOfOrderPlanningMixTrendingDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;

    constructor(data?: IOutboundMyScoreQueryOfOrderPlanningMixTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.fromHour = _data["fromHour"];
            this.toHour = _data["toHour"];
        }
    }

    static fromJS(data: any): OutboundMyScoreQueryOfOrderPlanningMixTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OutboundMyScoreQueryOfOrderPlanningMixTrendingDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        return data;
    }
}

export interface IOutboundMyScoreQueryOfOrderPlanningMixTrendingDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;
}

export abstract class OrderPlanningMixQueryOfOrderPlanningMixTrendingDto extends OutboundMyScoreQueryOfOrderPlanningMixTrendingDto implements IOrderPlanningMixQueryOfOrderPlanningMixTrendingDto {

    constructor(data?: IOrderPlanningMixQueryOfOrderPlanningMixTrendingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OrderPlanningMixQueryOfOrderPlanningMixTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OrderPlanningMixQueryOfOrderPlanningMixTrendingDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOrderPlanningMixQueryOfOrderPlanningMixTrendingDto extends IOutboundMyScoreQueryOfOrderPlanningMixTrendingDto {
}

export class GetOrderPlanningMixTrendingQuery extends OrderPlanningMixQueryOfOrderPlanningMixTrendingDto implements IGetOrderPlanningMixTrendingQuery {
    grouping?: MyScoreTrendingGrouping;

    constructor(data?: IGetOrderPlanningMixTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.grouping = _data["grouping"];
        }
    }

    static override fromJS(data: any): GetOrderPlanningMixTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderPlanningMixTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grouping"] = this.grouping;
        super.toJSON(data);
        return data;
    }
}

export interface IGetOrderPlanningMixTrendingQuery extends IOrderPlanningMixQueryOfOrderPlanningMixTrendingDto {
    grouping?: MyScoreTrendingGrouping;
}

export enum MyScoreTrendingGrouping {
    Day = 0,
    Hour = 1,
}

export class PreProductionOrdersScoreDto implements IPreProductionOrdersScoreDto {
    myScorePercent?: number | undefined;
    totals?: { [key: string]: number; };
    newPoReceived?: number;
    posReleasedToHdc?: number;
    loadsReleasedToHdc?: number;
    poUnitsReceived?: number;
    poUnitsReleasedToHdc?: number;
    poUnitsRejected?: number;

    constructor(data?: IPreProductionOrdersScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myScorePercent = _data["myScorePercent"];
            if (_data["totals"]) {
                this.totals = {} as any;
                for (let key in _data["totals"]) {
                    if (_data["totals"].hasOwnProperty(key))
                        (<any>this.totals)![key] = _data["totals"][key];
                }
            }
            this.newPoReceived = _data["newPoReceived"];
            this.posReleasedToHdc = _data["posReleasedToHdc"];
            this.loadsReleasedToHdc = _data["loadsReleasedToHdc"];
            this.poUnitsReceived = _data["poUnitsReceived"];
            this.poUnitsReleasedToHdc = _data["poUnitsReleasedToHdc"];
            this.poUnitsRejected = _data["poUnitsRejected"];
        }
    }

    static fromJS(data: any): PreProductionOrdersScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreProductionOrdersScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myScorePercent"] = this.myScorePercent;
        if (this.totals) {
            data["totals"] = {};
            for (let key in this.totals) {
                if (this.totals.hasOwnProperty(key))
                    (<any>data["totals"])[key] = (<any>this.totals)[key];
            }
        }
        data["newPoReceived"] = this.newPoReceived;
        data["posReleasedToHdc"] = this.posReleasedToHdc;
        data["loadsReleasedToHdc"] = this.loadsReleasedToHdc;
        data["poUnitsReceived"] = this.poUnitsReceived;
        data["poUnitsReleasedToHdc"] = this.poUnitsReleasedToHdc;
        data["poUnitsRejected"] = this.poUnitsRejected;
        return data;
    }
}

export interface IPreProductionOrdersScoreDto {
    myScorePercent?: number | undefined;
    totals?: { [key: string]: number; };
    newPoReceived?: number;
    posReleasedToHdc?: number;
    loadsReleasedToHdc?: number;
    poUnitsReceived?: number;
    poUnitsReleasedToHdc?: number;
    poUnitsRejected?: number;
}

export abstract class OutboundMyScoreQueryOfPreProductionOrdersScoreDto implements IOutboundMyScoreQueryOfPreProductionOrdersScoreDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;

    constructor(data?: IOutboundMyScoreQueryOfPreProductionOrdersScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.fromHour = _data["fromHour"];
            this.toHour = _data["toHour"];
        }
    }

    static fromJS(data: any): OutboundMyScoreQueryOfPreProductionOrdersScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OutboundMyScoreQueryOfPreProductionOrdersScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        return data;
    }
}

export interface IOutboundMyScoreQueryOfPreProductionOrdersScoreDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;
}

export abstract class PreProductionOrdersQueryOfPreProductionOrdersScoreDto extends OutboundMyScoreQueryOfPreProductionOrdersScoreDto implements IPreProductionOrdersQueryOfPreProductionOrdersScoreDto {

    constructor(data?: IPreProductionOrdersQueryOfPreProductionOrdersScoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PreProductionOrdersQueryOfPreProductionOrdersScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PreProductionOrdersQueryOfPreProductionOrdersScoreDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPreProductionOrdersQueryOfPreProductionOrdersScoreDto extends IOutboundMyScoreQueryOfPreProductionOrdersScoreDto {
}

export class GetPreProductionOrdersScoreQuery extends PreProductionOrdersQueryOfPreProductionOrdersScoreDto implements IGetPreProductionOrdersScoreQuery {

    constructor(data?: IGetPreProductionOrdersScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetPreProductionOrdersScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreProductionOrdersScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetPreProductionOrdersScoreQuery extends IPreProductionOrdersQueryOfPreProductionOrdersScoreDto {
}

export class PreProductionOrdersTrendingDto implements IPreProductionOrdersTrendingDto {
    points?: PreProductionOrdersTrendingPoint[];

    constructor(data?: IPreProductionOrdersTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PreProductionOrdersTrendingPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreProductionOrdersTrendingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreProductionOrdersTrendingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreProductionOrdersTrendingDto {
    points?: PreProductionOrdersTrendingPoint[];
}

export class PreProductionOrdersTrendingPoint implements IPreProductionOrdersTrendingPoint {
    period?: Date;
    releasedPercent?: number;
    latePercent?: number;

    constructor(data?: IPreProductionOrdersTrendingPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? new Date(_data["period"].toString()) : <any>undefined;
            this.releasedPercent = _data["releasedPercent"];
            this.latePercent = _data["latePercent"];
        }
    }

    static fromJS(data: any): PreProductionOrdersTrendingPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PreProductionOrdersTrendingPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toISOString() : <any>undefined;
        data["releasedPercent"] = this.releasedPercent;
        data["latePercent"] = this.latePercent;
        return data;
    }
}

export interface IPreProductionOrdersTrendingPoint {
    period?: Date;
    releasedPercent?: number;
    latePercent?: number;
}

export abstract class OutboundMyScoreQueryOfPreProductionOrdersTrendingDto implements IOutboundMyScoreQueryOfPreProductionOrdersTrendingDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;

    constructor(data?: IOutboundMyScoreQueryOfPreProductionOrdersTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.fromHour = _data["fromHour"];
            this.toHour = _data["toHour"];
        }
    }

    static fromJS(data: any): OutboundMyScoreQueryOfPreProductionOrdersTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OutboundMyScoreQueryOfPreProductionOrdersTrendingDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        return data;
    }
}

export interface IOutboundMyScoreQueryOfPreProductionOrdersTrendingDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;
}

export abstract class PreProductionOrdersQueryOfPreProductionOrdersTrendingDto extends OutboundMyScoreQueryOfPreProductionOrdersTrendingDto implements IPreProductionOrdersQueryOfPreProductionOrdersTrendingDto {

    constructor(data?: IPreProductionOrdersQueryOfPreProductionOrdersTrendingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PreProductionOrdersQueryOfPreProductionOrdersTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PreProductionOrdersQueryOfPreProductionOrdersTrendingDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPreProductionOrdersQueryOfPreProductionOrdersTrendingDto extends IOutboundMyScoreQueryOfPreProductionOrdersTrendingDto {
}

export class GetPreProductionOrdersTrendingQuery extends PreProductionOrdersQueryOfPreProductionOrdersTrendingDto implements IGetPreProductionOrdersTrendingQuery {
    grouping?: MyScoreTrendingGrouping;

    constructor(data?: IGetPreProductionOrdersTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.grouping = _data["grouping"];
        }
    }

    static override fromJS(data: any): GetPreProductionOrdersTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreProductionOrdersTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grouping"] = this.grouping;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPreProductionOrdersTrendingQuery extends IPreProductionOrdersQueryOfPreProductionOrdersTrendingDto {
    grouping?: MyScoreTrendingGrouping;
}

export class PostProductionMdtScoreDto implements IPostProductionMdtScoreDto {
    totalLoads?: number;
    totals?: { [key: string]: number; };

    constructor(data?: IPostProductionMdtScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLoads = _data["totalLoads"];
            if (_data["totals"]) {
                this.totals = {} as any;
                for (let key in _data["totals"]) {
                    if (_data["totals"].hasOwnProperty(key))
                        (<any>this.totals)![key] = _data["totals"][key];
                }
            }
        }
    }

    static fromJS(data: any): PostProductionMdtScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostProductionMdtScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLoads"] = this.totalLoads;
        if (this.totals) {
            data["totals"] = {};
            for (let key in this.totals) {
                if (this.totals.hasOwnProperty(key))
                    (<any>data["totals"])[key] = (<any>this.totals)[key];
            }
        }
        return data;
    }
}

export interface IPostProductionMdtScoreDto {
    totalLoads?: number;
    totals?: { [key: string]: number; };
}

export abstract class OutboundMyScoreQueryOfPostProductionMdtScoreDto implements IOutboundMyScoreQueryOfPostProductionMdtScoreDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;

    constructor(data?: IOutboundMyScoreQueryOfPostProductionMdtScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.fromHour = _data["fromHour"];
            this.toHour = _data["toHour"];
        }
    }

    static fromJS(data: any): OutboundMyScoreQueryOfPostProductionMdtScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OutboundMyScoreQueryOfPostProductionMdtScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        return data;
    }
}

export interface IOutboundMyScoreQueryOfPostProductionMdtScoreDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;
}

export abstract class PostProductionMdtQueryOfPostProductionMdtScoreDto extends OutboundMyScoreQueryOfPostProductionMdtScoreDto implements IPostProductionMdtQueryOfPostProductionMdtScoreDto {

    constructor(data?: IPostProductionMdtQueryOfPostProductionMdtScoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostProductionMdtQueryOfPostProductionMdtScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PostProductionMdtQueryOfPostProductionMdtScoreDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostProductionMdtQueryOfPostProductionMdtScoreDto extends IOutboundMyScoreQueryOfPostProductionMdtScoreDto {
}

export class GetPostProductionMdtScoreQuery extends PostProductionMdtQueryOfPostProductionMdtScoreDto implements IGetPostProductionMdtScoreQuery {

    constructor(data?: IGetPostProductionMdtScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetPostProductionMdtScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostProductionMdtScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetPostProductionMdtScoreQuery extends IPostProductionMdtQueryOfPostProductionMdtScoreDto {
}

export class PostProductionMdtTrendingDto implements IPostProductionMdtTrendingDto {
    points?: PostProductionMdtTrendingPoint[];

    constructor(data?: IPostProductionMdtTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PostProductionMdtTrendingPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PostProductionMdtTrendingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostProductionMdtTrendingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPostProductionMdtTrendingDto {
    points?: PostProductionMdtTrendingPoint[];
}

export class PostProductionMdtTrendingPoint implements IPostProductionMdtTrendingPoint {
    period?: Date;
    loadedOnTimePercent?: number;
    loadedLatePercent?: number;

    constructor(data?: IPostProductionMdtTrendingPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? new Date(_data["period"].toString()) : <any>undefined;
            this.loadedOnTimePercent = _data["loadedOnTimePercent"];
            this.loadedLatePercent = _data["loadedLatePercent"];
        }
    }

    static fromJS(data: any): PostProductionMdtTrendingPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PostProductionMdtTrendingPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toISOString() : <any>undefined;
        data["loadedOnTimePercent"] = this.loadedOnTimePercent;
        data["loadedLatePercent"] = this.loadedLatePercent;
        return data;
    }
}

export interface IPostProductionMdtTrendingPoint {
    period?: Date;
    loadedOnTimePercent?: number;
    loadedLatePercent?: number;
}

export abstract class OutboundMyScoreQueryOfPostProductionMdtTrendingDto implements IOutboundMyScoreQueryOfPostProductionMdtTrendingDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;

    constructor(data?: IOutboundMyScoreQueryOfPostProductionMdtTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.fromHour = _data["fromHour"];
            this.toHour = _data["toHour"];
        }
    }

    static fromJS(data: any): OutboundMyScoreQueryOfPostProductionMdtTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OutboundMyScoreQueryOfPostProductionMdtTrendingDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        return data;
    }
}

export interface IOutboundMyScoreQueryOfPostProductionMdtTrendingDto {
    from?: Date;
    to?: Date;
    fromHour?: number;
    toHour?: number;
}

export abstract class PostProductionMdtQueryOfPostProductionMdtTrendingDto extends OutboundMyScoreQueryOfPostProductionMdtTrendingDto implements IPostProductionMdtQueryOfPostProductionMdtTrendingDto {

    constructor(data?: IPostProductionMdtQueryOfPostProductionMdtTrendingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PostProductionMdtQueryOfPostProductionMdtTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PostProductionMdtQueryOfPostProductionMdtTrendingDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostProductionMdtQueryOfPostProductionMdtTrendingDto extends IOutboundMyScoreQueryOfPostProductionMdtTrendingDto {
}

export class GetPostProductionMdtTrendingQuery extends PostProductionMdtQueryOfPostProductionMdtTrendingDto implements IGetPostProductionMdtTrendingQuery {
    grouping?: MyScoreTrendingGrouping;

    constructor(data?: IGetPostProductionMdtTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.grouping = _data["grouping"];
        }
    }

    static override fromJS(data: any): GetPostProductionMdtTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostProductionMdtTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grouping"] = this.grouping;
        super.toJSON(data);
        return data;
    }
}

export interface IGetPostProductionMdtTrendingQuery extends IPostProductionMdtQueryOfPostProductionMdtTrendingDto {
    grouping?: MyScoreTrendingGrouping;
}

export class VendorDto implements IVendorDto {
    id?: string;
    number?: string;
    serviceTypeId?: string | undefined;
    glCodeId?: string | undefined;
    siteIds?: string[];
    status?: VendorStatus;
    term?: VendorTerm;
    name?: string;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    contactId?: string | undefined;
    contractFiles?: FileDto[];
    contractExpirationDate?: Date | undefined;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.glCodeId = _data["glCodeId"];
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            this.status = _data["status"];
            this.term = _data["term"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.contactId = _data["contactId"];
            if (Array.isArray(_data["contractFiles"])) {
                this.contractFiles = [] as any;
                for (let item of _data["contractFiles"])
                    this.contractFiles!.push(FileDto.fromJS(item));
            }
            this.contractExpirationDate = _data["contractExpirationDate"] ? new Date(_data["contractExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["serviceTypeId"] = this.serviceTypeId;
        data["glCodeId"] = this.glCodeId;
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        data["status"] = this.status;
        data["term"] = this.term;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["contactId"] = this.contactId;
        if (Array.isArray(this.contractFiles)) {
            data["contractFiles"] = [];
            for (let item of this.contractFiles)
                data["contractFiles"].push(item.toJSON());
        }
        data["contractExpirationDate"] = this.contractExpirationDate ? this.contractExpirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVendorDto {
    id?: string;
    number?: string;
    serviceTypeId?: string | undefined;
    glCodeId?: string | undefined;
    siteIds?: string[];
    status?: VendorStatus;
    term?: VendorTerm;
    name?: string;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    contactId?: string | undefined;
    contractFiles?: FileDto[];
    contractExpirationDate?: Date | undefined;
}

export enum VendorStatus {
    Inactive = "Inactive",
    Active = "Active",
}

export enum VendorTerm {
    ThirtyDays = "ThirtyDays",
    FortyFiveDays = "FortyFiveDays",
    SixtyDays = "SixtyDays",
}

export class FileDto implements IFileDto {
    id?: string;
    fileUrl?: string;
    fileName?: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IFileDto {
    id?: string;
    fileUrl?: string;
    fileName?: string;
}

export class VendorInfoDto implements IVendorInfoDto {
    name?: string;
    serviceTypeId?: string | undefined;
    termDays?: number;
    glCodeId?: string | undefined;
    glCodeName?: string | undefined;
    glCodeSiteId?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    contact?: EmployeeDto | undefined;

    constructor(data?: IVendorInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.termDays = _data["termDays"];
            this.glCodeId = _data["glCodeId"];
            this.glCodeName = _data["glCodeName"];
            this.glCodeSiteId = _data["glCodeSiteId"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.contact = _data["contact"] ? EmployeeDto.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serviceTypeId"] = this.serviceTypeId;
        data["termDays"] = this.termDays;
        data["glCodeId"] = this.glCodeId;
        data["glCodeName"] = this.glCodeName;
        data["glCodeSiteId"] = this.glCodeSiteId;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVendorInfoDto {
    name?: string;
    serviceTypeId?: string | undefined;
    termDays?: number;
    glCodeId?: string | undefined;
    glCodeName?: string | undefined;
    glCodeSiteId?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    contact?: EmployeeDto | undefined;
}

export class CreateVendorCommand implements ICreateVendorCommand {
    number?: string;
    serviceTypeId?: string;
    glCodeId?: string | undefined;
    siteIds?: string[];
    status?: VendorStatus;
    term?: VendorTerm;
    name?: string;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    contractFiles?: UploadedFileDto[];
    contractExpirationDate?: Date | undefined;

    constructor(data?: ICreateVendorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.glCodeId = _data["glCodeId"];
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            this.status = _data["status"];
            this.term = _data["term"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            if (Array.isArray(_data["contractFiles"])) {
                this.contractFiles = [] as any;
                for (let item of _data["contractFiles"])
                    this.contractFiles!.push(UploadedFileDto.fromJS(item));
            }
            this.contractExpirationDate = _data["contractExpirationDate"] ? new Date(_data["contractExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateVendorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVendorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["serviceTypeId"] = this.serviceTypeId;
        data["glCodeId"] = this.glCodeId;
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        data["status"] = this.status;
        data["term"] = this.term;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        if (Array.isArray(this.contractFiles)) {
            data["contractFiles"] = [];
            for (let item of this.contractFiles)
                data["contractFiles"].push(item.toJSON());
        }
        data["contractExpirationDate"] = this.contractExpirationDate ? this.contractExpirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateVendorCommand {
    number?: string;
    serviceTypeId?: string;
    glCodeId?: string | undefined;
    siteIds?: string[];
    status?: VendorStatus;
    term?: VendorTerm;
    name?: string;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    contractFiles?: UploadedFileDto[];
    contractExpirationDate?: Date | undefined;
}

export class UploadedFileDto implements IUploadedFileDto {
    fileName?: string;
    contentType?: string;
    content?: string;

    constructor(data?: IUploadedFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UploadedFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["content"] = this.content;
        return data;
    }
}

export interface IUploadedFileDto {
    fileName?: string;
    contentType?: string;
    content?: string;
}

export class UpdateVendorCommand extends CreateVendorCommand implements IUpdateVendorCommand {
    id?: string;
    contractFilesToRemove?: string[];
    contactId?: string | undefined;

    constructor(data?: IUpdateVendorCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["contractFilesToRemove"])) {
                this.contractFilesToRemove = [] as any;
                for (let item of _data["contractFilesToRemove"])
                    this.contractFilesToRemove!.push(item);
            }
            this.contactId = _data["contactId"];
        }
    }

    static override fromJS(data: any): UpdateVendorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.contractFilesToRemove)) {
            data["contractFilesToRemove"] = [];
            for (let item of this.contractFilesToRemove)
                data["contractFilesToRemove"].push(item);
        }
        data["contactId"] = this.contactId;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateVendorCommand extends ICreateVendorCommand {
    id?: string;
    contractFilesToRemove?: string[];
    contactId?: string | undefined;
}

export class MyScoreVendorsScoreDto implements IMyScoreVendorsScoreDto {
    myScorePercent?: number | undefined;
    totals?: { [key: string]: number; };

    constructor(data?: IMyScoreVendorsScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myScorePercent = _data["myScorePercent"];
            if (_data["totals"]) {
                this.totals = {} as any;
                for (let key in _data["totals"]) {
                    if (_data["totals"].hasOwnProperty(key))
                        (<any>this.totals)![key] = _data["totals"][key];
                }
            }
        }
    }

    static fromJS(data: any): MyScoreVendorsScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyScoreVendorsScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myScorePercent"] = this.myScorePercent;
        if (this.totals) {
            data["totals"] = {};
            for (let key in this.totals) {
                if (this.totals.hasOwnProperty(key))
                    (<any>data["totals"])[key] = (<any>this.totals)[key];
            }
        }
        return data;
    }
}

export interface IMyScoreVendorsScoreDto {
    myScorePercent?: number | undefined;
    totals?: { [key: string]: number; };
}

export abstract class MyScoreInvoicingQueryOfMyScoreVendorsScoreDto implements IMyScoreInvoicingQueryOfMyScoreVendorsScoreDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;

    constructor(data?: IMyScoreInvoicingQueryOfMyScoreVendorsScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreInvoicingQueryOfMyScoreVendorsScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreInvoicingQueryOfMyScoreVendorsScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreInvoicingQueryOfMyScoreVendorsScoreDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;
}

export abstract class MyScoreVendorsQueryOfMyScoreVendorsScoreDto extends MyScoreInvoicingQueryOfMyScoreVendorsScoreDto implements IMyScoreVendorsQueryOfMyScoreVendorsScoreDto {

    constructor(data?: IMyScoreVendorsQueryOfMyScoreVendorsScoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreVendorsQueryOfMyScoreVendorsScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreVendorsQueryOfMyScoreVendorsScoreDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreVendorsQueryOfMyScoreVendorsScoreDto extends IMyScoreInvoicingQueryOfMyScoreVendorsScoreDto {
}

export class GetMyScoreVendorsScoreQuery extends MyScoreVendorsQueryOfMyScoreVendorsScoreDto implements IGetMyScoreVendorsScoreQuery {

    constructor(data?: IGetMyScoreVendorsScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMyScoreVendorsScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreVendorsScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreVendorsScoreQuery extends IMyScoreVendorsQueryOfMyScoreVendorsScoreDto {
}

export abstract class MyScoreInvoicingQueryOfTrendingDto implements IMyScoreInvoicingQueryOfTrendingDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;

    constructor(data?: IMyScoreInvoicingQueryOfTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreInvoicingQueryOfTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreInvoicingQueryOfTrendingDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreInvoicingQueryOfTrendingDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;
}

export abstract class MyScoreVendorsQueryOfTrendingDto extends MyScoreInvoicingQueryOfTrendingDto implements IMyScoreVendorsQueryOfTrendingDto {

    constructor(data?: IMyScoreVendorsQueryOfTrendingDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreVendorsQueryOfTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreVendorsQueryOfTrendingDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreVendorsQueryOfTrendingDto extends IMyScoreInvoicingQueryOfTrendingDto {
}

export class GetMyScoreVendorsTrendingQuery extends MyScoreVendorsQueryOfTrendingDto implements IGetMyScoreVendorsTrendingQuery {
    aggregateType?: AggregateType;

    constructor(data?: IGetMyScoreVendorsTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.aggregateType = _data["aggregateType"];
        }
    }

    static override fromJS(data: any): GetMyScoreVendorsTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreVendorsTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateType"] = this.aggregateType;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreVendorsTrendingQuery extends IMyScoreVendorsQueryOfTrendingDto {
    aggregateType?: AggregateType;
}

export abstract class MyScoreInvoicingQueryOfExportedFileDto implements IMyScoreInvoicingQueryOfExportedFileDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;

    constructor(data?: IMyScoreInvoicingQueryOfExportedFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreInvoicingQueryOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreInvoicingQueryOfExportedFileDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreInvoicingQueryOfExportedFileDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;
}

export abstract class MyScoreVendorsQueryOfExportedFileDto extends MyScoreInvoicingQueryOfExportedFileDto implements IMyScoreVendorsQueryOfExportedFileDto {

    constructor(data?: IMyScoreVendorsQueryOfExportedFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreVendorsQueryOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreVendorsQueryOfExportedFileDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreVendorsQueryOfExportedFileDto extends IMyScoreInvoicingQueryOfExportedFileDto {
}

export class ExportMyScoreVendorsQuery extends MyScoreVendorsQueryOfExportedFileDto implements IExportMyScoreVendorsQuery {

    constructor(data?: IExportMyScoreVendorsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportMyScoreVendorsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExportMyScoreVendorsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportMyScoreVendorsQuery extends IMyScoreVendorsQueryOfExportedFileDto {
}

export class MyScoreOperationsScoreDto implements IMyScoreOperationsScoreDto {
    myScorePercent?: number | undefined;
    pendingUnder24?: number;
    pendingOver24?: number;
    approved?: number;

    constructor(data?: IMyScoreOperationsScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myScorePercent = _data["myScorePercent"];
            this.pendingUnder24 = _data["pendingUnder24"];
            this.pendingOver24 = _data["pendingOver24"];
            this.approved = _data["approved"];
        }
    }

    static fromJS(data: any): MyScoreOperationsScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyScoreOperationsScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myScorePercent"] = this.myScorePercent;
        data["pendingUnder24"] = this.pendingUnder24;
        data["pendingOver24"] = this.pendingOver24;
        data["approved"] = this.approved;
        return data;
    }
}

export interface IMyScoreOperationsScoreDto {
    myScorePercent?: number | undefined;
    pendingUnder24?: number;
    pendingOver24?: number;
    approved?: number;
}

export abstract class MyScoreInvoicingQueryOfMyScoreOperationsScoreDto implements IMyScoreInvoicingQueryOfMyScoreOperationsScoreDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;

    constructor(data?: IMyScoreInvoicingQueryOfMyScoreOperationsScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreInvoicingQueryOfMyScoreOperationsScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreInvoicingQueryOfMyScoreOperationsScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreInvoicingQueryOfMyScoreOperationsScoreDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;
}

export abstract class MyScoreOperationsQueryOfMyScoreOperationsScoreDto extends MyScoreInvoicingQueryOfMyScoreOperationsScoreDto implements IMyScoreOperationsQueryOfMyScoreOperationsScoreDto {

    constructor(data?: IMyScoreOperationsQueryOfMyScoreOperationsScoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreOperationsQueryOfMyScoreOperationsScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreOperationsQueryOfMyScoreOperationsScoreDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreOperationsQueryOfMyScoreOperationsScoreDto extends IMyScoreInvoicingQueryOfMyScoreOperationsScoreDto {
}

export class GetMyScoreOperationsL1ScoreQuery extends MyScoreOperationsQueryOfMyScoreOperationsScoreDto implements IGetMyScoreOperationsL1ScoreQuery {

    constructor(data?: IGetMyScoreOperationsL1ScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMyScoreOperationsL1ScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreOperationsL1ScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreOperationsL1ScoreQuery extends IMyScoreOperationsQueryOfMyScoreOperationsScoreDto {
}

export class GetMyScoreOperationsL2ScoreQuery extends MyScoreOperationsQueryOfMyScoreOperationsScoreDto implements IGetMyScoreOperationsL2ScoreQuery {

    constructor(data?: IGetMyScoreOperationsL2ScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMyScoreOperationsL2ScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreOperationsL2ScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreOperationsL2ScoreQuery extends IMyScoreOperationsQueryOfMyScoreOperationsScoreDto {
}

export class GetMyScoreOperationsL3ScoreQuery extends MyScoreOperationsQueryOfMyScoreOperationsScoreDto implements IGetMyScoreOperationsL3ScoreQuery {

    constructor(data?: IGetMyScoreOperationsL3ScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMyScoreOperationsL3ScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreOperationsL3ScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreOperationsL3ScoreQuery extends IMyScoreOperationsQueryOfMyScoreOperationsScoreDto {
}

export abstract class MyScoreOperationsQueryOfExportedFileDto extends MyScoreInvoicingQueryOfExportedFileDto implements IMyScoreOperationsQueryOfExportedFileDto {

    constructor(data?: IMyScoreOperationsQueryOfExportedFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreOperationsQueryOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreOperationsQueryOfExportedFileDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreOperationsQueryOfExportedFileDto extends IMyScoreInvoicingQueryOfExportedFileDto {
}

export class ExportMyScoreOperationsQuery extends MyScoreOperationsQueryOfExportedFileDto implements IExportMyScoreOperationsQuery {

    constructor(data?: IExportMyScoreOperationsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportMyScoreOperationsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExportMyScoreOperationsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportMyScoreOperationsQuery extends IMyScoreOperationsQueryOfExportedFileDto {
}

export class MyScoreFinanceScoreDto implements IMyScoreFinanceScoreDto {
    myScorePercent?: number | undefined;
    pendingUnder48?: number;
    pendingOver48?: number;
    finalized?: number;

    constructor(data?: IMyScoreFinanceScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myScorePercent = _data["myScorePercent"];
            this.pendingUnder48 = _data["pendingUnder48"];
            this.pendingOver48 = _data["pendingOver48"];
            this.finalized = _data["finalized"];
        }
    }

    static fromJS(data: any): MyScoreFinanceScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyScoreFinanceScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myScorePercent"] = this.myScorePercent;
        data["pendingUnder48"] = this.pendingUnder48;
        data["pendingOver48"] = this.pendingOver48;
        data["finalized"] = this.finalized;
        return data;
    }
}

export interface IMyScoreFinanceScoreDto {
    myScorePercent?: number | undefined;
    pendingUnder48?: number;
    pendingOver48?: number;
    finalized?: number;
}

export abstract class MyScoreInvoicingQueryOfMyScoreFinanceScoreDto implements IMyScoreInvoicingQueryOfMyScoreFinanceScoreDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;

    constructor(data?: IMyScoreInvoicingQueryOfMyScoreFinanceScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreInvoicingQueryOfMyScoreFinanceScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreInvoicingQueryOfMyScoreFinanceScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreInvoicingQueryOfMyScoreFinanceScoreDto {
    from?: Date;
    to?: Date;
    vendorIds?: string[] | undefined;
    siteIds?: string[] | undefined;
}

export abstract class MyScoreFinanceQueryOfMyScoreFinanceScoreDto extends MyScoreInvoicingQueryOfMyScoreFinanceScoreDto implements IMyScoreFinanceQueryOfMyScoreFinanceScoreDto {

    constructor(data?: IMyScoreFinanceQueryOfMyScoreFinanceScoreDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreFinanceQueryOfMyScoreFinanceScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreFinanceQueryOfMyScoreFinanceScoreDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreFinanceQueryOfMyScoreFinanceScoreDto extends IMyScoreInvoicingQueryOfMyScoreFinanceScoreDto {
}

export class GetMyScoreFinanceInvoicesScoreQuery extends MyScoreFinanceQueryOfMyScoreFinanceScoreDto implements IGetMyScoreFinanceInvoicesScoreQuery {

    constructor(data?: IGetMyScoreFinanceInvoicesScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMyScoreFinanceInvoicesScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreFinanceInvoicesScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreFinanceInvoicesScoreQuery extends IMyScoreFinanceQueryOfMyScoreFinanceScoreDto {
}

export class GetMyScoreCreditRequestsScoreQuery extends MyScoreFinanceQueryOfMyScoreFinanceScoreDto implements IGetMyScoreCreditRequestsScoreQuery {

    constructor(data?: IGetMyScoreCreditRequestsScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetMyScoreCreditRequestsScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyScoreCreditRequestsScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyScoreCreditRequestsScoreQuery extends IMyScoreFinanceQueryOfMyScoreFinanceScoreDto {
}

export abstract class MyScoreFinanceQueryOfExportedFileDto extends MyScoreInvoicingQueryOfExportedFileDto implements IMyScoreFinanceQueryOfExportedFileDto {

    constructor(data?: IMyScoreFinanceQueryOfExportedFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MyScoreFinanceQueryOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreFinanceQueryOfExportedFileDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMyScoreFinanceQueryOfExportedFileDto extends IMyScoreInvoicingQueryOfExportedFileDto {
}

export class ExportMyScoreFinanceQuery extends MyScoreFinanceQueryOfExportedFileDto implements IExportMyScoreFinanceQuery {

    constructor(data?: IExportMyScoreFinanceQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportMyScoreFinanceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExportMyScoreFinanceQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportMyScoreFinanceQuery extends IMyScoreFinanceQueryOfExportedFileDto {
}

export class CreateGlCodeCommand implements ICreateGlCodeCommand {
    code?: string;
    description?: string;
    clientId?: string;

    constructor(data?: ICreateGlCodeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): CreateGlCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGlCodeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ICreateGlCodeCommand {
    code?: string;
    description?: string;
    clientId?: string;
}

export class UpdateGlCodeCommand extends CreateGlCodeCommand implements IUpdateGlCodeCommand {
    id?: string;

    constructor(data?: IUpdateGlCodeCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateGlCodeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlCodeCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateGlCodeCommand extends ICreateGlCodeCommand {
    id?: string;
}

export class CreateGlCodeClientCommand implements ICreateGlCodeClientCommand {
    name?: string;
    department?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    phoneNumber?: string;

    constructor(data?: ICreateGlCodeClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.department = _data["department"];
            this.province = _data["province"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateGlCodeClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGlCodeClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["department"] = this.department;
        data["province"] = this.province;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateGlCodeClientCommand {
    name?: string;
    department?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    phoneNumber?: string;
}

export class UpdateGlCodeClientCommand extends CreateGlCodeClientCommand implements IUpdateGlCodeClientCommand {
    id?: string;

    constructor(data?: IUpdateGlCodeClientCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateGlCodeClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlCodeClientCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateGlCodeClientCommand extends ICreateGlCodeClientCommand {
    id?: string;
}

export class BillToInfoDto implements IBillToInfoDto {
    name?: string;
    address?: string;
    city?: string;
    province?: string;
    postalCode?: string;
    phoneNumber?: string;

    constructor(data?: IBillToInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): BillToInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillToInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["province"] = this.province;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IBillToInfoDto {
    name?: string;
    address?: string;
    city?: string;
    province?: string;
    postalCode?: string;
    phoneNumber?: string;
}

export class CreateServiceTypeCommand implements ICreateServiceTypeCommand {
    name?: string;

    constructor(data?: ICreateServiceTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateServiceTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateServiceTypeCommand {
    name?: string;
}

export class UpdateServiceTypeCommand extends CreateServiceTypeCommand implements IUpdateServiceTypeCommand {
    id?: string;

    constructor(data?: IUpdateServiceTypeCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateServiceTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceTypeCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateServiceTypeCommand extends ICreateServiceTypeCommand {
    id?: string;
}

export class CreateInvoicePurchaseOrderCommand implements ICreateInvoicePurchaseOrderCommand {
    action?: InvoicePurchaseOrderAction;
    currency?: CurrencyCode;
    vendorId?: string;
    billToClientId?: string | undefined;
    serviceTypeId?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    items?: FinancialDocumentItemDto[];
    recurrenceRule?: RecurrenceRuleDto | undefined;

    constructor(data?: ICreateInvoicePurchaseOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.billToClientId = _data["billToClientId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.conversionRate = _data["conversionRate"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDocumentItemDto.fromJS(item));
            }
            this.recurrenceRule = _data["recurrenceRule"] ? RecurrenceRuleDto.fromJS(_data["recurrenceRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateInvoicePurchaseOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoicePurchaseOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["billToClientId"] = this.billToClientId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["conversionRate"] = this.conversionRate;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["recurrenceRule"] = this.recurrenceRule ? this.recurrenceRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateInvoicePurchaseOrderCommand {
    action?: InvoicePurchaseOrderAction;
    currency?: CurrencyCode;
    vendorId?: string;
    billToClientId?: string | undefined;
    serviceTypeId?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    items?: FinancialDocumentItemDto[];
    recurrenceRule?: RecurrenceRuleDto | undefined;
}

export enum InvoicePurchaseOrderAction {
    SaveAsDraft = "SaveAsDraft",
    Save = "Save",
    Submit = "Submit",
    Cancel = "Cancel",
    InvoiceMissed = "InvoiceMissed",
    InvoicePending = "InvoicePending",
    InvoicedLate = "InvoicedLate",
    BackToOpen = "BackToOpen",
    Posted = "Posted",
    OnHold = "OnHold",
    ResumePO = "ResumePO",
}

export enum CurrencyCode {
    CAD = "CAD",
    USD = "USD",
}

export class FinancialDocumentItemDto implements IFinancialDocumentItemDto {
    id?: string;
    quantity?: number;
    description?: string;
    unitPrice?: number;
    taxRate?: number;
    glCodeId?: string | undefined;
    glCodeName?: string | undefined;
    siteId?: string | undefined;

    constructor(data?: IFinancialDocumentItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.taxRate = _data["taxRate"];
            this.glCodeId = _data["glCodeId"];
            this.glCodeName = _data["glCodeName"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any): FinancialDocumentItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDocumentItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["taxRate"] = this.taxRate;
        data["glCodeId"] = this.glCodeId;
        data["glCodeName"] = this.glCodeName;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IFinancialDocumentItemDto {
    id?: string;
    quantity?: number;
    description?: string;
    unitPrice?: number;
    taxRate?: number;
    glCodeId?: string | undefined;
    glCodeName?: string | undefined;
    siteId?: string | undefined;
}

export class RecurrenceRuleDto implements IRecurrenceRuleDto {
    interval?: number;
    frequency?: RecurrenceFrequency;
    mode?: RecurrenceMode;
    weekdays?: DayOfWeek[];
    until?: Date;

    constructor(data?: IRecurrenceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interval = _data["interval"];
            this.frequency = _data["frequency"];
            this.mode = _data["mode"];
            if (Array.isArray(_data["weekdays"])) {
                this.weekdays = [] as any;
                for (let item of _data["weekdays"])
                    this.weekdays!.push(item);
            }
            this.until = _data["until"] ? new Date(_data["until"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecurrenceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurrenceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval;
        data["frequency"] = this.frequency;
        data["mode"] = this.mode;
        if (Array.isArray(this.weekdays)) {
            data["weekdays"] = [];
            for (let item of this.weekdays)
                data["weekdays"].push(item);
        }
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecurrenceRuleDto {
    interval?: number;
    frequency?: RecurrenceFrequency;
    mode?: RecurrenceMode;
    weekdays?: DayOfWeek[];
    until?: Date;
}

export enum RecurrenceFrequency {
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export enum RecurrenceMode {
    OnDate = "OnDate",
    NthWeekday = "NthWeekday",
}

export class UpdateInvoicePurchaseOrderCommand extends CreateInvoicePurchaseOrderCommand implements IUpdateInvoicePurchaseOrderCommand {
    number?: string;

    constructor(data?: IUpdateInvoicePurchaseOrderCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): UpdateInvoicePurchaseOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoicePurchaseOrderCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateInvoicePurchaseOrderCommand extends ICreateInvoicePurchaseOrderCommand {
    number?: string;
}

export abstract class FinancialDocumentDto implements IFinancialDocumentDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    currency?: CurrencyCode;
    vendorId?: string;
    billToClientId?: string | undefined;
    billToName?: string | undefined;
    serviceTypeId?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    subTotal?: number;
    taxAmount?: number;
    totalAmount?: number;
    convertedSubTotal?: number | undefined;
    convertedTaxAmount?: number | undefined;
    convertedTotalAmount?: number | undefined;
    items?: FinancialDocumentItemDto[];

    constructor(data?: IFinancialDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.numberWithPrefix = _data["numberWithPrefix"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.billToClientId = _data["billToClientId"];
            this.billToName = _data["billToName"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.conversionRate = _data["conversionRate"];
            this.subTotal = _data["subTotal"];
            this.taxAmount = _data["taxAmount"];
            this.totalAmount = _data["totalAmount"];
            this.convertedSubTotal = _data["convertedSubTotal"];
            this.convertedTaxAmount = _data["convertedTaxAmount"];
            this.convertedTotalAmount = _data["convertedTotalAmount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDocumentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancialDocumentDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FinancialDocumentDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["numberWithPrefix"] = this.numberWithPrefix;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["billToClientId"] = this.billToClientId;
        data["billToName"] = this.billToName;
        data["serviceTypeId"] = this.serviceTypeId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["conversionRate"] = this.conversionRate;
        data["subTotal"] = this.subTotal;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["convertedSubTotal"] = this.convertedSubTotal;
        data["convertedTaxAmount"] = this.convertedTaxAmount;
        data["convertedTotalAmount"] = this.convertedTotalAmount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFinancialDocumentDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    currency?: CurrencyCode;
    vendorId?: string;
    billToClientId?: string | undefined;
    billToName?: string | undefined;
    serviceTypeId?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    subTotal?: number;
    taxAmount?: number;
    totalAmount?: number;
    convertedSubTotal?: number | undefined;
    convertedTaxAmount?: number | undefined;
    convertedTotalAmount?: number | undefined;
    items?: FinancialDocumentItemDto[];
}

export class InvoicePurchaseOrderDto extends FinancialDocumentDto implements IInvoicePurchaseOrderDto {
    status?: InvoicePurchaseOrderStatus;
    invoiceNumber?: string | undefined;
    actions?: InvoicePurchaseOrderAction[];
    recurrenceRule?: RecurrenceRuleDto | undefined;

    constructor(data?: IInvoicePurchaseOrderDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.invoiceNumber = _data["invoiceNumber"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            this.recurrenceRule = _data["recurrenceRule"] ? RecurrenceRuleDto.fromJS(_data["recurrenceRule"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): InvoicePurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePurchaseOrderDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["invoiceNumber"] = this.invoiceNumber;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        data["recurrenceRule"] = this.recurrenceRule ? this.recurrenceRule.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicePurchaseOrderDto extends IFinancialDocumentDto {
    status?: InvoicePurchaseOrderStatus;
    invoiceNumber?: string | undefined;
    actions?: InvoicePurchaseOrderAction[];
    recurrenceRule?: RecurrenceRuleDto | undefined;
}

export enum InvoicePurchaseOrderStatus {
    Draft = "Draft",
    Open = "Open",
    Canceled = "Canceled",
    InvoiceMissed = "InvoiceMissed",
    InvoicedLate = "InvoicedLate",
    InvoicePending = "InvoicePending",
    Posted = "Posted",
    OnHold = "OnHold",
    Invoiced = "Invoiced",
    Completed = "Completed",
    Scheduled = "Scheduled",
}

export class InvoicePurchaseOrderInfoDto implements IInvoicePurchaseOrderInfoDto {
    id?: string;
    currency?: CurrencyCode;
    vendorId?: string;
    serviceTypeId?: string;
    billToClientId?: string | undefined;
    conversionRate?: number | undefined;
    items?: FinancialDocumentItemDto[];

    constructor(data?: IInvoicePurchaseOrderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.billToClientId = _data["billToClientId"];
            this.conversionRate = _data["conversionRate"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDocumentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicePurchaseOrderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePurchaseOrderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["billToClientId"] = this.billToClientId;
        data["conversionRate"] = this.conversionRate;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoicePurchaseOrderInfoDto {
    id?: string;
    currency?: CurrencyCode;
    vendorId?: string;
    serviceTypeId?: string;
    billToClientId?: string | undefined;
    conversionRate?: number | undefined;
    items?: FinancialDocumentItemDto[];
}

export class CreateConversionRateCommand implements ICreateConversionRateCommand {
    rate?: number;
    month?: Month;
    year?: number;

    constructor(data?: ICreateConversionRateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CreateConversionRateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConversionRateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ICreateConversionRateCommand {
    rate?: number;
    month?: Month;
    year?: number;
}

export class UpdateConversionRateCommand extends CreateConversionRateCommand implements IUpdateConversionRateCommand {
    id?: string;

    constructor(data?: IUpdateConversionRateCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateConversionRateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConversionRateCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateConversionRateCommand extends ICreateConversionRateCommand {
    id?: string;
}

export class CreateInvoiceCommand implements ICreateInvoiceCommand {
    action?: InvoiceAction;
    currency?: CurrencyCode;
    purchaseOrderId?: string | undefined;
    purchaseOrderNotFound?: boolean;
    serviceTypeId?: string;
    vendorId?: string;
    billToClientId?: string | undefined;
    invoiceNumber?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    totalAmountAfterTax?: number;
    invoiceFiles?: UploadedFileDto[];
    billOfMaterialsFiles?: UploadedFileDto[];
    items?: FinancialDocumentItemDto[];

    constructor(data?: ICreateInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.currency = _data["currency"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseOrderNotFound = _data["purchaseOrderNotFound"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.vendorId = _data["vendorId"];
            this.billToClientId = _data["billToClientId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.conversionRate = _data["conversionRate"];
            this.totalAmountAfterTax = _data["totalAmountAfterTax"];
            if (Array.isArray(_data["invoiceFiles"])) {
                this.invoiceFiles = [] as any;
                for (let item of _data["invoiceFiles"])
                    this.invoiceFiles!.push(UploadedFileDto.fromJS(item));
            }
            if (Array.isArray(_data["billOfMaterialsFiles"])) {
                this.billOfMaterialsFiles = [] as any;
                for (let item of _data["billOfMaterialsFiles"])
                    this.billOfMaterialsFiles!.push(UploadedFileDto.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDocumentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["currency"] = this.currency;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseOrderNotFound"] = this.purchaseOrderNotFound;
        data["serviceTypeId"] = this.serviceTypeId;
        data["vendorId"] = this.vendorId;
        data["billToClientId"] = this.billToClientId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["conversionRate"] = this.conversionRate;
        data["totalAmountAfterTax"] = this.totalAmountAfterTax;
        if (Array.isArray(this.invoiceFiles)) {
            data["invoiceFiles"] = [];
            for (let item of this.invoiceFiles)
                data["invoiceFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.billOfMaterialsFiles)) {
            data["billOfMaterialsFiles"] = [];
            for (let item of this.billOfMaterialsFiles)
                data["billOfMaterialsFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateInvoiceCommand {
    action?: InvoiceAction;
    currency?: CurrencyCode;
    purchaseOrderId?: string | undefined;
    purchaseOrderNotFound?: boolean;
    serviceTypeId?: string;
    vendorId?: string;
    billToClientId?: string | undefined;
    invoiceNumber?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    totalAmountAfterTax?: number;
    invoiceFiles?: UploadedFileDto[];
    billOfMaterialsFiles?: UploadedFileDto[];
    items?: FinancialDocumentItemDto[];
}

export enum InvoiceAction {
    SaveAsDraft = "SaveAsDraft",
    Save = "Save",
    Submit = "Submit",
    BackToVendor = "BackToVendor",
    Investigate = "Investigate",
    InvestigationCompleted = "InvestigationCompleted",
    Decline = "Decline",
    ApproveL1 = "ApproveL1",
    ApproveL2 = "ApproveL2",
    ApproveL3 = "ApproveL3",
    OnHold = "OnHold",
    ResumeInvoice = "ResumeInvoice",
    BackToL1 = "BackToL1",
    Posted = "Posted",
    UndoToPendingAP = "UndoToPendingAP",
}

export class UpdateInvoiceCommand extends CreateInvoiceCommand implements IUpdateInvoiceCommand {
    number?: string;
    invoiceFilesRemove?: string[];
    billOfMaterialsFilesRemove?: string[];

    constructor(data?: IUpdateInvoiceCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            if (Array.isArray(_data["invoiceFilesRemove"])) {
                this.invoiceFilesRemove = [] as any;
                for (let item of _data["invoiceFilesRemove"])
                    this.invoiceFilesRemove!.push(item);
            }
            if (Array.isArray(_data["billOfMaterialsFilesRemove"])) {
                this.billOfMaterialsFilesRemove = [] as any;
                for (let item of _data["billOfMaterialsFilesRemove"])
                    this.billOfMaterialsFilesRemove!.push(item);
            }
        }
    }

    static override fromJS(data: any): UpdateInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        if (Array.isArray(this.invoiceFilesRemove)) {
            data["invoiceFilesRemove"] = [];
            for (let item of this.invoiceFilesRemove)
                data["invoiceFilesRemove"].push(item);
        }
        if (Array.isArray(this.billOfMaterialsFilesRemove)) {
            data["billOfMaterialsFilesRemove"] = [];
            for (let item of this.billOfMaterialsFilesRemove)
                data["billOfMaterialsFilesRemove"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateInvoiceCommand extends ICreateInvoiceCommand {
    number?: string;
    invoiceFilesRemove?: string[];
    billOfMaterialsFilesRemove?: string[];
}

export class InvoiceDto extends FinancialDocumentDto implements IInvoiceDto {
    status?: InvoiceStatus;
    purchaseOrderId?: string | undefined;
    purchaseOrderNotFound?: boolean;
    invoiceNumber?: string;
    purchaseOrderNumber?: string;
    totalAmountAfterTax?: number;
    invoiceFiles?: FileDto[];
    billOfMaterialsFiles?: FileDto[];
    actions?: InvoiceAction[];

    constructor(data?: IInvoiceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseOrderNotFound = _data["purchaseOrderNotFound"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.totalAmountAfterTax = _data["totalAmountAfterTax"];
            if (Array.isArray(_data["invoiceFiles"])) {
                this.invoiceFiles = [] as any;
                for (let item of _data["invoiceFiles"])
                    this.invoiceFiles!.push(FileDto.fromJS(item));
            }
            if (Array.isArray(_data["billOfMaterialsFiles"])) {
                this.billOfMaterialsFiles = [] as any;
                for (let item of _data["billOfMaterialsFiles"])
                    this.billOfMaterialsFiles!.push(FileDto.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
        }
    }

    static override fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseOrderNotFound"] = this.purchaseOrderNotFound;
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["totalAmountAfterTax"] = this.totalAmountAfterTax;
        if (Array.isArray(this.invoiceFiles)) {
            data["invoiceFiles"] = [];
            for (let item of this.invoiceFiles)
                data["invoiceFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.billOfMaterialsFiles)) {
            data["billOfMaterialsFiles"] = [];
            for (let item of this.billOfMaterialsFiles)
                data["billOfMaterialsFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceDto extends IFinancialDocumentDto {
    status?: InvoiceStatus;
    purchaseOrderId?: string | undefined;
    purchaseOrderNotFound?: boolean;
    invoiceNumber?: string;
    purchaseOrderNumber?: string;
    totalAmountAfterTax?: number;
    invoiceFiles?: FileDto[];
    billOfMaterialsFiles?: FileDto[];
    actions?: InvoiceAction[];
}

export enum InvoiceStatus {
    Draft = "Draft",
    Submitted = "Submitted",
    OnHold = "OnHold",
    L1Approval = "L1Approval",
    Declined = "Declined",
    Investigation = "Investigation",
    L2Approval = "L2Approval",
    L3Approval = "L3Approval",
    PendingAP = "PendingAP",
    Posted = "Posted",
}

export class CreateCreditRequestCommand implements ICreateCreditRequestCommand {
    action?: CreditRequestAction;
    currency?: CurrencyCode;
    vendorId?: string;
    billToClientId?: string | undefined;
    serviceTypeId?: string;
    invoiceId?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    items?: FinancialDocumentItemDto[];

    constructor(data?: ICreateCreditRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.billToClientId = _data["billToClientId"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.invoiceId = _data["invoiceId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.conversionRate = _data["conversionRate"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDocumentItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCreditRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCreditRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["billToClientId"] = this.billToClientId;
        data["serviceTypeId"] = this.serviceTypeId;
        data["invoiceId"] = this.invoiceId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["conversionRate"] = this.conversionRate;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCreditRequestCommand {
    action?: CreditRequestAction;
    currency?: CurrencyCode;
    vendorId?: string;
    billToClientId?: string | undefined;
    serviceTypeId?: string;
    invoiceId?: string;
    issueDate?: Date;
    dueDate?: Date;
    conversionRate?: number | undefined;
    items?: FinancialDocumentItemDto[];
}

export enum CreditRequestAction {
    SaveAsDraft = "SaveAsDraft",
    Save = "Save",
    Submit = "Submit",
    Cancel = "Cancel",
    BackToAP = "BackToAP",
    Complete = "Complete",
}

export class UpdateCreditRequestCommand extends CreateCreditRequestCommand implements IUpdateCreditRequestCommand {
    number?: string;

    constructor(data?: IUpdateCreditRequestCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): UpdateCreditRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCreditRequestCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCreditRequestCommand extends ICreateCreditRequestCommand {
    number?: string;
}

export class CreditRequestDto extends FinancialDocumentDto implements ICreditRequestDto {
    invoiceId?: string;
    status?: CreditRequestStatus;
    actions?: CreditRequestAction[];

    constructor(data?: ICreditRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.status = _data["status"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
        }
    }

    static override fromJS(data: any): CreditRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["status"] = this.status;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreditRequestDto extends IFinancialDocumentDto {
    invoiceId?: string;
    status?: CreditRequestStatus;
    actions?: CreditRequestAction[];
}

export enum CreditRequestStatus {
    Draft = "Draft",
    PendingAP = "PendingAP",
    Cancelled = "Cancelled",
    Completed = "Completed",
}

export class MaterialGridViewDto implements IMaterialGridViewDto {
    number?: string;
    status?: MaterialStatus;
    storageType?: StorageType;
    actualStorageType?: StorageType | undefined;
    business?: string | undefined;
    description?: string | undefined;
    clientTotShelfLife?: number;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    weightType?: string | undefined;
    unit?: string | undefined;
    salesUnit?: string | undefined;
    eachesPerSalesUnit?: number | undefined;
    piecesPerPallet?: number | undefined;
    casesPerLayer?: number | undefined;
    casesPerPallet?: number | undefined;
    layersPerPallet?: number | undefined;
    stackingFactor?: number;
    category?: string | undefined;
    categoryDescription?: string | undefined;
    hierarchyDescription?: string | undefined;
    nationalPrice?: number | undefined;
    corporateBrand?: string | undefined;
    corporateBrandDescription?: string | undefined;
    rangeBrand?: string | undefined;
    rangeBrandDescription?: string | undefined;
    materialGroup?: string | undefined;
    materialGroupDescription?: string | undefined;
    nestecProductCategoryName?: string | undefined;
    originDescription?: string | undefined;
    created?: Date | undefined;

    constructor(data?: IMaterialGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.status = _data["status"];
            this.storageType = _data["storageType"];
            this.actualStorageType = _data["actualStorageType"];
            this.business = _data["business"];
            this.description = _data["description"];
            this.clientTotShelfLife = _data["clientTotShelfLife"];
            this.grossWeight = _data["grossWeight"];
            this.netWeight = _data["netWeight"];
            this.weightType = _data["weightType"];
            this.unit = _data["unit"];
            this.salesUnit = _data["salesUnit"];
            this.eachesPerSalesUnit = _data["eachesPerSalesUnit"];
            this.piecesPerPallet = _data["piecesPerPallet"];
            this.casesPerLayer = _data["casesPerLayer"];
            this.casesPerPallet = _data["casesPerPallet"];
            this.layersPerPallet = _data["layersPerPallet"];
            this.stackingFactor = _data["stackingFactor"];
            this.category = _data["category"];
            this.categoryDescription = _data["categoryDescription"];
            this.hierarchyDescription = _data["hierarchyDescription"];
            this.nationalPrice = _data["nationalPrice"];
            this.corporateBrand = _data["corporateBrand"];
            this.corporateBrandDescription = _data["corporateBrandDescription"];
            this.rangeBrand = _data["rangeBrand"];
            this.rangeBrandDescription = _data["rangeBrandDescription"];
            this.materialGroup = _data["materialGroup"];
            this.materialGroupDescription = _data["materialGroupDescription"];
            this.nestecProductCategoryName = _data["nestecProductCategoryName"];
            this.originDescription = _data["originDescription"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["status"] = this.status;
        data["storageType"] = this.storageType;
        data["actualStorageType"] = this.actualStorageType;
        data["business"] = this.business;
        data["description"] = this.description;
        data["clientTotShelfLife"] = this.clientTotShelfLife;
        data["grossWeight"] = this.grossWeight;
        data["netWeight"] = this.netWeight;
        data["weightType"] = this.weightType;
        data["unit"] = this.unit;
        data["salesUnit"] = this.salesUnit;
        data["eachesPerSalesUnit"] = this.eachesPerSalesUnit;
        data["piecesPerPallet"] = this.piecesPerPallet;
        data["casesPerLayer"] = this.casesPerLayer;
        data["casesPerPallet"] = this.casesPerPallet;
        data["layersPerPallet"] = this.layersPerPallet;
        data["stackingFactor"] = this.stackingFactor;
        data["category"] = this.category;
        data["categoryDescription"] = this.categoryDescription;
        data["hierarchyDescription"] = this.hierarchyDescription;
        data["nationalPrice"] = this.nationalPrice;
        data["corporateBrand"] = this.corporateBrand;
        data["corporateBrandDescription"] = this.corporateBrandDescription;
        data["rangeBrand"] = this.rangeBrand;
        data["rangeBrandDescription"] = this.rangeBrandDescription;
        data["materialGroup"] = this.materialGroup;
        data["materialGroupDescription"] = this.materialGroupDescription;
        data["nestecProductCategoryName"] = this.nestecProductCategoryName;
        data["originDescription"] = this.originDescription;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMaterialGridViewDto {
    number?: string;
    status?: MaterialStatus;
    storageType?: StorageType;
    actualStorageType?: StorageType | undefined;
    business?: string | undefined;
    description?: string | undefined;
    clientTotShelfLife?: number;
    grossWeight?: number | undefined;
    netWeight?: number | undefined;
    weightType?: string | undefined;
    unit?: string | undefined;
    salesUnit?: string | undefined;
    eachesPerSalesUnit?: number | undefined;
    piecesPerPallet?: number | undefined;
    casesPerLayer?: number | undefined;
    casesPerPallet?: number | undefined;
    layersPerPallet?: number | undefined;
    stackingFactor?: number;
    category?: string | undefined;
    categoryDescription?: string | undefined;
    hierarchyDescription?: string | undefined;
    nationalPrice?: number | undefined;
    corporateBrand?: string | undefined;
    corporateBrandDescription?: string | undefined;
    rangeBrand?: string | undefined;
    rangeBrandDescription?: string | undefined;
    materialGroup?: string | undefined;
    materialGroupDescription?: string | undefined;
    nestecProductCategoryName?: string | undefined;
    originDescription?: string | undefined;
    created?: Date | undefined;
}

export class MaterialDto extends MaterialGridViewDto implements IMaterialDto {

    constructor(data?: IMaterialDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMaterialDto extends IMaterialGridViewDto {
}

export enum MaterialStatus {
    Discontinued = "Discontinued",
    BeingDiscontinued = "BeingDiscontinued",
    Active = "Active",
    CostingInProcess = "CostingInProcess",
    Forecast = "Forecast",
}

export enum StorageType {
    Ambient = "Ambient",
    Cooler = "Cooler",
}

export class UpdateMaterialCommand implements IUpdateMaterialCommand {
    number?: string;
    actualStorageType?: StorageType | undefined;

    constructor(data?: IUpdateMaterialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.actualStorageType = _data["actualStorageType"];
        }
    }

    static fromJS(data: any): UpdateMaterialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMaterialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["actualStorageType"] = this.actualStorageType;
        return data;
    }
}

export interface IUpdateMaterialCommand {
    number?: string;
    actualStorageType?: StorageType | undefined;
}

export class HalbGridViewDto implements IHalbGridViewDto {
    number?: string;
    materialType?: string | undefined;
    mdrRecordOwner?: string | undefined;
    imspShared?: string | undefined;
    description?: string | undefined;
    fullPallet?: number;
    storageType?: StorageType;
    materialGroup?: string | undefined;

    constructor(data?: IHalbGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.materialType = _data["materialType"];
            this.mdrRecordOwner = _data["mdrRecordOwner"];
            this.imspShared = _data["imspShared"];
            this.description = _data["description"];
            this.fullPallet = _data["fullPallet"];
            this.storageType = _data["storageType"];
            this.materialGroup = _data["materialGroup"];
        }
    }

    static fromJS(data: any): HalbGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HalbGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["materialType"] = this.materialType;
        data["mdrRecordOwner"] = this.mdrRecordOwner;
        data["imspShared"] = this.imspShared;
        data["description"] = this.description;
        data["fullPallet"] = this.fullPallet;
        data["storageType"] = this.storageType;
        data["materialGroup"] = this.materialGroup;
        return data;
    }
}

export interface IHalbGridViewDto {
    number?: string;
    materialType?: string | undefined;
    mdrRecordOwner?: string | undefined;
    imspShared?: string | undefined;
    description?: string | undefined;
    fullPallet?: number;
    storageType?: StorageType;
    materialGroup?: string | undefined;
}

export class HalbDto extends HalbGridViewDto implements IHalbDto {

    constructor(data?: IHalbDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HalbDto {
        data = typeof data === 'object' ? data : {};
        let result = new HalbDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHalbDto extends IHalbGridViewDto {
}

export class UpdateHalbCommand implements IUpdateHalbCommand {
    number?: string;
    revisedStorageType?: StorageType;
    materialGroup?: string | undefined;

    constructor(data?: IUpdateHalbCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.revisedStorageType = _data["revisedStorageType"];
            this.materialGroup = _data["materialGroup"];
        }
    }

    static fromJS(data: any): UpdateHalbCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHalbCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["revisedStorageType"] = this.revisedStorageType;
        data["materialGroup"] = this.materialGroup;
        return data;
    }
}

export interface IUpdateHalbCommand {
    number?: string;
    revisedStorageType?: StorageType;
    materialGroup?: string | undefined;
}

export class BinGridViewDto implements IBinGridViewDto {
    number?: string;
    storageTypeCode?: string;
    storageBinType?: string | undefined;
    storageType?: StorageType;
    maxPallets?: number | undefined;
    aisle?: string | undefined;
    zone?: string | undefined;

    constructor(data?: IBinGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.storageTypeCode = _data["storageTypeCode"];
            this.storageBinType = _data["storageBinType"];
            this.storageType = _data["storageType"];
            this.maxPallets = _data["maxPallets"];
            this.aisle = _data["aisle"];
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): BinGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BinGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["storageTypeCode"] = this.storageTypeCode;
        data["storageBinType"] = this.storageBinType;
        data["storageType"] = this.storageType;
        data["maxPallets"] = this.maxPallets;
        data["aisle"] = this.aisle;
        data["zone"] = this.zone;
        return data;
    }
}

export interface IBinGridViewDto {
    number?: string;
    storageTypeCode?: string;
    storageBinType?: string | undefined;
    storageType?: StorageType;
    maxPallets?: number | undefined;
    aisle?: string | undefined;
    zone?: string | undefined;
}

export class BinDto extends BinGridViewDto implements IBinDto {

    constructor(data?: IBinDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BinDto {
        data = typeof data === 'object' ? data : {};
        let result = new BinDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBinDto extends IBinGridViewDto {
}

export class UpdateBinCommand implements IUpdateBinCommand {
    number?: string;
    storageTypeCode?: string;
    storageBinType?: string | undefined;
    storageType?: StorageType;
    maxPallets?: number | undefined;
    aisle?: string | undefined;
    zone?: string | undefined;

    constructor(data?: IUpdateBinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.storageTypeCode = _data["storageTypeCode"];
            this.storageBinType = _data["storageBinType"];
            this.storageType = _data["storageType"];
            this.maxPallets = _data["maxPallets"];
            this.aisle = _data["aisle"];
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): UpdateBinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["storageTypeCode"] = this.storageTypeCode;
        data["storageBinType"] = this.storageBinType;
        data["storageType"] = this.storageType;
        data["maxPallets"] = this.maxPallets;
        data["aisle"] = this.aisle;
        data["zone"] = this.zone;
        return data;
    }
}

export interface IUpdateBinCommand {
    number?: string;
    storageTypeCode?: string;
    storageBinType?: string | undefined;
    storageType?: StorageType;
    maxPallets?: number | undefined;
    aisle?: string | undefined;
    zone?: string | undefined;
}

export enum CountType {
    PalletCount = "PalletCount",
    MaterialCount = "MaterialCount",
    DistinctBinsUsed = "DistinctBinsUsed",
}

export enum PalletCountType {
    Full = "Full",
    Partial = "Partial",
    HALB = "HALB",
}

export class FacilityCapacityDto implements IFacilityCapacityDto {
    ambientCapacity?: number;
    coolerCapacity?: number;

    constructor(data?: IFacilityCapacityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ambientCapacity = _data["ambientCapacity"];
            this.coolerCapacity = _data["coolerCapacity"];
        }
    }

    static fromJS(data: any): FacilityCapacityDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityCapacityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ambientCapacity"] = this.ambientCapacity;
        data["coolerCapacity"] = this.coolerCapacity;
        return data;
    }
}

export interface IFacilityCapacityDto {
    ambientCapacity?: number;
    coolerCapacity?: number;
}

export class UpdateFacilityCapacityCommand implements IUpdateFacilityCapacityCommand {
    ambientCapacity?: number;
    coolerCapacity?: number;

    constructor(data?: IUpdateFacilityCapacityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ambientCapacity = _data["ambientCapacity"];
            this.coolerCapacity = _data["coolerCapacity"];
        }
    }

    static fromJS(data: any): UpdateFacilityCapacityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFacilityCapacityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ambientCapacity"] = this.ambientCapacity;
        data["coolerCapacity"] = this.coolerCapacity;
        return data;
    }
}

export interface IUpdateFacilityCapacityCommand {
    ambientCapacity?: number;
    coolerCapacity?: number;
}

export class CreateDurationSettingCommand implements ICreateDurationSettingCommand {
    from?: number;
    to?: number | undefined;
    name?: string;
    color?: ColorClass;
    storageTypeCode?: string;

    constructor(data?: ICreateDurationSettingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.storageTypeCode = _data["storageTypeCode"];
        }
    }

    static fromJS(data: any): CreateDurationSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDurationSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        data["name"] = this.name;
        data["color"] = this.color;
        data["storageTypeCode"] = this.storageTypeCode;
        return data;
    }
}

export interface ICreateDurationSettingCommand {
    from?: number;
    to?: number | undefined;
    name?: string;
    color?: ColorClass;
    storageTypeCode?: string;
}

export class UpdateDurationSettingCommand extends CreateDurationSettingCommand implements IUpdateDurationSettingCommand {
    id?: string;

    constructor(data?: IUpdateDurationSettingCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateDurationSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDurationSettingCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDurationSettingCommand extends ICreateDurationSettingCommand {
    id?: string;
}

export class StorageUnitGridViewDto implements IStorageUnitGridViewDto {
    number?: string;
    storageTypeCode?: string;
    storageUnitType?: string | undefined;
    status?: StorageUnitStatus;
    batch?: string | undefined;
    sledBbd?: Date | undefined;
    wmUnit?: string | undefined;
    numberOfQuants?: number | undefined;
    duration?: number | undefined;
    shipmentNumber?: string | undefined;
    binNumber?: string;
    lastModified?: Date;
    created?: Date;
    palletType?: PalletType;
    materialNumber?: string[];
    materialDescription?: (string | undefined)[];
    materialStorageType?: StorageType[];
    rangeBrandDescription?: (string | undefined)[];
    category?: (string | undefined)[];
    casesPerPallet?: (number | undefined)[];
    storageType?: StorageType;
    storageBinType?: string | undefined;
    maxPallets?: number | undefined;
    aisle?: string | undefined;
    zone?: string | undefined;

    constructor(data?: IStorageUnitGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.storageTypeCode = _data["storageTypeCode"];
            this.storageUnitType = _data["storageUnitType"];
            this.status = _data["status"];
            this.batch = _data["batch"];
            this.sledBbd = _data["sledBbd"] ? new Date(_data["sledBbd"].toString()) : <any>undefined;
            this.wmUnit = _data["wmUnit"];
            this.numberOfQuants = _data["numberOfQuants"];
            this.duration = _data["duration"];
            this.shipmentNumber = _data["shipmentNumber"];
            this.binNumber = _data["binNumber"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.palletType = _data["palletType"];
            if (Array.isArray(_data["materialNumber"])) {
                this.materialNumber = [] as any;
                for (let item of _data["materialNumber"])
                    this.materialNumber!.push(item);
            }
            if (Array.isArray(_data["materialDescription"])) {
                this.materialDescription = [] as any;
                for (let item of _data["materialDescription"])
                    this.materialDescription!.push(item);
            }
            if (Array.isArray(_data["materialStorageType"])) {
                this.materialStorageType = [] as any;
                for (let item of _data["materialStorageType"])
                    this.materialStorageType!.push(item);
            }
            if (Array.isArray(_data["rangeBrandDescription"])) {
                this.rangeBrandDescription = [] as any;
                for (let item of _data["rangeBrandDescription"])
                    this.rangeBrandDescription!.push(item);
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
            if (Array.isArray(_data["casesPerPallet"])) {
                this.casesPerPallet = [] as any;
                for (let item of _data["casesPerPallet"])
                    this.casesPerPallet!.push(item);
            }
            this.storageType = _data["storageType"];
            this.storageBinType = _data["storageBinType"];
            this.maxPallets = _data["maxPallets"];
            this.aisle = _data["aisle"];
            this.zone = _data["zone"];
        }
    }

    static fromJS(data: any): StorageUnitGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUnitGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["storageTypeCode"] = this.storageTypeCode;
        data["storageUnitType"] = this.storageUnitType;
        data["status"] = this.status;
        data["batch"] = this.batch;
        data["sledBbd"] = this.sledBbd ? this.sledBbd.toISOString() : <any>undefined;
        data["wmUnit"] = this.wmUnit;
        data["numberOfQuants"] = this.numberOfQuants;
        data["duration"] = this.duration;
        data["shipmentNumber"] = this.shipmentNumber;
        data["binNumber"] = this.binNumber;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["palletType"] = this.palletType;
        if (Array.isArray(this.materialNumber)) {
            data["materialNumber"] = [];
            for (let item of this.materialNumber)
                data["materialNumber"].push(item);
        }
        if (Array.isArray(this.materialDescription)) {
            data["materialDescription"] = [];
            for (let item of this.materialDescription)
                data["materialDescription"].push(item);
        }
        if (Array.isArray(this.materialStorageType)) {
            data["materialStorageType"] = [];
            for (let item of this.materialStorageType)
                data["materialStorageType"].push(item);
        }
        if (Array.isArray(this.rangeBrandDescription)) {
            data["rangeBrandDescription"] = [];
            for (let item of this.rangeBrandDescription)
                data["rangeBrandDescription"].push(item);
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (Array.isArray(this.casesPerPallet)) {
            data["casesPerPallet"] = [];
            for (let item of this.casesPerPallet)
                data["casesPerPallet"].push(item);
        }
        data["storageType"] = this.storageType;
        data["storageBinType"] = this.storageBinType;
        data["maxPallets"] = this.maxPallets;
        data["aisle"] = this.aisle;
        data["zone"] = this.zone;
        return data;
    }
}

export interface IStorageUnitGridViewDto {
    number?: string;
    storageTypeCode?: string;
    storageUnitType?: string | undefined;
    status?: StorageUnitStatus;
    batch?: string | undefined;
    sledBbd?: Date | undefined;
    wmUnit?: string | undefined;
    numberOfQuants?: number | undefined;
    duration?: number | undefined;
    shipmentNumber?: string | undefined;
    binNumber?: string;
    lastModified?: Date;
    created?: Date;
    palletType?: PalletType;
    materialNumber?: string[];
    materialDescription?: (string | undefined)[];
    materialStorageType?: StorageType[];
    rangeBrandDescription?: (string | undefined)[];
    category?: (string | undefined)[];
    casesPerPallet?: (number | undefined)[];
    storageType?: StorageType;
    storageBinType?: string | undefined;
    maxPallets?: number | undefined;
    aisle?: string | undefined;
    zone?: string | undefined;
}

export class StorageUnitDto extends StorageUnitGridViewDto implements IStorageUnitDto {
    materials?: StorageUnitMaterialDto[];
    history?: StorageUnitBinHistoryDto[];
    latestBin?: BinDto;
    dateEntered?: Date;

    constructor(data?: IStorageUnitDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(StorageUnitMaterialDto.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(StorageUnitBinHistoryDto.fromJS(item));
            }
            this.latestBin = _data["latestBin"] ? BinDto.fromJS(_data["latestBin"]) : <any>undefined;
            this.dateEntered = _data["dateEntered"] ? new Date(_data["dateEntered"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): StorageUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUnitDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        data["latestBin"] = this.latestBin ? this.latestBin.toJSON() : <any>undefined;
        data["dateEntered"] = this.dateEntered ? this.dateEntered.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStorageUnitDto extends IStorageUnitGridViewDto {
    materials?: StorageUnitMaterialDto[];
    history?: StorageUnitBinHistoryDto[];
    latestBin?: BinDto;
    dateEntered?: Date;
}

export class StorageUnitMaterialDto implements IStorageUnitMaterialDto {
    type?: GenericMaterialType;
    number?: string;
    description?: string | undefined;
    storageType?: StorageType;
    rangeBrandDescription?: string | undefined;
    category?: string | undefined;
    casesPerPallet?: number | undefined;
    materialGroup?: string | undefined;
    weight?: number;
    totalQuantityWmUoM?: number;
    salesUnit?: string | undefined;

    constructor(data?: IStorageUnitMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.storageType = _data["storageType"];
            this.rangeBrandDescription = _data["rangeBrandDescription"];
            this.category = _data["category"];
            this.casesPerPallet = _data["casesPerPallet"];
            this.materialGroup = _data["materialGroup"];
            this.weight = _data["weight"];
            this.totalQuantityWmUoM = _data["totalQuantityWmUoM"];
            this.salesUnit = _data["salesUnit"];
        }
    }

    static fromJS(data: any): StorageUnitMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUnitMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["number"] = this.number;
        data["description"] = this.description;
        data["storageType"] = this.storageType;
        data["rangeBrandDescription"] = this.rangeBrandDescription;
        data["category"] = this.category;
        data["casesPerPallet"] = this.casesPerPallet;
        data["materialGroup"] = this.materialGroup;
        data["weight"] = this.weight;
        data["totalQuantityWmUoM"] = this.totalQuantityWmUoM;
        data["salesUnit"] = this.salesUnit;
        return data;
    }
}

export interface IStorageUnitMaterialDto {
    type?: GenericMaterialType;
    number?: string;
    description?: string | undefined;
    storageType?: StorageType;
    rangeBrandDescription?: string | undefined;
    category?: string | undefined;
    casesPerPallet?: number | undefined;
    materialGroup?: string | undefined;
    weight?: number;
    totalQuantityWmUoM?: number;
    salesUnit?: string | undefined;
}

export enum GenericMaterialType {
    Material = "Material",
    HALB = "HALB",
}

export class StorageUnitBinHistoryDto implements IStorageUnitBinHistoryDto {
    id?: string;
    binNumber?: string;
    storageTypeCode?: string;
    status?: StorageUnitStatus;
    zone?: string | undefined;
    duration?: number;
    lastModified?: Date;
    created?: Date;

    constructor(data?: IStorageUnitBinHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.binNumber = _data["binNumber"];
            this.storageTypeCode = _data["storageTypeCode"];
            this.status = _data["status"];
            this.zone = _data["zone"];
            this.duration = _data["duration"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StorageUnitBinHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUnitBinHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["binNumber"] = this.binNumber;
        data["storageTypeCode"] = this.storageTypeCode;
        data["status"] = this.status;
        data["zone"] = this.zone;
        data["duration"] = this.duration;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStorageUnitBinHistoryDto {
    id?: string;
    binNumber?: string;
    storageTypeCode?: string;
    status?: StorageUnitStatus;
    zone?: string | undefined;
    duration?: number;
    lastModified?: Date;
    created?: Date;
}

export enum StorageUnitStatus {
    Active = "Active",
    Completed = "Completed",
}

export enum PalletType {
    NA = "NA",
    Full = "Full",
    Partial = "Partial",
}

export class SLAScoreExportQuery implements ISLAScoreExportQuery {
    storageTypeCode?: string;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: ISLAScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageTypeCode = _data["storageTypeCode"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SLAScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SLAScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageTypeCode"] = this.storageTypeCode;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISLAScoreExportQuery {
    storageTypeCode?: string;
    from?: Date;
    to?: Date | undefined;
}

export class SLAScoreQuery implements ISLAScoreQuery {
    storageTypeCode?: string;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: ISLAScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageTypeCode = _data["storageTypeCode"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SLAScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SLAScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageTypeCode"] = this.storageTypeCode;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISLAScoreQuery {
    storageTypeCode?: string;
    from?: Date;
    to?: Date | undefined;
}

export class SLATrendingQuery implements ISLATrendingQuery {
    storageTypeCode?: string;
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;

    constructor(data?: ISLATrendingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageTypeCode = _data["storageTypeCode"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.aggregateType = _data["aggregateType"];
        }
    }

    static fromJS(data: any): SLATrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SLATrendingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageTypeCode"] = this.storageTypeCode;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["aggregateType"] = this.aggregateType;
        return data;
    }
}

export interface ISLATrendingQuery {
    storageTypeCode?: string;
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;
}

export class FacilityUtilizationScoreExportQuery implements IFacilityUtilizationScoreExportQuery {
    scoreType?: FacilityUtilizationScoreType;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IFacilityUtilizationScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreType = _data["scoreType"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FacilityUtilizationScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityUtilizationScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreType"] = this.scoreType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFacilityUtilizationScoreExportQuery {
    scoreType?: FacilityUtilizationScoreType;
    from?: Date;
    to?: Date | undefined;
}

export enum FacilityUtilizationScoreType {
    FacilityUsage = "FacilityUsage",
    CoolerUsage = "CoolerUsage",
    AmbientUsage = "AmbientUsage",
}

export class FacilityUtilizationScoreQuery implements IFacilityUtilizationScoreQuery {
    scoreType?: FacilityUtilizationScoreType;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IFacilityUtilizationScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreType = _data["scoreType"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FacilityUtilizationScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityUtilizationScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreType"] = this.scoreType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFacilityUtilizationScoreQuery {
    scoreType?: FacilityUtilizationScoreType;
    from?: Date;
    to?: Date | undefined;
}

export class FacilityUtilizationTrendingQuery implements IFacilityUtilizationTrendingQuery {
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;

    constructor(data?: IFacilityUtilizationTrendingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.aggregateType = _data["aggregateType"];
        }
    }

    static fromJS(data: any): FacilityUtilizationTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityUtilizationTrendingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["aggregateType"] = this.aggregateType;
        return data;
    }
}

export interface IFacilityUtilizationTrendingQuery {
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;
}

export class BlockedStockScoreAggregateDto implements IBlockedStockScoreAggregateDto {
    date?: Date;
    minDate?: Date;
    maxDate?: Date;
    blockedStock?: number;
    unmatchedBlockedStock?: number;
    totalBlockedStock?: number;
    blockedStockPercent?: number;
    noRacCodingUnmatchedPercent?: number;
    onHold30Days?: number;
    onHold30DaysPercent?: number;
    onHold45Days?: number;
    onHold45DaysPercent?: number;
    onHold90Days?: number;
    onHold90DaysPercent?: number;
    noRacCodingPercent?: number;
    agedOrNearingExpiryPercent?: number;
    expired?: number;
    expiredPercent?: number;
    foreignMaterial?: number;
    foreignMaterialPercent?: number;
    labellingPackaging?: number;
    labellingPackagingPercent?: number;
    infestation?: number;
    infestationPercent?: number;
    returns?: number;
    returnsPercent?: number;
    damage?: number;
    damagePercent?: number;
    logistical?: number;
    logisticalPercent?: number;

    constructor(data?: IBlockedStockScoreAggregateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.minDate = _data["minDate"] ? new Date(_data["minDate"].toString()) : <any>undefined;
            this.maxDate = _data["maxDate"] ? new Date(_data["maxDate"].toString()) : <any>undefined;
            this.blockedStock = _data["blockedStock"];
            this.unmatchedBlockedStock = _data["unmatchedBlockedStock"];
            this.totalBlockedStock = _data["totalBlockedStock"];
            this.blockedStockPercent = _data["blockedStockPercent"];
            this.noRacCodingUnmatchedPercent = _data["noRacCodingUnmatchedPercent"];
            this.onHold30Days = _data["onHold30Days"];
            this.onHold30DaysPercent = _data["onHold30DaysPercent"];
            this.onHold45Days = _data["onHold45Days"];
            this.onHold45DaysPercent = _data["onHold45DaysPercent"];
            this.onHold90Days = _data["onHold90Days"];
            this.onHold90DaysPercent = _data["onHold90DaysPercent"];
            this.noRacCodingPercent = _data["noRacCodingPercent"];
            this.agedOrNearingExpiryPercent = _data["agedOrNearingExpiryPercent"];
            this.expired = _data["expired"];
            this.expiredPercent = _data["expiredPercent"];
            this.foreignMaterial = _data["foreignMaterial"];
            this.foreignMaterialPercent = _data["foreignMaterialPercent"];
            this.labellingPackaging = _data["labellingPackaging"];
            this.labellingPackagingPercent = _data["labellingPackagingPercent"];
            this.infestation = _data["infestation"];
            this.infestationPercent = _data["infestationPercent"];
            this.returns = _data["returns"];
            this.returnsPercent = _data["returnsPercent"];
            this.damage = _data["damage"];
            this.damagePercent = _data["damagePercent"];
            this.logistical = _data["logistical"];
            this.logisticalPercent = _data["logisticalPercent"];
        }
    }

    static fromJS(data: any): BlockedStockScoreAggregateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedStockScoreAggregateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["minDate"] = this.minDate ? this.minDate.toISOString() : <any>undefined;
        data["maxDate"] = this.maxDate ? this.maxDate.toISOString() : <any>undefined;
        data["blockedStock"] = this.blockedStock;
        data["unmatchedBlockedStock"] = this.unmatchedBlockedStock;
        data["totalBlockedStock"] = this.totalBlockedStock;
        data["blockedStockPercent"] = this.blockedStockPercent;
        data["noRacCodingUnmatchedPercent"] = this.noRacCodingUnmatchedPercent;
        data["onHold30Days"] = this.onHold30Days;
        data["onHold30DaysPercent"] = this.onHold30DaysPercent;
        data["onHold45Days"] = this.onHold45Days;
        data["onHold45DaysPercent"] = this.onHold45DaysPercent;
        data["onHold90Days"] = this.onHold90Days;
        data["onHold90DaysPercent"] = this.onHold90DaysPercent;
        data["noRacCodingPercent"] = this.noRacCodingPercent;
        data["agedOrNearingExpiryPercent"] = this.agedOrNearingExpiryPercent;
        data["expired"] = this.expired;
        data["expiredPercent"] = this.expiredPercent;
        data["foreignMaterial"] = this.foreignMaterial;
        data["foreignMaterialPercent"] = this.foreignMaterialPercent;
        data["labellingPackaging"] = this.labellingPackaging;
        data["labellingPackagingPercent"] = this.labellingPackagingPercent;
        data["infestation"] = this.infestation;
        data["infestationPercent"] = this.infestationPercent;
        data["returns"] = this.returns;
        data["returnsPercent"] = this.returnsPercent;
        data["damage"] = this.damage;
        data["damagePercent"] = this.damagePercent;
        data["logistical"] = this.logistical;
        data["logisticalPercent"] = this.logisticalPercent;
        return data;
    }
}

export interface IBlockedStockScoreAggregateDto {
    date?: Date;
    minDate?: Date;
    maxDate?: Date;
    blockedStock?: number;
    unmatchedBlockedStock?: number;
    totalBlockedStock?: number;
    blockedStockPercent?: number;
    noRacCodingUnmatchedPercent?: number;
    onHold30Days?: number;
    onHold30DaysPercent?: number;
    onHold45Days?: number;
    onHold45DaysPercent?: number;
    onHold90Days?: number;
    onHold90DaysPercent?: number;
    noRacCodingPercent?: number;
    agedOrNearingExpiryPercent?: number;
    expired?: number;
    expiredPercent?: number;
    foreignMaterial?: number;
    foreignMaterialPercent?: number;
    labellingPackaging?: number;
    labellingPackagingPercent?: number;
    infestation?: number;
    infestationPercent?: number;
    returns?: number;
    returnsPercent?: number;
    damage?: number;
    damagePercent?: number;
    logistical?: number;
    logisticalPercent?: number;
}

export class BlockedStockScoreAggregateQuery implements IBlockedStockScoreAggregateQuery {
    aggregateType?: AggregateType;
    from?: Date;
    to?: Date | undefined;
    timeZoneOffset?: number;

    constructor(data?: IBlockedStockScoreAggregateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregateType = _data["aggregateType"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): BlockedStockScoreAggregateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedStockScoreAggregateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateType"] = this.aggregateType;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }
}

export interface IBlockedStockScoreAggregateQuery {
    aggregateType?: AggregateType;
    from?: Date;
    to?: Date | undefined;
    timeZoneOffset?: number;
}

export enum MB51Reason {
    Other = "Other",
    Damage = "Damage",
    Adjustment = "Adjustment",
}

export class MB51AggregateDto implements IMB51AggregateDto {
    date?: Date;
    minDate?: Date;
    maxDate?: Date;
    amountInLc?: number;
    quantity?: number;
    quantityCs?: number;
    quantityPal?: number;
    quantityDsp?: number;
    quantityEa?: number;

    constructor(data?: IMB51AggregateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.minDate = _data["minDate"] ? new Date(_data["minDate"].toString()) : <any>undefined;
            this.maxDate = _data["maxDate"] ? new Date(_data["maxDate"].toString()) : <any>undefined;
            this.amountInLc = _data["amountInLc"];
            this.quantity = _data["quantity"];
            this.quantityCs = _data["quantityCs"];
            this.quantityPal = _data["quantityPal"];
            this.quantityDsp = _data["quantityDsp"];
            this.quantityEa = _data["quantityEa"];
        }
    }

    static fromJS(data: any): MB51AggregateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MB51AggregateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["minDate"] = this.minDate ? this.minDate.toISOString() : <any>undefined;
        data["maxDate"] = this.maxDate ? this.maxDate.toISOString() : <any>undefined;
        data["amountInLc"] = this.amountInLc;
        data["quantity"] = this.quantity;
        data["quantityCs"] = this.quantityCs;
        data["quantityPal"] = this.quantityPal;
        data["quantityDsp"] = this.quantityDsp;
        data["quantityEa"] = this.quantityEa;
        return data;
    }
}

export interface IMB51AggregateDto {
    date?: Date;
    minDate?: Date;
    maxDate?: Date;
    amountInLc?: number;
    quantity?: number;
    quantityCs?: number;
    quantityPal?: number;
    quantityDsp?: number;
    quantityEa?: number;
}

export class MB51AggregateQuery implements IMB51AggregateQuery {
    aggregateType?: AggregateType;
    reason?: MB51Reason | undefined;
    from?: Date;
    to?: Date | undefined;
    timeZoneOffset?: number;

    constructor(data?: IMB51AggregateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregateType = _data["aggregateType"];
            this.reason = _data["reason"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): MB51AggregateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MB51AggregateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateType"] = this.aggregateType;
        data["reason"] = this.reason;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }
}

export interface IMB51AggregateQuery {
    aggregateType?: AggregateType;
    reason?: MB51Reason | undefined;
    from?: Date;
    to?: Date | undefined;
    timeZoneOffset?: number;
}

export class CreateAppointmentCommand implements ICreateAppointmentCommand {
    action?: AppointmentAction;
    supplierId?: string;
    carrierId?: string;
    billOfLadingNumber?: string | undefined;
    palletCount?: number;
    loadType?: AppointmentLoadType | undefined;
    trailerNumber?: string | undefined;
    weightOfShipment?: string | undefined;
    requestDate?: Date | undefined;
    packingSlipFiles?: UploadedFileDto[];
    otherFiles?: UploadedFileDto[];
    purchaseOrders?: string[];

    constructor(data?: ICreateAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.supplierId = _data["supplierId"];
            this.carrierId = _data["carrierId"];
            this.billOfLadingNumber = _data["billOfLadingNumber"];
            this.palletCount = _data["palletCount"];
            this.loadType = _data["loadType"];
            this.trailerNumber = _data["trailerNumber"];
            this.weightOfShipment = _data["weightOfShipment"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["packingSlipFiles"])) {
                this.packingSlipFiles = [] as any;
                for (let item of _data["packingSlipFiles"])
                    this.packingSlipFiles!.push(UploadedFileDto.fromJS(item));
            }
            if (Array.isArray(_data["otherFiles"])) {
                this.otherFiles = [] as any;
                for (let item of _data["otherFiles"])
                    this.otherFiles!.push(UploadedFileDto.fromJS(item));
            }
            if (Array.isArray(_data["purchaseOrders"])) {
                this.purchaseOrders = [] as any;
                for (let item of _data["purchaseOrders"])
                    this.purchaseOrders!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["supplierId"] = this.supplierId;
        data["carrierId"] = this.carrierId;
        data["billOfLadingNumber"] = this.billOfLadingNumber;
        data["palletCount"] = this.palletCount;
        data["loadType"] = this.loadType;
        data["trailerNumber"] = this.trailerNumber;
        data["weightOfShipment"] = this.weightOfShipment;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        if (Array.isArray(this.packingSlipFiles)) {
            data["packingSlipFiles"] = [];
            for (let item of this.packingSlipFiles)
                data["packingSlipFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.otherFiles)) {
            data["otherFiles"] = [];
            for (let item of this.otherFiles)
                data["otherFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.purchaseOrders)) {
            data["purchaseOrders"] = [];
            for (let item of this.purchaseOrders)
                data["purchaseOrders"].push(item);
        }
        return data;
    }
}

export interface ICreateAppointmentCommand {
    action?: AppointmentAction;
    supplierId?: string;
    carrierId?: string;
    billOfLadingNumber?: string | undefined;
    palletCount?: number;
    loadType?: AppointmentLoadType | undefined;
    trailerNumber?: string | undefined;
    weightOfShipment?: string | undefined;
    requestDate?: Date | undefined;
    packingSlipFiles?: UploadedFileDto[];
    otherFiles?: UploadedFileDto[];
    purchaseOrders?: string[];
}

export enum AppointmentAction {
    SaveAsDraft = "SaveAsDraft",
    Save = "Save",
    Submit = "Submit",
    Approve = "Approve",
    SendBack = "SendBack",
    Decline = "Decline",
    NoShow = "NoShow",
    CheckedIn = "CheckedIn",
    RefuseLoad = "RefuseLoad",
    AcceptLoad = "AcceptLoad",
    CompleteMove = "CompleteMove",
    CancelMove = "CancelMove",
    ShuntMovePending = "ShuntMovePending",
    AssignToUnload = "AssignToUnload",
    RequestTags = "RequestTags",
    TagsAsnPgiConfirmed = "TagsAsnPgiConfirmed",
    Investigate = "Investigate",
    InvestigationCompleted = "InvestigationCompleted",
    Complete = "Complete",
    CheckOut = "CheckOut",
}

export enum AppointmentLoadType {
    FloorLoad = "FloorLoad",
    Pallet = "Pallet",
    SlipSheet = "SlipSheet",
    CHEP = "CHEP",
    Returns = "Returns",
}

export class UpdateAppointmentCommand extends CreateAppointmentCommand implements IUpdateAppointmentCommand {
    number?: string;
    isBillOfLadingNumberCorrect?: boolean | undefined;
    correctBillOfLadingNumber?: string | undefined;
    isTrailerNumberCorrect?: boolean | undefined;
    correctTrailerNumber?: string | undefined;
    driverName?: string | undefined;
    driverId?: string | undefined;
    trailerType?: TrailerType | undefined;
    trailerTemperature?: string | undefined;
    sealNumber?: string | undefined;
    sealMatchesPaperwork?: boolean | undefined;
    guardHouseLocation?: ShuntLocationType | undefined;
    guardHouseLocationId?: string | undefined;
    confirmedDate?: Date | undefined;
    packingSlipFilesToRemove?: string[];
    otherFilesToRemove?: string[];

    constructor(data?: IUpdateAppointmentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.isBillOfLadingNumberCorrect = _data["isBillOfLadingNumberCorrect"];
            this.correctBillOfLadingNumber = _data["correctBillOfLadingNumber"];
            this.isTrailerNumberCorrect = _data["isTrailerNumberCorrect"];
            this.correctTrailerNumber = _data["correctTrailerNumber"];
            this.driverName = _data["driverName"];
            this.driverId = _data["driverId"];
            this.trailerType = _data["trailerType"];
            this.trailerTemperature = _data["trailerTemperature"];
            this.sealNumber = _data["sealNumber"];
            this.sealMatchesPaperwork = _data["sealMatchesPaperwork"];
            this.guardHouseLocation = _data["guardHouseLocation"];
            this.guardHouseLocationId = _data["guardHouseLocationId"];
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["packingSlipFilesToRemove"])) {
                this.packingSlipFilesToRemove = [] as any;
                for (let item of _data["packingSlipFilesToRemove"])
                    this.packingSlipFilesToRemove!.push(item);
            }
            if (Array.isArray(_data["otherFilesToRemove"])) {
                this.otherFilesToRemove = [] as any;
                for (let item of _data["otherFilesToRemove"])
                    this.otherFilesToRemove!.push(item);
            }
        }
    }

    static override fromJS(data: any): UpdateAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["isBillOfLadingNumberCorrect"] = this.isBillOfLadingNumberCorrect;
        data["correctBillOfLadingNumber"] = this.correctBillOfLadingNumber;
        data["isTrailerNumberCorrect"] = this.isTrailerNumberCorrect;
        data["correctTrailerNumber"] = this.correctTrailerNumber;
        data["driverName"] = this.driverName;
        data["driverId"] = this.driverId;
        data["trailerType"] = this.trailerType;
        data["trailerTemperature"] = this.trailerTemperature;
        data["sealNumber"] = this.sealNumber;
        data["sealMatchesPaperwork"] = this.sealMatchesPaperwork;
        data["guardHouseLocation"] = this.guardHouseLocation;
        data["guardHouseLocationId"] = this.guardHouseLocationId;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.packingSlipFilesToRemove)) {
            data["packingSlipFilesToRemove"] = [];
            for (let item of this.packingSlipFilesToRemove)
                data["packingSlipFilesToRemove"].push(item);
        }
        if (Array.isArray(this.otherFilesToRemove)) {
            data["otherFilesToRemove"] = [];
            for (let item of this.otherFilesToRemove)
                data["otherFilesToRemove"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAppointmentCommand extends ICreateAppointmentCommand {
    number?: string;
    isBillOfLadingNumberCorrect?: boolean | undefined;
    correctBillOfLadingNumber?: string | undefined;
    isTrailerNumberCorrect?: boolean | undefined;
    correctTrailerNumber?: string | undefined;
    driverName?: string | undefined;
    driverId?: string | undefined;
    trailerType?: TrailerType | undefined;
    trailerTemperature?: string | undefined;
    sealNumber?: string | undefined;
    sealMatchesPaperwork?: boolean | undefined;
    guardHouseLocation?: ShuntLocationType | undefined;
    guardHouseLocationId?: string | undefined;
    confirmedDate?: Date | undefined;
    packingSlipFilesToRemove?: string[];
    otherFilesToRemove?: string[];
}

export class ShuntAppointmentCommand extends UpdateAppointmentCommand implements IShuntAppointmentCommand {
    location?: ShuntLocationType;
    shuntLocationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;

    constructor(data?: IShuntAppointmentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.location = _data["location"];
            this.shuntLocationId = _data["shuntLocationId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static override fromJS(data: any): ShuntAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntAppointmentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["shuntLocationId"] = this.shuntLocationId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        super.toJSON(data);
        return data;
    }
}

export interface IShuntAppointmentCommand extends IUpdateAppointmentCommand {
    location?: ShuntLocationType;
    shuntLocationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;
}

export class AssignToUnloadAppointmentCommand extends UpdateAppointmentCommand implements IAssignToUnloadAppointmentCommand {
    employeeId?: string;
    stagingLane?: StagingLane;

    constructor(data?: IAssignToUnloadAppointmentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.stagingLane = _data["stagingLane"];
        }
    }

    static override fromJS(data: any): AssignToUnloadAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignToUnloadAppointmentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["stagingLane"] = this.stagingLane;
        super.toJSON(data);
        return data;
    }
}

export interface IAssignToUnloadAppointmentCommand extends IUpdateAppointmentCommand {
    employeeId?: string;
    stagingLane?: StagingLane;
}

export enum StagingLane {
    LaneOne = "LaneOne",
    LaneTwo = "LaneTwo",
    LaneThree = "LaneThree",
    LaneFour = "LaneFour",
    LaneFive = "LaneFive",
    LaneSix = "LaneSix",
    LaneSeven = "LaneSeven",
    LaneEight = "LaneEight",
    LaneNine = "LaneNine",
    LaneTen = "LaneTen",
    LaneEleven = "LaneEleven",
    LaneTwelve = "LaneTwelve",
    LaneThirteen = "LaneThirteen",
    LaneFourteen = "LaneFourteen",
    LaneFifteen = "LaneFifteen",
    LaneSixteen = "LaneSixteen",
    LaneSeventeen = "LaneSeventeen",
    LaneEighteen = "LaneEighteen",
    LaneNineteen = "LaneNineteen",
    LaneTwenty = "LaneTwenty",
    LaneTwentyOne = "LaneTwentyOne",
    LaneTwentyTwo = "LaneTwentyTwo",
    LaneTwentyThree = "LaneTwentyThree",
    LaneTwentyFour = "LaneTwentyFour",
    LaneTwentyFive = "LaneTwentyFive",
    LaneTwentySix = "LaneTwentySix",
    LaneTwentySeven = "LaneTwentySeven",
    LaneTwentyEight = "LaneTwentyEight",
    LaneTwentyNine = "LaneTwentyNine",
    LaneThirty = "LaneThirty",
    LaneThirtyOne = "LaneThirtyOne",
    LaneThirtyTwo = "LaneThirtyTwo",
    LaneThirtyThree = "LaneThirtyThree",
    LaneThirtyFour = "LaneThirtyFour",
    LaneThirtyFive = "LaneThirtyFive",
    LaneThirtySix = "LaneThirtySix",
    LaneThirtySeven = "LaneThirtySeven",
    LaneThirtyEight = "LaneThirtyEight",
    LaneThirtyNine = "LaneThirtyNine",
    LaneForty = "LaneForty",
    LaneFortyOne = "LaneFortyOne",
    LaneFortyTwo = "LaneFortyTwo",
    LaneFortyThree = "LaneFortyThree",
    LaneFortyFour = "LaneFortyFour",
    LaneFortyFive = "LaneFortyFive",
    LaneFortySix = "LaneFortySix",
    LaneFortySeven = "LaneFortySeven",
    LaneSOne = "LaneSOne",
    LaneSTwo = "LaneSTwo",
    LaneSThree = "LaneSThree",
    LaneSFour = "LaneSFour",
    LaneSFive = "LaneSFive",
}

export class CompleteAppointmentCommand extends UpdateAppointmentCommand implements ICompleteAppointmentCommand {
    hasValidAppointment?: boolean;
    wasDeliveryOnTime?: boolean;
    wasPackingSlipProvided?: boolean;
    wasLoadDamageFree?: boolean;
    wasAsnOrTagsProvided?: boolean;
    wereBarcodesScannable?: boolean;
    wasFreeOfExcessPartialPallets?: boolean;
    didAsnMatchPalletsAndQuantity?: boolean;
    wasWrappedAndStackedProperly?: boolean;
    isTrailerRequiredForOutbound?: boolean;

    constructor(data?: ICompleteAppointmentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasValidAppointment = _data["hasValidAppointment"];
            this.wasDeliveryOnTime = _data["wasDeliveryOnTime"];
            this.wasPackingSlipProvided = _data["wasPackingSlipProvided"];
            this.wasLoadDamageFree = _data["wasLoadDamageFree"];
            this.wasAsnOrTagsProvided = _data["wasAsnOrTagsProvided"];
            this.wereBarcodesScannable = _data["wereBarcodesScannable"];
            this.wasFreeOfExcessPartialPallets = _data["wasFreeOfExcessPartialPallets"];
            this.didAsnMatchPalletsAndQuantity = _data["didAsnMatchPalletsAndQuantity"];
            this.wasWrappedAndStackedProperly = _data["wasWrappedAndStackedProperly"];
            this.isTrailerRequiredForOutbound = _data["isTrailerRequiredForOutbound"];
        }
    }

    static override fromJS(data: any): CompleteAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteAppointmentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasValidAppointment"] = this.hasValidAppointment;
        data["wasDeliveryOnTime"] = this.wasDeliveryOnTime;
        data["wasPackingSlipProvided"] = this.wasPackingSlipProvided;
        data["wasLoadDamageFree"] = this.wasLoadDamageFree;
        data["wasAsnOrTagsProvided"] = this.wasAsnOrTagsProvided;
        data["wereBarcodesScannable"] = this.wereBarcodesScannable;
        data["wasFreeOfExcessPartialPallets"] = this.wasFreeOfExcessPartialPallets;
        data["didAsnMatchPalletsAndQuantity"] = this.didAsnMatchPalletsAndQuantity;
        data["wasWrappedAndStackedProperly"] = this.wasWrappedAndStackedProperly;
        data["isTrailerRequiredForOutbound"] = this.isTrailerRequiredForOutbound;
        super.toJSON(data);
        return data;
    }
}

export interface ICompleteAppointmentCommand extends IUpdateAppointmentCommand {
    hasValidAppointment?: boolean;
    wasDeliveryOnTime?: boolean;
    wasPackingSlipProvided?: boolean;
    wasLoadDamageFree?: boolean;
    wasAsnOrTagsProvided?: boolean;
    wereBarcodesScannable?: boolean;
    wasFreeOfExcessPartialPallets?: boolean;
    didAsnMatchPalletsAndQuantity?: boolean;
    wasWrappedAndStackedProperly?: boolean;
    isTrailerRequiredForOutbound?: boolean;
}

export class CheckOutAppointmentCommand extends UpdateAppointmentCommand implements ICheckOutAppointmentCommand {

    constructor(data?: ICheckOutAppointmentCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CheckOutAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOutAppointmentCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICheckOutAppointmentCommand extends IUpdateAppointmentCommand {
}

export class UpdateAppointmentComplianceCommand implements IUpdateAppointmentComplianceCommand {
    number?: string;
    hasValidAppointment?: boolean;
    wasDeliveryOnTime?: boolean;
    wasPackingSlipProvided?: boolean;
    wasLoadDamageFree?: boolean;
    wasAsnOrTagsProvided?: boolean;
    wereBarcodesScannable?: boolean;
    wasFreeOfExcessPartialPallets?: boolean;
    didAsnMatchPalletsAndQuantity?: boolean;
    wasWrappedAndStackedProperly?: boolean;

    constructor(data?: IUpdateAppointmentComplianceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.hasValidAppointment = _data["hasValidAppointment"];
            this.wasDeliveryOnTime = _data["wasDeliveryOnTime"];
            this.wasPackingSlipProvided = _data["wasPackingSlipProvided"];
            this.wasLoadDamageFree = _data["wasLoadDamageFree"];
            this.wasAsnOrTagsProvided = _data["wasAsnOrTagsProvided"];
            this.wereBarcodesScannable = _data["wereBarcodesScannable"];
            this.wasFreeOfExcessPartialPallets = _data["wasFreeOfExcessPartialPallets"];
            this.didAsnMatchPalletsAndQuantity = _data["didAsnMatchPalletsAndQuantity"];
            this.wasWrappedAndStackedProperly = _data["wasWrappedAndStackedProperly"];
        }
    }

    static fromJS(data: any): UpdateAppointmentComplianceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentComplianceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["hasValidAppointment"] = this.hasValidAppointment;
        data["wasDeliveryOnTime"] = this.wasDeliveryOnTime;
        data["wasPackingSlipProvided"] = this.wasPackingSlipProvided;
        data["wasLoadDamageFree"] = this.wasLoadDamageFree;
        data["wasAsnOrTagsProvided"] = this.wasAsnOrTagsProvided;
        data["wereBarcodesScannable"] = this.wereBarcodesScannable;
        data["wasFreeOfExcessPartialPallets"] = this.wasFreeOfExcessPartialPallets;
        data["didAsnMatchPalletsAndQuantity"] = this.didAsnMatchPalletsAndQuantity;
        data["wasWrappedAndStackedProperly"] = this.wasWrappedAndStackedProperly;
        return data;
    }
}

export interface IUpdateAppointmentComplianceCommand {
    number?: string;
    hasValidAppointment?: boolean;
    wasDeliveryOnTime?: boolean;
    wasPackingSlipProvided?: boolean;
    wasLoadDamageFree?: boolean;
    wasAsnOrTagsProvided?: boolean;
    wereBarcodesScannable?: boolean;
    wasFreeOfExcessPartialPallets?: boolean;
    didAsnMatchPalletsAndQuantity?: boolean;
    wasWrappedAndStackedProperly?: boolean;
}

export class AppointmentDto implements IAppointmentDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    emptyCheckInNumber?: string;
    emptyCheckOutNumber?: string;
    status?: AppointmentStatus;
    supplierId?: string;
    carrierId?: string;
    billOfLadingNumber?: string | undefined;
    isBillOfLadingNumberCorrect?: boolean | undefined;
    correctBillOfLadingNumber?: string | undefined;
    palletCount?: number;
    loadType?: AppointmentLoadType | undefined;
    trailerNumber?: string | undefined;
    isTrailerNumberCorrect?: boolean | undefined;
    correctTrailerNumber?: string | undefined;
    weightOfShipment?: string | undefined;
    driverName?: string | undefined;
    driverId?: string | undefined;
    trailerType?: TrailerType | undefined;
    trailerTemperature?: string | undefined;
    sealNumber?: string | undefined;
    sealMatchesPaperwork?: boolean | undefined;
    guardHouseLocation?: ShuntLocationType | undefined;
    guardHouseLocationId?: string | undefined;
    requestDate?: Date | undefined;
    confirmedDate?: Date | undefined;
    packingSlipFiles?: FileDto[];
    otherFiles?: FileDto[];
    purchaseOrders?: string[];
    actions?: AppointmentAction[];
    sections?: AppointmentSection[];
    showGuardHouse?: boolean;
    showConfirmedDate?: boolean;
    canEditGuardHouseLocation?: boolean;

    constructor(data?: IAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.numberWithPrefix = _data["numberWithPrefix"];
            this.emptyCheckInNumber = _data["emptyCheckInNumber"];
            this.emptyCheckOutNumber = _data["emptyCheckOutNumber"];
            this.status = _data["status"];
            this.supplierId = _data["supplierId"];
            this.carrierId = _data["carrierId"];
            this.billOfLadingNumber = _data["billOfLadingNumber"];
            this.isBillOfLadingNumberCorrect = _data["isBillOfLadingNumberCorrect"];
            this.correctBillOfLadingNumber = _data["correctBillOfLadingNumber"];
            this.palletCount = _data["palletCount"];
            this.loadType = _data["loadType"];
            this.trailerNumber = _data["trailerNumber"];
            this.isTrailerNumberCorrect = _data["isTrailerNumberCorrect"];
            this.correctTrailerNumber = _data["correctTrailerNumber"];
            this.weightOfShipment = _data["weightOfShipment"];
            this.driverName = _data["driverName"];
            this.driverId = _data["driverId"];
            this.trailerType = _data["trailerType"];
            this.trailerTemperature = _data["trailerTemperature"];
            this.sealNumber = _data["sealNumber"];
            this.sealMatchesPaperwork = _data["sealMatchesPaperwork"];
            this.guardHouseLocation = _data["guardHouseLocation"];
            this.guardHouseLocationId = _data["guardHouseLocationId"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["packingSlipFiles"])) {
                this.packingSlipFiles = [] as any;
                for (let item of _data["packingSlipFiles"])
                    this.packingSlipFiles!.push(FileDto.fromJS(item));
            }
            if (Array.isArray(_data["otherFiles"])) {
                this.otherFiles = [] as any;
                for (let item of _data["otherFiles"])
                    this.otherFiles!.push(FileDto.fromJS(item));
            }
            if (Array.isArray(_data["purchaseOrders"])) {
                this.purchaseOrders = [] as any;
                for (let item of _data["purchaseOrders"])
                    this.purchaseOrders!.push(item);
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(item);
            }
            this.showGuardHouse = _data["showGuardHouse"];
            this.showConfirmedDate = _data["showConfirmedDate"];
            this.canEditGuardHouseLocation = _data["canEditGuardHouseLocation"];
        }
    }

    static fromJS(data: any): AppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["numberWithPrefix"] = this.numberWithPrefix;
        data["emptyCheckInNumber"] = this.emptyCheckInNumber;
        data["emptyCheckOutNumber"] = this.emptyCheckOutNumber;
        data["status"] = this.status;
        data["supplierId"] = this.supplierId;
        data["carrierId"] = this.carrierId;
        data["billOfLadingNumber"] = this.billOfLadingNumber;
        data["isBillOfLadingNumberCorrect"] = this.isBillOfLadingNumberCorrect;
        data["correctBillOfLadingNumber"] = this.correctBillOfLadingNumber;
        data["palletCount"] = this.palletCount;
        data["loadType"] = this.loadType;
        data["trailerNumber"] = this.trailerNumber;
        data["isTrailerNumberCorrect"] = this.isTrailerNumberCorrect;
        data["correctTrailerNumber"] = this.correctTrailerNumber;
        data["weightOfShipment"] = this.weightOfShipment;
        data["driverName"] = this.driverName;
        data["driverId"] = this.driverId;
        data["trailerType"] = this.trailerType;
        data["trailerTemperature"] = this.trailerTemperature;
        data["sealNumber"] = this.sealNumber;
        data["sealMatchesPaperwork"] = this.sealMatchesPaperwork;
        data["guardHouseLocation"] = this.guardHouseLocation;
        data["guardHouseLocationId"] = this.guardHouseLocationId;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.packingSlipFiles)) {
            data["packingSlipFiles"] = [];
            for (let item of this.packingSlipFiles)
                data["packingSlipFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.otherFiles)) {
            data["otherFiles"] = [];
            for (let item of this.otherFiles)
                data["otherFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.purchaseOrders)) {
            data["purchaseOrders"] = [];
            for (let item of this.purchaseOrders)
                data["purchaseOrders"].push(item);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item);
        }
        data["showGuardHouse"] = this.showGuardHouse;
        data["showConfirmedDate"] = this.showConfirmedDate;
        data["canEditGuardHouseLocation"] = this.canEditGuardHouseLocation;
        return data;
    }
}

export interface IAppointmentDto {
    id?: string;
    number?: number;
    numberWithPrefix?: string;
    emptyCheckInNumber?: string;
    emptyCheckOutNumber?: string;
    status?: AppointmentStatus;
    supplierId?: string;
    carrierId?: string;
    billOfLadingNumber?: string | undefined;
    isBillOfLadingNumberCorrect?: boolean | undefined;
    correctBillOfLadingNumber?: string | undefined;
    palletCount?: number;
    loadType?: AppointmentLoadType | undefined;
    trailerNumber?: string | undefined;
    isTrailerNumberCorrect?: boolean | undefined;
    correctTrailerNumber?: string | undefined;
    weightOfShipment?: string | undefined;
    driverName?: string | undefined;
    driverId?: string | undefined;
    trailerType?: TrailerType | undefined;
    trailerTemperature?: string | undefined;
    sealNumber?: string | undefined;
    sealMatchesPaperwork?: boolean | undefined;
    guardHouseLocation?: ShuntLocationType | undefined;
    guardHouseLocationId?: string | undefined;
    requestDate?: Date | undefined;
    confirmedDate?: Date | undefined;
    packingSlipFiles?: FileDto[];
    otherFiles?: FileDto[];
    purchaseOrders?: string[];
    actions?: AppointmentAction[];
    sections?: AppointmentSection[];
    showGuardHouse?: boolean;
    showConfirmedDate?: boolean;
    canEditGuardHouseLocation?: boolean;
}

export enum AppointmentStatus {
    Draft = "Draft",
    UnderReview = "UnderReview",
    Declined = "Declined",
    NoShow = "NoShow",
    Approved = "Approved",
    CheckedIn = "CheckedIn",
    ShuntMovePending = "ShuntMovePending",
    ReadyToUnload = "ReadyToUnload",
    Investigation = "Investigation",
    Unloading = "Unloading",
    TagsAsnPgiRequired = "TagsAsnPgiRequired",
    Refused = "Refused",
    Completed = "Completed",
    OutboundRefused = "OutboundRefused",
}

export enum AppointmentSection {
    Details = "Details",
    GuardHouse = "GuardHouse",
    Compliance = "Compliance",
}

export class AppointmentComplianceDto implements IAppointmentComplianceDto {
    hasValidAppointment?: boolean;
    wasDeliveryOnTime?: boolean;
    wasPackingSlipProvided?: boolean;
    wasLoadDamageFree?: boolean;
    wasAsnOrTagsProvided?: boolean;
    wereBarcodesScannable?: boolean;
    wasFreeOfExcessPartialPallets?: boolean;
    didAsnMatchPalletsAndQuantity?: boolean;
    wasWrappedAndStackedProperly?: boolean;
    isTrailerRequiredForOutbound?: boolean;

    constructor(data?: IAppointmentComplianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasValidAppointment = _data["hasValidAppointment"];
            this.wasDeliveryOnTime = _data["wasDeliveryOnTime"];
            this.wasPackingSlipProvided = _data["wasPackingSlipProvided"];
            this.wasLoadDamageFree = _data["wasLoadDamageFree"];
            this.wasAsnOrTagsProvided = _data["wasAsnOrTagsProvided"];
            this.wereBarcodesScannable = _data["wereBarcodesScannable"];
            this.wasFreeOfExcessPartialPallets = _data["wasFreeOfExcessPartialPallets"];
            this.didAsnMatchPalletsAndQuantity = _data["didAsnMatchPalletsAndQuantity"];
            this.wasWrappedAndStackedProperly = _data["wasWrappedAndStackedProperly"];
            this.isTrailerRequiredForOutbound = _data["isTrailerRequiredForOutbound"];
        }
    }

    static fromJS(data: any): AppointmentComplianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentComplianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasValidAppointment"] = this.hasValidAppointment;
        data["wasDeliveryOnTime"] = this.wasDeliveryOnTime;
        data["wasPackingSlipProvided"] = this.wasPackingSlipProvided;
        data["wasLoadDamageFree"] = this.wasLoadDamageFree;
        data["wasAsnOrTagsProvided"] = this.wasAsnOrTagsProvided;
        data["wereBarcodesScannable"] = this.wereBarcodesScannable;
        data["wasFreeOfExcessPartialPallets"] = this.wasFreeOfExcessPartialPallets;
        data["didAsnMatchPalletsAndQuantity"] = this.didAsnMatchPalletsAndQuantity;
        data["wasWrappedAndStackedProperly"] = this.wasWrappedAndStackedProperly;
        data["isTrailerRequiredForOutbound"] = this.isTrailerRequiredForOutbound;
        return data;
    }
}

export interface IAppointmentComplianceDto {
    hasValidAppointment?: boolean;
    wasDeliveryOnTime?: boolean;
    wasPackingSlipProvided?: boolean;
    wasLoadDamageFree?: boolean;
    wasAsnOrTagsProvided?: boolean;
    wereBarcodesScannable?: boolean;
    wasFreeOfExcessPartialPallets?: boolean;
    didAsnMatchPalletsAndQuantity?: boolean;
    wasWrappedAndStackedProperly?: boolean;
    isTrailerRequiredForOutbound?: boolean;
}

export class CalendarAppointmentDto implements ICalendarAppointmentDto {
    number?: string;
    startDate?: Date;
    endDate?: Date;
    status?: AppointmentStatus;
    loadType?: AppointmentLoadType;
    label?: string;

    constructor(data?: ICalendarAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.loadType = _data["loadType"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): CalendarAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["loadType"] = this.loadType;
        data["label"] = this.label;
        return data;
    }
}

export interface ICalendarAppointmentDto {
    number?: string;
    startDate?: Date;
    endDate?: Date;
    status?: AppointmentStatus;
    loadType?: AppointmentLoadType;
    label?: string;
}

export class GetCalendarAppointmentsQuery implements IGetCalendarAppointmentsQuery {
    from?: Date;
    to?: Date;

    constructor(data?: IGetCalendarAppointmentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCalendarAppointmentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarAppointmentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCalendarAppointmentsQuery {
    from?: Date;
    to?: Date;
}

export class AppointmentAgingScoreExportQuery implements IAppointmentAgingScoreExportQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IAppointmentAgingScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentAgingScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentAgingScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IAppointmentAgingScoreExportQuery {
    from?: Date;
    to?: Date | undefined;
}

export class AppointmentAgingScoreQuery implements IAppointmentAgingScoreQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IAppointmentAgingScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentAgingScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentAgingScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IAppointmentAgingScoreQuery {
    from?: Date;
    to?: Date | undefined;
}

export class AppointmentAgingTrendingQuery extends TrendingQuery implements IAppointmentAgingTrendingQuery {

    constructor(data?: IAppointmentAgingTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AppointmentAgingTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentAgingTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAppointmentAgingTrendingQuery extends ITrendingQuery {
}

export class InboundProductivityScoreExportQuery implements IInboundProductivityScoreExportQuery {
    employeeIds?: string[] | undefined;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IInboundProductivityScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InboundProductivityScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InboundProductivityScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IInboundProductivityScoreExportQuery {
    employeeIds?: string[] | undefined;
    from?: Date;
    to?: Date | undefined;
}

export class InboundProductivityScoreQuery implements IInboundProductivityScoreQuery {
    employeeIds?: string[] | undefined;
    from?: Date;
    to?: Date | undefined;

    constructor(data?: IInboundProductivityScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InboundProductivityScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InboundProductivityScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface IInboundProductivityScoreQuery {
    employeeIds?: string[] | undefined;
    from?: Date;
    to?: Date | undefined;
}

export class InboundProductivityTrendingQuery implements IInboundProductivityTrendingQuery {
    employeeIds?: string[] | undefined;
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;

    constructor(data?: IInboundProductivityTrendingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.aggregateType = _data["aggregateType"];
        }
    }

    static fromJS(data: any): InboundProductivityTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InboundProductivityTrendingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["aggregateType"] = this.aggregateType;
        return data;
    }
}

export interface IInboundProductivityTrendingQuery {
    employeeIds?: string[] | undefined;
    from?: Date;
    to?: Date;
    aggregateType?: AggregateType;
}

export abstract class MyScoreAppointmentComplianceQueryOfScoreDto implements IMyScoreAppointmentComplianceQueryOfScoreDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;

    constructor(data?: IMyScoreAppointmentComplianceQueryOfScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreAppointmentComplianceQueryOfScoreDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreAppointmentComplianceQueryOfScoreDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreAppointmentComplianceQueryOfScoreDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;
}

export class GetAppointmentComplianceScoreQuery extends MyScoreAppointmentComplianceQueryOfScoreDto implements IGetAppointmentComplianceScoreQuery {

    constructor(data?: IGetAppointmentComplianceScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAppointmentComplianceScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentComplianceScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppointmentComplianceScoreQuery extends IMyScoreAppointmentComplianceQueryOfScoreDto {
}

export abstract class MyScoreAppointmentComplianceQueryOfTrendingDto implements IMyScoreAppointmentComplianceQueryOfTrendingDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;

    constructor(data?: IMyScoreAppointmentComplianceQueryOfTrendingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreAppointmentComplianceQueryOfTrendingDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreAppointmentComplianceQueryOfTrendingDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreAppointmentComplianceQueryOfTrendingDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;
}

export class GetAppointmentComplianceTrendingQuery extends MyScoreAppointmentComplianceQueryOfTrendingDto implements IGetAppointmentComplianceTrendingQuery {
    aggregateType?: AggregateType;

    constructor(data?: IGetAppointmentComplianceTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.aggregateType = _data["aggregateType"];
        }
    }

    static override fromJS(data: any): GetAppointmentComplianceTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentComplianceTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateType"] = this.aggregateType;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppointmentComplianceTrendingQuery extends IMyScoreAppointmentComplianceQueryOfTrendingDto {
    aggregateType?: AggregateType;
}

export class SupplierComplianceBreakdownDto implements ISupplierComplianceBreakdownDto {
    compliancePercentBySupplier?: { [key: string]: number; };

    constructor(data?: ISupplierComplianceBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["compliancePercentBySupplier"]) {
                this.compliancePercentBySupplier = {} as any;
                for (let key in _data["compliancePercentBySupplier"]) {
                    if (_data["compliancePercentBySupplier"].hasOwnProperty(key))
                        (<any>this.compliancePercentBySupplier)![key] = _data["compliancePercentBySupplier"][key];
                }
            }
        }
    }

    static fromJS(data: any): SupplierComplianceBreakdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierComplianceBreakdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.compliancePercentBySupplier) {
            data["compliancePercentBySupplier"] = {};
            for (let key in this.compliancePercentBySupplier) {
                if (this.compliancePercentBySupplier.hasOwnProperty(key))
                    (<any>data["compliancePercentBySupplier"])[key] = (<any>this.compliancePercentBySupplier)[key];
            }
        }
        return data;
    }
}

export interface ISupplierComplianceBreakdownDto {
    compliancePercentBySupplier?: { [key: string]: number; };
}

export abstract class MyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto implements IMyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;

    constructor(data?: IMyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;
}

export class GetAppointmentSupplierComplianceTrendingQuery extends MyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto implements IGetAppointmentSupplierComplianceTrendingQuery {

    constructor(data?: IGetAppointmentSupplierComplianceTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAppointmentSupplierComplianceTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentSupplierComplianceTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppointmentSupplierComplianceTrendingQuery extends IMyScoreAppointmentComplianceQueryOfSupplierComplianceBreakdownDto {
}

export abstract class MyScoreAppointmentComplianceQueryOfExportedFileDto implements IMyScoreAppointmentComplianceQueryOfExportedFileDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;

    constructor(data?: IMyScoreAppointmentComplianceQueryOfExportedFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MyScoreAppointmentComplianceQueryOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreAppointmentComplianceQueryOfExportedFileDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        return data;
    }
}

export interface IMyScoreAppointmentComplianceQueryOfExportedFileDto {
    from?: Date;
    to?: Date;
    supplierIds?: string[] | undefined;
}

export class ExportAppointmentComplianceQuery extends MyScoreAppointmentComplianceQueryOfExportedFileDto implements IExportAppointmentComplianceQuery {

    constructor(data?: IExportAppointmentComplianceQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportAppointmentComplianceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAppointmentComplianceQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportAppointmentComplianceQuery extends IMyScoreAppointmentComplianceQueryOfExportedFileDto {
}

export class TagsRequiredScoreExportQuery implements ITagsRequiredScoreExportQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: ITagsRequiredScoreExportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TagsRequiredScoreExportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagsRequiredScoreExportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface ITagsRequiredScoreExportQuery {
    from?: Date;
    to?: Date | undefined;
}

export class TagsRequiredScoreQuery implements ITagsRequiredScoreQuery {
    from?: Date;
    to?: Date | undefined;

    constructor(data?: ITagsRequiredScoreQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TagsRequiredScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagsRequiredScoreQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        return data;
    }
}

export interface ITagsRequiredScoreQuery {
    from?: Date;
    to?: Date | undefined;
}

export class TagsRequiredTrendingQuery extends TrendingQuery implements ITagsRequiredTrendingQuery {

    constructor(data?: ITagsRequiredTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TagsRequiredTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagsRequiredTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITagsRequiredTrendingQuery extends ITrendingQuery {
}

export class CarrierDto implements ICarrierDto {
    id?: string;
    number?: string;
    status?: CarrierStatus;
    name?: string;
    scac?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.scac = _data["scac"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["scac"] = this.scac;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ICarrierDto {
    id?: string;
    number?: string;
    status?: CarrierStatus;
    name?: string;
    scac?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
}

export enum CarrierStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class CreateCarrierCommand implements ICreateCarrierCommand {
    number?: string;
    status?: CarrierStatus;
    name?: string;
    scac?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICreateCarrierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.scac = _data["scac"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateCarrierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCarrierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["scac"] = this.scac;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateCarrierCommand {
    number?: string;
    status?: CarrierStatus;
    name?: string;
    scac?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
}

export class UpdateCarrierCommand extends CreateCarrierCommand implements IUpdateCarrierCommand {
    id?: string;

    constructor(data?: IUpdateCarrierCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateCarrierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCarrierCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCarrierCommand extends ICreateCarrierCommand {
    id?: string;
}

export class CreateEmptyCheckInCommand implements ICreateEmptyCheckInCommand {
    action?: EmptyCheckInAction;
    carrierId?: string;
    appointmentId?: string | undefined;
    trailerType?: TrailerType;
    trailerNumber?: string;
    location?: ShuntLocationType;
    shuntLocationId?: string | undefined;
    employeeId?: string | undefined;
    isTrailerRequiredForOutbound?: boolean | undefined;
    shipments?: string[];

    constructor(data?: ICreateEmptyCheckInCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.carrierId = _data["carrierId"];
            this.appointmentId = _data["appointmentId"];
            this.trailerType = _data["trailerType"];
            this.trailerNumber = _data["trailerNumber"];
            this.location = _data["location"];
            this.shuntLocationId = _data["shuntLocationId"];
            this.employeeId = _data["employeeId"];
            this.isTrailerRequiredForOutbound = _data["isTrailerRequiredForOutbound"];
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateEmptyCheckInCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmptyCheckInCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["carrierId"] = this.carrierId;
        data["appointmentId"] = this.appointmentId;
        data["trailerType"] = this.trailerType;
        data["trailerNumber"] = this.trailerNumber;
        data["location"] = this.location;
        data["shuntLocationId"] = this.shuntLocationId;
        data["employeeId"] = this.employeeId;
        data["isTrailerRequiredForOutbound"] = this.isTrailerRequiredForOutbound;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item);
        }
        return data;
    }
}

export interface ICreateEmptyCheckInCommand {
    action?: EmptyCheckInAction;
    carrierId?: string;
    appointmentId?: string | undefined;
    trailerType?: TrailerType;
    trailerNumber?: string;
    location?: ShuntLocationType;
    shuntLocationId?: string | undefined;
    employeeId?: string | undefined;
    isTrailerRequiredForOutbound?: boolean | undefined;
    shipments?: string[];
}

export enum EmptyCheckInAction {
    Save = "Save",
    CheckIn = "CheckIn",
    NotRequired = "NotRequired",
    Required = "Required",
    InvestigationCompleted = "InvestigationCompleted",
    CompleteMove = "CompleteMove",
    CancelMove = "CancelMove",
    ShuntMove = "ShuntMove",
    Investigate = "Investigate",
    CheckOut = "CheckOut",
    StartLoading = "StartLoading",
    MarkAsLoaded = "MarkAsLoaded",
}

export class UpdateEmptyCheckInCommand extends CreateEmptyCheckInCommand implements IUpdateEmptyCheckInCommand {
    number?: string;

    constructor(data?: IUpdateEmptyCheckInCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): UpdateEmptyCheckInCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmptyCheckInCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateEmptyCheckInCommand extends ICreateEmptyCheckInCommand {
    number?: string;
}

export class ShuntEmptyCheckInCommand extends UpdateEmptyCheckInCommand implements IShuntEmptyCheckInCommand {
    shuntMoveLocation?: ShuntLocationType;
    shuntMoveLocationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;

    constructor(data?: IShuntEmptyCheckInCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.shuntMoveLocation = _data["shuntMoveLocation"];
            this.shuntMoveLocationId = _data["shuntMoveLocationId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static override fromJS(data: any): ShuntEmptyCheckInCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntEmptyCheckInCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shuntMoveLocation"] = this.shuntMoveLocation;
        data["shuntMoveLocationId"] = this.shuntMoveLocationId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        super.toJSON(data);
        return data;
    }
}

export interface IShuntEmptyCheckInCommand extends IUpdateEmptyCheckInCommand {
    shuntMoveLocation?: ShuntLocationType;
    shuntMoveLocationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;
}

export class CheckOutEmptyCheckInCommand extends UpdateEmptyCheckInCommand implements ICheckOutEmptyCheckInCommand {

    constructor(data?: ICheckOutEmptyCheckInCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CheckOutEmptyCheckInCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOutEmptyCheckInCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICheckOutEmptyCheckInCommand extends IUpdateEmptyCheckInCommand {
}

export class EmptyCheckInDto implements IEmptyCheckInDto {
    id?: string;
    numberWithPrefix?: string;
    appointmentNumber?: string | undefined;
    emptyCheckOutNumber?: string | undefined;
    status?: EmptyCheckInStatus;
    carrierId?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    location?: ShuntLocationType;
    shuntLocationId?: string | undefined;
    employeeId?: string | undefined;
    currentLocationText?: string | undefined;
    shipments?: string[];
    actions?: EmptyCheckInAction[];

    constructor(data?: IEmptyCheckInDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberWithPrefix = _data["numberWithPrefix"];
            this.appointmentNumber = _data["appointmentNumber"];
            this.emptyCheckOutNumber = _data["emptyCheckOutNumber"];
            this.status = _data["status"];
            this.carrierId = _data["carrierId"];
            this.trailerType = _data["trailerType"];
            this.trailerNumber = _data["trailerNumber"];
            this.location = _data["location"];
            this.shuntLocationId = _data["shuntLocationId"];
            this.employeeId = _data["employeeId"];
            this.currentLocationText = _data["currentLocationText"];
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(item);
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(item);
            }
        }
    }

    static fromJS(data: any): EmptyCheckInDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCheckInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberWithPrefix"] = this.numberWithPrefix;
        data["appointmentNumber"] = this.appointmentNumber;
        data["emptyCheckOutNumber"] = this.emptyCheckOutNumber;
        data["status"] = this.status;
        data["carrierId"] = this.carrierId;
        data["trailerType"] = this.trailerType;
        data["trailerNumber"] = this.trailerNumber;
        data["location"] = this.location;
        data["shuntLocationId"] = this.shuntLocationId;
        data["employeeId"] = this.employeeId;
        data["currentLocationText"] = this.currentLocationText;
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item);
        }
        return data;
    }
}

export interface IEmptyCheckInDto {
    id?: string;
    numberWithPrefix?: string;
    appointmentNumber?: string | undefined;
    emptyCheckOutNumber?: string | undefined;
    status?: EmptyCheckInStatus;
    carrierId?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    location?: ShuntLocationType;
    shuntLocationId?: string | undefined;
    employeeId?: string | undefined;
    currentLocationText?: string | undefined;
    shipments?: string[];
    actions?: EmptyCheckInAction[];
}

export enum EmptyCheckInStatus {
    Draft = "Draft",
    EmptyRequired = "EmptyRequired",
    EmptyNotRequired = "EmptyNotRequired",
    Investigation = "Investigation",
    ShuntMovePending = "ShuntMovePending",
    OutboundEmpty = "OutboundEmpty",
    Loading = "Loading",
    OutboundLoaded = "OutboundLoaded",
    Loaded = "Loaded",
}

export class PurchaseOrderGridViewDto implements IPurchaseOrderGridViewDto {
    purchasingDocument?: string;
    receivingPlant?: string | undefined;
    companyCode?: string | undefined;
    purchasingGroup?: string | undefined;
    purchasingDocType?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    asnReferenceNumber?: string | undefined;
    vendorSupplyingPlant?: string | undefined;
    supplyingPlant?: string | undefined;
    shipFromName?: string | undefined;
    shippingPointReceivingPt?: string | undefined;
    carrierCode?: string | undefined;
    carrierName?: string | undefined;
    scac?: string | undefined;
    transportStatus?: string | undefined;
    ourReference?: string | undefined;
    vehicleType?: string | undefined;
    shipToName?: string | undefined;
    documentDate?: Date;
    deliveryDate?: Date;
    status?: PurchaseOrderStatus;
    orderQuantity?: number;
    stillToBeDeliveredQty?: number;
    supplierNumber?: string | undefined;

    constructor(data?: IPurchaseOrderGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchasingDocument = _data["purchasingDocument"];
            this.receivingPlant = _data["receivingPlant"];
            this.companyCode = _data["companyCode"];
            this.purchasingGroup = _data["purchasingGroup"];
            this.purchasingDocType = _data["purchasingDocType"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.asnReferenceNumber = _data["asnReferenceNumber"];
            this.vendorSupplyingPlant = _data["vendorSupplyingPlant"];
            this.supplyingPlant = _data["supplyingPlant"];
            this.shipFromName = _data["shipFromName"];
            this.shippingPointReceivingPt = _data["shippingPointReceivingPt"];
            this.carrierCode = _data["carrierCode"];
            this.carrierName = _data["carrierName"];
            this.scac = _data["scac"];
            this.transportStatus = _data["transportStatus"];
            this.ourReference = _data["ourReference"];
            this.vehicleType = _data["vehicleType"];
            this.shipToName = _data["shipToName"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.orderQuantity = _data["orderQuantity"];
            this.stillToBeDeliveredQty = _data["stillToBeDeliveredQty"];
            this.supplierNumber = _data["supplierNumber"];
        }
    }

    static fromJS(data: any): PurchaseOrderGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchasingDocument"] = this.purchasingDocument;
        data["receivingPlant"] = this.receivingPlant;
        data["companyCode"] = this.companyCode;
        data["purchasingGroup"] = this.purchasingGroup;
        data["purchasingDocType"] = this.purchasingDocType;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["asnReferenceNumber"] = this.asnReferenceNumber;
        data["vendorSupplyingPlant"] = this.vendorSupplyingPlant;
        data["supplyingPlant"] = this.supplyingPlant;
        data["shipFromName"] = this.shipFromName;
        data["shippingPointReceivingPt"] = this.shippingPointReceivingPt;
        data["carrierCode"] = this.carrierCode;
        data["carrierName"] = this.carrierName;
        data["scac"] = this.scac;
        data["transportStatus"] = this.transportStatus;
        data["ourReference"] = this.ourReference;
        data["vehicleType"] = this.vehicleType;
        data["shipToName"] = this.shipToName;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["orderQuantity"] = this.orderQuantity;
        data["stillToBeDeliveredQty"] = this.stillToBeDeliveredQty;
        data["supplierNumber"] = this.supplierNumber;
        return data;
    }
}

export interface IPurchaseOrderGridViewDto {
    purchasingDocument?: string;
    receivingPlant?: string | undefined;
    companyCode?: string | undefined;
    purchasingGroup?: string | undefined;
    purchasingDocType?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    asnReferenceNumber?: string | undefined;
    vendorSupplyingPlant?: string | undefined;
    supplyingPlant?: string | undefined;
    shipFromName?: string | undefined;
    shippingPointReceivingPt?: string | undefined;
    carrierCode?: string | undefined;
    carrierName?: string | undefined;
    scac?: string | undefined;
    transportStatus?: string | undefined;
    ourReference?: string | undefined;
    vehicleType?: string | undefined;
    shipToName?: string | undefined;
    documentDate?: Date;
    deliveryDate?: Date;
    status?: PurchaseOrderStatus;
    orderQuantity?: number;
    stillToBeDeliveredQty?: number;
    supplierNumber?: string | undefined;
}

export class PurchaseOrderDto extends PurchaseOrderGridViewDto implements IPurchaseOrderDto {
    items?: PurchaseOrderItemDto[];

    constructor(data?: IPurchaseOrderDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PurchaseOrderItemDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PurchaseOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPurchaseOrderDto extends IPurchaseOrderGridViewDto {
    items?: PurchaseOrderItemDto[];
}

export class PurchaseOrderItemDto implements IPurchaseOrderItemDto {
    purchasingDocument?: string;
    item?: string;
    material?: string;
    materialDescription?: string | undefined;
    materialType?: string | undefined;
    orderQuantity?: number;
    committedQuantity?: number;
    grQuantityReceived?: number;
    stillToBeInvoicedQty?: number;
    goodsReceiptPostingDate?: Date | undefined;
    stillToBeDeliveredQty?: number;

    constructor(data?: IPurchaseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchasingDocument = _data["purchasingDocument"];
            this.item = _data["item"];
            this.material = _data["material"];
            this.materialDescription = _data["materialDescription"];
            this.materialType = _data["materialType"];
            this.orderQuantity = _data["orderQuantity"];
            this.committedQuantity = _data["committedQuantity"];
            this.grQuantityReceived = _data["grQuantityReceived"];
            this.stillToBeInvoicedQty = _data["stillToBeInvoicedQty"];
            this.goodsReceiptPostingDate = _data["goodsReceiptPostingDate"] ? new Date(_data["goodsReceiptPostingDate"].toString()) : <any>undefined;
            this.stillToBeDeliveredQty = _data["stillToBeDeliveredQty"];
        }
    }

    static fromJS(data: any): PurchaseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchasingDocument"] = this.purchasingDocument;
        data["item"] = this.item;
        data["material"] = this.material;
        data["materialDescription"] = this.materialDescription;
        data["materialType"] = this.materialType;
        data["orderQuantity"] = this.orderQuantity;
        data["committedQuantity"] = this.committedQuantity;
        data["grQuantityReceived"] = this.grQuantityReceived;
        data["stillToBeInvoicedQty"] = this.stillToBeInvoicedQty;
        data["goodsReceiptPostingDate"] = this.goodsReceiptPostingDate ? this.goodsReceiptPostingDate.toISOString() : <any>undefined;
        data["stillToBeDeliveredQty"] = this.stillToBeDeliveredQty;
        return data;
    }
}

export interface IPurchaseOrderItemDto {
    purchasingDocument?: string;
    item?: string;
    material?: string;
    materialDescription?: string | undefined;
    materialType?: string | undefined;
    orderQuantity?: number;
    committedQuantity?: number;
    grQuantityReceived?: number;
    stillToBeInvoicedQty?: number;
    goodsReceiptPostingDate?: Date | undefined;
    stillToBeDeliveredQty?: number;
}

export enum PurchaseOrderStatus {
    Open = "Open",
    Closed = "Closed",
}

export class SupplierDto implements ISupplierDto {
    id?: string;
    number?: string;
    status?: SupplierStatus;
    name?: string;
    group?: string | undefined;
    plant?: string | undefined;
    sac?: string | undefined;
    address?: string;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.plant = _data["plant"];
            this.sac = _data["sac"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["group"] = this.group;
        data["plant"] = this.plant;
        data["sac"] = this.sac;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ISupplierDto {
    id?: string;
    number?: string;
    status?: SupplierStatus;
    name?: string;
    group?: string | undefined;
    plant?: string | undefined;
    sac?: string | undefined;
    address?: string;
    email?: string | undefined;
    phone?: string | undefined;
}

export enum SupplierStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class CreateSupplierCommand implements ICreateSupplierCommand {
    number?: string;
    status?: SupplierStatus;
    name?: string;
    group?: string | undefined;
    plant?: string | undefined;
    sac?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICreateSupplierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.plant = _data["plant"];
            this.sac = _data["sac"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateSupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["group"] = this.group;
        data["plant"] = this.plant;
        data["sac"] = this.sac;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateSupplierCommand {
    number?: string;
    status?: SupplierStatus;
    name?: string;
    group?: string | undefined;
    plant?: string | undefined;
    sac?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class UpdateSupplierCommand extends CreateSupplierCommand implements IUpdateSupplierCommand {
    id?: string;

    constructor(data?: IUpdateSupplierCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateSupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplierCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateSupplierCommand extends ICreateSupplierCommand {
    id?: string;
}

export class FileImportByHourDto implements IFileImportByHourDto {
    stats?: { [key: string]: StatsLine; }[];

    constructor(data?: IFileImportByHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(item);
            }
        }
    }

    static fromJS(data: any): FileImportByHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportByHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item);
        }
        return data;
    }
}

export interface IFileImportByHourDto {
    stats?: { [key: string]: StatsLine; }[];
}

export class StatsLine implements IStatsLine {
    fileType?: ImportFileType;
    fileName?: string | undefined;
    message?: string | undefined;
    status?: FileImportStatus | undefined;
    url?: string | undefined;
    created?: Date | undefined;
    allowMultipleFileUpload?: boolean;

    constructor(data?: IStatsLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.url = _data["url"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.allowMultipleFileUpload = _data["allowMultipleFileUpload"];
        }
    }

    static fromJS(data: any): StatsLine {
        data = typeof data === 'object' ? data : {};
        let result = new StatsLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["message"] = this.message;
        data["status"] = this.status;
        data["url"] = this.url;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["allowMultipleFileUpload"] = this.allowMultipleFileUpload;
        return data;
    }
}

export interface IStatsLine {
    fileType?: ImportFileType;
    fileName?: string | undefined;
    message?: string | undefined;
    status?: FileImportStatus | undefined;
    url?: string | undefined;
    created?: Date | undefined;
    allowMultipleFileUpload?: boolean;
}

export enum ImportFileType {
    Employees = "Employees",
    Vacations = "Vacations",
    Materials = "Materials",
    Bins = "Bins",
    HALB = "HALB",
    StorageUnits = "StorageUnits",
    StorageUnits210 = "StorageUnits210",
    StorageUnits216 = "StorageUnits216",
    StorageUnits260 = "StorageUnits260",
    StorageUnits999 = "StorageUnits999",
    StorageUnitsLT22 = "StorageUnitsLT22",
    PurchaseOrders = "PurchaseOrders",
    BlockedStock = "BlockedStock",
    MB51 = "MB51",
    NextView = "NextView",
    YearToDate = "YearToDate",
    Orders = "Orders",
    TmReport = "TmReport",
    GlCodes = "GlCodes",
}

export enum FileImportStatus {
    Completed = "Completed",
    Failed = "Failed",
    Processing = "Processing",
    Uploading = "Uploading",
}

export class GetFileImportsByHourQuery implements IGetFileImportsByHourQuery {
    date?: Date;
    offsetMinutes?: number;

    constructor(data?: IGetFileImportsByHourQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.offsetMinutes = _data["offsetMinutes"];
        }
    }

    static fromJS(data: any): GetFileImportsByHourQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileImportsByHourQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["offsetMinutes"] = this.offsetMinutes;
        return data;
    }
}

export interface IGetFileImportsByHourQuery {
    date?: Date;
    offsetMinutes?: number;
}

export class FileImportStatusDto implements IFileImportStatusDto {
    id?: string;
    fileType?: ImportFileType;
    status?: FileImportStatus;
    message?: string | undefined;

    constructor(data?: IFileImportStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileType = _data["fileType"];
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): FileImportStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileType"] = this.fileType;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IFileImportStatusDto {
    id?: string;
    fileType?: ImportFileType;
    status?: FileImportStatus;
    message?: string | undefined;
}

export class GetFileImportStatusQuery implements IGetFileImportStatusQuery {
    ids?: string[];

    constructor(data?: IGetFileImportStatusQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetFileImportStatusQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileImportStatusQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IGetFileImportStatusQuery {
    ids?: string[];
}

export class ChangePasswordCommand implements IChangePasswordCommand {
    userId?: string;
    newPassword?: string;

    constructor(data?: IChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordCommand {
    userId?: string;
    newPassword?: string;
}

export class CreateUrlSignatureCommand implements ICreateUrlSignatureCommand {
    url?: string;

    constructor(data?: ICreateUrlSignatureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateUrlSignatureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUrlSignatureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateUrlSignatureCommand {
    url?: string;
}

export class AuthResponseDto implements IAuthResponseDto {
    accessToken?: string;
    expires?: Date;

    constructor(data?: IAuthResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuthResponseDto {
    accessToken?: string;
    expires?: Date;
}

export class LoginCommand implements ILoginCommand {
    email?: string;
    password?: string;
    ipAddress?: string;
    userAgent?: string | undefined;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        return data;
    }
}

export interface ILoginCommand {
    email?: string;
    password?: string;
    ipAddress?: string;
    userAgent?: string | undefined;
}

export class MeDto implements IMeDto {
    id?: string;
    avatarUrl?: string | undefined;
    email?: string;

    constructor(data?: IMeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.avatarUrl = _data["avatarUrl"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avatarUrl"] = this.avatarUrl;
        data["email"] = this.email;
        return data;
    }
}

export interface IMeDto {
    id?: string;
    avatarUrl?: string | undefined;
    email?: string;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    token?: string;
    newPassword?: string;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordCommand {
    token?: string;
    newPassword?: string;
}

export class EmployeeBalanceDto implements IEmployeeBalanceDto {
    vacationDaysAvailable?: number;
    personalTimeMinutesAvailable?: number;
    floaterDaysAvailable?: number;
    lieuDaysAvailable?: number;
    nextAvailableLieuDay?: string | undefined;

    constructor(data?: IEmployeeBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacationDaysAvailable = _data["vacationDaysAvailable"];
            this.personalTimeMinutesAvailable = _data["personalTimeMinutesAvailable"];
            this.floaterDaysAvailable = _data["floaterDaysAvailable"];
            this.lieuDaysAvailable = _data["lieuDaysAvailable"];
            this.nextAvailableLieuDay = _data["nextAvailableLieuDay"];
        }
    }

    static fromJS(data: any): EmployeeBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacationDaysAvailable"] = this.vacationDaysAvailable;
        data["personalTimeMinutesAvailable"] = this.personalTimeMinutesAvailable;
        data["floaterDaysAvailable"] = this.floaterDaysAvailable;
        data["lieuDaysAvailable"] = this.lieuDaysAvailable;
        data["nextAvailableLieuDay"] = this.nextAvailableLieuDay;
        return data;
    }
}

export interface IEmployeeBalanceDto {
    vacationDaysAvailable?: number;
    personalTimeMinutesAvailable?: number;
    floaterDaysAvailable?: number;
    lieuDaysAvailable?: number;
    nextAvailableLieuDay?: string | undefined;
}

export class GetWorkingDaysQuery implements IGetWorkingDaysQuery {
    startDate?: Date;
    endDate?: Date;
    employeeId?: string;

    constructor(data?: IGetWorkingDaysQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): GetWorkingDaysQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkingDaysQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IGetWorkingDaysQuery {
    startDate?: Date;
    endDate?: Date;
    employeeId?: string;
}

export class VacationConflictDto implements IVacationConflictDto {
    startDate?: Date;
    endDate?: Date;
    employee?: EmployeeDto;

    constructor(data?: IVacationConflictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VacationConflictDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacationConflictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVacationConflictDto {
    startDate?: Date;
    endDate?: Date;
    employee?: EmployeeDto;
}

export class GetVacationConflictsQuery implements IGetVacationConflictsQuery {
    vacationId?: string;

    constructor(data?: IGetVacationConflictsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vacationId = _data["vacationId"];
        }
    }

    static fromJS(data: any): GetVacationConflictsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetVacationConflictsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vacationId"] = this.vacationId;
        return data;
    }
}

export interface IGetVacationConflictsQuery {
    vacationId?: string;
}

export class CreateTimeOffCommand implements ICreateTimeOffCommand {
    userId?: string;
    description?: string;

    constructor(data?: ICreateTimeOffCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateTimeOffCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTimeOffCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateTimeOffCommand {
    userId?: string;
    description?: string;
}

export class CreateVacationCommand extends CreateTimeOffCommand implements ICreateVacationCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;

    constructor(data?: ICreateVacationCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateVacationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVacationCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateVacationCommand extends ICreateTimeOffCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;
}

export class ChangeVacationStatusCommand implements IChangeVacationStatusCommand {
    id?: string;
    status?: TimeOffStatus;

    constructor(data?: IChangeVacationStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeVacationStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeVacationStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeVacationStatusCommand {
    id?: string;
    status?: TimeOffStatus;
}

export enum TimeOffStatus {
    Pending = "Pending",
    Approved = "Approved",
    Declined = "Declined",
    Withdrawn = "Withdrawn",
    Expired = "Expired",
}

export class CreateLieuDayCommand extends CreateTimeOffCommand implements ICreateLieuDayCommand {
    type?: LieuDaySlotType;
    requestedDate?: Date;

    constructor(data?: ICreateLieuDayCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateLieuDayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLieuDayCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["requestedDate"] = this.requestedDate ? formatDate(this.requestedDate) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLieuDayCommand extends ICreateTimeOffCommand {
    type?: LieuDaySlotType;
    requestedDate?: Date;
}

export enum LieuDaySlotType {
    BankLieuDay = "BankLieuDay",
    TakeLieuDay = "TakeLieuDay",
}

export class ChangeLieuDayStatusCommand implements IChangeLieuDayStatusCommand {
    userId?: string;
    slotId?: string;
    status?: TimeOffStatus;

    constructor(data?: IChangeLieuDayStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.slotId = _data["slotId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeLieuDayStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLieuDayStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["slotId"] = this.slotId;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeLieuDayStatusCommand {
    userId?: string;
    slotId?: string;
    status?: TimeOffStatus;
}

export class CreatePersonalTimeCommand extends CreateTimeOffCommand implements ICreatePersonalTimeCommand {
    requestedDate?: Date;
    requestedStartTime?: string;
    requestedEndTime?: string;

    constructor(data?: ICreatePersonalTimeCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.requestedStartTime = _data["requestedStartTime"];
            this.requestedEndTime = _data["requestedEndTime"];
        }
    }

    static override fromJS(data: any): CreatePersonalTimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalTimeCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedDate"] = this.requestedDate ? formatDate(this.requestedDate) : <any>undefined;
        data["requestedStartTime"] = this.requestedStartTime;
        data["requestedEndTime"] = this.requestedEndTime;
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePersonalTimeCommand extends ICreateTimeOffCommand {
    requestedDate?: Date;
    requestedStartTime?: string;
    requestedEndTime?: string;
}

export class ChangePersonalTimeStatusCommand implements IChangePersonalTimeStatusCommand {
    id?: string;
    status?: TimeOffStatus;

    constructor(data?: IChangePersonalTimeStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangePersonalTimeStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePersonalTimeStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangePersonalTimeStatusCommand {
    id?: string;
    status?: TimeOffStatus;
}

export class CreateFloaterDayCommand extends CreateTimeOffCommand implements ICreateFloaterDayCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;

    constructor(data?: ICreateFloaterDayCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CreateFloaterDayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFloaterDayCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateFloaterDayCommand extends ICreateTimeOffCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;
}

export class ChangeFloaterDayStatusCommand implements IChangeFloaterDayStatusCommand {
    id?: string;
    status?: TimeOffStatus;

    constructor(data?: IChangeFloaterDayStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeFloaterDayStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeFloaterDayStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeFloaterDayStatusCommand {
    id?: string;
    status?: TimeOffStatus;
}

export class CreateLeaveOfAbsenceCommand extends CreateTimeOffCommand implements ICreateLeaveOfAbsenceCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;
    uploadedFiles?: UploadedFileDto[];

    constructor(data?: ICreateLeaveOfAbsenceCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["uploadedFiles"])) {
                this.uploadedFiles = [] as any;
                for (let item of _data["uploadedFiles"])
                    this.uploadedFiles!.push(UploadedFileDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CreateLeaveOfAbsenceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeaveOfAbsenceCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        if (Array.isArray(this.uploadedFiles)) {
            data["uploadedFiles"] = [];
            for (let item of this.uploadedFiles)
                data["uploadedFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLeaveOfAbsenceCommand extends ICreateTimeOffCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;
    uploadedFiles?: UploadedFileDto[];
}

export class ChangeLeaveOfAbsenceStatusCommand implements IChangeLeaveOfAbsenceStatusCommand {
    id?: string;
    status?: TimeOffStatus;

    constructor(data?: IChangeLeaveOfAbsenceStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeLeaveOfAbsenceStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLeaveOfAbsenceStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeLeaveOfAbsenceStatusCommand {
    id?: string;
    status?: TimeOffStatus;
}

export class CreateAgencyTimeOffCommand extends CreateTimeOffCommand implements ICreateAgencyTimeOffCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;
    uploadedFiles?: UploadedFileDto[];

    constructor(data?: ICreateAgencyTimeOffCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["uploadedFiles"])) {
                this.uploadedFiles = [] as any;
                for (let item of _data["uploadedFiles"])
                    this.uploadedFiles!.push(UploadedFileDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CreateAgencyTimeOffCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgencyTimeOffCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        if (Array.isArray(this.uploadedFiles)) {
            data["uploadedFiles"] = [];
            for (let item of this.uploadedFiles)
                data["uploadedFiles"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAgencyTimeOffCommand extends ICreateTimeOffCommand {
    requestedStartDate?: Date;
    requestedEndDate?: Date;
    uploadedFiles?: UploadedFileDto[];
}

export class ChangeAgencyTimeOffStatusCommand implements IChangeAgencyTimeOffStatusCommand {
    id?: string;
    status?: TimeOffStatus;

    constructor(data?: IChangeAgencyTimeOffStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeAgencyTimeOffStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeAgencyTimeOffStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeAgencyTimeOffStatusCommand {
    id?: string;
    status?: TimeOffStatus;
}

export class ClearExceptionsCommand implements IClearExceptionsCommand {
    timeLogId?: string;
    shiftId?: string | undefined;
    shiftStart?: string | undefined;
    shiftEnd?: string | undefined;
    punchInTime?: string | undefined;
    punchOutTime?: string | undefined;
    isAbsent?: boolean | undefined;
    reason?: string;

    constructor(data?: IClearExceptionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeLogId = _data["timeLogId"];
            this.shiftId = _data["shiftId"];
            this.shiftStart = _data["shiftStart"];
            this.shiftEnd = _data["shiftEnd"];
            this.punchInTime = _data["punchInTime"];
            this.punchOutTime = _data["punchOutTime"];
            this.isAbsent = _data["isAbsent"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ClearExceptionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClearExceptionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeLogId"] = this.timeLogId;
        data["shiftId"] = this.shiftId;
        data["shiftStart"] = this.shiftStart;
        data["shiftEnd"] = this.shiftEnd;
        data["punchInTime"] = this.punchInTime;
        data["punchOutTime"] = this.punchOutTime;
        data["isAbsent"] = this.isAbsent;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IClearExceptionsCommand {
    timeLogId?: string;
    shiftId?: string | undefined;
    shiftStart?: string | undefined;
    shiftEnd?: string | undefined;
    punchInTime?: string | undefined;
    punchOutTime?: string | undefined;
    isAbsent?: boolean | undefined;
    reason?: string;
}

export class SchedulerEventDto implements ISchedulerEventDto {
    date?: Date;
    type?: SchedulerEventType;
    status?: SchedulerEventStatus | undefined;
    count?: number;
    shiftType?: ShiftType | undefined;
    shiftCode?: string | undefined;
    shiftRate?: number;
    scheduledHoursSpan?: string;
    label?: string;
    employees?: SchedulerEmployeeInfoDto[];

    constructor(data?: ISchedulerEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.status = _data["status"];
            this.count = _data["count"];
            this.shiftType = _data["shiftType"];
            this.shiftCode = _data["shiftCode"];
            this.shiftRate = _data["shiftRate"];
            this.scheduledHoursSpan = _data["scheduledHoursSpan"];
            this.label = _data["label"];
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(SchedulerEmployeeInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchedulerEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        data["count"] = this.count;
        data["shiftType"] = this.shiftType;
        data["shiftCode"] = this.shiftCode;
        data["shiftRate"] = this.shiftRate;
        data["scheduledHoursSpan"] = this.scheduledHoursSpan;
        data["label"] = this.label;
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISchedulerEventDto {
    date?: Date;
    type?: SchedulerEventType;
    status?: SchedulerEventStatus | undefined;
    count?: number;
    shiftType?: ShiftType | undefined;
    shiftCode?: string | undefined;
    shiftRate?: number;
    scheduledHoursSpan?: string;
    label?: string;
    employees?: SchedulerEmployeeInfoDto[];
}

export enum SchedulerEventType {
    Scheduled = "Scheduled",
    TimeOff = "TimeOff",
    Status = "Status",
}

export enum SchedulerEventStatus {
    OnTime = "OnTime",
    ArrivedLate = "ArrivedLate",
    Exception = "Exception",
    Absent = "Absent",
    Day = "Day",
    Afternoons = "Afternoons",
    WeekendDays = "WeekendDays",
    WeekendNights = "WeekendNights",
    Vacation = "Vacation",
    FloaterDay = "FloaterDay",
    LeaveOfAbsence = "LeaveOfAbsence",
    AgencyTimeOff = "AgencyTimeOff",
    LieuDay = "LieuDay",
    PersonalTime = "PersonalTime",
}

export class SchedulerEmployeeInfoDto implements ISchedulerEmployeeInfoDto {
    employeeId?: string;
    employeeName?: string;
    employeeEmail?: string | undefined;
    employeeAvatar?: string | undefined;
    shiftType?: ShiftType | undefined;
    shiftCode?: string | undefined;
    shiftName?: string;

    constructor(data?: ISchedulerEmployeeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeEmail = _data["employeeEmail"];
            this.employeeAvatar = _data["employeeAvatar"];
            this.shiftType = _data["shiftType"];
            this.shiftCode = _data["shiftCode"];
            this.shiftName = _data["shiftName"];
        }
    }

    static fromJS(data: any): SchedulerEmployeeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulerEmployeeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeEmail"] = this.employeeEmail;
        data["employeeAvatar"] = this.employeeAvatar;
        data["shiftType"] = this.shiftType;
        data["shiftCode"] = this.shiftCode;
        data["shiftName"] = this.shiftName;
        return data;
    }
}

export interface ISchedulerEmployeeInfoDto {
    employeeId?: string;
    employeeName?: string;
    employeeEmail?: string | undefined;
    employeeAvatar?: string | undefined;
    shiftType?: ShiftType | undefined;
    shiftCode?: string | undefined;
    shiftName?: string;
}

export class GetSchedulerEventsQuery implements IGetSchedulerEventsQuery {
    from?: Date;
    to?: Date;
    employeeId?: string | undefined;

    constructor(data?: IGetSchedulerEventsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): GetSchedulerEventsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSchedulerEventsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IGetSchedulerEventsQuery {
    from?: Date;
    to?: Date;
    employeeId?: string | undefined;
}

export class ContactInfoDto implements IContactInfoDto {
    id?: string;
    firstName?: string;
    middleName?: string | undefined;
    lastName?: string;
    name?: string;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    avatarUrl?: string | undefined;
    roles?: string[];

    constructor(data?: IContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.avatarUrl = _data["avatarUrl"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): ContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["name"] = this.name;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["avatarUrl"] = this.avatarUrl;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IContactInfoDto {
    id?: string;
    firstName?: string;
    middleName?: string | undefined;
    lastName?: string;
    name?: string;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    avatarUrl?: string | undefined;
    roles?: string[];
}

export class AlternativeNameDto implements IAlternativeNameDto {
    alternativeFirstName?: string | undefined;
    alternativeLastName?: string | undefined;

    constructor(data?: IAlternativeNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alternativeFirstName = _data["alternativeFirstName"];
            this.alternativeLastName = _data["alternativeLastName"];
        }
    }

    static fromJS(data: any): AlternativeNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlternativeNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeFirstName"] = this.alternativeFirstName;
        data["alternativeLastName"] = this.alternativeLastName;
        return data;
    }
}

export interface IAlternativeNameDto {
    alternativeFirstName?: string | undefined;
    alternativeLastName?: string | undefined;
}

export class EmergencyDetailsDto implements IEmergencyDetailsDto {
    emergencyContactName?: string | undefined;
    emergencyContactNumber?: string | undefined;
    medicalConditions?: string | undefined;

    constructor(data?: IEmergencyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emergencyContactName = _data["emergencyContactName"];
            this.emergencyContactNumber = _data["emergencyContactNumber"];
            this.medicalConditions = _data["medicalConditions"];
        }
    }

    static fromJS(data: any): EmergencyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emergencyContactName"] = this.emergencyContactName;
        data["emergencyContactNumber"] = this.emergencyContactNumber;
        data["medicalConditions"] = this.medicalConditions;
        return data;
    }
}

export interface IEmergencyDetailsDto {
    emergencyContactName?: string | undefined;
    emergencyContactNumber?: string | undefined;
    medicalConditions?: string | undefined;
}

export class EmployeePositionDto implements IEmployeePositionDto {
    positionId?: string | undefined;
    jobTitleDescription?: JobTitle | undefined;

    constructor(data?: IEmployeePositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"];
            this.jobTitleDescription = _data["jobTitleDescription"];
        }
    }

    static fromJS(data: any): EmployeePositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId;
        data["jobTitleDescription"] = this.jobTitleDescription;
        return data;
    }
}

export interface IEmployeePositionDto {
    positionId?: string | undefined;
    jobTitleDescription?: JobTitle | undefined;
}

export enum JobTitle {
    JobTitleDescription = "JobTitleDescription",
    WarehouseAssociate = "WarehouseAssociate",
    Supervisor = "Supervisor",
    Office = "Office",
    ComplianceManager = "ComplianceManager",
    OperationsManager = "OperationsManager",
    DirectorOfOperations = "DirectorOfOperations",
    ContinousImprovementMgr = "ContinousImprovementMgr",
}

export class EmploymentDetailsDto implements IEmploymentDetailsDto {
    positionStatus?: PositionStatus;
    positionId?: string | undefined;
    payrollCompanyCode?: PayrollCompanyCode | undefined;
    taxId?: string | undefined;
    birthDate?: string | undefined;
    age?: string | undefined;
    hireDate?: string | undefined;
    yearsWorked?: number | undefined;
    jobTitleDescription?: string | undefined;
    payClass?: string | undefined;
    homeDepartmentCode?: string;
    standardHours?: number | undefined;
    sapAccess?: boolean | undefined;
    dwaAccess?: boolean | undefined;
    nextViewAccess?: boolean | undefined;
    systemAccessLocked?: boolean;

    constructor(data?: IEmploymentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionStatus = _data["positionStatus"];
            this.positionId = _data["positionId"];
            this.payrollCompanyCode = _data["payrollCompanyCode"];
            this.taxId = _data["taxId"];
            this.birthDate = _data["birthDate"];
            this.age = _data["age"];
            this.hireDate = _data["hireDate"];
            this.yearsWorked = _data["yearsWorked"];
            this.jobTitleDescription = _data["jobTitleDescription"];
            this.payClass = _data["payClass"];
            this.homeDepartmentCode = _data["homeDepartmentCode"];
            this.standardHours = _data["standardHours"];
            this.sapAccess = _data["sapAccess"];
            this.dwaAccess = _data["dwaAccess"];
            this.nextViewAccess = _data["nextViewAccess"];
            this.systemAccessLocked = _data["systemAccessLocked"];
        }
    }

    static fromJS(data: any): EmploymentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionStatus"] = this.positionStatus;
        data["positionId"] = this.positionId;
        data["payrollCompanyCode"] = this.payrollCompanyCode;
        data["taxId"] = this.taxId;
        data["birthDate"] = this.birthDate;
        data["age"] = this.age;
        data["hireDate"] = this.hireDate;
        data["yearsWorked"] = this.yearsWorked;
        data["jobTitleDescription"] = this.jobTitleDescription;
        data["payClass"] = this.payClass;
        data["homeDepartmentCode"] = this.homeDepartmentCode;
        data["standardHours"] = this.standardHours;
        data["sapAccess"] = this.sapAccess;
        data["dwaAccess"] = this.dwaAccess;
        data["nextViewAccess"] = this.nextViewAccess;
        data["systemAccessLocked"] = this.systemAccessLocked;
        return data;
    }
}

export interface IEmploymentDetailsDto {
    positionStatus?: PositionStatus;
    positionId?: string | undefined;
    payrollCompanyCode?: PayrollCompanyCode | undefined;
    taxId?: string | undefined;
    birthDate?: string | undefined;
    age?: string | undefined;
    hireDate?: string | undefined;
    yearsWorked?: number | undefined;
    jobTitleDescription?: string | undefined;
    payClass?: string | undefined;
    homeDepartmentCode?: string;
    standardHours?: number | undefined;
    sapAccess?: boolean | undefined;
    dwaAccess?: boolean | undefined;
    nextViewAccess?: boolean | undefined;
    systemAccessLocked?: boolean;
}

export enum PositionStatus {
    Active = "Active",
    Leave = "Leave",
    Deactivated = "Deactivated",
    Terminated = "Terminated",
    Inactive = "Inactive",
}

export enum PayrollCompanyCode {
    N4sv = "N4sv",
}

export class FinancialDetailsDto implements IFinancialDetailsDto {
    standardHours?: number | undefined;
    regularPayRateCode?: RegularPayRateCode | undefined;
    payRateAmount?: string | undefined;

    constructor(data?: IFinancialDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardHours = _data["standardHours"];
            this.regularPayRateCode = _data["regularPayRateCode"];
            this.payRateAmount = _data["payRateAmount"];
        }
    }

    static fromJS(data: any): FinancialDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardHours"] = this.standardHours;
        data["regularPayRateCode"] = this.regularPayRateCode;
        data["payRateAmount"] = this.payRateAmount;
        return data;
    }
}

export interface IFinancialDetailsDto {
    standardHours?: number | undefined;
    regularPayRateCode?: RegularPayRateCode | undefined;
    payRateAmount?: string | undefined;
}

export enum RegularPayRateCode {
    H = "H",
    S = "S",
}

export class NestleDetailsDto implements INestleDetailsDto {
    hasSystemAccess?: boolean;
    adpHireDate?: Date | undefined;
    newHire?: boolean | undefined;
    agency?: string | undefined;
    positionId?: string | undefined;
    sapSuccessFactorId?: string | undefined;
    employeeId?: string | undefined;
    nestleUserId?: string | undefined;
    email?: string | undefined;
    nextPasswordExpiryDate?: Date | undefined;

    constructor(data?: INestleDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSystemAccess = _data["hasSystemAccess"];
            this.adpHireDate = _data["adpHireDate"] ? new Date(_data["adpHireDate"].toString()) : <any>undefined;
            this.newHire = _data["newHire"];
            this.agency = _data["agency"];
            this.positionId = _data["positionId"];
            this.sapSuccessFactorId = _data["sapSuccessFactorId"];
            this.employeeId = _data["employeeId"];
            this.nestleUserId = _data["nestleUserId"];
            this.email = _data["email"];
            this.nextPasswordExpiryDate = _data["nextPasswordExpiryDate"] ? new Date(_data["nextPasswordExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NestleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestleDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSystemAccess"] = this.hasSystemAccess;
        data["adpHireDate"] = this.adpHireDate ? this.adpHireDate.toISOString() : <any>undefined;
        data["newHire"] = this.newHire;
        data["agency"] = this.agency;
        data["positionId"] = this.positionId;
        data["sapSuccessFactorId"] = this.sapSuccessFactorId;
        data["employeeId"] = this.employeeId;
        data["nestleUserId"] = this.nestleUserId;
        data["email"] = this.email;
        data["nextPasswordExpiryDate"] = this.nextPasswordExpiryDate ? this.nextPasswordExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INestleDetailsDto {
    hasSystemAccess?: boolean;
    adpHireDate?: Date | undefined;
    newHire?: boolean | undefined;
    agency?: string | undefined;
    positionId?: string | undefined;
    sapSuccessFactorId?: string | undefined;
    employeeId?: string | undefined;
    nestleUserId?: string | undefined;
    email?: string | undefined;
    nextPasswordExpiryDate?: Date | undefined;
}

export class NestleStatusDto implements INestleStatusDto {
    status?: NestleStatus | undefined;

    constructor(data?: INestleStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NestleStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestleStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface INestleStatusDto {
    status?: NestleStatus | undefined;
}

export enum NestleStatus {
    SapPendingNestle = "SapPendingNestle",
    DwaPendingNestle = "DwaPendingNestle",
    DwaPendingHopewell = "DwaPendingHopewell",
    NextViewPendingHopewell = "NextViewPendingHopewell",
    Active = "Active",
    TerminationPending = "TerminationPending",
    Terminated = "Terminated",
    DeactivationPending = "DeactivationPending",
    Inactive = "Inactive",
    PasswordResetRequired = "PasswordResetRequired",
}

export class SecurityPermissionsDto implements ISecurityPermissionsDto {
    status?: UserStatus;
    notifyByEmail?: boolean;
    notifyByPhone?: boolean;
    twoFactorAuthentication?: boolean;
    roles?: string[];

    constructor(data?: ISecurityPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.notifyByEmail = _data["notifyByEmail"];
            this.notifyByPhone = _data["notifyByPhone"];
            this.twoFactorAuthentication = _data["twoFactorAuthentication"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): SecurityPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["notifyByEmail"] = this.notifyByEmail;
        data["notifyByPhone"] = this.notifyByPhone;
        data["twoFactorAuthentication"] = this.twoFactorAuthentication;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ISecurityPermissionsDto {
    status?: UserStatus;
    notifyByEmail?: boolean;
    notifyByPhone?: boolean;
    twoFactorAuthentication?: boolean;
    roles?: string[];
}

export enum UserStatus {
    Active = "Active",
    Leave = "Leave",
    Inactive = "Inactive",
    Terminated = "Terminated",
}

export class ShiftDetailsDto implements IShiftDetailsDto {
    shiftId?: string | undefined;
    supervisorId?: string | undefined;

    constructor(data?: IShiftDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.supervisorId = _data["supervisorId"];
        }
    }

    static fromJS(data: any): ShiftDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["supervisorId"] = this.supervisorId;
        return data;
    }
}

export interface IShiftDetailsDto {
    shiftId?: string | undefined;
    supervisorId?: string | undefined;
}

export class ProfileSupplierDto implements IProfileSupplierDto {
    suppliers?: string[];

    constructor(data?: IProfileSupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileSupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        return data;
    }
}

export interface IProfileSupplierDto {
    suppliers?: string[];
}

export class ProfileCarrierDto implements IProfileCarrierDto {
    carriers?: string[];

    constructor(data?: IProfileCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["carriers"])) {
                this.carriers = [] as any;
                for (let item of _data["carriers"])
                    this.carriers!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.carriers)) {
            data["carriers"] = [];
            for (let item of this.carriers)
                data["carriers"].push(item);
        }
        return data;
    }
}

export interface IProfileCarrierDto {
    carriers?: string[];
}

export class ProfileVendorDto implements IProfileVendorDto {
    vendors?: string[];

    constructor(data?: IProfileVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item);
        }
        return data;
    }
}

export interface IProfileVendorDto {
    vendors?: string[];
}

export class ProfileCustomerDto implements IProfileCustomerDto {
    customers?: string[];

    constructor(data?: IProfileCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item);
        }
        return data;
    }
}

export interface IProfileCustomerDto {
    customers?: string[];
}

export class ProfileSiteDto implements IProfileSiteDto {
    sites?: string[];

    constructor(data?: IProfileSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item);
        }
        return data;
    }
}

export interface IProfileSiteDto {
    sites?: string[];
}

export class ProfileAgencyDto implements IProfileAgencyDto {
    agencyIds?: string[];

    constructor(data?: IProfileAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["agencyIds"])) {
                this.agencyIds = [] as any;
                for (let item of _data["agencyIds"])
                    this.agencyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileAgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.agencyIds)) {
            data["agencyIds"] = [];
            for (let item of this.agencyIds)
                data["agencyIds"].push(item);
        }
        return data;
    }
}

export interface IProfileAgencyDto {
    agencyIds?: string[];
}

export class UserStatusDto implements IUserStatusDto {
    status?: UserStatus;
    suspended?: boolean;
    terminated?: boolean;
    canDelimitPosition?: boolean;
    canIssuePassword?: boolean;

    constructor(data?: IUserStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.suspended = _data["suspended"];
            this.terminated = _data["terminated"];
            this.canDelimitPosition = _data["canDelimitPosition"];
            this.canIssuePassword = _data["canIssuePassword"];
        }
    }

    static fromJS(data: any): UserStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["suspended"] = this.suspended;
        data["terminated"] = this.terminated;
        data["canDelimitPosition"] = this.canDelimitPosition;
        data["canIssuePassword"] = this.canIssuePassword;
        return data;
    }
}

export interface IUserStatusDto {
    status?: UserStatus;
    suspended?: boolean;
    terminated?: boolean;
    canDelimitPosition?: boolean;
    canIssuePassword?: boolean;
}

export class UpdateAlternativeNameCommand implements IUpdateAlternativeNameCommand {
    userId?: string;
    alternativeFirstName?: string | undefined;
    alternativeLastName?: string | undefined;

    constructor(data?: IUpdateAlternativeNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.alternativeFirstName = _data["alternativeFirstName"];
            this.alternativeLastName = _data["alternativeLastName"];
        }
    }

    static fromJS(data: any): UpdateAlternativeNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlternativeNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["alternativeFirstName"] = this.alternativeFirstName;
        data["alternativeLastName"] = this.alternativeLastName;
        return data;
    }
}

export interface IUpdateAlternativeNameCommand {
    userId?: string;
    alternativeFirstName?: string | undefined;
    alternativeLastName?: string | undefined;
}

export class UpdateProfileCarrierCommand implements IUpdateProfileCarrierCommand {
    userId?: string;
    carriers?: string[];

    constructor(data?: IUpdateProfileCarrierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["carriers"])) {
                this.carriers = [] as any;
                for (let item of _data["carriers"])
                    this.carriers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProfileCarrierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileCarrierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.carriers)) {
            data["carriers"] = [];
            for (let item of this.carriers)
                data["carriers"].push(item);
        }
        return data;
    }
}

export interface IUpdateProfileCarrierCommand {
    userId?: string;
    carriers?: string[];
}

export class UpdateProfileSupplierCommand implements IUpdateProfileSupplierCommand {
    userId?: string;
    suppliers?: string[];

    constructor(data?: IUpdateProfileSupplierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProfileSupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileSupplierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        return data;
    }
}

export interface IUpdateProfileSupplierCommand {
    userId?: string;
    suppliers?: string[];
}

export class UpdateProfileVendorCommand implements IUpdateProfileVendorCommand {
    userId?: string;
    vendors?: string[];

    constructor(data?: IUpdateProfileVendorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProfileVendorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileVendorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item);
        }
        return data;
    }
}

export interface IUpdateProfileVendorCommand {
    userId?: string;
    vendors?: string[];
}

export class UpdateProfileCustomerCommand implements IUpdateProfileCustomerCommand {
    userId?: string;
    customers?: string[];

    constructor(data?: IUpdateProfileCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProfileCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item);
        }
        return data;
    }
}

export interface IUpdateProfileCustomerCommand {
    userId?: string;
    customers?: string[];
}

export class UpdateProfileSiteCommand implements IUpdateProfileSiteCommand {
    userId?: string;
    sites?: string[];

    constructor(data?: IUpdateProfileSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProfileSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item);
        }
        return data;
    }
}

export interface IUpdateProfileSiteCommand {
    userId?: string;
    sites?: string[];
}

export class UpdateProfileAgencyCommand implements IUpdateProfileAgencyCommand {
    userId?: string;
    agencyIds?: string[];

    constructor(data?: IUpdateProfileAgencyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["agencyIds"])) {
                this.agencyIds = [] as any;
                for (let item of _data["agencyIds"])
                    this.agencyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProfileAgencyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileAgencyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.agencyIds)) {
            data["agencyIds"] = [];
            for (let item of this.agencyIds)
                data["agencyIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateProfileAgencyCommand {
    userId?: string;
    agencyIds?: string[];
}

export class UpdateEmploymentDetailsCommand implements IUpdateEmploymentDetailsCommand {
    userId?: string;
    sapAccess?: boolean | undefined;
    dwaAccess?: boolean | undefined;
    nextViewAccess?: boolean | undefined;

    constructor(data?: IUpdateEmploymentDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sapAccess = _data["sapAccess"];
            this.dwaAccess = _data["dwaAccess"];
            this.nextViewAccess = _data["nextViewAccess"];
        }
    }

    static fromJS(data: any): UpdateEmploymentDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sapAccess"] = this.sapAccess;
        data["dwaAccess"] = this.dwaAccess;
        data["nextViewAccess"] = this.nextViewAccess;
        return data;
    }
}

export interface IUpdateEmploymentDetailsCommand {
    userId?: string;
    sapAccess?: boolean | undefined;
    dwaAccess?: boolean | undefined;
    nextViewAccess?: boolean | undefined;
}

export class UpdateNestleDetailsCommand implements IUpdateNestleDetailsCommand {
    userId?: string;
    adpHireDate?: Date | undefined;
    newHire?: boolean | undefined;
    agency?: string | undefined;
    positionId?: string | undefined;
    sapSuccessFactorId?: string | undefined;
    employeeId?: string | undefined;
    nestleUserId?: string | undefined;
    email?: string | undefined;
    nextPasswordExpiryDate?: Date | undefined;

    constructor(data?: IUpdateNestleDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.adpHireDate = _data["adpHireDate"] ? new Date(_data["adpHireDate"].toString()) : <any>undefined;
            this.newHire = _data["newHire"];
            this.agency = _data["agency"];
            this.positionId = _data["positionId"];
            this.sapSuccessFactorId = _data["sapSuccessFactorId"];
            this.employeeId = _data["employeeId"];
            this.nestleUserId = _data["nestleUserId"];
            this.email = _data["email"];
            this.nextPasswordExpiryDate = _data["nextPasswordExpiryDate"] ? new Date(_data["nextPasswordExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateNestleDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNestleDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["adpHireDate"] = this.adpHireDate ? this.adpHireDate.toISOString() : <any>undefined;
        data["newHire"] = this.newHire;
        data["agency"] = this.agency;
        data["positionId"] = this.positionId;
        data["sapSuccessFactorId"] = this.sapSuccessFactorId;
        data["employeeId"] = this.employeeId;
        data["nestleUserId"] = this.nestleUserId;
        data["email"] = this.email;
        data["nextPasswordExpiryDate"] = this.nextPasswordExpiryDate ? this.nextPasswordExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateNestleDetailsCommand {
    userId?: string;
    adpHireDate?: Date | undefined;
    newHire?: boolean | undefined;
    agency?: string | undefined;
    positionId?: string | undefined;
    sapSuccessFactorId?: string | undefined;
    employeeId?: string | undefined;
    nestleUserId?: string | undefined;
    email?: string | undefined;
    nextPasswordExpiryDate?: Date | undefined;
}

export class ConfirmSapNestleCommand implements IConfirmSapNestleCommand {
    userId?: string;

    constructor(data?: IConfirmSapNestleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ConfirmSapNestleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmSapNestleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IConfirmSapNestleCommand {
    userId?: string;
}

export class ConfirmDwaNestleCommand implements IConfirmDwaNestleCommand {
    userId?: string;

    constructor(data?: IConfirmDwaNestleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ConfirmDwaNestleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDwaNestleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IConfirmDwaNestleCommand {
    userId?: string;
}

export class ConfirmDwaHopewellCommand implements IConfirmDwaHopewellCommand {
    userId?: string;

    constructor(data?: IConfirmDwaHopewellCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ConfirmDwaHopewellCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDwaHopewellCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IConfirmDwaHopewellCommand {
    userId?: string;
}

export class ConfirmNextViewHopewellCommand implements IConfirmNextViewHopewellCommand {
    userId?: string;

    constructor(data?: IConfirmNextViewHopewellCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ConfirmNextViewHopewellCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmNextViewHopewellCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IConfirmNextViewHopewellCommand {
    userId?: string;
}

export class ConfirmPasswordResetCommand implements IConfirmPasswordResetCommand {
    userId?: string;

    constructor(data?: IConfirmPasswordResetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ConfirmPasswordResetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordResetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IConfirmPasswordResetCommand {
    userId?: string;
}

export class TerminateUserCommand implements ITerminateUserCommand {
    userId?: string;

    constructor(data?: ITerminateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TerminateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TerminateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITerminateUserCommand {
    userId?: string;
}

export class ActivateUserCommand implements IActivateUserCommand {
    userId?: string;

    constructor(data?: IActivateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ActivateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IActivateUserCommand {
    userId?: string;
}

export class IssuePasswordCommand implements IIssuePasswordCommand {
    userId?: string;
    password?: string;

    constructor(data?: IIssuePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): IssuePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IssuePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }
}

export interface IIssuePasswordCommand {
    userId?: string;
    password?: string;
}

export abstract class UserStatusUpdateCommand implements IUserStatusUpdateCommand {
    userId?: string;
    effectiveDate?: Date;
    positionDelimited?: boolean;
    ticketNumber?: string;
    note?: string | undefined;
    uploadedFiles?: UploadedFileDto[];

    constructor(data?: IUserStatusUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.positionDelimited = _data["positionDelimited"];
            this.ticketNumber = _data["ticketNumber"];
            this.note = _data["note"];
            if (Array.isArray(_data["uploadedFiles"])) {
                this.uploadedFiles = [] as any;
                for (let item of _data["uploadedFiles"])
                    this.uploadedFiles!.push(UploadedFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserStatusUpdateCommand {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UserStatusUpdateCommand' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["positionDelimited"] = this.positionDelimited;
        data["ticketNumber"] = this.ticketNumber;
        data["note"] = this.note;
        if (Array.isArray(this.uploadedFiles)) {
            data["uploadedFiles"] = [];
            for (let item of this.uploadedFiles)
                data["uploadedFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserStatusUpdateCommand {
    userId?: string;
    effectiveDate?: Date;
    positionDelimited?: boolean;
    ticketNumber?: string;
    note?: string | undefined;
    uploadedFiles?: UploadedFileDto[];
}

export class ConfirmTerminationCommand extends UserStatusUpdateCommand implements IConfirmTerminationCommand {

    constructor(data?: IConfirmTerminationCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ConfirmTerminationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTerminationCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmTerminationCommand extends IUserStatusUpdateCommand {
}

export class ConfirmDeactivationCommand extends UserStatusUpdateCommand implements IConfirmDeactivationCommand {

    constructor(data?: IConfirmDeactivationCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ConfirmDeactivationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDeactivationCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IConfirmDeactivationCommand extends IUserStatusUpdateCommand {
}

export class DelimitPositionCommand extends UserStatusUpdateCommand implements IDelimitPositionCommand {

    constructor(data?: IDelimitPositionCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DelimitPositionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DelimitPositionCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDelimitPositionCommand extends IUserStatusUpdateCommand {
}

export class UpdateContactInfoCommand implements IUpdateContactInfoCommand {
    userId?: string;
    firstName?: string;
    middleName?: string | undefined;
    lastName?: string;
    address?: string;
    email?: string;
    phone?: string;

    constructor(data?: IUpdateContactInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UpdateContactInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUpdateContactInfoCommand {
    userId?: string;
    firstName?: string;
    middleName?: string | undefined;
    lastName?: string;
    address?: string;
    email?: string;
    phone?: string;
}

export class UpdateEmergencyDetailsCommand implements IUpdateEmergencyDetailsCommand {
    userId?: string;
    emergencyContactName?: string | undefined;
    emergencyContactNumber?: string | undefined;
    medicalConditions?: string | undefined;

    constructor(data?: IUpdateEmergencyDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.emergencyContactName = _data["emergencyContactName"];
            this.emergencyContactNumber = _data["emergencyContactNumber"];
            this.medicalConditions = _data["medicalConditions"];
        }
    }

    static fromJS(data: any): UpdateEmergencyDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmergencyDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["emergencyContactName"] = this.emergencyContactName;
        data["emergencyContactNumber"] = this.emergencyContactNumber;
        data["medicalConditions"] = this.medicalConditions;
        return data;
    }
}

export interface IUpdateEmergencyDetailsCommand {
    userId?: string;
    emergencyContactName?: string | undefined;
    emergencyContactNumber?: string | undefined;
    medicalConditions?: string | undefined;
}

export class UpdateSecurityPermissionsCommand implements IUpdateSecurityPermissionsCommand {
    userId?: string;
    notifyByEmail?: boolean;
    notifyByPhone?: boolean;
    twoFactorAuthentication?: boolean;
    roles?: string[];

    constructor(data?: IUpdateSecurityPermissionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.notifyByEmail = _data["notifyByEmail"];
            this.notifyByPhone = _data["notifyByPhone"];
            this.twoFactorAuthentication = _data["twoFactorAuthentication"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSecurityPermissionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityPermissionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["notifyByEmail"] = this.notifyByEmail;
        data["notifyByPhone"] = this.notifyByPhone;
        data["twoFactorAuthentication"] = this.twoFactorAuthentication;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateSecurityPermissionsCommand {
    userId?: string;
    notifyByEmail?: boolean;
    notifyByPhone?: boolean;
    twoFactorAuthentication?: boolean;
    roles?: string[];
}

export class UpdateShiftDetailsCommand implements IUpdateShiftDetailsCommand {
    userId?: string;
    shiftId?: string | undefined;
    supervisorId?: string | undefined;

    constructor(data?: IUpdateShiftDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.shiftId = _data["shiftId"];
            this.supervisorId = _data["supervisorId"];
        }
    }

    static fromJS(data: any): UpdateShiftDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShiftDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["shiftId"] = this.shiftId;
        data["supervisorId"] = this.supervisorId;
        return data;
    }
}

export interface IUpdateShiftDetailsCommand {
    userId?: string;
    shiftId?: string | undefined;
    supervisorId?: string | undefined;
}

export class MarkAsLateCommand implements IMarkAsLateCommand {
    employeeId?: string;

    constructor(data?: IMarkAsLateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): MarkAsLateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsLateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IMarkAsLateCommand {
    employeeId?: string;
}

export class UndoLateCommand implements IUndoLateCommand {
    employeeId?: string;

    constructor(data?: IUndoLateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): UndoLateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UndoLateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        return data;
    }
}

export interface IUndoLateCommand {
    employeeId?: string;
}

export class CreateEmployeeCommand implements ICreateEmployeeCommand {
    firstName?: string;
    middleName?: string | undefined;
    lastName?: string;
    email?: string;
    phone?: string;
    address?: string;
    roles?: string[];
    carrierIds?: string[];
    supplierIds?: string[];
    vendorIds?: string[];
    customerIds?: string[];
    siteIds?: string[];
    agencyIds?: string[];
    shiftId?: string | undefined;

    constructor(data?: ICreateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["carrierIds"])) {
                this.carrierIds = [] as any;
                for (let item of _data["carrierIds"])
                    this.carrierIds!.push(item);
            }
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            if (Array.isArray(_data["agencyIds"])) {
                this.agencyIds = [] as any;
                for (let item of _data["agencyIds"])
                    this.agencyIds!.push(item);
            }
            this.shiftId = _data["shiftId"];
        }
    }

    static fromJS(data: any): CreateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.carrierIds)) {
            data["carrierIds"] = [];
            for (let item of this.carrierIds)
                data["carrierIds"].push(item);
        }
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        if (Array.isArray(this.agencyIds)) {
            data["agencyIds"] = [];
            for (let item of this.agencyIds)
                data["agencyIds"].push(item);
        }
        data["shiftId"] = this.shiftId;
        return data;
    }
}

export interface ICreateEmployeeCommand {
    firstName?: string;
    middleName?: string | undefined;
    lastName?: string;
    email?: string;
    phone?: string;
    address?: string;
    roles?: string[];
    carrierIds?: string[];
    supplierIds?: string[];
    vendorIds?: string[];
    customerIds?: string[];
    siteIds?: string[];
    agencyIds?: string[];
    shiftId?: string | undefined;
}

export abstract class CreateNoteCommand implements ICreateNoteCommand {
    body?: string;
    uploadedFiles?: UploadedFileDto[];

    constructor(data?: ICreateNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
            if (Array.isArray(_data["uploadedFiles"])) {
                this.uploadedFiles = [] as any;
                for (let item of _data["uploadedFiles"])
                    this.uploadedFiles!.push(UploadedFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateNoteCommand {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CreateNoteCommand' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        if (Array.isArray(this.uploadedFiles)) {
            data["uploadedFiles"] = [];
            for (let item of this.uploadedFiles)
                data["uploadedFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateNoteCommand {
    body?: string;
    uploadedFiles?: UploadedFileDto[];
}

export class CreateEmployeeNoteCommand extends CreateNoteCommand implements ICreateEmployeeNoteCommand {
    userId?: string;

    constructor(data?: ICreateEmployeeNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static override fromJS(data: any): CreateEmployeeNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmployeeNoteCommand extends ICreateNoteCommand {
    userId?: string;
}

export class CreateAssetNoteCommand extends CreateNoteCommand implements ICreateAssetNoteCommand {
    assetId?: string;

    constructor(data?: ICreateAssetNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetId = _data["assetId"];
        }
    }

    static override fromJS(data: any): CreateAssetNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAssetNoteCommand extends ICreateNoteCommand {
    assetId?: string;
}

export class CreateChecklistNoteCommand extends CreateNoteCommand implements ICreateChecklistNoteCommand {
    checklistId?: string;

    constructor(data?: ICreateChecklistNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.checklistId = _data["checklistId"];
        }
    }

    static override fromJS(data: any): CreateChecklistNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChecklistNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistId"] = this.checklistId;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateChecklistNoteCommand extends ICreateNoteCommand {
    checklistId?: string;
}

export class CreateIncidentReportNoteCommand extends CreateNoteCommand implements ICreateIncidentReportNoteCommand {
    incidentReportId?: string;

    constructor(data?: ICreateIncidentReportNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentReportId = _data["incidentReportId"];
        }
    }

    static override fromJS(data: any): CreateIncidentReportNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncidentReportNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentReportId"] = this.incidentReportId;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateIncidentReportNoteCommand extends ICreateNoteCommand {
    incidentReportId?: string;
}

export class CreateAppointmentNoteCommand extends CreateNoteCommand implements ICreateAppointmentNoteCommand {
    number?: string;

    constructor(data?: ICreateAppointmentNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): CreateAppointmentNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAppointmentNoteCommand extends ICreateNoteCommand {
    number?: string;
}

export class CreateEmptyCheckInNoteCommand extends CreateNoteCommand implements ICreateEmptyCheckInNoteCommand {
    number?: string;

    constructor(data?: ICreateEmptyCheckInNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): CreateEmptyCheckInNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmptyCheckInNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmptyCheckInNoteCommand extends ICreateNoteCommand {
    number?: string;
}

export class CreateEmptyCheckOutNoteCommand extends CreateNoteCommand implements ICreateEmptyCheckOutNoteCommand {
    number?: string;

    constructor(data?: ICreateEmptyCheckOutNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
        }
    }

    static override fromJS(data: any): CreateEmptyCheckOutNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmptyCheckOutNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateEmptyCheckOutNoteCommand extends ICreateNoteCommand {
    number?: string;
}

export class CreateInvoicePurchaseOrderNoteCommand extends CreateNoteCommand implements ICreateInvoicePurchaseOrderNoteCommand {
    number?: string;
    isInternal?: boolean;

    constructor(data?: ICreateInvoicePurchaseOrderNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.isInternal = _data["isInternal"];
        }
    }

    static override fromJS(data: any): CreateInvoicePurchaseOrderNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoicePurchaseOrderNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["isInternal"] = this.isInternal;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateInvoicePurchaseOrderNoteCommand extends ICreateNoteCommand {
    number?: string;
    isInternal?: boolean;
}

export class CreateInvoiceNoteCommand extends CreateNoteCommand implements ICreateInvoiceNoteCommand {
    number?: string;
    isInternal?: boolean;

    constructor(data?: ICreateInvoiceNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.isInternal = _data["isInternal"];
        }
    }

    static override fromJS(data: any): CreateInvoiceNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["isInternal"] = this.isInternal;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateInvoiceNoteCommand extends ICreateNoteCommand {
    number?: string;
    isInternal?: boolean;
}

export class CreateCreditRequestNoteCommand extends CreateNoteCommand implements ICreateCreditRequestNoteCommand {
    number?: string;
    isInternal?: boolean;

    constructor(data?: ICreateCreditRequestNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.number = _data["number"];
            this.isInternal = _data["isInternal"];
        }
    }

    static override fromJS(data: any): CreateCreditRequestNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCreditRequestNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["isInternal"] = this.isInternal;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCreditRequestNoteCommand extends ICreateNoteCommand {
    number?: string;
    isInternal?: boolean;
}

export abstract class ResultBase implements IResultBase {
    isFailed?: boolean;
    isSuccess?: boolean;
    reasons?: IReason[] | undefined;
    errors?: IError[] | undefined;
    successes?: ISuccess[] | undefined;

    constructor(data?: IResultBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFailed = _data["isFailed"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(IReason.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(IError.fromJS(item));
            }
            if (Array.isArray(_data["successes"])) {
                this.successes = [] as any;
                for (let item of _data["successes"])
                    this.successes!.push(ISuccess.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResultBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFailed"] = this.isFailed;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (Array.isArray(this.successes)) {
            data["successes"] = [];
            for (let item of this.successes)
                data["successes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultBase {
    isFailed?: boolean;
    isSuccess?: boolean;
    reasons?: IReason[] | undefined;
    errors?: IError[] | undefined;
    successes?: ISuccess[] | undefined;
}

export abstract class ResultBaseOfResultOfListOfNoteDto extends ResultBase implements IResultBaseOfResultOfListOfNoteDto {

    constructor(data?: IResultBaseOfResultOfListOfNoteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResultBaseOfResultOfListOfNoteDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResultBaseOfResultOfListOfNoteDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResultBaseOfResultOfListOfNoteDto extends IResultBase {
}

export class ResultOfListOfNoteDto extends ResultBaseOfResultOfListOfNoteDto implements IResultOfListOfNoteDto {
    valueOrDefault?: NoteDto[];
    value?: NoteDto[];

    constructor(data?: IResultOfListOfNoteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["valueOrDefault"])) {
                this.valueOrDefault = [] as any;
                for (let item of _data["valueOrDefault"])
                    this.valueOrDefault!.push(NoteDto.fromJS(item));
            }
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(NoteDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ResultOfListOfNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfNoteDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valueOrDefault)) {
            data["valueOrDefault"] = [];
            for (let item of this.valueOrDefault)
                data["valueOrDefault"].push(item.toJSON());
        }
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfNoteDto extends IResultBaseOfResultOfListOfNoteDto {
    valueOrDefault?: NoteDto[];
    value?: NoteDto[];
}

export class NoteDto implements INoteDto {
    body?: string;
    attachments?: DocumentDto[];
    isInternal?: boolean;
    lastModified?: Date;
    lastModifiedBy?: EmployeeDto | undefined;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(DocumentDto.fromJS(item));
            }
            this.isInternal = _data["isInternal"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["isInternal"] = this.isInternal;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface INoteDto {
    body?: string;
    attachments?: DocumentDto[];
    isInternal?: boolean;
    lastModified?: Date;
    lastModifiedBy?: EmployeeDto | undefined;
}

export class DocumentDto implements IDocumentDto {
    fileUrl?: string;
    fileName?: string;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IDocumentDto {
    fileUrl?: string;
    fileName?: string;
}

export abstract class IReason implements IIReason {
    message?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;

    constructor(data?: IIReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): IReason {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IReason' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IIReason {
    message?: string | undefined;
    metadata?: { [key: string]: any; } | undefined;
}

export abstract class ISuccess implements IISuccess {

    constructor(data?: IISuccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ISuccess {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ISuccess' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IISuccess {
}

export abstract class ResultBaseOfResultOfExportedFileDto extends ResultBase implements IResultBaseOfResultOfExportedFileDto {

    constructor(data?: IResultBaseOfResultOfExportedFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ResultBaseOfResultOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ResultBaseOfResultOfExportedFileDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IResultBaseOfResultOfExportedFileDto extends IResultBase {
}

export class ResultOfExportedFileDto extends ResultBaseOfResultOfExportedFileDto implements IResultOfExportedFileDto {
    valueOrDefault?: ExportedFileDto;
    value?: ExportedFileDto;

    constructor(data?: IResultOfExportedFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valueOrDefault = _data["valueOrDefault"] ? ExportedFileDto.fromJS(_data["valueOrDefault"]) : <any>undefined;
            this.value = _data["value"] ? ExportedFileDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ResultOfExportedFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfExportedFileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueOrDefault"] = this.valueOrDefault ? this.valueOrDefault.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfExportedFileDto extends IResultBaseOfResultOfExportedFileDto {
    valueOrDefault?: ExportedFileDto;
    value?: ExportedFileDto;
}

export class ExportScoreQuery extends MyScoreQueryOfExportedFileDto implements IExportScoreQuery {

    constructor(data?: IExportScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ExportScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExportScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportScoreQuery extends IMyScoreQueryOfExportedFileDto {
}

export class GetAttendanceScoreQuery extends MyScoreShiftQuery implements IGetAttendanceScoreQuery {

    constructor(data?: IGetAttendanceScoreQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAttendanceScoreQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceScoreQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAttendanceScoreQuery extends IMyScoreShiftQuery {
}

export class AttendanceSummaryDto implements IAttendanceSummaryDto {
    score?: number | undefined;
    expected?: number | undefined;
    onSite?: number | undefined;
    timeOff?: number | undefined;
    hoursWorked?: number | undefined;
    labourCost?: number | undefined;
    mealTickets?: number | undefined;

    constructor(data?: IAttendanceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.expected = _data["expected"];
            this.onSite = _data["onSite"];
            this.timeOff = _data["timeOff"];
            this.hoursWorked = _data["hoursWorked"];
            this.labourCost = _data["labourCost"];
            this.mealTickets = _data["mealTickets"];
        }
    }

    static fromJS(data: any): AttendanceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["expected"] = this.expected;
        data["onSite"] = this.onSite;
        data["timeOff"] = this.timeOff;
        data["hoursWorked"] = this.hoursWorked;
        data["labourCost"] = this.labourCost;
        data["mealTickets"] = this.mealTickets;
        return data;
    }
}

export interface IAttendanceSummaryDto {
    score?: number | undefined;
    expected?: number | undefined;
    onSite?: number | undefined;
    timeOff?: number | undefined;
    hoursWorked?: number | undefined;
    labourCost?: number | undefined;
    mealTickets?: number | undefined;
}

export abstract class MyScoreQueryOfAttendanceSummaryDto implements IMyScoreQueryOfAttendanceSummaryDto {
    from?: Date;
    to?: Date | undefined;
    userId?: string | undefined;

    constructor(data?: IMyScoreQueryOfAttendanceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MyScoreQueryOfAttendanceSummaryDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MyScoreQueryOfAttendanceSummaryDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : <any>undefined;
        data["to"] = this.to ? formatDate(this.to) : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMyScoreQueryOfAttendanceSummaryDto {
    from?: Date;
    to?: Date | undefined;
    userId?: string | undefined;
}

export class GetAttendanceSummaryQuery extends MyScoreQueryOfAttendanceSummaryDto implements IGetAttendanceSummaryQuery {

    constructor(data?: IGetAttendanceSummaryQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAttendanceSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceSummaryQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAttendanceSummaryQuery extends IMyScoreQueryOfAttendanceSummaryDto {
}

export class GetAttendanceTrendingQuery extends TrendingQuery implements IGetAttendanceTrendingQuery {

    constructor(data?: IGetAttendanceTrendingQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAttendanceTrendingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceTrendingQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAttendanceTrendingQuery extends ITrendingQuery {
}

export enum ChangeRequestStatus {
    Pending = "Pending",
    SentToHr = "SentToHr",
    Approved = "Approved",
    Declined = "Declined",
    Withdrawn = "Withdrawn",
    Completed = "Completed",
}

export class CreateChangeRequestCommand implements ICreateChangeRequestCommand {
    userId?: string;
    typeOfChange?: ChangeRequestType;
    newValue?: string | undefined;
    institutionNumber?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    uploadedFile?: UploadedFileDto | undefined;
    reasonForChange?: string;

    constructor(data?: ICreateChangeRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.typeOfChange = _data["typeOfChange"];
            this.newValue = _data["newValue"];
            this.institutionNumber = _data["institutionNumber"];
            this.transitNumber = _data["transitNumber"];
            this.accountNumber = _data["accountNumber"];
            this.uploadedFile = _data["uploadedFile"] ? UploadedFileDto.fromJS(_data["uploadedFile"]) : <any>undefined;
            this.reasonForChange = _data["reasonForChange"];
        }
    }

    static fromJS(data: any): CreateChangeRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChangeRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["typeOfChange"] = this.typeOfChange;
        data["newValue"] = this.newValue;
        data["institutionNumber"] = this.institutionNumber;
        data["transitNumber"] = this.transitNumber;
        data["accountNumber"] = this.accountNumber;
        data["uploadedFile"] = this.uploadedFile ? this.uploadedFile.toJSON() : <any>undefined;
        data["reasonForChange"] = this.reasonForChange;
        return data;
    }
}

export interface ICreateChangeRequestCommand {
    userId?: string;
    typeOfChange?: ChangeRequestType;
    newValue?: string | undefined;
    institutionNumber?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    uploadedFile?: UploadedFileDto | undefined;
    reasonForChange?: string;
}

export enum ChangeRequestType {
    PhoneNumber = "PhoneNumber",
    Address = "Address",
    Email = "Email",
    BankAccount = "BankAccount",
}

export class CurrentValuesDto implements ICurrentValuesDto {
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;

    constructor(data?: ICurrentValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): CurrentValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address;
        return data;
    }
}

export interface ICurrentValuesDto {
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
}

export class ChangeRequestGridViewDto implements IChangeRequestGridViewDto {
    id?: string;
    number?: string;
    typeOfChange?: ChangeRequestType;
    employee?: EmployeeDto;
    lastModifiedByName?: string | undefined;
    status?: ChangeRequestStatus;
    submittedDate?: Date;
    finalizedDate?: Date | undefined;
    reasonForChange?: string;

    constructor(data?: IChangeRequestGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.typeOfChange = _data["typeOfChange"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.status = _data["status"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.finalizedDate = _data["finalizedDate"] ? new Date(_data["finalizedDate"].toString()) : <any>undefined;
            this.reasonForChange = _data["reasonForChange"];
        }
    }

    static fromJS(data: any): ChangeRequestGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["typeOfChange"] = this.typeOfChange;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["status"] = this.status;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["finalizedDate"] = this.finalizedDate ? this.finalizedDate.toISOString() : <any>undefined;
        data["reasonForChange"] = this.reasonForChange;
        return data;
    }
}

export interface IChangeRequestGridViewDto {
    id?: string;
    number?: string;
    typeOfChange?: ChangeRequestType;
    employee?: EmployeeDto;
    lastModifiedByName?: string | undefined;
    status?: ChangeRequestStatus;
    submittedDate?: Date;
    finalizedDate?: Date | undefined;
    reasonForChange?: string;
}

export class ChangeRequestViewDto extends ChangeRequestGridViewDto implements IChangeRequestViewDto {
    newValue?: string | undefined;
    institutionNumber?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    chequeFile?: DocumentDto | undefined;
    canApprove?: boolean;
    canDecline?: boolean;
    canWithdraw?: boolean;
    canComplete?: boolean;

    constructor(data?: IChangeRequestViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.newValue = _data["newValue"];
            this.institutionNumber = _data["institutionNumber"];
            this.transitNumber = _data["transitNumber"];
            this.accountNumber = _data["accountNumber"];
            this.chequeFile = _data["chequeFile"] ? DocumentDto.fromJS(_data["chequeFile"]) : <any>undefined;
            this.canApprove = _data["canApprove"];
            this.canDecline = _data["canDecline"];
            this.canWithdraw = _data["canWithdraw"];
            this.canComplete = _data["canComplete"];
        }
    }

    static override fromJS(data: any): ChangeRequestViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newValue"] = this.newValue;
        data["institutionNumber"] = this.institutionNumber;
        data["transitNumber"] = this.transitNumber;
        data["accountNumber"] = this.accountNumber;
        data["chequeFile"] = this.chequeFile ? this.chequeFile.toJSON() : <any>undefined;
        data["canApprove"] = this.canApprove;
        data["canDecline"] = this.canDecline;
        data["canWithdraw"] = this.canWithdraw;
        data["canComplete"] = this.canComplete;
        super.toJSON(data);
        return data;
    }
}

export interface IChangeRequestViewDto extends IChangeRequestGridViewDto {
    newValue?: string | undefined;
    institutionNumber?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    chequeFile?: DocumentDto | undefined;
    canApprove?: boolean;
    canDecline?: boolean;
    canWithdraw?: boolean;
    canComplete?: boolean;
}

export class ShuntMoveDto implements IShuntMoveDto {
    location?: ShuntLocationType;
    locationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;

    constructor(data?: IShuntMoveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ShuntMoveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntMoveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface IShuntMoveDto {
    location?: ShuntLocationType;
    locationId?: string;
    priority?: ShuntPriority;
    note?: string | undefined;
}

export class UserGridViewDto implements IUserGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    address?: string | undefined;
    phone?: string | undefined;
    status?: UserStatus;
    mainRole?: string | undefined;
    roles?: string[];

    constructor(data?: IUserGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.mainRole = _data["mainRole"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["mainRole"] = this.mainRole;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    address?: string | undefined;
    phone?: string | undefined;
    status?: UserStatus;
    mainRole?: string | undefined;
    roles?: string[];
}

export class TimeOffDto implements ITimeOffDto {
    id?: string;
    number?: string;
    shiftCode?: string | undefined;
    employee?: EmployeeDto;
    lastModifiedByName?: string | undefined;
    status?: TimeOffStatus;
    submittedDate?: Date;
    finalizedDate?: Date | undefined;
    description?: string;

    constructor(data?: ITimeOffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.shiftCode = _data["shiftCode"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.status = _data["status"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.finalizedDate = _data["finalizedDate"] ? new Date(_data["finalizedDate"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TimeOffDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["shiftCode"] = this.shiftCode;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["status"] = this.status;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["finalizedDate"] = this.finalizedDate ? this.finalizedDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ITimeOffDto {
    id?: string;
    number?: string;
    shiftCode?: string | undefined;
    employee?: EmployeeDto;
    lastModifiedByName?: string | undefined;
    status?: TimeOffStatus;
    submittedDate?: Date;
    finalizedDate?: Date | undefined;
    description?: string;
}

export class VacationGridViewDto extends TimeOffDto implements IVacationGridViewDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    vacationDaysAvailable?: number;
    workingDays?: number;

    constructor(data?: IVacationGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
            this.vacationDaysAvailable = _data["vacationDaysAvailable"];
            this.workingDays = _data["workingDays"];
        }
    }

    static override fromJS(data: any): VacationGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacationGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        data["vacationDaysAvailable"] = this.vacationDaysAvailable;
        data["workingDays"] = this.workingDays;
        super.toJSON(data);
        return data;
    }
}

export interface IVacationGridViewDto extends ITimeOffDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    vacationDaysAvailable?: number;
    workingDays?: number;
}

export class PersonalTimesGridViewDto extends TimeOffDto implements IPersonalTimesGridViewDto {
    requestedDate?: Date;
    requestedStartTime?: string;
    requestedEndTime?: string;
    personalTimeAvailable?: number;

    constructor(data?: IPersonalTimesGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.requestedStartTime = _data["requestedStartTime"];
            this.requestedEndTime = _data["requestedEndTime"];
            this.personalTimeAvailable = _data["personalTimeAvailable"];
        }
    }

    static override fromJS(data: any): PersonalTimesGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalTimesGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedDate"] = this.requestedDate ? formatDate(this.requestedDate) : <any>undefined;
        data["requestedStartTime"] = this.requestedStartTime;
        data["requestedEndTime"] = this.requestedEndTime;
        data["personalTimeAvailable"] = this.personalTimeAvailable;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonalTimesGridViewDto extends ITimeOffDto {
    requestedDate?: Date;
    requestedStartTime?: string;
    requestedEndTime?: string;
    personalTimeAvailable?: number;
}

export class LieuDayGridViewDto extends TimeOffDto implements ILieuDayGridViewDto {
    type?: LieuDaySlotType;
    requestedDate?: Date;
    expireDate?: Date;
    takenBankSlotDate?: Date | undefined;

    constructor(data?: ILieuDayGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.takenBankSlotDate = _data["takenBankSlotDate"] ? new Date(_data["takenBankSlotDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): LieuDayGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LieuDayGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["requestedDate"] = this.requestedDate ? formatDate(this.requestedDate) : <any>undefined;
        data["expireDate"] = this.expireDate ? formatDate(this.expireDate) : <any>undefined;
        data["takenBankSlotDate"] = this.takenBankSlotDate ? formatDate(this.takenBankSlotDate) : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILieuDayGridViewDto extends ITimeOffDto {
    type?: LieuDaySlotType;
    requestedDate?: Date;
    expireDate?: Date;
    takenBankSlotDate?: Date | undefined;
}

export class LeaveOfAbsenceGridViewDto extends TimeOffDto implements ILeaveOfAbsenceGridViewDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    files?: DocumentDto[];
    workingDays?: number;

    constructor(data?: ILeaveOfAbsenceGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DocumentDto.fromJS(item));
            }
            this.workingDays = _data["workingDays"];
        }
    }

    static override fromJS(data: any): LeaveOfAbsenceGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveOfAbsenceGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["workingDays"] = this.workingDays;
        super.toJSON(data);
        return data;
    }
}

export interface ILeaveOfAbsenceGridViewDto extends ITimeOffDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    files?: DocumentDto[];
    workingDays?: number;
}

export class FloaterDayGridViewDto extends TimeOffDto implements IFloaterDayGridViewDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    floaterDaysAvailable?: number;
    workingDays?: number;

    constructor(data?: IFloaterDayGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
            this.floaterDaysAvailable = _data["floaterDaysAvailable"];
            this.workingDays = _data["workingDays"];
        }
    }

    static override fromJS(data: any): FloaterDayGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FloaterDayGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        data["floaterDaysAvailable"] = this.floaterDaysAvailable;
        data["workingDays"] = this.workingDays;
        super.toJSON(data);
        return data;
    }
}

export interface IFloaterDayGridViewDto extends ITimeOffDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    floaterDaysAvailable?: number;
    workingDays?: number;
}

export class AgencyTimeOffGridViewDto extends TimeOffDto implements IAgencyTimeOffGridViewDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    files?: DocumentDto[];
    workingDays?: number;

    constructor(data?: IAgencyTimeOffGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestedStartDate = _data["requestedStartDate"] ? new Date(_data["requestedStartDate"].toString()) : <any>undefined;
            this.requestedEndDate = _data["requestedEndDate"] ? new Date(_data["requestedEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DocumentDto.fromJS(item));
            }
            this.workingDays = _data["workingDays"];
        }
    }

    static override fromJS(data: any): AgencyTimeOffGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyTimeOffGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedStartDate"] = this.requestedStartDate ? formatDate(this.requestedStartDate) : <any>undefined;
        data["requestedEndDate"] = this.requestedEndDate ? formatDate(this.requestedEndDate) : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["workingDays"] = this.workingDays;
        super.toJSON(data);
        return data;
    }
}

export interface IAgencyTimeOffGridViewDto extends ITimeOffDto {
    requestedStartDate?: Date | undefined;
    requestedEndDate?: Date | undefined;
    files?: DocumentDto[];
    workingDays?: number;
}

export class TimeLogGridViewDto implements ITimeLogGridViewDto {
    id?: string;
    punchInStatus?: PunchInStatus | undefined;
    punchOutStatus?: PunchOutStatus | undefined;
    huddleStatus?: HuddleStatus | undefined;
    hasMealTicket?: boolean;
    checklistCompliance?: ChecklistCompliance;
    punchInTimes?: string[];
    punchOutTimes?: string[];
    lateHuddles?: LateHuddleDto[];
    checklists?: TimeLogChecklist[];
    punchDate?: Date;
    scheduledHoursSpan?: string;
    hoursWorkedSpan?: string;
    shiftCode?: string | undefined;
    shiftRate?: number | undefined;
    exceptionType?: ExceptionType;
    firstPunchInTime?: string | undefined;
    firstPunchOutTime?: string | undefined;
    shiftId?: string | undefined;
    shiftStartTime?: string | undefined;
    shiftEndTime?: string | undefined;
    shiftType?: ShiftType | undefined;
    clearingExceptionReason?: string | undefined;
    employee?: EmployeeDto;
    homeDepartmentCode?: string | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    createdByAvatar?: string | undefined;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;

    constructor(data?: ITimeLogGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.punchInStatus = _data["punchInStatus"];
            this.punchOutStatus = _data["punchOutStatus"];
            this.huddleStatus = _data["huddleStatus"];
            this.hasMealTicket = _data["hasMealTicket"];
            this.checklistCompliance = _data["checklistCompliance"];
            if (Array.isArray(_data["punchInTimes"])) {
                this.punchInTimes = [] as any;
                for (let item of _data["punchInTimes"])
                    this.punchInTimes!.push(item);
            }
            if (Array.isArray(_data["punchOutTimes"])) {
                this.punchOutTimes = [] as any;
                for (let item of _data["punchOutTimes"])
                    this.punchOutTimes!.push(item);
            }
            if (Array.isArray(_data["lateHuddles"])) {
                this.lateHuddles = [] as any;
                for (let item of _data["lateHuddles"])
                    this.lateHuddles!.push(LateHuddleDto.fromJS(item));
            }
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(TimeLogChecklist.fromJS(item));
            }
            this.punchDate = _data["punchDate"] ? new Date(_data["punchDate"].toString()) : <any>undefined;
            this.scheduledHoursSpan = _data["scheduledHoursSpan"];
            this.hoursWorkedSpan = _data["hoursWorkedSpan"];
            this.shiftCode = _data["shiftCode"];
            this.shiftRate = _data["shiftRate"];
            this.exceptionType = _data["exceptionType"];
            this.firstPunchInTime = _data["firstPunchInTime"];
            this.firstPunchOutTime = _data["firstPunchOutTime"];
            this.shiftId = _data["shiftId"];
            this.shiftStartTime = _data["shiftStartTime"];
            this.shiftEndTime = _data["shiftEndTime"];
            this.shiftType = _data["shiftType"];
            this.clearingExceptionReason = _data["clearingExceptionReason"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.homeDepartmentCode = _data["homeDepartmentCode"];
            this.createdByName = _data["createdByName"];
            this.createdByEmail = _data["createdByEmail"];
            this.createdByAvatar = _data["createdByAvatar"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeLogGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeLogGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["punchInStatus"] = this.punchInStatus;
        data["punchOutStatus"] = this.punchOutStatus;
        data["huddleStatus"] = this.huddleStatus;
        data["hasMealTicket"] = this.hasMealTicket;
        data["checklistCompliance"] = this.checklistCompliance;
        if (Array.isArray(this.punchInTimes)) {
            data["punchInTimes"] = [];
            for (let item of this.punchInTimes)
                data["punchInTimes"].push(item);
        }
        if (Array.isArray(this.punchOutTimes)) {
            data["punchOutTimes"] = [];
            for (let item of this.punchOutTimes)
                data["punchOutTimes"].push(item);
        }
        if (Array.isArray(this.lateHuddles)) {
            data["lateHuddles"] = [];
            for (let item of this.lateHuddles)
                data["lateHuddles"].push(item.toJSON());
        }
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item.toJSON());
        }
        data["punchDate"] = this.punchDate ? formatDate(this.punchDate) : <any>undefined;
        data["scheduledHoursSpan"] = this.scheduledHoursSpan;
        data["hoursWorkedSpan"] = this.hoursWorkedSpan;
        data["shiftCode"] = this.shiftCode;
        data["shiftRate"] = this.shiftRate;
        data["exceptionType"] = this.exceptionType;
        data["firstPunchInTime"] = this.firstPunchInTime;
        data["firstPunchOutTime"] = this.firstPunchOutTime;
        data["shiftId"] = this.shiftId;
        data["shiftStartTime"] = this.shiftStartTime;
        data["shiftEndTime"] = this.shiftEndTime;
        data["shiftType"] = this.shiftType;
        data["clearingExceptionReason"] = this.clearingExceptionReason;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["homeDepartmentCode"] = this.homeDepartmentCode;
        data["createdByName"] = this.createdByName;
        data["createdByEmail"] = this.createdByEmail;
        data["createdByAvatar"] = this.createdByAvatar;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITimeLogGridViewDto {
    id?: string;
    punchInStatus?: PunchInStatus | undefined;
    punchOutStatus?: PunchOutStatus | undefined;
    huddleStatus?: HuddleStatus | undefined;
    hasMealTicket?: boolean;
    checklistCompliance?: ChecklistCompliance;
    punchInTimes?: string[];
    punchOutTimes?: string[];
    lateHuddles?: LateHuddleDto[];
    checklists?: TimeLogChecklist[];
    punchDate?: Date;
    scheduledHoursSpan?: string;
    hoursWorkedSpan?: string;
    shiftCode?: string | undefined;
    shiftRate?: number | undefined;
    exceptionType?: ExceptionType;
    firstPunchInTime?: string | undefined;
    firstPunchOutTime?: string | undefined;
    shiftId?: string | undefined;
    shiftStartTime?: string | undefined;
    shiftEndTime?: string | undefined;
    shiftType?: ShiftType | undefined;
    clearingExceptionReason?: string | undefined;
    employee?: EmployeeDto;
    homeDepartmentCode?: string | undefined;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    createdByAvatar?: string | undefined;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
}

export enum PunchInStatus {
    OnTime = "OnTime",
    ArrivedLate = "ArrivedLate",
    Exception = "Exception",
    Absent = "Absent",
}

export enum PunchOutStatus {
    Exception = "Exception",
    LeftEarly = "LeftEarly",
    OnTime = "OnTime",
    Overtime = "Overtime",
    Absent = "Absent",
}

export enum HuddleStatus {
    OnTime = "OnTime",
    Late = "Late",
}

export enum ChecklistCompliance {
    None = "None",
    Created = "Created",
    Missing = "Missing",
}

export class LateHuddleDto implements ILateHuddleDto {
    initiator?: HuddleInitiator;
    createdBy?: string | undefined;
    created?: Date | undefined;

    constructor(data?: ILateHuddleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiator = _data["initiator"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LateHuddleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LateHuddleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiator"] = this.initiator;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILateHuddleDto {
    initiator?: HuddleInitiator;
    createdBy?: string | undefined;
    created?: Date | undefined;
}

export enum HuddleInitiator {
    System = "System",
    User = "User",
}

export class TimeLogChecklist implements ITimeLogChecklist {
    checklistId?: string | undefined;
    number?: string | undefined;
    created?: Date;

    constructor(data?: ITimeLogChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistId = _data["checklistId"];
            this.number = _data["number"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeLogChecklist {
        data = typeof data === 'object' ? data : {};
        let result = new TimeLogChecklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistId"] = this.checklistId;
        data["number"] = this.number;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITimeLogChecklist {
    checklistId?: string | undefined;
    number?: string | undefined;
    created?: Date;
}

export enum ExceptionType {
    None = "None",
    Absent = "Absent",
    MissingPunch = "MissingPunch",
    DoublePunch = "DoublePunch",
    UnscheduledShift = "UnscheduledShift",
}

export class ShuntLocationOptionDto implements IShuntLocationOptionDto {
    id?: string;
    number?: string;

    constructor(data?: IShuntLocationOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): ShuntLocationOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShuntLocationOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        return data;
    }
}

export interface IShuntLocationOptionDto {
    id?: string;
    number?: string;
}

export class ShiftGridViewDto implements IShiftGridViewDto {
    id?: string;
    code?: string;
    days?: DayOfWeek[];
    supervisor?: EmployeeDto;
    shiftType?: ShiftType;
    shiftStart?: string;
    shiftEnd?: string;
    created?: Date;
    premiumRate?: number;
    locked?: boolean;
    hasMealTicked?: boolean;
    showInHuddle?: boolean;

    constructor(data?: IShiftGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            this.supervisor = _data["supervisor"] ? EmployeeDto.fromJS(_data["supervisor"]) : <any>undefined;
            this.shiftType = _data["shiftType"];
            this.shiftStart = _data["shiftStart"];
            this.shiftEnd = _data["shiftEnd"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.premiumRate = _data["premiumRate"];
            this.locked = _data["locked"];
            this.hasMealTicked = _data["hasMealTicked"];
            this.showInHuddle = _data["showInHuddle"];
        }
    }

    static fromJS(data: any): ShiftGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["supervisor"] = this.supervisor ? this.supervisor.toJSON() : <any>undefined;
        data["shiftType"] = this.shiftType;
        data["shiftStart"] = this.shiftStart;
        data["shiftEnd"] = this.shiftEnd;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["premiumRate"] = this.premiumRate;
        data["locked"] = this.locked;
        data["hasMealTicked"] = this.hasMealTicked;
        data["showInHuddle"] = this.showInHuddle;
        return data;
    }
}

export interface IShiftGridViewDto {
    id?: string;
    code?: string;
    days?: DayOfWeek[];
    supervisor?: EmployeeDto;
    shiftType?: ShiftType;
    shiftStart?: string;
    shiftEnd?: string;
    created?: Date;
    premiumRate?: number;
    locked?: boolean;
    hasMealTicked?: boolean;
    showInHuddle?: boolean;
}

export class ShiftOptionDto implements IShiftOptionDto {
    id?: string;
    code?: string;
    type?: ShiftType;
    startTime?: string;
    endTime?: string;
    name?: string;

    constructor(data?: IShiftOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ShiftOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["name"] = this.name;
        return data;
    }
}

export interface IShiftOptionDto {
    id?: string;
    code?: string;
    type?: ShiftType;
    startTime?: string;
    endTime?: string;
    name?: string;
}

export class IncidentReportGridViewDto implements IIncidentReportGridViewDto {
    id?: string;
    number?: string;
    incidentDate?: Date;
    status?: IncidentStatus;
    category?: IncidentCategory;
    location?: IncidentLocation;
    employee?: EmployeeDto | undefined;
    externalName?: string | undefined;
    humanResourcesContacted?: boolean;
    type?: IncidentType;
    injuryType?: InjuryType;
    outsideMedical?: boolean;
    shiftCode?: string;
    emsCalled?: boolean;
    firstAidAdministered?: boolean;
    lostTime?: boolean;
    created?: Date;
    createdBy?: EmployeeDto | undefined;
    lastModified?: Date;
    lastModifiedBy?: EmployeeDto | undefined;

    constructor(data?: IIncidentReportGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.incidentDate = _data["incidentDate"] ? new Date(_data["incidentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.category = _data["category"];
            this.location = _data["location"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.externalName = _data["externalName"];
            this.humanResourcesContacted = _data["humanResourcesContacted"];
            this.type = _data["type"];
            this.injuryType = _data["injuryType"];
            this.outsideMedical = _data["outsideMedical"];
            this.shiftCode = _data["shiftCode"];
            this.emsCalled = _data["emsCalled"];
            this.firstAidAdministered = _data["firstAidAdministered"];
            this.lostTime = _data["lostTime"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IncidentReportGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentReportGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["incidentDate"] = this.incidentDate ? this.incidentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["category"] = this.category;
        data["location"] = this.location;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["externalName"] = this.externalName;
        data["humanResourcesContacted"] = this.humanResourcesContacted;
        data["type"] = this.type;
        data["injuryType"] = this.injuryType;
        data["outsideMedical"] = this.outsideMedical;
        data["shiftCode"] = this.shiftCode;
        data["emsCalled"] = this.emsCalled;
        data["firstAidAdministered"] = this.firstAidAdministered;
        data["lostTime"] = this.lostTime;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIncidentReportGridViewDto {
    id?: string;
    number?: string;
    incidentDate?: Date;
    status?: IncidentStatus;
    category?: IncidentCategory;
    location?: IncidentLocation;
    employee?: EmployeeDto | undefined;
    externalName?: string | undefined;
    humanResourcesContacted?: boolean;
    type?: IncidentType;
    injuryType?: InjuryType;
    outsideMedical?: boolean;
    shiftCode?: string;
    emsCalled?: boolean;
    firstAidAdministered?: boolean;
    lostTime?: boolean;
    created?: Date;
    createdBy?: EmployeeDto | undefined;
    lastModified?: Date;
    lastModifiedBy?: EmployeeDto | undefined;
}

export class ChecklistGridViewDto implements IChecklistGridViewDto {
    id?: string;
    number?: string;
    employee?: EmployeeDto;
    machineNumber?: string | undefined;
    equipmentNumber?: string | undefined;
    assetType?: AssetType;
    condition?: ChecklistCondition;
    created?: Date;

    constructor(data?: IChecklistGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.machineNumber = _data["machineNumber"];
            this.equipmentNumber = _data["equipmentNumber"];
            this.assetType = _data["assetType"];
            this.condition = _data["condition"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChecklistGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["machineNumber"] = this.machineNumber;
        data["equipmentNumber"] = this.equipmentNumber;
        data["assetType"] = this.assetType;
        data["condition"] = this.condition;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChecklistGridViewDto {
    id?: string;
    number?: string;
    employee?: EmployeeDto;
    machineNumber?: string | undefined;
    equipmentNumber?: string | undefined;
    assetType?: AssetType;
    condition?: ChecklistCondition;
    created?: Date;
}

export class RoleGridViewDto implements IRoleGridViewDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    userCount?: number;
    created?: Date;

    constructor(data?: IRoleGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.userCount = _data["userCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["userCount"] = this.userCount;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRoleGridViewDto {
    id?: string;
    name?: string;
    description?: string | undefined;
    userCount?: number;
    created?: Date;
}

export class YearToDateGridViewDto implements IYearToDateGridViewDto {
    id?: string;
    looseCpPercentage?: number;
    layerPickPercentage?: number;
    looseCases?: number;
    fullCasesFert?: number;
    fullPalletsFertFpPickedOnly?: number;
    clubPackCasesPicked?: number;
    clubPackPalletsCpPickedOnly?: number;
    layerCases?: number;
    fertReceivedCases?: number;
    fertReceivedPallets?: number;
    clubPackReceivedCases?: number;
    clubPackReceivedPallets?: number;
    putsCasesFert?: number;
    outboundCases?: number;
    inboundCases?: number;
    throughput?: number;
    mpsPallets?: number;
    refill?: number;
    refillLayer?: number;
    totalRefill?: number;
    partialIns?: number;
    palletsReceivedAll?: number;
    fullPalletVolumePallets?: number;
    dateKey?: number;
    date?: Date;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
    createdBy?: EmployeeDto | undefined;
    created?: Date;

    constructor(data?: IYearToDateGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.looseCpPercentage = _data["looseCpPercentage"];
            this.layerPickPercentage = _data["layerPickPercentage"];
            this.looseCases = _data["looseCases"];
            this.fullCasesFert = _data["fullCasesFert"];
            this.fullPalletsFertFpPickedOnly = _data["fullPalletsFertFpPickedOnly"];
            this.clubPackCasesPicked = _data["clubPackCasesPicked"];
            this.clubPackPalletsCpPickedOnly = _data["clubPackPalletsCpPickedOnly"];
            this.layerCases = _data["layerCases"];
            this.fertReceivedCases = _data["fertReceivedCases"];
            this.fertReceivedPallets = _data["fertReceivedPallets"];
            this.clubPackReceivedCases = _data["clubPackReceivedCases"];
            this.clubPackReceivedPallets = _data["clubPackReceivedPallets"];
            this.putsCasesFert = _data["putsCasesFert"];
            this.outboundCases = _data["outboundCases"];
            this.inboundCases = _data["inboundCases"];
            this.throughput = _data["throughput"];
            this.mpsPallets = _data["mpsPallets"];
            this.refill = _data["refill"];
            this.refillLayer = _data["refillLayer"];
            this.totalRefill = _data["totalRefill"];
            this.partialIns = _data["partialIns"];
            this.palletsReceivedAll = _data["palletsReceivedAll"];
            this.fullPalletVolumePallets = _data["fullPalletVolumePallets"];
            this.dateKey = _data["dateKey"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): YearToDateGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearToDateGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["looseCpPercentage"] = this.looseCpPercentage;
        data["layerPickPercentage"] = this.layerPickPercentage;
        data["looseCases"] = this.looseCases;
        data["fullCasesFert"] = this.fullCasesFert;
        data["fullPalletsFertFpPickedOnly"] = this.fullPalletsFertFpPickedOnly;
        data["clubPackCasesPicked"] = this.clubPackCasesPicked;
        data["clubPackPalletsCpPickedOnly"] = this.clubPackPalletsCpPickedOnly;
        data["layerCases"] = this.layerCases;
        data["fertReceivedCases"] = this.fertReceivedCases;
        data["fertReceivedPallets"] = this.fertReceivedPallets;
        data["clubPackReceivedCases"] = this.clubPackReceivedCases;
        data["clubPackReceivedPallets"] = this.clubPackReceivedPallets;
        data["putsCasesFert"] = this.putsCasesFert;
        data["outboundCases"] = this.outboundCases;
        data["inboundCases"] = this.inboundCases;
        data["throughput"] = this.throughput;
        data["mpsPallets"] = this.mpsPallets;
        data["refill"] = this.refill;
        data["refillLayer"] = this.refillLayer;
        data["totalRefill"] = this.totalRefill;
        data["partialIns"] = this.partialIns;
        data["palletsReceivedAll"] = this.palletsReceivedAll;
        data["fullPalletVolumePallets"] = this.fullPalletVolumePallets;
        data["dateKey"] = this.dateKey;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IYearToDateGridViewDto {
    id?: string;
    looseCpPercentage?: number;
    layerPickPercentage?: number;
    looseCases?: number;
    fullCasesFert?: number;
    fullPalletsFertFpPickedOnly?: number;
    clubPackCasesPicked?: number;
    clubPackPalletsCpPickedOnly?: number;
    layerCases?: number;
    fertReceivedCases?: number;
    fertReceivedPallets?: number;
    clubPackReceivedCases?: number;
    clubPackReceivedPallets?: number;
    putsCasesFert?: number;
    outboundCases?: number;
    inboundCases?: number;
    throughput?: number;
    mpsPallets?: number;
    refill?: number;
    refillLayer?: number;
    totalRefill?: number;
    partialIns?: number;
    palletsReceivedAll?: number;
    fullPalletVolumePallets?: number;
    dateKey?: number;
    date?: Date;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
    createdBy?: EmployeeDto | undefined;
    created?: Date;
}

export class ProductivitySettingGridViewDto implements IProductivitySettingGridViewDto {
    id?: string;
    value?: number;
    month?: Month;
    year?: number;
    created?: Date;

    constructor(data?: IProductivitySettingGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductivitySettingGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductivitySettingGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["month"] = this.month;
        data["year"] = this.year;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductivitySettingGridViewDto {
    id?: string;
    value?: number;
    month?: Month;
    year?: number;
    created?: Date;
}

export class PerformanceGridViewDto implements IPerformanceGridViewDto {
    id?: string;
    date?: Date;
    type?: ProductivityReportType;
    dateKey?: number;
    volume?: number;
    stdTotal?: number;
    stdHours?: number;
    efficiencyPercent?: number;
    efficiencyPercentChange?: number | undefined;
    casesPerHour?: number;
    casesPerHourPercentChange?: number | undefined;
    palletPerHour?: number;

    constructor(data?: IPerformanceGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.dateKey = _data["dateKey"];
            this.volume = _data["volume"];
            this.stdTotal = _data["stdTotal"];
            this.stdHours = _data["stdHours"];
            this.efficiencyPercent = _data["efficiencyPercent"];
            this.efficiencyPercentChange = _data["efficiencyPercentChange"];
            this.casesPerHour = _data["casesPerHour"];
            this.casesPerHourPercentChange = _data["casesPerHourPercentChange"];
            this.palletPerHour = _data["palletPerHour"];
        }
    }

    static fromJS(data: any): PerformanceGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["dateKey"] = this.dateKey;
        data["volume"] = this.volume;
        data["stdTotal"] = this.stdTotal;
        data["stdHours"] = this.stdHours;
        data["efficiencyPercent"] = this.efficiencyPercent;
        data["efficiencyPercentChange"] = this.efficiencyPercentChange;
        data["casesPerHour"] = this.casesPerHour;
        data["casesPerHourPercentChange"] = this.casesPerHourPercentChange;
        data["palletPerHour"] = this.palletPerHour;
        return data;
    }
}

export interface IPerformanceGridViewDto {
    id?: string;
    date?: Date;
    type?: ProductivityReportType;
    dateKey?: number;
    volume?: number;
    stdTotal?: number;
    stdHours?: number;
    efficiencyPercent?: number;
    efficiencyPercentChange?: number | undefined;
    casesPerHour?: number;
    casesPerHourPercentChange?: number | undefined;
    palletPerHour?: number;
}

export enum ProductivityReportType {
    CasePicking = "CasePicking",
    LayerPicking = "LayerPicking",
    PalletPicking = "PalletPicking",
    Putaway = "Putaway",
    Refill = "Refill",
}

export class NextViewGridViewDto implements INextViewGridViewDto {
    id?: string;
    employee?: EmployeeDto | undefined;
    employeeName?: string | undefined;
    positionId?: string | undefined;
    status?: EmployeeStatus;
    shift?: string | undefined;
    type?: ProductivityReportType;
    stdTotal?: number;
    stdHours?: number;
    efficiency?: number;
    dateKey?: number;
    date?: Date;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
    createdBy?: EmployeeDto | undefined;
    created?: Date;

    constructor(data?: INextViewGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.employeeName = _data["employeeName"];
            this.positionId = _data["positionId"];
            this.status = _data["status"];
            this.shift = _data["shift"];
            this.type = _data["type"];
            this.stdTotal = _data["stdTotal"];
            this.stdHours = _data["stdHours"];
            this.efficiency = _data["efficiency"];
            this.dateKey = _data["dateKey"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NextViewGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new NextViewGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["employeeName"] = this.employeeName;
        data["positionId"] = this.positionId;
        data["status"] = this.status;
        data["shift"] = this.shift;
        data["type"] = this.type;
        data["stdTotal"] = this.stdTotal;
        data["stdHours"] = this.stdHours;
        data["efficiency"] = this.efficiency;
        data["dateKey"] = this.dateKey;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface INextViewGridViewDto {
    id?: string;
    employee?: EmployeeDto | undefined;
    employeeName?: string | undefined;
    positionId?: string | undefined;
    status?: EmployeeStatus;
    shift?: string | undefined;
    type?: ProductivityReportType;
    stdTotal?: number;
    stdHours?: number;
    efficiency?: number;
    dateKey?: number;
    date?: Date;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
    createdBy?: EmployeeDto | undefined;
    created?: Date;
}

export enum EmployeeStatus {
    Active = "Active",
    Inactive = "Inactive",
    Exception = "Exception",
}

export class ShipmentOptionDto implements IShipmentOptionDto {
    logisticalGroup?: string;

    constructor(data?: IShipmentOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logisticalGroup = _data["logisticalGroup"];
        }
    }

    static fromJS(data: any): ShipmentOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logisticalGroup"] = this.logisticalGroup;
        return data;
    }
}

export interface IShipmentOptionDto {
    logisticalGroup?: string;
}

export class LoadGridViewDto implements ILoadGridViewDto {
    logisticalGroup?: string;
    stagingArea?: string | undefined;
    overallWmStatus?: string | undefined;
    productionStatuses?: ProductionStatus[];
    emptyTrailerNumber?: string | undefined;
    outboundNumber?: string | undefined;
    hasDataConflict?: boolean;
    casePick?: number;
    layerPick?: number;
    palletPick?: number;
    missedOpportunities?: MissedOpportunity[];
    appointmentStatuses?: OrderAppointmentStatus[];
    mdts?: Date[];
    appointments?: Date[];
    latestMdt?: Date | undefined;
    latestAppointment?: Date | undefined;
    shipToId?: string | undefined;
    shipToName?: string | undefined;
    shipToStreetNumber?: string | undefined;
    shipToStreet?: string | undefined;
    shipToCity?: string | undefined;
    shipToRegion?: string | undefined;
    shipToPostalCode?: string | undefined;

    constructor(data?: ILoadGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logisticalGroup = _data["logisticalGroup"];
            this.stagingArea = _data["stagingArea"];
            this.overallWmStatus = _data["overallWmStatus"];
            if (Array.isArray(_data["productionStatuses"])) {
                this.productionStatuses = [] as any;
                for (let item of _data["productionStatuses"])
                    this.productionStatuses!.push(item);
            }
            this.emptyTrailerNumber = _data["emptyTrailerNumber"];
            this.outboundNumber = _data["outboundNumber"];
            this.hasDataConflict = _data["hasDataConflict"];
            this.casePick = _data["casePick"];
            this.layerPick = _data["layerPick"];
            this.palletPick = _data["palletPick"];
            if (Array.isArray(_data["missedOpportunities"])) {
                this.missedOpportunities = [] as any;
                for (let item of _data["missedOpportunities"])
                    this.missedOpportunities!.push(item);
            }
            if (Array.isArray(_data["appointmentStatuses"])) {
                this.appointmentStatuses = [] as any;
                for (let item of _data["appointmentStatuses"])
                    this.appointmentStatuses!.push(item);
            }
            if (Array.isArray(_data["mdts"])) {
                this.mdts = [] as any;
                for (let item of _data["mdts"])
                    this.mdts!.push(new Date(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(new Date(item));
            }
            this.latestMdt = _data["latestMdt"] ? new Date(_data["latestMdt"].toString()) : <any>undefined;
            this.latestAppointment = _data["latestAppointment"] ? new Date(_data["latestAppointment"].toString()) : <any>undefined;
            this.shipToId = _data["shipToId"];
            this.shipToName = _data["shipToName"];
            this.shipToStreetNumber = _data["shipToStreetNumber"];
            this.shipToStreet = _data["shipToStreet"];
            this.shipToCity = _data["shipToCity"];
            this.shipToRegion = _data["shipToRegion"];
            this.shipToPostalCode = _data["shipToPostalCode"];
        }
    }

    static fromJS(data: any): LoadGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logisticalGroup"] = this.logisticalGroup;
        data["stagingArea"] = this.stagingArea;
        data["overallWmStatus"] = this.overallWmStatus;
        if (Array.isArray(this.productionStatuses)) {
            data["productionStatuses"] = [];
            for (let item of this.productionStatuses)
                data["productionStatuses"].push(item);
        }
        data["emptyTrailerNumber"] = this.emptyTrailerNumber;
        data["outboundNumber"] = this.outboundNumber;
        data["hasDataConflict"] = this.hasDataConflict;
        data["casePick"] = this.casePick;
        data["layerPick"] = this.layerPick;
        data["palletPick"] = this.palletPick;
        if (Array.isArray(this.missedOpportunities)) {
            data["missedOpportunities"] = [];
            for (let item of this.missedOpportunities)
                data["missedOpportunities"].push(item);
        }
        if (Array.isArray(this.appointmentStatuses)) {
            data["appointmentStatuses"] = [];
            for (let item of this.appointmentStatuses)
                data["appointmentStatuses"].push(item);
        }
        if (Array.isArray(this.mdts)) {
            data["mdts"] = [];
            for (let item of this.mdts)
                data["mdts"].push(item.toISOString());
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toISOString());
        }
        data["latestMdt"] = this.latestMdt ? this.latestMdt.toISOString() : <any>undefined;
        data["latestAppointment"] = this.latestAppointment ? this.latestAppointment.toISOString() : <any>undefined;
        data["shipToId"] = this.shipToId;
        data["shipToName"] = this.shipToName;
        data["shipToStreetNumber"] = this.shipToStreetNumber;
        data["shipToStreet"] = this.shipToStreet;
        data["shipToCity"] = this.shipToCity;
        data["shipToRegion"] = this.shipToRegion;
        data["shipToPostalCode"] = this.shipToPostalCode;
        return data;
    }
}

export interface ILoadGridViewDto {
    logisticalGroup?: string;
    stagingArea?: string | undefined;
    overallWmStatus?: string | undefined;
    productionStatuses?: ProductionStatus[];
    emptyTrailerNumber?: string | undefined;
    outboundNumber?: string | undefined;
    hasDataConflict?: boolean;
    casePick?: number;
    layerPick?: number;
    palletPick?: number;
    missedOpportunities?: MissedOpportunity[];
    appointmentStatuses?: OrderAppointmentStatus[];
    mdts?: Date[];
    appointments?: Date[];
    latestMdt?: Date | undefined;
    latestAppointment?: Date | undefined;
    shipToId?: string | undefined;
    shipToName?: string | undefined;
    shipToStreetNumber?: string | undefined;
    shipToStreet?: string | undefined;
    shipToCity?: string | undefined;
    shipToRegion?: string | undefined;
    shipToPostalCode?: string | undefined;
}

export class OrderHistoryGridViewDto implements IOrderHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto | undefined;
    created?: Date;
    level?: OrderHistoryLevel;
    kind?: OrderHistoryKind;
    typeLabel?: string;
    salesDocumentItem?: string | undefined;
    referenceItem?: string | undefined;
    field?: OrderHistoryField | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    oldValueDate?: Date | undefined;
    newValueDate?: Date | undefined;

    constructor(data?: IOrderHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.level = _data["level"];
            this.kind = _data["kind"];
            this.typeLabel = _data["typeLabel"];
            this.salesDocumentItem = _data["salesDocumentItem"];
            this.referenceItem = _data["referenceItem"];
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.oldValueDate = _data["oldValueDate"] ? new Date(_data["oldValueDate"].toString()) : <any>undefined;
            this.newValueDate = _data["newValueDate"] ? new Date(_data["newValueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["level"] = this.level;
        data["kind"] = this.kind;
        data["typeLabel"] = this.typeLabel;
        data["salesDocumentItem"] = this.salesDocumentItem;
        data["referenceItem"] = this.referenceItem;
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["oldValueDate"] = this.oldValueDate ? this.oldValueDate.toISOString() : <any>undefined;
        data["newValueDate"] = this.newValueDate ? this.newValueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto | undefined;
    created?: Date;
    level?: OrderHistoryLevel;
    kind?: OrderHistoryKind;
    typeLabel?: string;
    salesDocumentItem?: string | undefined;
    referenceItem?: string | undefined;
    field?: OrderHistoryField | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    oldValueDate?: Date | undefined;
    newValueDate?: Date | undefined;
}

export enum OrderHistoryLevel {
    Header = "Header",
    Line = "Line",
}

export enum OrderHistoryKind {
    FieldChange = "FieldChange",
    LineAdded = "LineAdded",
    LineRemoved = "LineRemoved",
}

export enum OrderHistoryField {
    LogisticalGroup = "LogisticalGroup",
    DeliveryNumber = "DeliveryNumber",
    SalesOrganization = "SalesOrganization",
    PreProductionStatus = "PreProductionStatus",
    DeliveryCreated = "DeliveryCreated",
    DocumentDate = "DocumentDate",
    StagingArea = "StagingArea",
    OverallWmStatus = "OverallWmStatus",
    ProductionStatus = "ProductionStatus",
    RequestedDeliveryDate = "RequestedDeliveryDate",
    DeliveryAppointment = "DeliveryAppointment",
    Loading = "Loading",
    DeliveryDateTime = "DeliveryDateTime",
    SourceLocationAppointmentDate = "SourceLocationAppointmentDate",
    DestinationLocationAppointmentDate = "DestinationLocationAppointmentDate",
    DestinationLocationAppointmentTimeZone = "DestinationLocationAppointmentTimeZone",
    AppointmentStatus = "AppointmentStatus",
    Appointment = "Appointment",
    AppointmentOverride = "AppointmentOverride",
    Mdt = "Mdt",
    HeaderException = "HeaderException",
    EmptyTrailer = "EmptyTrailer",
    Outbound = "Outbound",
    ShipToId = "ShipToId",
    ShipToName = "ShipToName",
    ShipToStreet = "ShipToStreet",
    ShipToStreetNumber = "ShipToStreetNumber",
    ShipToCity = "ShipToCity",
    ShipToRegion = "ShipToRegion",
    ShipToPostalCode = "ShipToPostalCode",
    PoNumber = "PoNumber",
    ProductionItem = "ProductionItem",
    ReasonForRejection = "ReasonForRejection",
    Batch = "Batch",
    OrderQuantity = "OrderQuantity",
    OrderConfirmedQuantity = "OrderConfirmedQuantity",
    ActualQuantityDelivered = "ActualQuantityDelivered",
    DeliveryQuantity = "DeliveryQuantity",
    WmActivityStatus = "WmActivityStatus",
    OverallPickStatus = "OverallPickStatus",
    Exceptions = "Exceptions",
    CasesPerLayer = "CasesPerLayer",
    CasesPerPallet = "CasesPerPallet",
    MissedOpportunity = "MissedOpportunity",
}

export class EmptyCheckOutGridViewDto implements IEmptyCheckOutGridViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    driverName?: string | undefined;
    tractor?: string | undefined;
    isTrailerEmpty?: boolean | undefined;
    sealNumber?: string | undefined;
    location?: ShuntLocationType | undefined;
    shuntLocationNumber?: string | undefined;
    status?: EmptyCheckOutStatus;
    created?: Date;
    createdBy?: EmployeeDto;

    constructor(data?: IEmptyCheckOutGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.carrier = _data["carrier"];
            this.trailerType = _data["trailerType"];
            this.trailerNumber = _data["trailerNumber"];
            this.driverName = _data["driverName"];
            this.tractor = _data["tractor"];
            this.isTrailerEmpty = _data["isTrailerEmpty"];
            this.sealNumber = _data["sealNumber"];
            this.location = _data["location"];
            this.shuntLocationNumber = _data["shuntLocationNumber"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyCheckOutGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCheckOutGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["carrier"] = this.carrier;
        data["trailerType"] = this.trailerType;
        data["trailerNumber"] = this.trailerNumber;
        data["driverName"] = this.driverName;
        data["tractor"] = this.tractor;
        data["isTrailerEmpty"] = this.isTrailerEmpty;
        data["sealNumber"] = this.sealNumber;
        data["location"] = this.location;
        data["shuntLocationNumber"] = this.shuntLocationNumber;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmptyCheckOutGridViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerType?: TrailerType;
    trailerNumber?: string;
    driverName?: string | undefined;
    tractor?: string | undefined;
    isTrailerEmpty?: boolean | undefined;
    sealNumber?: string | undefined;
    location?: ShuntLocationType | undefined;
    shuntLocationNumber?: string | undefined;
    status?: EmptyCheckOutStatus;
    created?: Date;
    createdBy?: EmployeeDto;
}

export class EmptyCheckOutHistoryGridViewDto implements IEmptyCheckOutHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    status?: EmptyCheckOutStatus;
    location?: ShuntLocationType | undefined;
    number?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    notes?: string | undefined;
    created?: Date;

    constructor(data?: IEmptyCheckOutHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.status = _data["status"];
            this.location = _data["location"];
            this.number = _data["number"];
            this.shuntPriority = _data["shuntPriority"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyCheckOutHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCheckOutHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["location"] = this.location;
        data["number"] = this.number;
        data["shuntPriority"] = this.shuntPriority;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmptyCheckOutHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    status?: EmptyCheckOutStatus;
    location?: ShuntLocationType | undefined;
    number?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    notes?: string | undefined;
    created?: Date;
}

export class CustomerOptionDto implements ICustomerOptionDto {
    id?: string;
    name?: string;

    constructor(data?: ICustomerOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomerOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICustomerOptionDto {
    id?: string;
    name?: string;
}

export class CustomerGridViewDto implements ICustomerGridViewDto {
    id?: string;
    number?: string;
    status?: CustomerStatus;
    name?: string;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    lastModified?: Date;

    constructor(data?: ICustomerGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerGridViewDto {
    id?: string;
    number?: string;
    status?: CustomerStatus;
    name?: string;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    lastModified?: Date;
}

export class MustDepartTimeGridViewDto implements IMustDepartTimeGridViewDto {
    id?: string;
    city?: string;
    province?: Province;
    country?: Country;
    shipToTimeZone?: ShipToTimeZone;
    dropToHdcHours?: number;
    mdtHopewell?: string | undefined;
    travelTimeHours?: number;

    constructor(data?: IMustDepartTimeGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
            this.shipToTimeZone = _data["shipToTimeZone"];
            this.dropToHdcHours = _data["dropToHdcHours"];
            this.mdtHopewell = _data["mdtHopewell"];
            this.travelTimeHours = _data["travelTimeHours"];
        }
    }

    static fromJS(data: any): MustDepartTimeGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MustDepartTimeGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        data["shipToTimeZone"] = this.shipToTimeZone;
        data["dropToHdcHours"] = this.dropToHdcHours;
        data["mdtHopewell"] = this.mdtHopewell;
        data["travelTimeHours"] = this.travelTimeHours;
        return data;
    }
}

export interface IMustDepartTimeGridViewDto {
    id?: string;
    city?: string;
    province?: Province;
    country?: Country;
    shipToTimeZone?: ShipToTimeZone;
    dropToHdcHours?: number;
    mdtHopewell?: string | undefined;
    travelTimeHours?: number;
}

export class VendorOptionDto implements IVendorOptionDto {
    id?: string;
    name?: string;
    status?: VendorStatus;

    constructor(data?: IVendorOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VendorOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }
}

export interface IVendorOptionDto {
    id?: string;
    name?: string;
    status?: VendorStatus;
}

export class VendorGridViewDto implements IVendorGridViewDto {
    id?: string;
    number?: string;
    status?: VendorStatus;
    term?: VendorTerm;
    name?: string;
    serviceTypeName?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    glCodeName?: string | undefined;
    sites?: string[];
    contractExpirationDate?: Date | undefined;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
    createdBy?: EmployeeDto | undefined;
    created?: Date;

    constructor(data?: IVendorGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.term = _data["term"];
            this.name = _data["name"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.glCodeName = _data["glCodeName"];
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(item);
            }
            this.contractExpirationDate = _data["contractExpirationDate"] ? new Date(_data["contractExpirationDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["term"] = this.term;
        data["name"] = this.name;
        data["serviceTypeName"] = this.serviceTypeName;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["glCodeName"] = this.glCodeName;
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item);
        }
        data["contractExpirationDate"] = this.contractExpirationDate ? this.contractExpirationDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVendorGridViewDto {
    id?: string;
    number?: string;
    status?: VendorStatus;
    term?: VendorTerm;
    name?: string;
    serviceTypeName?: string | undefined;
    address?: string;
    phone?: string | undefined;
    email?: string | undefined;
    glCodeName?: string | undefined;
    sites?: string[];
    contractExpirationDate?: Date | undefined;
    lastModifiedBy?: EmployeeDto | undefined;
    lastModified?: Date;
    createdBy?: EmployeeDto | undefined;
    created?: Date;
}

export class ServiceTypeOptionDto implements IServiceTypeOptionDto {
    id?: string;
    name?: string;
    hasActiveVendors?: boolean;

    constructor(data?: IServiceTypeOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hasActiveVendors = _data["hasActiveVendors"];
        }
    }

    static fromJS(data: any): ServiceTypeOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hasActiveVendors"] = this.hasActiveVendors;
        return data;
    }
}

export interface IServiceTypeOptionDto {
    id?: string;
    name?: string;
    hasActiveVendors?: boolean;
}

export class ServiceTypeGridViewDto implements IServiceTypeGridViewDto {
    id?: string;
    name?: string;

    constructor(data?: IServiceTypeGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceTypeGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceTypeGridViewDto {
    id?: string;
    name?: string;
}

export class InvoicePurchaseOrderOptionDto implements IInvoicePurchaseOrderOptionDto {
    id?: string;
    number?: string;

    constructor(data?: IInvoicePurchaseOrderOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): InvoicePurchaseOrderOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePurchaseOrderOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        return data;
    }
}

export interface IInvoicePurchaseOrderOptionDto {
    id?: string;
    number?: string;
}

export abstract class FinancialDocumentGridViewDto implements IFinancialDocumentGridViewDto {
    id?: string;
    number?: string;
    serviceType?: string;
    vendor?: string;
    billToName?: string | undefined;
    currency?: CurrencyCode;
    conversionRate?: number | undefined;
    subTotal?: number;
    taxAmount?: number;
    totalAmount?: number;
    convertedSubTotal?: number | undefined;
    convertedTaxAmount?: number | undefined;
    convertedTotalAmount?: number | undefined;
    issueDate?: Date;
    dueDate?: Date;

    constructor(data?: IFinancialDocumentGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.serviceType = _data["serviceType"];
            this.vendor = _data["vendor"];
            this.billToName = _data["billToName"];
            this.currency = _data["currency"];
            this.conversionRate = _data["conversionRate"];
            this.subTotal = _data["subTotal"];
            this.taxAmount = _data["taxAmount"];
            this.totalAmount = _data["totalAmount"];
            this.convertedSubTotal = _data["convertedSubTotal"];
            this.convertedTaxAmount = _data["convertedTaxAmount"];
            this.convertedTotalAmount = _data["convertedTotalAmount"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialDocumentGridViewDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FinancialDocumentGridViewDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["serviceType"] = this.serviceType;
        data["vendor"] = this.vendor;
        data["billToName"] = this.billToName;
        data["currency"] = this.currency;
        data["conversionRate"] = this.conversionRate;
        data["subTotal"] = this.subTotal;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["convertedSubTotal"] = this.convertedSubTotal;
        data["convertedTaxAmount"] = this.convertedTaxAmount;
        data["convertedTotalAmount"] = this.convertedTotalAmount;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFinancialDocumentGridViewDto {
    id?: string;
    number?: string;
    serviceType?: string;
    vendor?: string;
    billToName?: string | undefined;
    currency?: CurrencyCode;
    conversionRate?: number | undefined;
    subTotal?: number;
    taxAmount?: number;
    totalAmount?: number;
    convertedSubTotal?: number | undefined;
    convertedTaxAmount?: number | undefined;
    convertedTotalAmount?: number | undefined;
    issueDate?: Date;
    dueDate?: Date;
}

export class InvoicePurchaseOrderGridViewDto extends FinancialDocumentGridViewDto implements IInvoicePurchaseOrderGridViewDto {
    status?: InvoicePurchaseOrderStatus;

    constructor(data?: IInvoicePurchaseOrderGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): InvoicePurchaseOrderGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePurchaseOrderGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicePurchaseOrderGridViewDto extends IFinancialDocumentGridViewDto {
    status?: InvoicePurchaseOrderStatus;
}

export class InvoicePurchaseOrderHistoryGridViewDto implements IInvoicePurchaseOrderHistoryGridViewDto {
    id?: string;
    createdBy?: EmployeeDto | undefined;
    status?: InvoicePurchaseOrderStatus;
    created?: Date;

    constructor(data?: IInvoicePurchaseOrderHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicePurchaseOrderHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePurchaseOrderHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInvoicePurchaseOrderHistoryGridViewDto {
    id?: string;
    createdBy?: EmployeeDto | undefined;
    status?: InvoicePurchaseOrderStatus;
    created?: Date;
}

export class InvoiceOptionDto implements IInvoiceOptionDto {
    id?: string;
    number?: string;
    billToClientId?: string | undefined;

    constructor(data?: IInvoiceOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.billToClientId = _data["billToClientId"];
        }
    }

    static fromJS(data: any): InvoiceOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["billToClientId"] = this.billToClientId;
        return data;
    }
}

export interface IInvoiceOptionDto {
    id?: string;
    number?: string;
    billToClientId?: string | undefined;
}

export class InvoiceGridViewDto extends FinancialDocumentGridViewDto implements IInvoiceGridViewDto {
    status?: InvoiceStatus;
    poNumber?: string | undefined;
    invoiceNumber?: string;
    totalAmountAfterTax?: number;

    constructor(data?: IInvoiceGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.poNumber = _data["poNumber"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalAmountAfterTax = _data["totalAmountAfterTax"];
        }
    }

    static override fromJS(data: any): InvoiceGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["poNumber"] = this.poNumber;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalAmountAfterTax"] = this.totalAmountAfterTax;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceGridViewDto extends IFinancialDocumentGridViewDto {
    status?: InvoiceStatus;
    poNumber?: string | undefined;
    invoiceNumber?: string;
    totalAmountAfterTax?: number;
}

export class InvoiceHistoryGridViewDto implements IInvoiceHistoryGridViewDto {
    id?: string;
    createdBy?: EmployeeDto;
    status?: InvoiceStatus;
    created?: Date;

    constructor(data?: IInvoiceHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInvoiceHistoryGridViewDto {
    id?: string;
    createdBy?: EmployeeDto;
    status?: InvoiceStatus;
    created?: Date;
}

export class GlCodesOptionDto implements IGlCodesOptionDto {
    id?: string;
    clientId?: string;
    name?: string;
    shortName?: string;

    constructor(data?: IGlCodesOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): GlCodesOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlCodesOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface IGlCodesOptionDto {
    id?: string;
    clientId?: string;
    name?: string;
    shortName?: string;
}

export class GlCodeGridViewDto implements IGlCodeGridViewDto {
    id?: string;
    code?: string;
    description?: string;
    clientId?: string;

    constructor(data?: IGlCodeGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): GlCodeGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlCodeGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IGlCodeGridViewDto {
    id?: string;
    code?: string;
    description?: string;
    clientId?: string;
}

export class BillToOptionDto implements IBillToOptionDto {
    id?: string;
    name?: string;

    constructor(data?: IBillToOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BillToOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillToOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBillToOptionDto {
    id?: string;
    name?: string;
}

export class GlCodeClientGridViewDto implements IGlCodeClientGridViewDto {
    id?: string;
    name?: string;
    department?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    phoneNumber?: string;

    constructor(data?: IGlCodeClientGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.department = _data["department"];
            this.province = _data["province"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): GlCodeClientGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlCodeClientGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["department"] = this.department;
        data["province"] = this.province;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IGlCodeClientGridViewDto {
    id?: string;
    name?: string;
    department?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    phoneNumber?: string;
}

export class CreditRequestGridViewDto extends FinancialDocumentGridViewDto implements ICreditRequestGridViewDto {
    invoiceNumber?: string;
    status?: CreditRequestStatus;

    constructor(data?: ICreditRequestGridViewDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): CreditRequestGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditRequestGridViewDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditRequestGridViewDto extends IFinancialDocumentGridViewDto {
    invoiceNumber?: string;
    status?: CreditRequestStatus;
}

export class CreditRequestHistoryGridViewDto implements ICreditRequestHistoryGridViewDto {
    id?: string;
    createdBy?: EmployeeDto;
    status?: CreditRequestStatus;
    created?: Date;

    constructor(data?: ICreditRequestHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditRequestHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditRequestHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreditRequestHistoryGridViewDto {
    id?: string;
    createdBy?: EmployeeDto;
    status?: CreditRequestStatus;
    created?: Date;
}

export class ConversionRateGridViewDto implements IConversionRateGridViewDto {
    id?: string;
    rate?: number;
    month?: Month;
    year?: number;

    constructor(data?: IConversionRateGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rate = _data["rate"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ConversionRateGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionRateGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rate"] = this.rate;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface IConversionRateGridViewDto {
    id?: string;
    rate?: number;
    month?: Month;
    year?: number;
}

export class StorageUnitByBinGridViewDto implements IStorageUnitByBinGridViewDto {
    id?: string;
    materialNumber?: string;
    storageUnitNumber?: string;
    binNumber?: string;
    materialDescription?: string | undefined;
    lastMovement?: Date;
    lastStockPlacement?: Date;
    slaStatus?: string | undefined;
    slaStatusColor?: ColorClass | undefined;
    status?: StorageUnitStatus;
    duplicate?: boolean;
    dateCompleted?: Date | undefined;
    duration?: number;
    batch?: string | undefined;
    stockCategory?: string | undefined;
    totalQuantityWmUoM?: number;
    wmUnit?: string | undefined;
    grDate?: Date | undefined;
    lastChangedBy?: string | undefined;
    sledBbd?: Date | undefined;
    numberOfQuants?: number | undefined;
    transferOrderNo?: string | undefined;
    sourceStorageType?: string | undefined;
    sourceStorageBin?: string | undefined;
    sourceTargetQty?: number | undefined;
    movementTypeWm?: string | undefined;
    destStorageType?: string | undefined;
    destStorageBin?: string | undefined;
    destTargetQuantity?: number | undefined;
    trNumber?: string | undefined;
    transferPriority?: string | undefined;
    user?: string | undefined;

    constructor(data?: IStorageUnitByBinGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialNumber = _data["materialNumber"];
            this.storageUnitNumber = _data["storageUnitNumber"];
            this.binNumber = _data["binNumber"];
            this.materialDescription = _data["materialDescription"];
            this.lastMovement = _data["lastMovement"] ? new Date(_data["lastMovement"].toString()) : <any>undefined;
            this.lastStockPlacement = _data["lastStockPlacement"] ? new Date(_data["lastStockPlacement"].toString()) : <any>undefined;
            this.slaStatus = _data["slaStatus"];
            this.slaStatusColor = _data["slaStatusColor"];
            this.status = _data["status"];
            this.duplicate = _data["duplicate"];
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.batch = _data["batch"];
            this.stockCategory = _data["stockCategory"];
            this.totalQuantityWmUoM = _data["totalQuantityWmUoM"];
            this.wmUnit = _data["wmUnit"];
            this.grDate = _data["grDate"] ? new Date(_data["grDate"].toString()) : <any>undefined;
            this.lastChangedBy = _data["lastChangedBy"];
            this.sledBbd = _data["sledBbd"] ? new Date(_data["sledBbd"].toString()) : <any>undefined;
            this.numberOfQuants = _data["numberOfQuants"];
            this.transferOrderNo = _data["transferOrderNo"];
            this.sourceStorageType = _data["sourceStorageType"];
            this.sourceStorageBin = _data["sourceStorageBin"];
            this.sourceTargetQty = _data["sourceTargetQty"];
            this.movementTypeWm = _data["movementTypeWm"];
            this.destStorageType = _data["destStorageType"];
            this.destStorageBin = _data["destStorageBin"];
            this.destTargetQuantity = _data["destTargetQuantity"];
            this.trNumber = _data["trNumber"];
            this.transferPriority = _data["transferPriority"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): StorageUnitByBinGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUnitByBinGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialNumber"] = this.materialNumber;
        data["storageUnitNumber"] = this.storageUnitNumber;
        data["binNumber"] = this.binNumber;
        data["materialDescription"] = this.materialDescription;
        data["lastMovement"] = this.lastMovement ? this.lastMovement.toISOString() : <any>undefined;
        data["lastStockPlacement"] = this.lastStockPlacement ? this.lastStockPlacement.toISOString() : <any>undefined;
        data["slaStatus"] = this.slaStatus;
        data["slaStatusColor"] = this.slaStatusColor;
        data["status"] = this.status;
        data["duplicate"] = this.duplicate;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["batch"] = this.batch;
        data["stockCategory"] = this.stockCategory;
        data["totalQuantityWmUoM"] = this.totalQuantityWmUoM;
        data["wmUnit"] = this.wmUnit;
        data["grDate"] = this.grDate ? this.grDate.toISOString() : <any>undefined;
        data["lastChangedBy"] = this.lastChangedBy;
        data["sledBbd"] = this.sledBbd ? this.sledBbd.toISOString() : <any>undefined;
        data["numberOfQuants"] = this.numberOfQuants;
        data["transferOrderNo"] = this.transferOrderNo;
        data["sourceStorageType"] = this.sourceStorageType;
        data["sourceStorageBin"] = this.sourceStorageBin;
        data["sourceTargetQty"] = this.sourceTargetQty;
        data["movementTypeWm"] = this.movementTypeWm;
        data["destStorageType"] = this.destStorageType;
        data["destStorageBin"] = this.destStorageBin;
        data["destTargetQuantity"] = this.destTargetQuantity;
        data["trNumber"] = this.trNumber;
        data["transferPriority"] = this.transferPriority;
        data["user"] = this.user;
        return data;
    }
}

export interface IStorageUnitByBinGridViewDto {
    id?: string;
    materialNumber?: string;
    storageUnitNumber?: string;
    binNumber?: string;
    materialDescription?: string | undefined;
    lastMovement?: Date;
    lastStockPlacement?: Date;
    slaStatus?: string | undefined;
    slaStatusColor?: ColorClass | undefined;
    status?: StorageUnitStatus;
    duplicate?: boolean;
    dateCompleted?: Date | undefined;
    duration?: number;
    batch?: string | undefined;
    stockCategory?: string | undefined;
    totalQuantityWmUoM?: number;
    wmUnit?: string | undefined;
    grDate?: Date | undefined;
    lastChangedBy?: string | undefined;
    sledBbd?: Date | undefined;
    numberOfQuants?: number | undefined;
    transferOrderNo?: string | undefined;
    sourceStorageType?: string | undefined;
    sourceStorageBin?: string | undefined;
    sourceTargetQty?: number | undefined;
    movementTypeWm?: string | undefined;
    destStorageType?: string | undefined;
    destStorageBin?: string | undefined;
    destTargetQuantity?: number | undefined;
    trNumber?: string | undefined;
    transferPriority?: string | undefined;
    user?: string | undefined;
}

export class DurationSettingGridViewDto implements IDurationSettingGridViewDto {
    id?: string;
    name?: string;
    color?: ColorClass;
    storageTypeCode?: string;
    from?: number;
    to?: number | undefined;

    constructor(data?: IDurationSettingGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.storageTypeCode = _data["storageTypeCode"];
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): DurationSettingGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationSettingGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["storageTypeCode"] = this.storageTypeCode;
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IDurationSettingGridViewDto {
    id?: string;
    name?: string;
    color?: ColorClass;
    storageTypeCode?: string;
    from?: number;
    to?: number | undefined;
}

export class MB51QuantityGridViewDto implements IMB51QuantityGridViewDto {
    id?: string;
    date?: Date;
    documentHeaderText?: string | undefined;
    amountInLc?: number;
    quantity?: number;
    quantityCs?: number;
    quantityPal?: number;
    quantityDsp?: number;
    quantityEa?: number;

    constructor(data?: IMB51QuantityGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.documentHeaderText = _data["documentHeaderText"];
            this.amountInLc = _data["amountInLc"];
            this.quantity = _data["quantity"];
            this.quantityCs = _data["quantityCs"];
            this.quantityPal = _data["quantityPal"];
            this.quantityDsp = _data["quantityDsp"];
            this.quantityEa = _data["quantityEa"];
        }
    }

    static fromJS(data: any): MB51QuantityGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MB51QuantityGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentHeaderText"] = this.documentHeaderText;
        data["amountInLc"] = this.amountInLc;
        data["quantity"] = this.quantity;
        data["quantityCs"] = this.quantityCs;
        data["quantityPal"] = this.quantityPal;
        data["quantityDsp"] = this.quantityDsp;
        data["quantityEa"] = this.quantityEa;
        return data;
    }
}

export interface IMB51QuantityGridViewDto {
    id?: string;
    date?: Date;
    documentHeaderText?: string | undefined;
    amountInLc?: number;
    quantity?: number;
    quantityCs?: number;
    quantityPal?: number;
    quantityDsp?: number;
    quantityEa?: number;
}

export class MB51GridViewDto implements IMB51GridViewDto {
    id?: string;
    material?: string;
    matDoc?: string;
    item?: string;
    batch?: string;
    materialDescription?: string | undefined;
    documentHeaderText?: string | undefined;
    reference?: string | undefined;
    reason?: MB51Reason;
    s?: string | undefined;
    postingDate?: Date;
    quantity?: number;
    amountInLc?: number;
    status?: MB51Status;
    duplicate?: boolean;
    dateCompleted?: Date | undefined;
    plnt?: string | undefined;
    sLoc?: string | undefined;
    mvT?: string | undefined;
    movementTypeText?: string | undefined;
    dc?: string | undefined;
    userName?: string | undefined;
    teTy?: string | undefined;
    eUn?: MB51Eun;
    currency?: string | undefined;
    created?: Date;
    lastSeenInUpload?: Date;

    constructor(data?: IMB51GridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.material = _data["material"];
            this.matDoc = _data["matDoc"];
            this.item = _data["item"];
            this.batch = _data["batch"];
            this.materialDescription = _data["materialDescription"];
            this.documentHeaderText = _data["documentHeaderText"];
            this.reference = _data["reference"];
            this.reason = _data["reason"];
            this.s = _data["s"];
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.amountInLc = _data["amountInLc"];
            this.status = _data["status"];
            this.duplicate = _data["duplicate"];
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.plnt = _data["plnt"];
            this.sLoc = _data["sLoc"];
            this.mvT = _data["mvT"];
            this.movementTypeText = _data["movementTypeText"];
            this.dc = _data["dc"];
            this.userName = _data["userName"];
            this.teTy = _data["teTy"];
            this.eUn = _data["eUn"];
            this.currency = _data["currency"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastSeenInUpload = _data["lastSeenInUpload"] ? new Date(_data["lastSeenInUpload"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MB51GridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MB51GridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["material"] = this.material;
        data["matDoc"] = this.matDoc;
        data["item"] = this.item;
        data["batch"] = this.batch;
        data["materialDescription"] = this.materialDescription;
        data["documentHeaderText"] = this.documentHeaderText;
        data["reference"] = this.reference;
        data["reason"] = this.reason;
        data["s"] = this.s;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["amountInLc"] = this.amountInLc;
        data["status"] = this.status;
        data["duplicate"] = this.duplicate;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["plnt"] = this.plnt;
        data["sLoc"] = this.sLoc;
        data["mvT"] = this.mvT;
        data["movementTypeText"] = this.movementTypeText;
        data["dc"] = this.dc;
        data["userName"] = this.userName;
        data["teTy"] = this.teTy;
        data["eUn"] = this.eUn;
        data["currency"] = this.currency;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastSeenInUpload"] = this.lastSeenInUpload ? this.lastSeenInUpload.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMB51GridViewDto {
    id?: string;
    material?: string;
    matDoc?: string;
    item?: string;
    batch?: string;
    materialDescription?: string | undefined;
    documentHeaderText?: string | undefined;
    reference?: string | undefined;
    reason?: MB51Reason;
    s?: string | undefined;
    postingDate?: Date;
    quantity?: number;
    amountInLc?: number;
    status?: MB51Status;
    duplicate?: boolean;
    dateCompleted?: Date | undefined;
    plnt?: string | undefined;
    sLoc?: string | undefined;
    mvT?: string | undefined;
    movementTypeText?: string | undefined;
    dc?: string | undefined;
    userName?: string | undefined;
    teTy?: string | undefined;
    eUn?: MB51Eun;
    currency?: string | undefined;
    created?: Date;
    lastSeenInUpload?: Date;
}

export enum MB51Status {
    Active = "Active",
    Completed = "Completed",
}

export enum MB51Eun {
    CS = "CS",
    DSP = "DSP",
    EA = "EA",
    PAL = "PAL",
}

export class FacilityUtilizationGridViewDto implements IFacilityUtilizationGridViewDto {
    id?: string;
    created?: Date;
    actualUsage?: number;
    actualUsageAmbient?: number;
    actualUsageCooler?: number;
    ambientCapacity?: number;
    ambientDeadEnd?: number;
    boost?: number;
    coolerCapacity?: number;
    coolerDeadEnd?: number;
    emptyBins?: number;
    floorFl?: number;
    footprintCapacity?: number;
    gerber?: number;
    starbucks?: number;
    vitality?: number;
    pallets?: number;
    ambientUtilization?: number;
    coolerUtilization?: number;
    utilization?: number;
    palletPositionsAvailable?: number;
    partialPalletsIncludingPick?: number;
    partialPalletsExcludingPick?: number;
    percentagePartialsExcludingPick?: number;
    percentagePartialsAll?: number;
    partialPalletsReceived?: number;
    halfs?: number;
    qtyExcludingPackaging?: number;
    coolerAvailablePositions?: number;
    coolerPendingPuts?: number;
    ambientAvailablePositions?: number;

    constructor(data?: IFacilityUtilizationGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.actualUsage = _data["actualUsage"];
            this.actualUsageAmbient = _data["actualUsageAmbient"];
            this.actualUsageCooler = _data["actualUsageCooler"];
            this.ambientCapacity = _data["ambientCapacity"];
            this.ambientDeadEnd = _data["ambientDeadEnd"];
            this.boost = _data["boost"];
            this.coolerCapacity = _data["coolerCapacity"];
            this.coolerDeadEnd = _data["coolerDeadEnd"];
            this.emptyBins = _data["emptyBins"];
            this.floorFl = _data["floorFl"];
            this.footprintCapacity = _data["footprintCapacity"];
            this.gerber = _data["gerber"];
            this.starbucks = _data["starbucks"];
            this.vitality = _data["vitality"];
            this.pallets = _data["pallets"];
            this.ambientUtilization = _data["ambientUtilization"];
            this.coolerUtilization = _data["coolerUtilization"];
            this.utilization = _data["utilization"];
            this.palletPositionsAvailable = _data["palletPositionsAvailable"];
            this.partialPalletsIncludingPick = _data["partialPalletsIncludingPick"];
            this.partialPalletsExcludingPick = _data["partialPalletsExcludingPick"];
            this.percentagePartialsExcludingPick = _data["percentagePartialsExcludingPick"];
            this.percentagePartialsAll = _data["percentagePartialsAll"];
            this.partialPalletsReceived = _data["partialPalletsReceived"];
            this.halfs = _data["halfs"];
            this.qtyExcludingPackaging = _data["qtyExcludingPackaging"];
            this.coolerAvailablePositions = _data["coolerAvailablePositions"];
            this.coolerPendingPuts = _data["coolerPendingPuts"];
            this.ambientAvailablePositions = _data["ambientAvailablePositions"];
        }
    }

    static fromJS(data: any): FacilityUtilizationGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityUtilizationGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["actualUsage"] = this.actualUsage;
        data["actualUsageAmbient"] = this.actualUsageAmbient;
        data["actualUsageCooler"] = this.actualUsageCooler;
        data["ambientCapacity"] = this.ambientCapacity;
        data["ambientDeadEnd"] = this.ambientDeadEnd;
        data["boost"] = this.boost;
        data["coolerCapacity"] = this.coolerCapacity;
        data["coolerDeadEnd"] = this.coolerDeadEnd;
        data["emptyBins"] = this.emptyBins;
        data["floorFl"] = this.floorFl;
        data["footprintCapacity"] = this.footprintCapacity;
        data["gerber"] = this.gerber;
        data["starbucks"] = this.starbucks;
        data["vitality"] = this.vitality;
        data["pallets"] = this.pallets;
        data["ambientUtilization"] = this.ambientUtilization;
        data["coolerUtilization"] = this.coolerUtilization;
        data["utilization"] = this.utilization;
        data["palletPositionsAvailable"] = this.palletPositionsAvailable;
        data["partialPalletsIncludingPick"] = this.partialPalletsIncludingPick;
        data["partialPalletsExcludingPick"] = this.partialPalletsExcludingPick;
        data["percentagePartialsExcludingPick"] = this.percentagePartialsExcludingPick;
        data["percentagePartialsAll"] = this.percentagePartialsAll;
        data["partialPalletsReceived"] = this.partialPalletsReceived;
        data["halfs"] = this.halfs;
        data["qtyExcludingPackaging"] = this.qtyExcludingPackaging;
        data["coolerAvailablePositions"] = this.coolerAvailablePositions;
        data["coolerPendingPuts"] = this.coolerPendingPuts;
        data["ambientAvailablePositions"] = this.ambientAvailablePositions;
        return data;
    }
}

export interface IFacilityUtilizationGridViewDto {
    id?: string;
    created?: Date;
    actualUsage?: number;
    actualUsageAmbient?: number;
    actualUsageCooler?: number;
    ambientCapacity?: number;
    ambientDeadEnd?: number;
    boost?: number;
    coolerCapacity?: number;
    coolerDeadEnd?: number;
    emptyBins?: number;
    floorFl?: number;
    footprintCapacity?: number;
    gerber?: number;
    starbucks?: number;
    vitality?: number;
    pallets?: number;
    ambientUtilization?: number;
    coolerUtilization?: number;
    utilization?: number;
    palletPositionsAvailable?: number;
    partialPalletsIncludingPick?: number;
    partialPalletsExcludingPick?: number;
    percentagePartialsExcludingPick?: number;
    percentagePartialsAll?: number;
    partialPalletsReceived?: number;
    halfs?: number;
    qtyExcludingPackaging?: number;
    coolerAvailablePositions?: number;
    coolerPendingPuts?: number;
    ambientAvailablePositions?: number;
}

export class CountsPerStoreTypeGridViewDto implements ICountsPerStoreTypeGridViewDto {
    date?: Date;
    s203?: number;
    s226?: number;
    s219?: number;
    s213?: number;
    s216?: number;
    s230?: number;
    s20B?: number;
    s236?: number;
    s200?: number;
    s202?: number;
    s220?: number;
    s260?: number;
    s204?: number;
    s212?: number;
    s210?: number;
    s955?: number;

    constructor(data?: ICountsPerStoreTypeGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.s203 = _data["s203"];
            this.s226 = _data["s226"];
            this.s219 = _data["s219"];
            this.s213 = _data["s213"];
            this.s216 = _data["s216"];
            this.s230 = _data["s230"];
            this.s20B = _data["s20B"];
            this.s236 = _data["s236"];
            this.s200 = _data["s200"];
            this.s202 = _data["s202"];
            this.s220 = _data["s220"];
            this.s260 = _data["s260"];
            this.s204 = _data["s204"];
            this.s212 = _data["s212"];
            this.s210 = _data["s210"];
            this.s955 = _data["s955"];
        }
    }

    static fromJS(data: any): CountsPerStoreTypeGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountsPerStoreTypeGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["s203"] = this.s203;
        data["s226"] = this.s226;
        data["s219"] = this.s219;
        data["s213"] = this.s213;
        data["s216"] = this.s216;
        data["s230"] = this.s230;
        data["s20B"] = this.s20B;
        data["s236"] = this.s236;
        data["s200"] = this.s200;
        data["s202"] = this.s202;
        data["s220"] = this.s220;
        data["s260"] = this.s260;
        data["s204"] = this.s204;
        data["s212"] = this.s212;
        data["s210"] = this.s210;
        data["s955"] = this.s955;
        return data;
    }
}

export interface ICountsPerStoreTypeGridViewDto {
    date?: Date;
    s203?: number;
    s226?: number;
    s219?: number;
    s213?: number;
    s216?: number;
    s230?: number;
    s20B?: number;
    s236?: number;
    s200?: number;
    s202?: number;
    s220?: number;
    s260?: number;
    s204?: number;
    s212?: number;
    s210?: number;
    s955?: number;
}

export class CountsPerPalletTypeGridViewDto implements ICountsPerPalletTypeGridViewDto {
    date?: Date;
    bars?: number;
    seasonal?: number;
    nescafe?: number;
    beverage?: number;
    starbucksCpg?: number;
    infant?: number;
    nhs?: number;
    specialtyFoods?: number;
    npImport?: number;
    starbucksFs?: number;
    water?: number;
    iceCream?: number;
    others?: number;

    constructor(data?: ICountsPerPalletTypeGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.bars = _data["bars"];
            this.seasonal = _data["seasonal"];
            this.nescafe = _data["nescafe"];
            this.beverage = _data["beverage"];
            this.starbucksCpg = _data["starbucksCpg"];
            this.infant = _data["infant"];
            this.nhs = _data["nhs"];
            this.specialtyFoods = _data["specialtyFoods"];
            this.npImport = _data["npImport"];
            this.starbucksFs = _data["starbucksFs"];
            this.water = _data["water"];
            this.iceCream = _data["iceCream"];
            this.others = _data["others"];
        }
    }

    static fromJS(data: any): CountsPerPalletTypeGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountsPerPalletTypeGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["bars"] = this.bars;
        data["seasonal"] = this.seasonal;
        data["nescafe"] = this.nescafe;
        data["beverage"] = this.beverage;
        data["starbucksCpg"] = this.starbucksCpg;
        data["infant"] = this.infant;
        data["nhs"] = this.nhs;
        data["specialtyFoods"] = this.specialtyFoods;
        data["npImport"] = this.npImport;
        data["starbucksFs"] = this.starbucksFs;
        data["water"] = this.water;
        data["iceCream"] = this.iceCream;
        data["others"] = this.others;
        return data;
    }
}

export interface ICountsPerPalletTypeGridViewDto {
    date?: Date;
    bars?: number;
    seasonal?: number;
    nescafe?: number;
    beverage?: number;
    starbucksCpg?: number;
    infant?: number;
    nhs?: number;
    specialtyFoods?: number;
    npImport?: number;
    starbucksFs?: number;
    water?: number;
    iceCream?: number;
    others?: number;
}

export class BlockedStockScoreGridViewDto implements IBlockedStockScoreGridViewDto {
    id?: string;
    created?: Date;
    blockUnits?: number;
    blockedStock?: number;
    unmatchedBlockedStock?: number;
    totalBlockedStock?: number;
    sumOfUnrestrain?: number;
    sumOfQualityInspection?: number;
    sumOfRestrictedUse?: number;
    sumOfInventory?: number;
    blockedStockPercent?: number;
    onHold30Days?: number;
    onHold30DaysPercent?: number;
    onHold45Days?: number;
    onHold45DaysPercent?: number;
    onHold90Days?: number;
    onHold90DaysPercent?: number;
    onHold90PlusDays?: number;
    onHold90PlusDaysPercent?: number;
    noRacCoding?: number;
    noRacCodingPercent?: number;
    noRacCodingUnmatchedPercent?: number;
    returns?: number;
    returnsPercent?: number;
    damage?: number;
    damagePercent?: number;
    logistical?: number;
    logisticalPercent?: number;
    agedOrNearingExpiry?: number;
    agedOrNearingExpiryPercent?: number;
    expired?: number;
    expiredPercent?: number;
    foreignMaterial?: number;
    foreignMaterialPercent?: number;
    labellingPackaging?: number;
    labellingPackagingPercent?: number;
    infestation?: number;
    infestationPercent?: number;

    constructor(data?: IBlockedStockScoreGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.blockUnits = _data["blockUnits"];
            this.blockedStock = _data["blockedStock"];
            this.unmatchedBlockedStock = _data["unmatchedBlockedStock"];
            this.totalBlockedStock = _data["totalBlockedStock"];
            this.sumOfUnrestrain = _data["sumOfUnrestrain"];
            this.sumOfQualityInspection = _data["sumOfQualityInspection"];
            this.sumOfRestrictedUse = _data["sumOfRestrictedUse"];
            this.sumOfInventory = _data["sumOfInventory"];
            this.blockedStockPercent = _data["blockedStockPercent"];
            this.onHold30Days = _data["onHold30Days"];
            this.onHold30DaysPercent = _data["onHold30DaysPercent"];
            this.onHold45Days = _data["onHold45Days"];
            this.onHold45DaysPercent = _data["onHold45DaysPercent"];
            this.onHold90Days = _data["onHold90Days"];
            this.onHold90DaysPercent = _data["onHold90DaysPercent"];
            this.onHold90PlusDays = _data["onHold90PlusDays"];
            this.onHold90PlusDaysPercent = _data["onHold90PlusDaysPercent"];
            this.noRacCoding = _data["noRacCoding"];
            this.noRacCodingPercent = _data["noRacCodingPercent"];
            this.noRacCodingUnmatchedPercent = _data["noRacCodingUnmatchedPercent"];
            this.returns = _data["returns"];
            this.returnsPercent = _data["returnsPercent"];
            this.damage = _data["damage"];
            this.damagePercent = _data["damagePercent"];
            this.logistical = _data["logistical"];
            this.logisticalPercent = _data["logisticalPercent"];
            this.agedOrNearingExpiry = _data["agedOrNearingExpiry"];
            this.agedOrNearingExpiryPercent = _data["agedOrNearingExpiryPercent"];
            this.expired = _data["expired"];
            this.expiredPercent = _data["expiredPercent"];
            this.foreignMaterial = _data["foreignMaterial"];
            this.foreignMaterialPercent = _data["foreignMaterialPercent"];
            this.labellingPackaging = _data["labellingPackaging"];
            this.labellingPackagingPercent = _data["labellingPackagingPercent"];
            this.infestation = _data["infestation"];
            this.infestationPercent = _data["infestationPercent"];
        }
    }

    static fromJS(data: any): BlockedStockScoreGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedStockScoreGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["blockUnits"] = this.blockUnits;
        data["blockedStock"] = this.blockedStock;
        data["unmatchedBlockedStock"] = this.unmatchedBlockedStock;
        data["totalBlockedStock"] = this.totalBlockedStock;
        data["sumOfUnrestrain"] = this.sumOfUnrestrain;
        data["sumOfQualityInspection"] = this.sumOfQualityInspection;
        data["sumOfRestrictedUse"] = this.sumOfRestrictedUse;
        data["sumOfInventory"] = this.sumOfInventory;
        data["blockedStockPercent"] = this.blockedStockPercent;
        data["onHold30Days"] = this.onHold30Days;
        data["onHold30DaysPercent"] = this.onHold30DaysPercent;
        data["onHold45Days"] = this.onHold45Days;
        data["onHold45DaysPercent"] = this.onHold45DaysPercent;
        data["onHold90Days"] = this.onHold90Days;
        data["onHold90DaysPercent"] = this.onHold90DaysPercent;
        data["onHold90PlusDays"] = this.onHold90PlusDays;
        data["onHold90PlusDaysPercent"] = this.onHold90PlusDaysPercent;
        data["noRacCoding"] = this.noRacCoding;
        data["noRacCodingPercent"] = this.noRacCodingPercent;
        data["noRacCodingUnmatchedPercent"] = this.noRacCodingUnmatchedPercent;
        data["returns"] = this.returns;
        data["returnsPercent"] = this.returnsPercent;
        data["damage"] = this.damage;
        data["damagePercent"] = this.damagePercent;
        data["logistical"] = this.logistical;
        data["logisticalPercent"] = this.logisticalPercent;
        data["agedOrNearingExpiry"] = this.agedOrNearingExpiry;
        data["agedOrNearingExpiryPercent"] = this.agedOrNearingExpiryPercent;
        data["expired"] = this.expired;
        data["expiredPercent"] = this.expiredPercent;
        data["foreignMaterial"] = this.foreignMaterial;
        data["foreignMaterialPercent"] = this.foreignMaterialPercent;
        data["labellingPackaging"] = this.labellingPackaging;
        data["labellingPackagingPercent"] = this.labellingPackagingPercent;
        data["infestation"] = this.infestation;
        data["infestationPercent"] = this.infestationPercent;
        return data;
    }
}

export interface IBlockedStockScoreGridViewDto {
    id?: string;
    created?: Date;
    blockUnits?: number;
    blockedStock?: number;
    unmatchedBlockedStock?: number;
    totalBlockedStock?: number;
    sumOfUnrestrain?: number;
    sumOfQualityInspection?: number;
    sumOfRestrictedUse?: number;
    sumOfInventory?: number;
    blockedStockPercent?: number;
    onHold30Days?: number;
    onHold30DaysPercent?: number;
    onHold45Days?: number;
    onHold45DaysPercent?: number;
    onHold90Days?: number;
    onHold90DaysPercent?: number;
    onHold90PlusDays?: number;
    onHold90PlusDaysPercent?: number;
    noRacCoding?: number;
    noRacCodingPercent?: number;
    noRacCodingUnmatchedPercent?: number;
    returns?: number;
    returnsPercent?: number;
    damage?: number;
    damagePercent?: number;
    logistical?: number;
    logisticalPercent?: number;
    agedOrNearingExpiry?: number;
    agedOrNearingExpiryPercent?: number;
    expired?: number;
    expiredPercent?: number;
    foreignMaterial?: number;
    foreignMaterialPercent?: number;
    labellingPackaging?: number;
    labellingPackagingPercent?: number;
    infestation?: number;
    infestationPercent?: number;
}

export class BlockedStockGridViewDto implements IBlockedStockGridViewDto {
    id?: string;
    material?: string;
    batch?: string;
    storageUnit?: string;
    materialDescription?: string | undefined;
    blocked?: number;
    primReasonCodeDes?: string | undefined;
    acdDescription?: string | undefined;
    lastTransferDate?: Date;
    mTyp?: string | undefined;
    materialGroup?: string | undefined;
    corpBr?: string | undefined;
    rangeBr?: string | undefined;
    brDenom?: string | undefined;
    mrpCn?: string | undefined;
    prodS?: string | undefined;
    profitCtr?: string | undefined;
    xPlSt?: string | undefined;
    plSpSt?: string | undefined;
    dbSalvage?: string | undefined;
    salvageRea?: string | undefined;
    salvageRea2?: string | undefined;
    movementType?: string | undefined;
    reason?: string | undefined;
    reason2?: string | undefined;
    stdPrice?: number;
    per?: number;
    manufacturingDate?: Date;
    available?: Date;
    sledBbd?: Date;
    lastGr?: Date;
    mfDate?: Date;
    reShLi?: number;
    shLife?: number;
    totalBUoM?: number;
    totalBUoMUnit?: string | undefined;
    totalIssue?: number;
    uoI?: string | undefined;
    totalDUoM?: number;
    totalDUoMUnit?: string | undefined;
    unrestricted?: number;
    qualityInspection?: number;
    restrictedUse?: number;
    stockInTfr?: number;
    transit?: number;
    inTrPl?: number;
    totalValue?: number;
    currency?: string | undefined;
    totalWeight?: number;
    totalWeightUnit?: string | undefined;
    salvageDate?: Date | undefined;
    dbSal?: number;
    rSalvagePercent?: number;
    typ?: string | undefined;
    storageBin?: string | undefined;
    prc?: string | undefined;
    src?: string | undefined;
    actCode?: string | undefined;
    toNumber?: string | undefined;
    toItem?: string | undefined;
    age?: number;
    daysOnHold?: DaysOnHoldType;
    perCase?: number;
    status?: BlockedStockStatus;
    duplicate?: boolean;
    exception?: BlockedStockException | undefined;
    dateCompleted?: Date | undefined;
    created?: Date;
    lastSeenInUpload?: Date;

    constructor(data?: IBlockedStockGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.material = _data["material"];
            this.batch = _data["batch"];
            this.storageUnit = _data["storageUnit"];
            this.materialDescription = _data["materialDescription"];
            this.blocked = _data["blocked"];
            this.primReasonCodeDes = _data["primReasonCodeDes"];
            this.acdDescription = _data["acdDescription"];
            this.lastTransferDate = _data["lastTransferDate"] ? new Date(_data["lastTransferDate"].toString()) : <any>undefined;
            this.mTyp = _data["mTyp"];
            this.materialGroup = _data["materialGroup"];
            this.corpBr = _data["corpBr"];
            this.rangeBr = _data["rangeBr"];
            this.brDenom = _data["brDenom"];
            this.mrpCn = _data["mrpCn"];
            this.prodS = _data["prodS"];
            this.profitCtr = _data["profitCtr"];
            this.xPlSt = _data["xPlSt"];
            this.plSpSt = _data["plSpSt"];
            this.dbSalvage = _data["dbSalvage"];
            this.salvageRea = _data["salvageRea"];
            this.salvageRea2 = _data["salvageRea2"];
            this.movementType = _data["movementType"];
            this.reason = _data["reason"];
            this.reason2 = _data["reason2"];
            this.stdPrice = _data["stdPrice"];
            this.per = _data["per"];
            this.manufacturingDate = _data["manufacturingDate"] ? new Date(_data["manufacturingDate"].toString()) : <any>undefined;
            this.available = _data["available"] ? new Date(_data["available"].toString()) : <any>undefined;
            this.sledBbd = _data["sledBbd"] ? new Date(_data["sledBbd"].toString()) : <any>undefined;
            this.lastGr = _data["lastGr"] ? new Date(_data["lastGr"].toString()) : <any>undefined;
            this.mfDate = _data["mfDate"] ? new Date(_data["mfDate"].toString()) : <any>undefined;
            this.reShLi = _data["reShLi"];
            this.shLife = _data["shLife"];
            this.totalBUoM = _data["totalBUoM"];
            this.totalBUoMUnit = _data["totalBUoMUnit"];
            this.totalIssue = _data["totalIssue"];
            this.uoI = _data["uoI"];
            this.totalDUoM = _data["totalDUoM"];
            this.totalDUoMUnit = _data["totalDUoMUnit"];
            this.unrestricted = _data["unrestricted"];
            this.qualityInspection = _data["qualityInspection"];
            this.restrictedUse = _data["restrictedUse"];
            this.stockInTfr = _data["stockInTfr"];
            this.transit = _data["transit"];
            this.inTrPl = _data["inTrPl"];
            this.totalValue = _data["totalValue"];
            this.currency = _data["currency"];
            this.totalWeight = _data["totalWeight"];
            this.totalWeightUnit = _data["totalWeightUnit"];
            this.salvageDate = _data["salvageDate"] ? new Date(_data["salvageDate"].toString()) : <any>undefined;
            this.dbSal = _data["dbSal"];
            this.rSalvagePercent = _data["rSalvagePercent"];
            this.typ = _data["typ"];
            this.storageBin = _data["storageBin"];
            this.prc = _data["prc"];
            this.src = _data["src"];
            this.actCode = _data["actCode"];
            this.toNumber = _data["toNumber"];
            this.toItem = _data["toItem"];
            this.age = _data["age"];
            this.daysOnHold = _data["daysOnHold"];
            this.perCase = _data["perCase"];
            this.status = _data["status"];
            this.duplicate = _data["duplicate"];
            this.exception = _data["exception"];
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastSeenInUpload = _data["lastSeenInUpload"] ? new Date(_data["lastSeenInUpload"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BlockedStockGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedStockGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["material"] = this.material;
        data["batch"] = this.batch;
        data["storageUnit"] = this.storageUnit;
        data["materialDescription"] = this.materialDescription;
        data["blocked"] = this.blocked;
        data["primReasonCodeDes"] = this.primReasonCodeDes;
        data["acdDescription"] = this.acdDescription;
        data["lastTransferDate"] = this.lastTransferDate ? this.lastTransferDate.toISOString() : <any>undefined;
        data["mTyp"] = this.mTyp;
        data["materialGroup"] = this.materialGroup;
        data["corpBr"] = this.corpBr;
        data["rangeBr"] = this.rangeBr;
        data["brDenom"] = this.brDenom;
        data["mrpCn"] = this.mrpCn;
        data["prodS"] = this.prodS;
        data["profitCtr"] = this.profitCtr;
        data["xPlSt"] = this.xPlSt;
        data["plSpSt"] = this.plSpSt;
        data["dbSalvage"] = this.dbSalvage;
        data["salvageRea"] = this.salvageRea;
        data["salvageRea2"] = this.salvageRea2;
        data["movementType"] = this.movementType;
        data["reason"] = this.reason;
        data["reason2"] = this.reason2;
        data["stdPrice"] = this.stdPrice;
        data["per"] = this.per;
        data["manufacturingDate"] = this.manufacturingDate ? this.manufacturingDate.toISOString() : <any>undefined;
        data["available"] = this.available ? this.available.toISOString() : <any>undefined;
        data["sledBbd"] = this.sledBbd ? this.sledBbd.toISOString() : <any>undefined;
        data["lastGr"] = this.lastGr ? this.lastGr.toISOString() : <any>undefined;
        data["mfDate"] = this.mfDate ? this.mfDate.toISOString() : <any>undefined;
        data["reShLi"] = this.reShLi;
        data["shLife"] = this.shLife;
        data["totalBUoM"] = this.totalBUoM;
        data["totalBUoMUnit"] = this.totalBUoMUnit;
        data["totalIssue"] = this.totalIssue;
        data["uoI"] = this.uoI;
        data["totalDUoM"] = this.totalDUoM;
        data["totalDUoMUnit"] = this.totalDUoMUnit;
        data["unrestricted"] = this.unrestricted;
        data["qualityInspection"] = this.qualityInspection;
        data["restrictedUse"] = this.restrictedUse;
        data["stockInTfr"] = this.stockInTfr;
        data["transit"] = this.transit;
        data["inTrPl"] = this.inTrPl;
        data["totalValue"] = this.totalValue;
        data["currency"] = this.currency;
        data["totalWeight"] = this.totalWeight;
        data["totalWeightUnit"] = this.totalWeightUnit;
        data["salvageDate"] = this.salvageDate ? this.salvageDate.toISOString() : <any>undefined;
        data["dbSal"] = this.dbSal;
        data["rSalvagePercent"] = this.rSalvagePercent;
        data["typ"] = this.typ;
        data["storageBin"] = this.storageBin;
        data["prc"] = this.prc;
        data["src"] = this.src;
        data["actCode"] = this.actCode;
        data["toNumber"] = this.toNumber;
        data["toItem"] = this.toItem;
        data["age"] = this.age;
        data["daysOnHold"] = this.daysOnHold;
        data["perCase"] = this.perCase;
        data["status"] = this.status;
        data["duplicate"] = this.duplicate;
        data["exception"] = this.exception;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastSeenInUpload"] = this.lastSeenInUpload ? this.lastSeenInUpload.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBlockedStockGridViewDto {
    id?: string;
    material?: string;
    batch?: string;
    storageUnit?: string;
    materialDescription?: string | undefined;
    blocked?: number;
    primReasonCodeDes?: string | undefined;
    acdDescription?: string | undefined;
    lastTransferDate?: Date;
    mTyp?: string | undefined;
    materialGroup?: string | undefined;
    corpBr?: string | undefined;
    rangeBr?: string | undefined;
    brDenom?: string | undefined;
    mrpCn?: string | undefined;
    prodS?: string | undefined;
    profitCtr?: string | undefined;
    xPlSt?: string | undefined;
    plSpSt?: string | undefined;
    dbSalvage?: string | undefined;
    salvageRea?: string | undefined;
    salvageRea2?: string | undefined;
    movementType?: string | undefined;
    reason?: string | undefined;
    reason2?: string | undefined;
    stdPrice?: number;
    per?: number;
    manufacturingDate?: Date;
    available?: Date;
    sledBbd?: Date;
    lastGr?: Date;
    mfDate?: Date;
    reShLi?: number;
    shLife?: number;
    totalBUoM?: number;
    totalBUoMUnit?: string | undefined;
    totalIssue?: number;
    uoI?: string | undefined;
    totalDUoM?: number;
    totalDUoMUnit?: string | undefined;
    unrestricted?: number;
    qualityInspection?: number;
    restrictedUse?: number;
    stockInTfr?: number;
    transit?: number;
    inTrPl?: number;
    totalValue?: number;
    currency?: string | undefined;
    totalWeight?: number;
    totalWeightUnit?: string | undefined;
    salvageDate?: Date | undefined;
    dbSal?: number;
    rSalvagePercent?: number;
    typ?: string | undefined;
    storageBin?: string | undefined;
    prc?: string | undefined;
    src?: string | undefined;
    actCode?: string | undefined;
    toNumber?: string | undefined;
    toItem?: string | undefined;
    age?: number;
    daysOnHold?: DaysOnHoldType;
    perCase?: number;
    status?: BlockedStockStatus;
    duplicate?: boolean;
    exception?: BlockedStockException | undefined;
    dateCompleted?: Date | undefined;
    created?: Date;
    lastSeenInUpload?: Date;
}

export enum DaysOnHoldType {
    LessThan30Days = "LessThan30Days",
    LessThan45Days = "LessThan45Days",
    LessThan90Days = "LessThan90Days",
    MoreThan90Days = "MoreThan90Days",
}

export enum BlockedStockStatus {
    Active = "Active",
    Completed = "Completed",
}

export enum BlockedStockException {
    DuplicateSu = "DuplicateSu",
}

export class SupplierOptionDto implements ISupplierOptionDto {
    id?: string;
    name?: string;

    constructor(data?: ISupplierOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SupplierOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISupplierOptionDto {
    id?: string;
    name?: string;
}

export class SupplierGridViewDto implements ISupplierGridViewDto {
    id?: string;
    number?: string;
    status?: SupplierStatus;
    name?: string;
    group?: string | undefined;
    plant?: string | undefined;
    sac?: string | undefined;
    address?: string;
    email?: string | undefined;
    phone?: string | undefined;
    lastModifiedBy?: EmployeeDto;
    lastModified?: Date;
    createdBy?: EmployeeDto;
    created?: Date;

    constructor(data?: ISupplierGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.plant = _data["plant"];
            this.sac = _data["sac"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SupplierGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["group"] = this.group;
        data["plant"] = this.plant;
        data["sac"] = this.sac;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISupplierGridViewDto {
    id?: string;
    number?: string;
    status?: SupplierStatus;
    name?: string;
    group?: string | undefined;
    plant?: string | undefined;
    sac?: string | undefined;
    address?: string;
    email?: string | undefined;
    phone?: string | undefined;
    lastModifiedBy?: EmployeeDto;
    lastModified?: Date;
    createdBy?: EmployeeDto;
    created?: Date;
}

export class PurchaseOrderOptionDto implements IPurchaseOrderOptionDto {
    purchasingDocument?: string;

    constructor(data?: IPurchaseOrderOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchasingDocument = _data["purchasingDocument"];
        }
    }

    static fromJS(data: any): PurchaseOrderOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchasingDocument"] = this.purchasingDocument;
        return data;
    }
}

export interface IPurchaseOrderOptionDto {
    purchasingDocument?: string;
}

export class EmptyCheckInGridViewDto implements IEmptyCheckInGridViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerNumber?: string;
    location?: ShuntLocationType | undefined;
    shuntLocationNumber?: string;
    status?: EmptyCheckInStatus;
    created?: Date;
    createdBy?: EmployeeDto;

    constructor(data?: IEmptyCheckInGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.carrier = _data["carrier"];
            this.trailerNumber = _data["trailerNumber"];
            this.location = _data["location"];
            this.shuntLocationNumber = _data["shuntLocationNumber"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyCheckInGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCheckInGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["carrier"] = this.carrier;
        data["trailerNumber"] = this.trailerNumber;
        data["location"] = this.location;
        data["shuntLocationNumber"] = this.shuntLocationNumber;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmptyCheckInGridViewDto {
    id?: string;
    number?: string;
    carrier?: string;
    trailerNumber?: string;
    location?: ShuntLocationType | undefined;
    shuntLocationNumber?: string;
    status?: EmptyCheckInStatus;
    created?: Date;
    createdBy?: EmployeeDto;
}

export class EmptyCheckInHistoryGridViewDto implements IEmptyCheckInHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    status?: EmptyCheckInStatus;
    location?: ShuntLocationType | undefined;
    number?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    notes?: string | undefined;
    created?: Date;

    constructor(data?: IEmptyCheckInHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.status = _data["status"];
            this.location = _data["location"];
            this.number = _data["number"];
            this.shuntPriority = _data["shuntPriority"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyCheckInHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCheckInHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["location"] = this.location;
        data["number"] = this.number;
        data["shuntPriority"] = this.shuntPriority;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmptyCheckInHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    status?: EmptyCheckInStatus;
    location?: ShuntLocationType | undefined;
    number?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    notes?: string | undefined;
    created?: Date;
}

export class CarrierOptionDto implements ICarrierOptionDto {
    id?: string;
    name?: string;

    constructor(data?: ICarrierOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CarrierOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICarrierOptionDto {
    id?: string;
    name?: string;
}

export class CarrierGridViewDto implements ICarrierGridViewDto {
    id?: string;
    number?: string;
    status?: CarrierStatus;
    name?: string;
    scac?: string | undefined;
    address?: string;
    email?: string | undefined;
    phone?: string | undefined;
    lastModifiedBy?: EmployeeDto;
    lastModified?: Date;
    createdBy?: EmployeeDto;
    created?: Date;

    constructor(data?: ICarrierGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.scac = _data["scac"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CarrierGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["name"] = this.name;
        data["scac"] = this.scac;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICarrierGridViewDto {
    id?: string;
    number?: string;
    status?: CarrierStatus;
    name?: string;
    scac?: string | undefined;
    address?: string;
    email?: string | undefined;
    phone?: string | undefined;
    lastModifiedBy?: EmployeeDto;
    lastModified?: Date;
    createdBy?: EmployeeDto;
    created?: Date;
}

export class AppointmentGridViewDto implements IAppointmentGridViewDto {
    id?: string;
    number?: string;
    status?: AppointmentStatus;
    supplier?: string;
    carrier?: string;
    shuntLocation?: ShuntLocationType | undefined;
    shuntLocationNumber?: string | undefined;
    billOfLadingNumber?: string | undefined;
    poOrStoNumber?: string[] | undefined;
    palletCount?: number;
    loadType?: AppointmentLoadType | undefined;
    trailerNumber?: string | undefined;
    weightOfShipment?: string | undefined;
    correctBillOfLadingNumber?: string | undefined;
    correctTrailerNumber?: string | undefined;
    trailerType?: TrailerType | undefined;
    trailerTemperature?: string | undefined;
    driverName?: string | undefined;
    driverId?: string | undefined;
    sealNumber?: string | undefined;
    sealMatchesPaperwork?: boolean | undefined;
    score?: number | undefined;
    percentage?: number | undefined;
    requestDate?: Date | undefined;
    confirmedDate?: Date | undefined;

    constructor(data?: IAppointmentGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.supplier = _data["supplier"];
            this.carrier = _data["carrier"];
            this.shuntLocation = _data["shuntLocation"];
            this.shuntLocationNumber = _data["shuntLocationNumber"];
            this.billOfLadingNumber = _data["billOfLadingNumber"];
            if (Array.isArray(_data["poOrStoNumber"])) {
                this.poOrStoNumber = [] as any;
                for (let item of _data["poOrStoNumber"])
                    this.poOrStoNumber!.push(item);
            }
            this.palletCount = _data["palletCount"];
            this.loadType = _data["loadType"];
            this.trailerNumber = _data["trailerNumber"];
            this.weightOfShipment = _data["weightOfShipment"];
            this.correctBillOfLadingNumber = _data["correctBillOfLadingNumber"];
            this.correctTrailerNumber = _data["correctTrailerNumber"];
            this.trailerType = _data["trailerType"];
            this.trailerTemperature = _data["trailerTemperature"];
            this.driverName = _data["driverName"];
            this.driverId = _data["driverId"];
            this.sealNumber = _data["sealNumber"];
            this.sealMatchesPaperwork = _data["sealMatchesPaperwork"];
            this.score = _data["score"];
            this.percentage = _data["percentage"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["status"] = this.status;
        data["supplier"] = this.supplier;
        data["carrier"] = this.carrier;
        data["shuntLocation"] = this.shuntLocation;
        data["shuntLocationNumber"] = this.shuntLocationNumber;
        data["billOfLadingNumber"] = this.billOfLadingNumber;
        if (Array.isArray(this.poOrStoNumber)) {
            data["poOrStoNumber"] = [];
            for (let item of this.poOrStoNumber)
                data["poOrStoNumber"].push(item);
        }
        data["palletCount"] = this.palletCount;
        data["loadType"] = this.loadType;
        data["trailerNumber"] = this.trailerNumber;
        data["weightOfShipment"] = this.weightOfShipment;
        data["correctBillOfLadingNumber"] = this.correctBillOfLadingNumber;
        data["correctTrailerNumber"] = this.correctTrailerNumber;
        data["trailerType"] = this.trailerType;
        data["trailerTemperature"] = this.trailerTemperature;
        data["driverName"] = this.driverName;
        data["driverId"] = this.driverId;
        data["sealNumber"] = this.sealNumber;
        data["sealMatchesPaperwork"] = this.sealMatchesPaperwork;
        data["score"] = this.score;
        data["percentage"] = this.percentage;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAppointmentGridViewDto {
    id?: string;
    number?: string;
    status?: AppointmentStatus;
    supplier?: string;
    carrier?: string;
    shuntLocation?: ShuntLocationType | undefined;
    shuntLocationNumber?: string | undefined;
    billOfLadingNumber?: string | undefined;
    poOrStoNumber?: string[] | undefined;
    palletCount?: number;
    loadType?: AppointmentLoadType | undefined;
    trailerNumber?: string | undefined;
    weightOfShipment?: string | undefined;
    correctBillOfLadingNumber?: string | undefined;
    correctTrailerNumber?: string | undefined;
    trailerType?: TrailerType | undefined;
    trailerTemperature?: string | undefined;
    driverName?: string | undefined;
    driverId?: string | undefined;
    sealNumber?: string | undefined;
    sealMatchesPaperwork?: boolean | undefined;
    score?: number | undefined;
    percentage?: number | undefined;
    requestDate?: Date | undefined;
    confirmedDate?: Date | undefined;
}

export class AppointmentHistoryGridViewDto implements IAppointmentHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    status?: AppointmentStatus;
    location?: ShuntLocationType | undefined;
    number?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    assignedEmployee?: EmployeeDto | undefined;
    stagingLane?: StagingLane | undefined;
    notes?: string | undefined;
    created?: Date;

    constructor(data?: IAppointmentHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.status = _data["status"];
            this.location = _data["location"];
            this.number = _data["number"];
            this.shuntPriority = _data["shuntPriority"];
            this.assignedEmployee = _data["assignedEmployee"] ? EmployeeDto.fromJS(_data["assignedEmployee"]) : <any>undefined;
            this.stagingLane = _data["stagingLane"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["location"] = this.location;
        data["number"] = this.number;
        data["shuntPriority"] = this.shuntPriority;
        data["assignedEmployee"] = this.assignedEmployee ? this.assignedEmployee.toJSON() : <any>undefined;
        data["stagingLane"] = this.stagingLane;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAppointmentHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto;
    status?: AppointmentStatus;
    location?: ShuntLocationType | undefined;
    number?: string | undefined;
    shuntPriority?: ShuntPriority | undefined;
    assignedEmployee?: EmployeeDto | undefined;
    stagingLane?: StagingLane | undefined;
    notes?: string | undefined;
    created?: Date;
}

export class AppointmentComplianceGridViewDto implements IAppointmentComplianceGridViewDto {
    id?: string;
    score?: number;
    percentage?: number;
    lastModifiedBy?: EmployeeDto;
    lastModified?: Date;
    createdBy?: EmployeeDto;
    created?: Date;

    constructor(data?: IAppointmentComplianceGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.score = _data["score"];
            this.percentage = _data["percentage"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AppointmentComplianceGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentComplianceGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["score"] = this.score;
        data["percentage"] = this.percentage;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAppointmentComplianceGridViewDto {
    id?: string;
    score?: number;
    percentage?: number;
    lastModifiedBy?: EmployeeDto;
    lastModified?: Date;
    createdBy?: EmployeeDto;
    created?: Date;
}

export class HuddleGridViewDto implements IHuddleGridViewDto {
    employeeId?: string;
    employeeName?: string;
    employeeEmail?: string | undefined;
    employeeAvatar?: string | undefined;
    huddleStatus?: HuddleStatus | undefined;
    shiftId?: string;
    shiftCode?: string;

    constructor(data?: IHuddleGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeEmail = _data["employeeEmail"];
            this.employeeAvatar = _data["employeeAvatar"];
            this.huddleStatus = _data["huddleStatus"];
            this.shiftId = _data["shiftId"];
            this.shiftCode = _data["shiftCode"];
        }
    }

    static fromJS(data: any): HuddleGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HuddleGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeEmail"] = this.employeeEmail;
        data["employeeAvatar"] = this.employeeAvatar;
        data["huddleStatus"] = this.huddleStatus;
        data["shiftId"] = this.shiftId;
        data["shiftCode"] = this.shiftCode;
        return data;
    }
}

export interface IHuddleGridViewDto {
    employeeId?: string;
    employeeName?: string;
    employeeEmail?: string | undefined;
    employeeAvatar?: string | undefined;
    huddleStatus?: HuddleStatus | undefined;
    shiftId?: string;
    shiftCode?: string;
}

export class FileImportGridViewDto implements IFileImportGridViewDto {
    id?: string;
    fileName?: string;
    url?: string;
    contentType?: string;
    fileType?: ImportFileType;
    message?: string | undefined;
    status?: FileImportStatus;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    createdByAvatar?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IFileImportGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.contentType = _data["contentType"];
            this.fileType = _data["fileType"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.createdByName = _data["createdByName"];
            this.createdByEmail = _data["createdByEmail"];
            this.createdByAvatar = _data["createdByAvatar"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileImportGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["contentType"] = this.contentType;
        data["fileType"] = this.fileType;
        data["message"] = this.message;
        data["status"] = this.status;
        data["createdByName"] = this.createdByName;
        data["createdByEmail"] = this.createdByEmail;
        data["createdByAvatar"] = this.createdByAvatar;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileImportGridViewDto {
    id?: string;
    fileName?: string;
    url?: string;
    contentType?: string;
    fileType?: ImportFileType;
    message?: string | undefined;
    status?: FileImportStatus;
    createdByName?: string | undefined;
    createdByEmail?: string | undefined;
    createdByAvatar?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class NestleDeactivationGridViewDto implements INestleDeactivationGridViewDto {
    id?: string;
    effectiveDate?: Date;
    positionDelimited?: boolean;
    type?: NestleDeactivationType;
    createdBy?: EmployeeDto | undefined;
    created?: Date;
    ticketNumber?: string;
    note?: string | undefined;
    attachments?: DocumentDto[];

    constructor(data?: INestleDeactivationGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.positionDelimited = _data["positionDelimited"];
            this.type = _data["type"];
            this.createdBy = _data["createdBy"] ? EmployeeDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.ticketNumber = _data["ticketNumber"];
            this.note = _data["note"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NestleDeactivationGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestleDeactivationGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["positionDelimited"] = this.positionDelimited;
        data["type"] = this.type;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["ticketNumber"] = this.ticketNumber;
        data["note"] = this.note;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface INestleDeactivationGridViewDto {
    id?: string;
    effectiveDate?: Date;
    positionDelimited?: boolean;
    type?: NestleDeactivationType;
    createdBy?: EmployeeDto | undefined;
    created?: Date;
    ticketNumber?: string;
    note?: string | undefined;
    attachments?: DocumentDto[];
}

export enum NestleDeactivationType {
    Terminated = "Terminated",
    Inactive = "Inactive",
}

export class UserHistoryGridViewDto implements IUserHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto | undefined;
    created?: Date;
    section?: UserHistorySection;
    field?: UserHistoryField;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IUserHistoryGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.section = _data["section"];
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): UserHistoryGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserHistoryGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["section"] = this.section;
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IUserHistoryGridViewDto {
    id?: string;
    employee?: EmployeeDto | undefined;
    created?: Date;
    section?: UserHistorySection;
    field?: UserHistoryField;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export enum UserHistorySection {
    Contact = "Contact",
    EmergencyDetails = "EmergencyDetails",
    ShiftDetails = "ShiftDetails",
    FinancialDetails = "FinancialDetails",
    EmploymentDetails = "EmploymentDetails",
    NestleDetails = "NestleDetails",
    SecurityAndPermissions = "SecurityAndPermissions",
    SupplierDetails = "SupplierDetails",
    CarrierDetails = "CarrierDetails",
    VendorDetails = "VendorDetails",
    CustomerDetails = "CustomerDetails",
    SiteDetails = "SiteDetails",
    AgencyDetails = "AgencyDetails",
    IssuePassword = "IssuePassword",
}

export enum UserHistoryField {
    FirstName = "FirstName",
    MiddleName = "MiddleName",
    LastName = "LastName",
    AlternativeFirstName = "AlternativeFirstName",
    AlternativeLastName = "AlternativeLastName",
    Email = "Email",
    Phone = "Phone",
    Address = "Address",
    EmergencyContactName = "EmergencyContactName",
    EmergencyContactNumber = "EmergencyContactNumber",
    MedicalConditions = "MedicalConditions",
    Shift = "Shift",
    Supervisor = "Supervisor",
    RegularPayRateCode = "RegularPayRateCode",
    RegularPayRateAmount = "RegularPayRateAmount",
    RegularPayEffectiveDate = "RegularPayEffectiveDate",
    AnnualSalary = "AnnualSalary",
    PayCycleDescription = "PayCycleDescription",
    PositionStatus = "PositionStatus",
    PositionId = "PositionId",
    PayrollCompanyCode = "PayrollCompanyCode",
    TaxId = "TaxId",
    BirthDate = "BirthDate",
    Age = "Age",
    HireDate = "HireDate",
    TerminationDate = "TerminationDate",
    JobTitleDescription = "JobTitleDescription",
    PayClass = "PayClass",
    PayDivision = "PayDivision",
    PaidPosition = "PaidPosition",
    HomeDepartmentCode = "HomeDepartmentCode",
    HomeCostNumberCode = "HomeCostNumberCode",
    ProvinceOfEmployment = "ProvinceOfEmployment",
    StandardHours = "StandardHours",
    SapAccess = "SapAccess",
    DwaAccess = "DwaAccess",
    NextViewAccess = "NextViewAccess",
    NestleStatus = "NestleStatus",
    AdpHireDate = "AdpHireDate",
    NewHire = "NewHire",
    NestleAgency = "NestleAgency",
    NestlePositionId = "NestlePositionId",
    SapSuccessFactorId = "SapSuccessFactorId",
    EmployeeId = "EmployeeId",
    NestleUserId = "NestleUserId",
    NestleEmail = "NestleEmail",
    NextPasswordExpiryDate = "NextPasswordExpiryDate",
    Status = "Status",
    Roles = "Roles",
    NotifyByEmail = "NotifyByEmail",
    NotifyByPhone = "NotifyByPhone",
    TwoFactorAuthentication = "TwoFactorAuthentication",
    Suppliers = "Suppliers",
    Carriers = "Carriers",
    Vendors = "Vendors",
    Customers = "Customers",
    Sites = "Sites",
    Agencies = "Agencies",
    Password = "Password",
}

export class EmployeeGridViewDto implements IEmployeeGridViewDto {
    id?: string;
    name?: string;
    email?: string | undefined;
    avatarUrl?: string | undefined;
    positionStatus?: PositionStatus | undefined;
    shiftType?: ShiftType | undefined;
    lastUpdated?: Date;
    punchInStatus?: PunchInStatus | undefined;
    punchOutStatus?: PunchOutStatus | undefined;
    requests?: number;
    positionId?: string | undefined;
    homeCostNumberCode?: string | undefined;
    homeDepartmentCode?: string | undefined;
    payClass?: string | undefined;
    emergencyContactName?: string | undefined;
    emergencyContactNumber?: string | undefined;
    medicalConditions?: string | undefined;
    taxId?: string | undefined;
    payrollCompanyCode?: PayrollCompanyCode | undefined;
    regularPayRateCode?: RegularPayRateCode | undefined;
    payRateAmount?: number | undefined;
    annualSalary?: number | undefined;
    birthDate?: Date | undefined;
    regularPayEffectiveDate?: Date | undefined;
    hireDate?: Date | undefined;
    paidPosition?: boolean | undefined;
    standardHours?: number | undefined;
    age?: string | undefined;
    yearsWorked?: number | undefined;
    jobTitleDescription?: JobTitle | undefined;
    sapAccess?: boolean | undefined;
    dwaAccess?: boolean | undefined;
    nextViewAccess?: boolean | undefined;
    nestleStatus?: NestleStatus | undefined;
    nestleDetailsAdpHireDate?: Date | undefined;
    nestleDetailsNewHire?: boolean | undefined;
    nestleDetailsAgency?: string | undefined;
    nestleDetailsPositionId?: string | undefined;
    nestleDetailsSapSuccessFactorId?: string | undefined;
    nestleDetailsEmployeeId?: string | undefined;
    nestleDetailsNestleUserId?: string | undefined;
    nestleDetailsEmail?: string | undefined;
    nestleDetailsNextPasswordExpiryDate?: Date | undefined;

    constructor(data?: IEmployeeGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.avatarUrl = _data["avatarUrl"];
            this.positionStatus = _data["positionStatus"];
            this.shiftType = _data["shiftType"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.punchInStatus = _data["punchInStatus"];
            this.punchOutStatus = _data["punchOutStatus"];
            this.requests = _data["requests"];
            this.positionId = _data["positionId"];
            this.homeCostNumberCode = _data["homeCostNumberCode"];
            this.homeDepartmentCode = _data["homeDepartmentCode"];
            this.payClass = _data["payClass"];
            this.emergencyContactName = _data["emergencyContactName"];
            this.emergencyContactNumber = _data["emergencyContactNumber"];
            this.medicalConditions = _data["medicalConditions"];
            this.taxId = _data["taxId"];
            this.payrollCompanyCode = _data["payrollCompanyCode"];
            this.regularPayRateCode = _data["regularPayRateCode"];
            this.payRateAmount = _data["payRateAmount"];
            this.annualSalary = _data["annualSalary"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.regularPayEffectiveDate = _data["regularPayEffectiveDate"] ? new Date(_data["regularPayEffectiveDate"].toString()) : <any>undefined;
            this.hireDate = _data["hireDate"] ? new Date(_data["hireDate"].toString()) : <any>undefined;
            this.paidPosition = _data["paidPosition"];
            this.standardHours = _data["standardHours"];
            this.age = _data["age"];
            this.yearsWorked = _data["yearsWorked"];
            this.jobTitleDescription = _data["jobTitleDescription"];
            this.sapAccess = _data["sapAccess"];
            this.dwaAccess = _data["dwaAccess"];
            this.nextViewAccess = _data["nextViewAccess"];
            this.nestleStatus = _data["nestleStatus"];
            this.nestleDetailsAdpHireDate = _data["nestleDetailsAdpHireDate"] ? new Date(_data["nestleDetailsAdpHireDate"].toString()) : <any>undefined;
            this.nestleDetailsNewHire = _data["nestleDetailsNewHire"];
            this.nestleDetailsAgency = _data["nestleDetailsAgency"];
            this.nestleDetailsPositionId = _data["nestleDetailsPositionId"];
            this.nestleDetailsSapSuccessFactorId = _data["nestleDetailsSapSuccessFactorId"];
            this.nestleDetailsEmployeeId = _data["nestleDetailsEmployeeId"];
            this.nestleDetailsNestleUserId = _data["nestleDetailsNestleUserId"];
            this.nestleDetailsEmail = _data["nestleDetailsEmail"];
            this.nestleDetailsNextPasswordExpiryDate = _data["nestleDetailsNextPasswordExpiryDate"] ? new Date(_data["nestleDetailsNextPasswordExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["avatarUrl"] = this.avatarUrl;
        data["positionStatus"] = this.positionStatus;
        data["shiftType"] = this.shiftType;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["punchInStatus"] = this.punchInStatus;
        data["punchOutStatus"] = this.punchOutStatus;
        data["requests"] = this.requests;
        data["positionId"] = this.positionId;
        data["homeCostNumberCode"] = this.homeCostNumberCode;
        data["homeDepartmentCode"] = this.homeDepartmentCode;
        data["payClass"] = this.payClass;
        data["emergencyContactName"] = this.emergencyContactName;
        data["emergencyContactNumber"] = this.emergencyContactNumber;
        data["medicalConditions"] = this.medicalConditions;
        data["taxId"] = this.taxId;
        data["payrollCompanyCode"] = this.payrollCompanyCode;
        data["regularPayRateCode"] = this.regularPayRateCode;
        data["payRateAmount"] = this.payRateAmount;
        data["annualSalary"] = this.annualSalary;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["regularPayEffectiveDate"] = this.regularPayEffectiveDate ? formatDate(this.regularPayEffectiveDate) : <any>undefined;
        data["hireDate"] = this.hireDate ? formatDate(this.hireDate) : <any>undefined;
        data["paidPosition"] = this.paidPosition;
        data["standardHours"] = this.standardHours;
        data["age"] = this.age;
        data["yearsWorked"] = this.yearsWorked;
        data["jobTitleDescription"] = this.jobTitleDescription;
        data["sapAccess"] = this.sapAccess;
        data["dwaAccess"] = this.dwaAccess;
        data["nextViewAccess"] = this.nextViewAccess;
        data["nestleStatus"] = this.nestleStatus;
        data["nestleDetailsAdpHireDate"] = this.nestleDetailsAdpHireDate ? this.nestleDetailsAdpHireDate.toISOString() : <any>undefined;
        data["nestleDetailsNewHire"] = this.nestleDetailsNewHire;
        data["nestleDetailsAgency"] = this.nestleDetailsAgency;
        data["nestleDetailsPositionId"] = this.nestleDetailsPositionId;
        data["nestleDetailsSapSuccessFactorId"] = this.nestleDetailsSapSuccessFactorId;
        data["nestleDetailsEmployeeId"] = this.nestleDetailsEmployeeId;
        data["nestleDetailsNestleUserId"] = this.nestleDetailsNestleUserId;
        data["nestleDetailsEmail"] = this.nestleDetailsEmail;
        data["nestleDetailsNextPasswordExpiryDate"] = this.nestleDetailsNextPasswordExpiryDate ? this.nestleDetailsNextPasswordExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployeeGridViewDto {
    id?: string;
    name?: string;
    email?: string | undefined;
    avatarUrl?: string | undefined;
    positionStatus?: PositionStatus | undefined;
    shiftType?: ShiftType | undefined;
    lastUpdated?: Date;
    punchInStatus?: PunchInStatus | undefined;
    punchOutStatus?: PunchOutStatus | undefined;
    requests?: number;
    positionId?: string | undefined;
    homeCostNumberCode?: string | undefined;
    homeDepartmentCode?: string | undefined;
    payClass?: string | undefined;
    emergencyContactName?: string | undefined;
    emergencyContactNumber?: string | undefined;
    medicalConditions?: string | undefined;
    taxId?: string | undefined;
    payrollCompanyCode?: PayrollCompanyCode | undefined;
    regularPayRateCode?: RegularPayRateCode | undefined;
    payRateAmount?: number | undefined;
    annualSalary?: number | undefined;
    birthDate?: Date | undefined;
    regularPayEffectiveDate?: Date | undefined;
    hireDate?: Date | undefined;
    paidPosition?: boolean | undefined;
    standardHours?: number | undefined;
    age?: string | undefined;
    yearsWorked?: number | undefined;
    jobTitleDescription?: JobTitle | undefined;
    sapAccess?: boolean | undefined;
    dwaAccess?: boolean | undefined;
    nextViewAccess?: boolean | undefined;
    nestleStatus?: NestleStatus | undefined;
    nestleDetailsAdpHireDate?: Date | undefined;
    nestleDetailsNewHire?: boolean | undefined;
    nestleDetailsAgency?: string | undefined;
    nestleDetailsPositionId?: string | undefined;
    nestleDetailsSapSuccessFactorId?: string | undefined;
    nestleDetailsEmployeeId?: string | undefined;
    nestleDetailsNestleUserId?: string | undefined;
    nestleDetailsEmail?: string | undefined;
    nestleDetailsNextPasswordExpiryDate?: Date | undefined;
}

export class RecipientOptionDto implements IRecipientOptionDto {
    value?: string;

    constructor(data?: IRecipientOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RecipientOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IRecipientOptionDto {
    value?: string;
}

export class EmailTemplateGridViewDto implements IEmailTemplateGridViewDto {
    type?: NotificationType;
    subject?: string | undefined;
    description?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: EmployeeDto | undefined;

    constructor(data?: IEmailTemplateGridViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? EmployeeDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailTemplateGridViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateGridViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmailTemplateGridViewDto {
    type?: NotificationType;
    subject?: string | undefined;
    description?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: EmployeeDto | undefined;
}

export class AgencyOptionDto implements IAgencyOptionDto {
    id?: string;
    name?: string;

    constructor(data?: IAgencyOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AgencyOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAgencyOptionDto {
    id?: string;
    name?: string;
}

export class ImportNotification implements IImportNotification {
    fileType?: ImportFileType;
    status?: FileImportStatus;
    message?: string;

    constructor(data?: IImportNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"];
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ImportNotification {
        data = typeof data === 'object' ? data : {};
        let result = new ImportNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IImportNotification {
    fileType?: ImportFileType;
    status?: FileImportStatus;
    message?: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}